/**!
 * Mineral UI
 * Copyright 2017 CA
 * License: Apache-2.0
 */
webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    Icon_fill: baseTheme.color_gray_60,
    Icon_size_small: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* pxToEm */])(12),
    Icon_size_medium: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* pxToEm */])(16),
    Icon_size_large: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* pxToEm */])(20)
  }, baseTheme);
};

var iconStyles = function iconStyles(_ref) {
  var color = _ref.color,
      rtl = _ref.rtl,
      size = _ref.size,
      baseTheme = _ref.theme;

  var theme = componentTheme(baseTheme);

  return {
    fill: color || theme.Icon_fill,
    fontSize: theme.fontSize_base,
    height: theme['Icon_size_' + size] || size,
    transform: theme.direction === 'rtl' && rtl && 'scaleX(-1)',
    width: theme['Icon_size_' + size] || size
  };
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('svg', iconStyles, { rootEl: 'svg' });

/**
 * Icons use graphical symbols to represent an object or concept in your UI.
 * They can be used to aid comprehension of core actions in your app, and to provide feedback for user input.
 *
 * Mineral UI provides a large number of bundled Icon components as well
 * as a generic Icon component to which you can provide your own SVG.
 */

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Icon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Icon.__proto__ || Object.getPrototypeOf(Icon)).call.apply(_ref2, [this].concat(args))), _this), _this.uniqueId = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* generateId */])(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          title = _props.title,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['size', 'title', 'children']);

      var titleElementId = 'Icon-title-' + this.uniqueId;
      var rootProps = _extends({
        'aria-hidden': title ? null : true,
        'aria-labelledby': title && titleElementId,
        role: 'icon',
        size: size,
        viewBox: '0 0 24 24'
      }, restProps);

      var titleProps = {
        id: titleElementId
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Root,
        rootProps,
        title && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'title',
          titleProps,
          title
        ),
        children
      );
    }
  }]);

  return Icon;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Icon.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large']), __webpack_require__(0).string]),
  children: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node) : __webpack_require__(0).any,
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};
Icon.displayName = 'Icon';
Icon.defaultProps = {
  size: 'medium'
};
/* harmony default export */ __webpack_exports__["b"] = (Icon);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStyledComponent__ = __webpack_require__(1471);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createStyledComponent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createThemedComponent__ = __webpack_require__(1473);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createThemedComponent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getNormalizedValue__ = __webpack_require__(1474);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__getNormalizedValue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pxToEm__ = __webpack_require__(262);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__pxToEm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__generateId__ = __webpack_require__(1475);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__generateId__["a"]; });
/* unused harmony reexport resetId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__composeEventHandlers__ = __webpack_require__(1476);
/* unused harmony reexport composeEventHandlers */
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */










/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(274);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["b"]; });
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(46);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createColorRamp__ = __webpack_require__(47);
/* unused harmony reexport createColorRamp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styleVariables__ = __webpack_require__(48);
/* unused harmony reexport styleVariables */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ThemeProvider__ = __webpack_require__(263);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__ThemeProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mineralTheme__ = __webpack_require__(264);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__mineralTheme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blueTheme__ = __webpack_require__(265);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__blueTheme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__duskTheme__ = __webpack_require__(1462);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__duskTheme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__indigoTheme__ = __webpack_require__(1463);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__indigoTheme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__limeTheme__ = __webpack_require__(1464);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__limeTheme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__purpleTheme__ = __webpack_require__(1465);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__purpleTheme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__skyTheme__ = __webpack_require__(1466);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_10__skyTheme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__slateTheme__ = __webpack_require__(1467);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_11__slateTheme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__tealTheme__ = __webpack_require__(1468);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_12__tealTheme__["a"]; });
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/* eslint-disable prettier/prettier */










/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(1606);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__Menu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MenuDivider__ = __webpack_require__(282);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__MenuDivider__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuGroup__ = __webpack_require__(283);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuGroup__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuGroupTitle__ = __webpack_require__(179);
/* unused harmony reexport MenuGroupTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MenuItem__ = __webpack_require__(180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__MenuItem__["b"]; });
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('figure', function (_ref) {
  var theme = _ref.theme;
  return {
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    padding: theme.space_inset_xs,
    width: '18em',

    '&:focus': {
      outline: '1px dotted currentColor'
    },

    '& > [role="icon"]': {
      marginRight: theme.space_inline_xs
    }
  };
}, {
  displayName: 'Figure',
  includeStyleReset: true
}));

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('figcaption', function (_ref) {
  var theme = _ref.theme;
  return {
    fontSize: theme.fontSize_mouse,
    marginLeft: theme.space_inline_xs
  };
}, {
  displayName: 'FigCaption',
  includeStyleReset: true
}));

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('div', function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'flex',
    flexWrap: 'wrap',
    marginLeft: '-' + theme.space_inline_xs
  };
}, {
  displayName: 'FigContainer',
  includeStyleReset: true
}));

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('h4', function (_ref) {
  var theme = _ref.theme;
  return {
    borderTop: '1px solid ' + theme.borderColor,
    paddingTop: theme.space_stack_lg,
    fontSize: theme.fontSize_h5,
    textTransform: 'capitalize',
    margin: parseFloat(Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* getNormalizedValue */])(theme.space_stack_lg, theme.fontSize_h5)) + 'em 0'
  };
}, {
  displayName: 'CategoryHeader',
  includeStyleReset: true
}));

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card__ = __webpack_require__(100);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__Card__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CardBlock__ = __webpack_require__(275);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__CardBlock__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CardImage__ = __webpack_require__(1512);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__CardImage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardTitle__ = __webpack_require__(276);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__CardTitle__["b"]; });
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('div', function (_ref) {
  var theme = _ref.theme,
      width = _ref.width;
  return {
    overflow: 'hidden',

    '& > div': {
      backgroundColor: theme.color_white,
      float: 'left',
      margin: '0 0.5rem 0.5rem 0',
      // Default width is width of DropdownContent
      width: width || Object(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* pxToEm */])(224)
    }
  };
}));

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Heading;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(77);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    Heading_color_1: baseTheme.color_text,
    Heading_color_2: baseTheme.color_gray_80,
    Heading_color_3: baseTheme.color_gray_80,
    Heading_color_4: baseTheme.color_gray_80,
    Heading_color_5: baseTheme.color_text,
    Heading_color_6: baseTheme.color_gray_80,
    Heading_fontSize_1: baseTheme.fontSize_h1,
    Heading_fontSize_2: baseTheme.fontSize_h2,
    Heading_fontSize_3: baseTheme.fontSize_h3,
    Heading_fontSize_4: baseTheme.fontSize_h4,
    Heading_fontSize_5: baseTheme.fontSize_h5,
    Heading_fontSize_6: baseTheme.fontSize_h6,
    Heading_fontWeight_1: baseTheme.fontWeight_extraBold,
    Heading_fontWeight_2: baseTheme.fontWeight_semiBold,
    Heading_fontWeight_3: baseTheme.fontWeight_semiBold,
    Heading_fontWeight_4: baseTheme.fontWeight_bold,
    Heading_fontWeight_5: baseTheme.fontWeight_bold,
    Heading_fontWeight_6: baseTheme.fontWeight_regular,
    Heading_marginMultiplier_1: 6,
    Heading_marginMultiplier_2: 5,
    Heading_marginMultiplier_3: 4,
    Heading_marginMultiplier_4: 3,
    Heading_marginMultiplier_5: 3,
    Heading_marginMultiplier_6: 3

  }, baseTheme);
};

var headingStyles = function headingStyles(_ref) {
  var level = _ref.level,
      baseTheme = _ref.theme;

  var theme = componentTheme(baseTheme);

  return {
    color: theme['Heading_color_' + level],
    fontSize: theme['Heading_fontSize_' + level],
    fontWeight: theme['Heading_fontWeight_' + level],
    margin: theme['Heading_marginMultiplier_' + level] * parseFloat(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getNormalizedValue */])(theme.space_stack_sm, theme['Heading_fontSize_' + level])) + 'em 0',

    '&:hover,&:focus': {
      '& > a': {
        visibility: 'visible'
      }
    }
  };
};
var Anchor = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], function (_ref2) {
  var theme = _ref2.theme;
  return {
    color: theme.color_caption,
    visibility: 'hidden'
  };
});

function Heading(_ref3) {
  var as = _ref3.as,
      children = _ref3.children,
      id = _ref3.id,
      level = _ref3.level,
      restProps = _objectWithoutProperties(_ref3, ['as', 'children', 'id', 'level']);

  var rootProps = _extends({
    id: id,
    level: level
  }, restProps);
  var useAs = as ? as : 'h' + level;
  var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(useAs, headingStyles);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    children,
    ' ',
    id && _jsx(Anchor, {
      href: '#' + id
    }, void 0, '#')
  );
}

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Markdown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marksy_components__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marksy_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_marksy_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Heading__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Paragraph__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Link__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MarkdownTable__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_prism__ = __webpack_require__(1487);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */










var Root = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('div', function (_ref) {
  var theme = _ref.theme;
  return {
    lineHeight: theme.lineHeight_prose,

    '& p': {
      marginBottom: theme.lineHeight * 1.5 + 'em'
    },

    '& a:link': {
      color: theme.color_text_primary,
      textDecoration: 'none'
    },
    '& a:hover': {
      color: theme.color_text_primary_hover,
      textDecoration: 'underline'
    },
    '& a:focus': {
      color: theme.color_text_primary_focus,
      outline: '1px solid ' + theme.borderColor_focus,
      outlineOffset: '2px'
    },
    // `:active` must be last, to follow LVHFA order:
    // https://developer.mozilla.org/en-US/docs/Web/CSS/:active
    '& a:active': {
      color: theme.color_text_primary_active
    },

    '& :not(pre) > code': {
      backgroundColor: theme.color_gray_20,
      borderRadius: theme.borderRadius_1,
      fontFamily: theme.fontFamily_monospace,
      padding: parseFloat(theme.space_inset_sm) / 2 + 'em'
    },

    // Specificity silliness due to having to style markdown content off of the
    // container
    '& h2,& h3,& h4,& h5,& h6': {
      '& > a:link': {
        color: theme.color_caption
      },
      '& > a:hover': {
        color: theme.color_text_primary_hover
      },
      '& > a:focus': {
        color: theme.color_text_primary_focus
      },
      // `:active` must be last, to follow LVHFA order:
      // https://developer.mozilla.org/en-US/docs/Web/CSS/:active
      '& > a:active': {
        color: theme.color_text_primary_active
      }
    },

    '& pre': {
      fontSize: theme.fontSize_ui,
      // Setting the maxHeight equal to, roughly, 20 lines,
      // then subtracting a bit to make it clear there's more beyond the scroll
      maxHeight: Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getNormalizedValue */])(parseFloat(theme.fontSize_ui) * theme.lineHeight * (20 - 0.5) + 'em', theme.fontSize_ui),
      overflow: 'auto'
    }
  };
});
var CodeBlock = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('div', function (_ref2) {
  var theme = _ref2.theme;
  return {
    marginBottom: theme.space_stack_xl
  };
});
var Image = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('img', {
  '@media(max-width: 60rem)': {
    width: '100%'
  }
});

function replaceHeading(level, children, headingProps) {
  // Render the same props and children that were passed in, but prepend a
  // link to this title with the text '#'.
  return _jsx(__WEBPACK_IMPORTED_MODULE_3__Heading__["a" /* default */], {
    level: level,
    id: headingProps.id
  }, void 0, children);
}

/**
 * Matches if:
 * (doesn't start with one or more dots &&
 *    (contains dot anywhere but the first character || starts with a hash)
 * )
 *
 * Should match:
 * http://non-routed-link.com,
 * http://non-routed-link.com#anchor
 * #non-routed-anchor
 *
 * Shouldn't match
 * routed-link
 * /routed-link
 * ../routed-link
 * routed-link#anchor
 * /routed-link#anchor
 * ../routed-link#anchor
 */

// eslint-disable-next-line no-useless-escape
var REGEX_IS_NON_ROUTED_LINK = /(?=^[^\.+])(?=[^\.]+\.|^#)/;

function isNormalLink(url) {
  return REGEX_IS_NON_ROUTED_LINK.test(url);
}

function Markdown(_ref3) {
  var children = _ref3.children,
      scope = _ref3.scope,
      restProps = _objectWithoutProperties(_ref3, ['children', 'scope']);

  var rootProps = _extends({}, restProps);

  var compile = __WEBPACK_IMPORTED_MODULE_1_marksy_components___default()({
    createElement: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"],
    elements: {
      a: function a(_ref4) {
        var href = _ref4.href,
            children = _ref4.children;

        var linkProps = isNormalLink(href) ? { href: href } : { to: href };
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__Link__["a" /* default */],
          linkProps,
          children
        );
      },
      code: function code(_ref5) {
        var _ref5$language = _ref5.language,
            language = _ref5$language === undefined ? 'jsx' : _ref5$language,
            code = _ref5.code,
            children = _ref5.children;

        return code ? _jsx(CodeBlock, {}, void 0, _jsx('pre', {
          className: 'prism-code language-' + language
        }, void 0, _jsx('code', {
          dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_7__utils_prism__["a" /* default */])(code, language) }
        }))) : _jsx('code', {}, void 0, children);
      },
      img: function img(_ref6) {
        var src = _ref6.src,
            alt = _ref6.alt;

        return _jsx(Image, {
          src: src,
          alt: alt
        });
      },
      h1: function h1(_ref7) {
        var children = _ref7.children;

        return replaceHeading(1, children, {});
      },
      h2: function h2(_ref8) {
        var id = _ref8.id,
            children = _ref8.children;

        return replaceHeading(2, children, { id: id });
      },
      h3: function h3(_ref9) {
        var id = _ref9.id,
            children = _ref9.children;

        return replaceHeading(3, children, { id: id });
      },
      h4: function h4(_ref10) {
        var id = _ref10.id,
            children = _ref10.children;

        return replaceHeading(4, children, { id: id });
      },
      h5: function h5(_ref11) {
        var id = _ref11.id,
            children = _ref11.children;

        return replaceHeading(5, children, { id: id });
      },
      h6: function h6(_ref12) {
        var id = _ref12.id,
            children = _ref12.children;

        return replaceHeading(6, children, { id: id });
      },
      p: function p(_ref13) {
        var children = _ref13.children;

        return _jsx(__WEBPACK_IMPORTED_MODULE_4__Paragraph__["a" /* default */], {
          variant: 'prose'
        }, void 0, children);
      },
      table: function table(_ref14) {
        var children = _ref14.children;

        return _jsx(__WEBPACK_IMPORTED_MODULE_6__MarkdownTable__["a" /* default */], {}, void 0, children);
      }
    },
    components: _extends({}, scope)
  });

  var compiled = compile(children, { smartypants: false });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    compiled.tree
  );
}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popover__ = __webpack_require__(1504);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Popover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopoverArrow__ = __webpack_require__(277);
/* unused harmony reexport PopoverArrow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PopoverContent__ = __webpack_require__(123);
/* unused harmony reexport PopoverContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PopoverTrigger__ = __webpack_require__(170);
/* unused harmony reexport PopoverTrigger */
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCloud;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z'
}));

/* eslint-disable prettier/prettier */
function IconCloud(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCloud.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('div', {
  '& > *': {
    '@media(min-width: 40em)': {
      width: '50%'
    },
    '@media(min-width: 64em)': {
      width: '33.333%'
    }
  }
}));

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var color = {
  black: '#1d1f24',
  white: '#fff',

  red_10: '#fce3e3',
  red_20: '#fabebe',
  red_30: '#f79999',
  red_40: '#f27474',
  red_50: '#eb4d4d',
  red_60: '#db2929',
  red_70: '#c71818',
  red_80: '#ad0e0e',
  red_90: '#940909',
  red_100: '#7d0606',

  magenta_10: '#f7dae3',
  magenta_20: '#f7bacd',
  magenta_30: '#f590b0',
  magenta_40: '#f06591',
  magenta_50: '#e63e73',
  magenta_60: '#d92762',
  magenta_70: '#c91451',
  magenta_80: '#b30b43',
  magenta_90: '#a1083b',
  magenta_100: '#8d0633',

  purple_10: '#eedefa',
  purple_20: '#e1c5fa',
  purple_30: '#d5a7fa',
  purple_40: '#c588f7',
  purple_50: '#af64ed',
  purple_60: '#9545d8',
  purple_70: '#8136bf',
  purple_80: '#6d2aa3',
  purple_90: '#5f248f',
  purple_100: '#511f7a',

  indigo_10: '#e3e3fa',
  indigo_20: '#cacafa',
  indigo_30: '#adadf7',
  indigo_40: '#8d8df2',
  indigo_50: '#6c6ceb',
  indigo_60: '#4c4ce0',
  indigo_70: '#3737d3',
  indigo_80: '#2c2abd',
  indigo_90: '#2621a6',
  indigo_100: '#201d8f',

  blue_10: '#e6eefc',
  blue_20: '#c2dbfc',
  blue_30: '#9dc2fa',
  blue_40: '#72a5f2',
  blue_50: '#4a89e8',
  blue_60: '#2e6fd9',
  blue_70: '#1f5dc2',
  blue_80: '#164ea8',
  blue_90: '#114091',
  blue_100: '#0f397d',

  sky_10: '#e1f3fc',
  sky_20: '#c0e5fc',
  sky_30: '#9fd9fc',
  sky_40: '#79c7f7',
  sky_50: '#51b3f0',
  sky_60: '#2f9fe0',
  sky_70: '#1b8bcc',
  sky_80: '#0f75b0',
  sky_90: '#0a6091',
  sky_100: '#084d75',

  teal_10: '#e6faf7',
  teal_20: '#bcf7ee',
  teal_30: '#8df0de',
  teal_40: '#5ee6cd',
  teal_50: '#34d1b7',
  teal_60: '#20baa3',
  teal_70: '#15a18e',
  teal_80: '#0f8c7c',
  teal_90: '#0c7567',
  teal_100: '#0a6358',

  green_10: '#e8fcf2',
  green_20: '#c0fadc',
  green_30: '#95f5c3',
  green_40: '#67eba7',
  green_50: '#40db8d',
  green_60: '#1fc06f',
  green_70: '#10a35a',
  green_80: '#0a8f4c',
  green_90: '#06783f',
  green_100: '#046132',

  lime_10: '#f1fae6',
  lime_20: '#e7facf',
  lime_30: '#d2f7a8',
  lime_40: '#b5f07a',
  lime_50: '#9be650',
  lime_60: '#81d42f',
  lime_70: '#6cbf19',
  lime_80: '#5aa60d',
  lime_90: '#4a8c08',
  lime_100: '#3d7307',

  yellow_10: '#fcf1dc',
  yellow_20: '#fce4b6',
  yellow_30: '#fad48e',
  yellow_40: '#f7c868',
  yellow_50: '#f0b241',
  yellow_60: '#e3a322',
  yellow_70: '#d19411',
  yellow_80: '#bd8308',
  yellow_90: '#a67305',
  yellow_100: '#916504',

  orange_10: '#fce8e1',
  orange_20: '#fcd0c0',
  orange_30: '#fab69d',
  orange_40: '#f59776',
  orange_50: '#ed774c',
  orange_60: '#e05b2b',
  orange_70: '#cf4615',
  orange_80: '#bd3909',
  orange_90: '#a83207',
  orange_100: '#942c06',

  gray_10: '#f5f7fa',
  gray_20: '#ebeff5',
  gray_30: '#dde3ed',
  gray_40: '#c8d1e0',
  gray_50: '#afbacc',
  gray_60: '#8e99ab',
  gray_70: '#707a8a',
  gray_80: '#58606e',
  gray_90: '#434a54',
  gray_100: '#333840',

  slate_10: '#ebf3f7',
  slate_20: '#d3e4ed',
  slate_30: '#b1cfde',
  slate_40: '#8fb6c9',
  slate_50: '#709cb3',
  slate_60: '#598296',
  slate_70: '#47697a',
  slate_80: '#3a5663',
  slate_90: '#2e444f',
  slate_100: '#253740',

  dusk_10: '#eff1f8',
  dusk_20: '#d8dced',
  dusk_30: '#bdc4de',
  dusk_40: '#99a3c4',
  dusk_50: '#7680a6',
  dusk_60: '#596387',
  dusk_70: '#454e6e',
  dusk_80: '#373f59',
  dusk_90: '#2c3247',
  dusk_100: '#24293b'
};

/* harmony default export */ __webpack_exports__["a"] = (color);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createColorRamp;
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function createColorRamp(key, // The key of the color in the color object
name, // The output key name
colors // The palette of colors
) {
  var ramp = {};

  for (var index = 10; index <= 100; index += 10) {
    ramp["color_" + name + "_" + index] = colors[key + "_" + index];
  }

  return ramp;
}

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fontSizeBase__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__ = __webpack_require__(262);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var spacing_quarter = Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(2);
var spacing_half = Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(4);
var spacing_1x = Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(8);
var spacing_2x = Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(16);
var spacing_3x = Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(24);
var spacing_4x = Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(32);
var spacing_8x = Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(64);

/* harmony default export */ __webpack_exports__["a"] = ({
  borderRadius_1: Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(3),

  direction: 'ltr',

  fontFamily: 'Open Sans',
  fontFamily_system: '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  fontFamily_monospace: 'monospace',

  fontSize_base: __WEBPACK_IMPORTED_MODULE_0__fontSizeBase__["a" /* default */],
  fontSize_h1: Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(34),
  fontSize_h2: Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(28),
  fontSize_h3: Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(22),
  fontSize_h4: Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(18),
  fontSize_h5: Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(14),
  fontSize_h6: Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(14),
  fontSize_mouse: Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(11),
  fontSize_prose: Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(16),
  fontSize_ui: Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(14),

  fontWeight_regular: 400,
  fontWeight_semiBold: 600,
  fontWeight_bold: 700,
  fontWeight_extraBold: 800,

  lineHeight: 1.25,
  lineHeight_prose: 1.5,

  shadow_1: '0 1px 2px 0 rgba(0,0,0,0.4)',
  shadow_2: '0 2px 4px 0 rgba(0,0,0,0.2), 0 1px 2px 0 rgba(0,0,0,0.4)',
  shadow_3: '0 4px 8px 0 rgba(0,0,0,0.2), 0 2px 4px 0 rgba(0,0,0,0.4)',
  shadow_4: '0 8px 16px 0 rgba(0,0,0,0.2), 0 4px 8px 0 rgba(0,0,0,0.4)',
  shadow_5: '0 24px 24px -8px rgba(0,0,0,0.4), 0 8px 16px 0 rgba(0,0,0,0.4)',

  size_small: Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(24),
  size_medium: Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(32),
  size_large: Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(40),
  size_jumbo: Object(__WEBPACK_IMPORTED_MODULE_1__utils_pxToEm__["a" /* default */])(52),

  space_inline_xxs: spacing_quarter,
  space_inline_xs: spacing_half,
  space_inline_sm: spacing_1x,
  space_inline_md: spacing_2x,
  space_inline_lg: spacing_3x,
  space_inline_xl: spacing_4x,
  space_inline_xxl: spacing_8x,

  space_inset_sm: spacing_1x,
  space_inset_md: spacing_2x,
  space_inset_lg: spacing_3x,

  space_stack_xxs: spacing_quarter,
  space_stack_xs: spacing_half,
  space_stack_sm: spacing_1x,
  space_stack_md: spacing_2x,
  space_stack_lg: spacing_3x,
  space_stack_xl: spacing_4x,
  space_stack_xxl: spacing_8x,

  zIndex_100: 100,
  zIndex_200: 200,
  zIndex_400: 400,
  zIndex_800: 800,
  zIndex_1600: 1600
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropdown__ = __webpack_require__(1612);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DropdownContent__ = __webpack_require__(178);
/* unused harmony reexport DropdownContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popover_PopoverTrigger__ = __webpack_require__(170);
/* unused harmony reexport DropdownTrigger */
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/***/ }),
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Link__ = __webpack_require__(268);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Link__["b"]; });
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DemoContent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', {
  width: '13.75em'
});

var _ref = _jsx(Root, {}, void 0, 'Light years star stuff harvesting star light citizens of distant epochs encyclopaedia galactica.');

function DemoContent() {
  return _ref;
}

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Link;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(52);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





function Link(props) {
  var rootProps = _extends({}, props);
  if (props.to) {
    rootProps.element = __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */];
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], rootProps);
}

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ([{
  items: [{
    text: 'Light years'
  }, {
    text: 'Star stuff'
  }, {
    text: 'Encyclopaedia galactica'
  }, {
    text: 'Cosmic ocean'
  }]
}]);

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSentimentSatisfied;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('circle', {
  cx: '15.5',
  cy: '9.5',
  r: '1.5'
}), _jsx('circle', {
  cx: '8.5',
  cy: '9.5',
  r: '1.5'
}), _jsx('path', {
  d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-1.48 0-2.75-.81-3.45-2H6.88a5.495 5.495 0 0 0 10.24 0h-1.67c-.7 1.19-1.97 2-3.45 2z'
}));

/* eslint-disable prettier/prettier */
function IconSentimentSatisfied(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSentimentSatisfied.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('section', function (_ref) {
  var theme = _ref.theme;
  return {
    margin: parseFloat(theme.space_stack_sm) * 16 + 'em 0'
  };
}));

/***/ }),
/* 99 */,
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = Card;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    Card_backgroundColor: baseTheme.color_white,
    Card_borderRadius: baseTheme.borderRadius_1,
    Card_boxShadow: baseTheme.shadow_1,
    Card_boxShadow_focus: '0 0 0 2px ' + baseTheme.color_theme_100 + ', ' + baseTheme.shadow_1,
    Card_paddingBottom: baseTheme.space_stack_md,

    CardRow_margin: baseTheme.space_stack_md,
    CardRow_padding: baseTheme.space_inset_lg

  }, baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', function (props) {
  var theme = componentTheme(props.theme);

  return {
    backgroundColor: theme.Card_backgroundColor,
    borderRadius: theme.Card_borderRadius,
    boxShadow: theme.Card_boxShadow,
    cursor: props.onClick && 'pointer',
    paddingBottom: theme.Card_paddingBottom,
    paddingTop: '0.01em', // Necessary to prevent margin collapse of first-child

    '&:focus, &[data-simulate-focus]': {
      boxShadow: theme.Card_boxShadow_focus
    }
  };
}, {
  displayName: 'Card',
  includeStyleReset: true
});

var onKeyPress = function onKeyPress(props, event) {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    props.onClick && props.onClick(event);
  }
};

/**
 * Cards are used to group conceptually related content.
 * Cards represent a gateway to more detailed information in another app view.
 * You can use Cards to provide detail about a feature in your app, or to represent data with which your users can interact.
 */
function Card(props) {
  var rootProps = _extends({
    onKeyPress: props.onClick ? onKeyPress.bind(null, props) : undefined,
    role: props.onClick ? 'button' : undefined,
    tabIndex: props.onClick ? 0 : undefined
  }, props);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Root, rootProps);
}
Card.propTypes = {
  children: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node).isRequired : __webpack_require__(0).any.isRequired,
  onClick: __webpack_require__(0).func
};

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GuidelinePage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', function (_ref) {
  var theme = _ref.theme;
  return {
    '& > div > h1 ~ p': {
      fontSize: theme.fontSize_h3,
      margin: '0 0 ' + theme.lineHeight * 0.8 + 'em'
    },
    // There might be more than one paragraph element in the Intro section.
    // marksy generates a flat-ish tree of elements, so body copy Ps are on the same level
    // as the intro paragraph.
    '& > div > h2 ~ p, & > div > ul ~ p': {
      fontSize: theme.fontSize_prose,
      margin: '0 0 ' + theme.lineHeight * 1.5 + 'em'
    }
  };
});

function GuidelinePage(_ref2) {
  var children = _ref2.children,
      restProps = _objectWithoutProperties(_ref2, ['children']);

  var rootProps = _extends({}, restProps);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    children
  );
}

/***/ }),
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Table; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TableCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TableHeaderCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TableRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



var styles = {
  cell: function cell(_ref) {
    var theme = _ref.theme;
    return {
      padding: theme.space_inset_md + ' ' + theme.space_inset_sm,
      verticalAlign: 'top',

      '&:first-child': {
        paddingLeft: 0
      },

      '&:last-child': {
        paddingRight: 0
      }
    };
  },
  headerCell: function headerCell(_ref2) {
    var theme = _ref2.theme,
        width = _ref2.width;
    return {
      borderBottom: '3px solid ' + theme.color_gray_60,
      color: theme.color_gray_60,
      fontWeight: theme.fontWeight_bold,
      padding: '0 ' + theme.space_inset_sm + ' ' + theme.space_inset_sm,
      textAlign: 'left',
      width: width && width + 'rem',

      '&:first-child': {
        paddingLeft: 0
      },

      '&:last-child': {
        paddingRight: 0
      }
    };
  },
  row: function row(_ref3) {
    var theme = _ref3.theme;
    return {
      borderBottom: '1px solid ' + theme.borderColor
    };
  },
  table: function table(_ref4) {
    var theme = _ref4.theme;
    return {
      borderCollapse: 'collapse',
      borderSpacing: 0,
      fontSize: theme.fontSize_ui,
      width: '100%'
    };
  }
};

var Table = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('table', styles.table);
var TableCell = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('td', styles.cell);
var TableHeaderCell = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('th', styles.headerCell);
var TableRow = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('tr', styles.row);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCheck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'
}));

/* eslint-disable prettier/prettier */
function IconCheck(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCheck.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAssignment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z'
}));

/* eslint-disable prettier/prettier */
function IconAssignment(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAssignment.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSlowMotionVideo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13.05 9.79L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zM11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69A7.941 7.941 0 0 1 11 4.07zM5.69 7.1L4.26 5.68A9.949 9.949 0 0 0 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43A7.868 7.868 0 0 1 4.07 13zm1.61 6.74A9.981 9.981 0 0 0 11 21.95v-2.02a7.941 7.941 0 0 1-3.9-1.62l-1.42 1.43zM22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z'
}));

/* eslint-disable prettier/prettier */
function IconSlowMotionVideo(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSlowMotionVideo.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Callout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', function (_ref) {
  var theme = _ref.theme,
      variant = _ref.variant;
  return {
    backgroundColor: variant === 'danger' ? theme.backgroundColor_input_danger : theme.color_theme_10,
    borderRadius: theme.borderRadius_1,
    padding: theme.space_inset_md
  };
});
var Title = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('h4', function (_ref2) {
  var variant = _ref2.variant,
      theme = _ref2.theme;
  return {
    color: variant === 'danger' ? theme.color_text_danger : theme.color_text_primary,
    fontSize: '1em',
    fontWeight: theme.fontWeight_semiBold,
    margin: '0 0 ' + theme.space_stack_sm
  };
});

function Callout(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      _ref3$title = _ref3.title,
      title = _ref3$title === undefined ? '💡 Info' : _ref3$title,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === undefined ? 'regular' : _ref3$variant;

  return _jsx(Root, {
    className: className,
    variant: variant
  }, void 0, _jsx(Title, {
    variant: variant
  }, void 0, title), children);
}
Callout.propTypes = {
  children: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node).isRequired : __webpack_require__(0).any.isRequired,
  className: __webpack_require__(0).string,
  title: __webpack_require__(0).string,
  variant: __webpack_require__(0).oneOf(['danger', 'regular'])
};

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_popper__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_popper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PopoverArrow__ = __webpack_require__(277);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







var arrowSize = '8px';

var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    PopoverContent_backgroundColor: baseTheme.color_white,
    PopoverContent_borderColor: baseTheme.color_gray_20,
    PopoverContent_borderRadius: baseTheme.borderRadius_1,
    PopoverContent_boxShadow: baseTheme.shadow_2,
    PopoverContent_paddingVertical: baseTheme.space_inset_sm,
    PopoverContent_zIndex: baseTheme.zIndex_100
  }, baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_1_react_popper__["Popper"], function (_ref) {
  var baseTheme = _ref.theme;

  var theme = componentTheme(baseTheme);

  return {
    backgroundColor: theme.PopoverContent_backgroundColor,
    border: '1px solid ' + theme.PopoverContent_borderColor,
    borderRadius: theme.PopoverContent_borderRadius,
    boxShadow: theme.PopoverContent_boxShadow,
    padding: theme.PopoverContent_paddingVertical + ' 0',
    zIndex: theme.PopoverContent_zIndex,

    '&[data-placement^="top"]': {
      marginBottom: arrowSize
    },
    '&[data-placement^="bottom"]': {
      marginTop: arrowSize
    },
    '&[data-placement^="left"]': {
      marginRight: arrowSize
    },
    '&[data-placement^="right"]': {
      marginLeft: arrowSize
    },
    '&[data-x-out-of-boundaries]': {
      visibility: 'hidden'
    }
  };
}, {
  displayName: 'PopoverContent',
  includeStyleReset: true
});

/**
 * Temporary overrides until Card theme updated to match updated design spec
 */
var cardOverrides = function cardOverrides(_ref2) {
  var theme = _ref2.theme;

  return {
    CardRow_margin: theme.space_stack_sm,
    CardRow_padding: theme.space_inset_md
  };
};

var PopoverBlock = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* createThemedComponent */])(__WEBPACK_IMPORTED_MODULE_3__Card__["a" /* CardBlock */], cardOverrides);
var PopoverTitle = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* createThemedComponent */])(__WEBPACK_IMPORTED_MODULE_3__Card__["c" /* CardTitle */], cardOverrides);

/**
 * PopoverContent component
 */

var PopoverContent = function (_Component) {
  _inherits(PopoverContent, _Component);

  function PopoverContent() {
    _classCallCheck(this, PopoverContent);

    return _possibleConstructorReturn(this, (PopoverContent.__proto__ || Object.getPrototypeOf(PopoverContent)).apply(this, arguments));
  }

  _createClass(PopoverContent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          hasArrow = _props.hasArrow,
          placement = _props.placement,
          subtitle = _props.subtitle,
          title = _props.title,
          restProps = _objectWithoutProperties(_props, ['children', 'hasArrow', 'placement', 'subtitle', 'title']);

      var rootProps = _extends({
        placement: placement,
        tabIndex: 0
      }, restProps);
      var popoverArrowProps = {
        size: arrowSize,
        placement: placement
      };

      var _ref4 = _jsx(PopoverTitle, {
        subtitle: subtitle
      }, void 0, title);

      var _ref5 = _jsx(PopoverBlock, {}, void 0, children);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Root,
        rootProps,
        function (_ref3) {
          var popperProps = _ref3.popperProps,
              restProps = _ref3.restProps;

          var wrapperProps = _extends({}, popperProps, restProps);
          popoverArrowProps.placement = wrapperProps['data-placement'];

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            wrapperProps,
            title && _ref4,
            _ref5,
            hasArrow && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PopoverArrow__["a" /* default */], popoverArrowProps)
          );
        }
      );
    }
  }]);

  return PopoverContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PopoverContent.propTypes = {
  children: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node).isRequired : __webpack_require__(0).any.isRequired,
  modifiers: __webpack_require__(0).object,
  hasArrow: __webpack_require__(0).bool,
  placement: __webpack_require__(0).oneOf(['auto', 'auto-end', 'auto-start', 'bottom', 'bottom-end', 'bottom-start', 'left', 'left-end', 'left-start', 'right', 'right-end', 'right-start', 'top', 'top-end', 'top-start']),
  subtitle: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node) : __webpack_require__(0).any,
  title: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node) : __webpack_require__(0).any
};
/* harmony default export */ __webpack_exports__["b"] = (PopoverContent);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFavorite;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z'
}));

/* eslint-disable prettier/prettier */
function IconFavorite(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFavorite.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHelp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z'
}));

/* eslint-disable prettier/prettier */
function IconHelp(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHelp.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWarning;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z'
}));

/* eslint-disable prettier/prettier */
function IconWarning(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWarning.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z'
}));

/* eslint-disable prettier/prettier */
function IconInfo(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconInfo.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_popper__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_popper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var Root = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_1_react_popper__["Target"], {}, {
  displayName: 'PopoverTrigger'
});

var PopoverTrigger = function (_Component) {
  _inherits(PopoverTrigger, _Component);

  function PopoverTrigger() {
    _classCallCheck(this, PopoverTrigger);

    return _possibleConstructorReturn(this, (PopoverTrigger.__proto__ || Object.getPrototypeOf(PopoverTrigger)).apply(this, arguments));
  }

  _createClass(PopoverTrigger, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          disabled = _props.disabled,
          isOpen = _props.isOpen,
          contentId = _props.contentId,
          restProps = _objectWithoutProperties(_props, ['children', 'disabled', 'isOpen', 'contentId']);

      var triggerProps = _extends({
        'aria-owns': contentId,
        'aria-describedby': contentId,
        'aria-disabled': disabled,
        'aria-expanded': isOpen,
        disabled: disabled,
        role: 'button'
      }, restProps);

      return _jsx(Root, {}, void 0, Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children), triggerProps));
    }
  }]);

  return PopoverTrigger;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PopoverTrigger.propTypes = {
  contentId: __webpack_require__(0).string.isRequired,
  children: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node).isRequired : __webpack_require__(0).any.isRequired,
  disabled: __webpack_require__(0).bool,
  isOpen: __webpack_require__(0).bool.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (PopoverTrigger);

/***/ }),
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconArrowBack;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z'
}));

/* eslint-disable prettier/prettier */
function IconArrowBack(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconArrowBack.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBackspace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z'
}));

/* eslint-disable prettier/prettier */
function IconBackspace(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBackspace.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_popper__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_popper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Menu__ = __webpack_require__(18);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    DropdownContent_backgroundColor: baseTheme.color_white,
    DropdownContent_borderColor: baseTheme.color_gray_20,
    DropdownContent_borderRadius: baseTheme.borderRadius_1,
    DropdownContent_boxShadow: baseTheme.shadow_2,
    DropdownContent_margin: '5px',
    DropdownContent_zIndex: baseTheme.zIndex_100
  }, baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_1_react_popper__["Popper"], function (_ref) {
  var baseTheme = _ref.theme,
      wide = _ref.wide;

  var theme = componentTheme(baseTheme);

  return {
    backgroundColor: theme.DropdownContent_backgroundColor,
    border: '1px solid ' + theme.DropdownContent_borderColor,
    borderRadius: theme.DropdownContent_borderRadius,
    boxShadow: theme.DropdownContent_boxShadow,
    maxHeight: Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* pxToEm */])(368),
    overflowY: 'auto',
    userSelect: 'none',
    width: wide ? Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* pxToEm */])(344) : Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* pxToEm */])(224),
    zIndex: theme.DropdownContent_zIndex,

    '&[data-placement^="top"]': {
      marginBottom: theme.DropdownContent_margin
    },
    '&[data-placement^="bottom"]': {
      marginTop: theme.DropdownContent_margin
    },
    '&[data-placement^="left"]': {
      marginRight: theme.DropdownContent_margin
    },
    '&[data-placement^="right"]': {
      marginLeft: theme.DropdownContent_margin
    },
    '&[data-x-out-of-boundaries]': {
      visibility: 'hidden'
    }
  };
}, {
  displayName: 'DropdownContent',
  includeStyleReset: true,
  filterProps: ['wide']
});

/**
 * DropdownContent component
 */

var DropdownContent = function (_Component) {
  _inherits(DropdownContent, _Component);

  function DropdownContent() {
    _classCallCheck(this, DropdownContent);

    return _possibleConstructorReturn(this, (DropdownContent.__proto__ || Object.getPrototypeOf(DropdownContent)).apply(this, arguments));
  }

  _createClass(DropdownContent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          getItemProps = _props.getItemProps,
          id = _props.id,
          placement = _props.placement,
          wide = _props.wide,
          restProps = _objectWithoutProperties(_props, ['data', 'getItemProps', 'id', 'placement', 'wide']);

      var rootProps = _extends({
        id: id,
        placement: placement,
        wide: wide
      }, restProps);

      var menuProps = {
        id: id + '-menu',
        data: data,
        getItemProps: getItemProps,
        role: 'menu'
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Root,
        rootProps,
        function (_ref2) {
          var popperProps = _ref2.popperProps,
              restProps = _ref2.restProps;

          var wrapperProps = _extends({}, popperProps, restProps);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            wrapperProps,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Menu__["d" /* default */], menuProps)
          );
        }
      );
    }
  }]);

  return DropdownContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DropdownContent.propTypes = {
  getItemProps: __webpack_require__(0).func,
  data: __webpack_require__(0).arrayOf(__webpack_require__(0).object).isRequired,
  id: __webpack_require__(0).string.isRequired,
  modifiers: __webpack_require__(0).object,
  placement: __webpack_require__(0).oneOf(['bottom-end', 'bottom-start', 'left-end', 'left-start', 'right-end', 'right-start', 'top-end', 'top-start']),
  wide: __webpack_require__(0).bool
};
/* harmony default export */ __webpack_exports__["b"] = (DropdownContent);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = MenuGroupTitle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Menu_MenuItem__ = __webpack_require__(180);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    MenuGroupTitle_fontSize: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* pxToEm */])(12),
    MenuGroupTitle_fontWeight: baseTheme.fontWeight_bold,
    MenuGroupTitle_paddingTop: baseTheme.space_stack_md,
    MenuGroupTitle_paddingBottom: baseTheme.space_stack_sm

  }, baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('h3', function (props) {
  var theme = _extends({}, componentTheme(props.theme), Object(__WEBPACK_IMPORTED_MODULE_2__Menu_MenuItem__["a" /* componentTheme */])(props.theme));

  var paddingBottom = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getNormalizedValue */])(theme.MenuGroupTitle_paddingBottom, theme.MenuGroupTitle_fontSize);

  var paddingTop = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getNormalizedValue */])(theme.MenuGroupTitle_paddingTop, theme.MenuGroupTitle_fontSize);

  // We need to use MenuItem's padding, to match
  var paddingHorizontal = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getNormalizedValue */])(theme.MenuItem_paddingHorizontal, theme.MenuGroupTitle_fontSize);

  return {
    fontSize: theme.MenuGroupTitle_fontSize,
    fontWeight: theme.MenuGroupTitle_fontWeight,
    margin: 0,
    padding: paddingTop + ' ' + paddingHorizontal + ' ' + paddingBottom
  };
}, {
  displayName: 'MenuGroupTitle'
});

/**
 * Menu group title component
 */
function MenuGroupTitle(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Root, props);
}

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = MenuItem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_glamorous__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon_custom_IconDanger__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon_custom_IconSuccess__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_custom_IconWarning__ = __webpack_require__(1609);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








// Some of these values (all of the margins & paddings and the content fontSize)
// come from Button (large)
var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    MenuItem_backgroundColor_active: baseTheme.color_gray_40,
    MenuItem_backgroundColor_focus: baseTheme.color_gray_20,
    MenuItem_backgroundColor_hover: baseTheme.color_gray_20,
    MenuItem_color_text: baseTheme.color_text,
    MenuItem_fontWeight: baseTheme.fontWeight_regular,
    MenuItem_paddingHorizontal: baseTheme.space_inset_md,
    MenuItem_paddingVertical: baseTheme.space_inset_sm,

    MenuItemContent_fontSize: baseTheme.fontSize_ui,

    MenuItemIcon_fill: baseTheme.color_theme_60,
    MenuItemIcon_margin: baseTheme.space_inset_sm,

    MenuItemSecondaryText_color_text: baseTheme.color_caption,
    MenuItemSecondaryText_fontSize: Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* pxToEm */])(12)

  }, baseTheme);
};

// These styles are based off of Button, with significant changes
var styles = {
  content: function content(props) {
    var theme = componentTheme(props.theme);

    var fontSize = theme.MenuItemContent_fontSize;
    var paddingBottom = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* pxToEm */])(4), fontSize);
    var paddingTop = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* pxToEm */])(3), fontSize);

    return {
      display: 'flex',
      flex: '1 1 auto',
      flexWrap: 'wrap',
      fontSize: fontSize,
      justifyContent: 'space-between',
      padding: paddingTop + ' 0 ' + paddingBottom,
      whiteSpace: 'normal',
      wordBreak: 'break-all'
    };
  },
  inner: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  menuItem: function menuItem(props) {
    var disabled = props.disabled,
        isHighlighted = props.isHighlighted,
        variant = props.variant;

    var theme = componentTheme(props.theme);

    if (variant !== 'regular') {
      // prettier-ignore
      theme = _extends({}, theme, {
        MenuItem_backgroundColor_active: theme['backgroundColor_' + variant + '_activeMuted'],
        MenuItem_color_text: theme['color_text_' + variant]
      });
    }

    return {
      backgroundColor: isHighlighted && theme.MenuItem_backgroundColor_hover,
      color: disabled ? theme.color_text_disabled : theme.MenuItem_color_text,
      cursor: disabled ? 'default' : 'pointer',
      fontWeight: theme.MenuItem_fontWeight,
      padding: theme.MenuItem_paddingVertical + ' ' + theme.MenuItem_paddingHorizontal,

      '&:focus': {
        backgroundColor: !disabled && theme.MenuItem_backgroundColor_focus,
        outline: 0
      },

      '&:hover': {
        backgroundColor: !disabled && theme.MenuItem_backgroundColor_hover
      },

      '&:active': {
        backgroundColor: !disabled && theme.MenuItem_backgroundColor_active
      },

      '& [role="icon"]': {
        boxSizing: 'content-box',
        display: 'block',
        fill: disabled || variant !== 'regular' ? 'currentColor' : theme.MenuItemIcon_fill,
        flex: '0 0 auto',

        '&:first-child': {
          marginLeft: theme.direction === 'rtl' ? theme.MenuItemIcon_margin : null,
          marginRight: theme.direction === 'ltr' ? theme.MenuItemIcon_margin : null
        },

        '&:last-child': {
          marginLeft: theme.direction === 'ltr' ? theme.MenuItemIcon_margin : null,
          marginRight: theme.direction === 'rtl' ? theme.MenuItemIcon_margin : null
        }
      }
    };
  },
  secondaryText: function secondaryText(props) {
    var theme = componentTheme(props.theme);

    return {
      color: theme.MenuItemSecondaryText_color_text,
      fontSize: theme.MenuItemSecondaryText_fontSize,
      // The regular text fontSize is larger than that of the secondary text.
      // This magic number (optically) re-aligns both sets of text vertically.
      paddingTop: Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* pxToEm */])(3), theme.MenuItemSecondaryText_fontSize),
      wordBreak: 'break-word'
    };
  },
  text: function text(props) {
    var theme = componentTheme(props.theme);

    var margin = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getNormalizedValue */])(theme.space_inline_sm, theme.MenuItemContent_fontSize);

    return {
      marginLeft: theme.direction === 'rtl' && margin,
      marginRight: theme.direction === 'ltr' && margin,
      wordBreak: 'break-word'
    };
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('div', styles.menuItem, {
  displayName: 'MenuItem'
});

var CustomRoot = Object(__WEBPACK_IMPORTED_MODULE_1_glamorous__["c" /* withTheme */])(function (_ref) {
  var item = _ref.item,
      itemProps = _ref.itemProps,
      render = _ref.render,
      baseTheme = _ref.theme;

  var theme = componentTheme(baseTheme);
  return render(item, itemProps, theme);
});

var Content = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('span', styles.content);
var Inner = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('span', styles.inner);
var SecondaryText = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('span', styles.secondaryText);
var Text = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('span', styles.text);

var onKeyDown = function onKeyDown(onClick, event) {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    onClick && onClick(event);
  }
};

var variantIcons = {
  danger: _jsx(__WEBPACK_IMPORTED_MODULE_3__Icon_custom_IconDanger__["a" /* default */], {
    size: Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* pxToEm */])(24)
  }),
  success: _jsx(__WEBPACK_IMPORTED_MODULE_4__Icon_custom_IconSuccess__["a" /* default */], {
    size: Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* pxToEm */])(24)
  }),
  warning: _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_custom_IconWarning__["a" /* default */], {
    size: Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* pxToEm */])(24)
  })
};

var defaultRender = function defaultRender(_ref2) {
  var children = _ref2.children,
      disabled = _ref2.disabled,
      iconEnd = _ref2.iconEnd,
      iconStart = _ref2.iconStart,
      onClick = _ref2.onClick,
      secondaryText = _ref2.secondaryText,
      variant = _ref2.variant,
      tabIndex = _ref2.tabIndex,
      restProps = _objectWithoutProperties(_ref2, ['children', 'disabled', 'iconEnd', 'iconStart', 'onClick', 'secondaryText', 'variant', 'tabIndex']);

  var rootProps = _extends({
    disabled: disabled,
    onClick: disabled ? undefined : onClick,
    onKeyDown: onClick ? onKeyDown.bind(null, onClick) : undefined,
    tabIndex: disabled ? '-1' : tabIndex,
    variant: variant
  }, restProps);

  var startIcon = variant !== undefined && variant !== 'regular' && variantIcons[variant];
  if (iconStart) {
    startIcon = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(iconStart, { size: Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* pxToEm */])(24) });
  }

  var endIcon = iconEnd && Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(iconEnd, { size: Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* pxToEm */])(24) });

  // This structure is based on Button
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    _jsx(Inner, {}, void 0, startIcon, (children || secondaryText) && _jsx(Content, {}, void 0, _jsx(Text, {}, void 0, children), SecondaryText && _jsx(SecondaryText, {}, void 0, secondaryText)), endIcon)
  );
};

var customRender = function customRender(_ref3) {
  var render = _ref3.render,
      item = _ref3.item,
      restProps = _objectWithoutProperties(_ref3, ['render', 'item']);

  var customRootProps = {
    item: item,
    itemProps: _extends({
      onKeyDown: item && item.onClick ? onKeyDown.bind(null, item.onClick) : undefined,
      tabIndex: item && item.disabled && '-1'
    }, restProps),
    render: render
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomRoot, customRootProps);
};

/**
 * A MenuItem represents an option in a [Menu](../menu).
 * They can be used to trigger actions or navigate to a new location.
 * MenuItems provide context through optional variants, secondary text, or [Icons](../icon).
 *
 * A custom rendering hook is exposed to enable any extra functionality your app requires.
 */
function MenuItem(_ref4) {
  var _ref4$tabIndex = _ref4.tabIndex,
      tabIndex = _ref4$tabIndex === undefined ? 0 : _ref4$tabIndex,
      _ref4$variant = _ref4.variant,
      variant = _ref4$variant === undefined ? 'regular' : _ref4$variant,
      restProps = _objectWithoutProperties(_ref4, ['tabIndex', 'variant']);

  var rootProps = _extends({
    tabIndex: tabIndex,
    variant: variant
  }, restProps);

  if (rootProps.render) {
    return customRender(rootProps);
  } else {
    return defaultRender(rootProps);
  }
}

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMenu;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z'
}));

/* eslint-disable prettier/prettier */
function IconMenu(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMenu.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRefresh;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17.65 6.35A7.958 7.958 0 0 0 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z'
}));

/* eslint-disable prettier/prettier */
function IconRefresh(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRefresh.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalPlay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z'
}));

/* eslint-disable prettier/prettier */
function IconLocalPlay(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalPlay.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalOffer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z'
}));

/* eslint-disable prettier/prettier */
function IconLocalOffer(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalOffer.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalLaundryService;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9.17 16.83a4.008 4.008 0 0 0 5.66 0 4.008 4.008 0 0 0 0-5.66l-5.66 5.66zM18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM10 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z'
}));

/* eslint-disable prettier/prettier */
function IconLocalLaundryService(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalLaundryService.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconStoreMallDirectory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z'
}));

/* eslint-disable prettier/prettier */
function IconStoreMallDirectory(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconStoreMallDirectory.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconStreetview;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z'
}), _jsx('circle', {
  cx: '18',
  cy: '6',
  r: '5'
}), _jsx('path', {
  d: 'M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82A6.435 6.435 0 0 1 11.5 6z'
}));

/* eslint-disable prettier/prettier */
function IconStreetview(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconStreetview.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Sample;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('span', function (_ref) {
  var theme = _ref.theme;
  return {
    backgroundColor: theme.Sample_backgroundColor || 'lavender',
    color: theme.Sample_color || theme.color_text,
    display: 'inline-block',
    outline: '1px solid ' + theme.borderColor,
    padding: theme.space_inset_sm
  };
});

function Sample(_ref2) {
  var className = _ref2.className,
      _ref2$text = _ref2.text,
      text = _ref2$text === undefined ? 'Sample' : _ref2$text;

  return _jsx(Root, {
    className: className
  }, void 0, text);
}
Sample.propTypes = {
  className: __webpack_require__(0).string,
  text: __webpack_require__(0).string
};

/***/ }),
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// Components are built on an 8px grid
var fontSize_base = 16;

/* harmony default export */ __webpack_exports__["a"] = (fontSize_base);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pxToEm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes_fontSizeBase__ = __webpack_require__(261);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
  * Helper to convert a px value to ems, relative to the base font size
  */


function pxToEm(value) {
  return value / __WEBPACK_IMPORTED_MODULE_0__themes_fontSizeBase__["a" /* default */] + 'em';
}

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ThemeProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_glamorous__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes_mineralTheme__ = __webpack_require__(264);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/**
 * ThemeProvider passes along a theme to its children.
 */
function ThemeProvider(_ref) {
  var children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === undefined ? __WEBPACK_IMPORTED_MODULE_2__themes_mineralTheme__["a" /* default */] : _ref$theme;

  return _jsx(__WEBPACK_IMPORTED_MODULE_1_glamorous__["a" /* ThemeProvider */], {
    theme: theme
  }, void 0, children);
}
ThemeProvider.propTypes = {
  children: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node) : __webpack_require__(0).any,
  theme: __webpack_require__(0).object
};

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blueTheme__ = __webpack_require__(265);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__blueTheme__["a"]; });
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createColorRamp__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styleVariables__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var grays = Object(__WEBPACK_IMPORTED_MODULE_1__createColorRamp__["a" /* default */])('gray', 'gray', __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */]);
var primaries = Object(__WEBPACK_IMPORTED_MODULE_1__createColorRamp__["a" /* default */])('blue', 'theme', __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (_extends({}, __WEBPACK_IMPORTED_MODULE_2__styleVariables__["a" /* default */], primaries, grays, {

  color_black: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].black,
  color_white: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,

  backgroundColor_disabled: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_20,
  backgroundColor_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  backgroundColor_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  backgroundColor_danger_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_30,
  backgroundColor_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  backgroundColor_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_50,
  backgroundColor_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  backgroundColor_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  backgroundColor_success_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_30,
  backgroundColor_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  backgroundColor_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_70,
  backgroundColor_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  backgroundColor_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  backgroundColor_warning_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_30,
  backgroundColor_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  backgroundColor_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_50,

  backgroundColor_input_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_10,
  backgroundColor_input_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_10,
  backgroundColor_input_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_10,

  backgroundColor_link_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_30,

  borderColor: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_40,
  borderColor_active: primaries.color_theme_50,
  borderColor_focus: primaries.color_theme_80,
  borderColor_hover: primaries.color_theme_60,
  borderColor_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_80,
  borderColor_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_100,
  borderColor_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  borderColor_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  borderColor_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  borderColor_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_100,
  borderColor_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  borderColor_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_60,
  borderColor_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_70,
  borderColor_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_100,
  borderColor_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  borderColor_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_60,

  color_caption: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_80,

  color_placeholder: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_60,

  color_text: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_100,
  color_text_disabled: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_50,
  color_text_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  color_text_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  color_text_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  color_text_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_50,
  color_text_ondanger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_primary: primaries.color_theme_60,
  color_text_primary_active: primaries.color_theme_70,
  color_text_primary_focus: primaries.color_theme_60,
  color_text_primary_hover: primaries.color_theme_50,
  color_text_onprimary: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  color_text_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_100,
  color_text_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  color_text_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  color_text_onsuccess: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  color_text_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_80,
  color_text_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  color_text_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  color_text_onwarning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white
}));

/***/ }),
/* 266 */,
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ComponentDoc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Heading__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DocBestPractices__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DocExamples__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DocHeader__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DocProps__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DocThemeVariables__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DocWhenHowToUse__ = __webpack_require__(1520);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */












var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', function (_ref) {
  var theme = _ref.theme;
  return {
    fontFamily: theme.fontFamily_system
  };
}, {
  includeStyleReset: true
});

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_3__Heading__["a" /* default */], {
  level: 2,
  id: 'usage'
}, void 0, 'Usage');

function ComponentDoc(_ref2) {
  var bestPractices = _ref2.bestPractices,
      className = _ref2.className,
      doc = _ref2.doc,
      examples = _ref2.examples,
      hidePropDoc = _ref2.hidePropDoc,
      componentTheme = _ref2.componentTheme,
      title = _ref2.title,
      whenHowToUse = _ref2.whenHowToUse;
  var propDoc = doc.props;

  var headerProps = {
    bestPractices: bestPractices,
    componentTheme: componentTheme,
    examples: examples,
    props: !!(propDoc || componentTheme),
    title: title,
    whenHowToUse: whenHowToUse
  };
  var propProps = { propDoc: propDoc, title: title };
  var themeVariablesProps = {
    baseTheme: __WEBPACK_IMPORTED_MODULE_2__themes__["g" /* mineralTheme */],
    componentTheme: componentTheme,
    title: title
  };

  return _jsx(Root, {
    className: className
  }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__DocHeader__["a" /* default */],
    headerProps,
    doc.description
  ), examples && _jsx(__WEBPACK_IMPORTED_MODULE_5__DocExamples__["a" /* default */], {
    examples: examples
  }), !hidePropDoc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DocProps__["a" /* default */], propProps), componentTheme && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__DocThemeVariables__["a" /* default */], themeVariablesProps), (whenHowToUse || bestPractices) && _ref3, whenHowToUse && _jsx(__WEBPACK_IMPORTED_MODULE_9__DocWhenHowToUse__["a" /* default */], {
    content: whenHowToUse
  }), bestPractices && _jsx(__WEBPACK_IMPORTED_MODULE_4__DocBestPractices__["a" /* default */], {
    practices: bestPractices
  }));
}
ComponentDoc.propTypes = {
  bestPractices: __webpack_require__(0).arrayOf(__webpack_require__(0).shape({
    type: __webpack_require__(0).string.isRequired,
    title: __webpack_require__(0).string.isRequired,
    example: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node).isRequired : __webpack_require__(0).any.isRequired,
    description: __webpack_require__(0).string.isRequired
  })),
  className: __webpack_require__(0).string,
  componentTheme: __webpack_require__(0).oneOfType([typeof Theme === 'function' ? __webpack_require__(0).instanceOf(Theme) : __webpack_require__(0).any, __webpack_require__(0).arrayOf(typeof Theme === 'function' ? __webpack_require__(0).instanceOf(Theme) : __webpack_require__(0).any)]),
  description: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node) : __webpack_require__(0).any,
  doc: __webpack_require__(0).object.isRequired,
  examples: __webpack_require__(0).arrayOf(__webpack_require__(0).any),
  hidePropDoc: __webpack_require__(0).bool,
  title: __webpack_require__(0).string.isRequired,
  whenHowToUse: __webpack_require__(0).string
};

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = Link;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    Link_borderColor_focus: baseTheme.borderColor_focus,
    Link_color: baseTheme.color_text_primary,
    Link_color_active: baseTheme.color_text_primary_active,
    Link_color_hover: baseTheme.color_text_primary_hover,
    Link_color_focus: baseTheme.color_text_primary_focus

  }, baseTheme);
};

var linkStyles = function linkStyles(_ref) {
  var variant = _ref.variant,
      baseTheme = _ref.theme;

  var theme = componentTheme(baseTheme);

  if (variant !== 'regular') {
    // prettier-ignore
    theme = _extends({}, theme, {
      Link_borderColor_focus: baseTheme['borderColor_' + variant + '_focus'],
      Link_color: baseTheme['color_text_' + variant],
      Link_color_hover: baseTheme['color_text_' + variant + '_hover'],
      Link_color_focus: baseTheme['color_text_' + variant + '_focus'],
      Link_color_active: baseTheme['color_text_' + variant + '_active']
    });
  }

  return {
    color: theme.Link_color,
    textDecoration: 'none',

    '&:hover': {
      color: theme.Link_color_hover,
      textDecoration: 'underline'
    },
    '&:focus': {
      color: theme.Link_color_focus,
      outline: '1px solid ' + theme.Link_borderColor_focus,
      outlineOffset: '2px'
    },
    // `:active` must be last, to follow LVHFA order:
    // https://developer.mozilla.org/en-US/docs/Web/CSS/:active
    '&:active': {
      color: theme.Link_color_active
    }
  };
};

/**
 * The Link component creates a hyperlink to external pages, files, anchors on the same page or another URL.
 * Links trigger an action, select an option, or provide a gateway to more information.
 * Links are used to reduce clutter on a page when there are potentially many actions available.
 *
 * Links with clear messaging and an appropriate variant applied communicate intention effectively.
 */
function Link(_ref2) {
  var children = _ref2.children,
      _ref2$element = _ref2.element,
      element = _ref2$element === undefined ? 'a' : _ref2$element,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === undefined ? 'regular' : _ref2$variant,
      restProps = _objectWithoutProperties(_ref2, ['children', 'element', 'variant']);

  var rootProps = _extends({
    variant: variant
  }, restProps);
  var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(element, linkStyles, {
    displayName: 'Link',
    filterProps: ['variant']
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    children
  );
}

/***/ }),
/* 269 */,
/* 270 */,
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Paragraph;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    Paragraph_color: baseTheme.color_text,
    Paragraph_fontSize_mouse: baseTheme.fontSize_mouse,
    Paragraph_fontSize_prose: baseTheme.fontSize_prose,
    Paragraph_fontSize_ui: baseTheme.fontSize_ui,

    Paragraph_lineHeight_normal: baseTheme.lineHeight,
    Paragraph_lineHeight_prose: baseTheme.lineHeight_prose

  }, baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('p', function (_ref) {
  var variant = _ref.variant,
      baseTheme = _ref.theme;

  var theme = componentTheme(baseTheme);

  return {
    color: theme.Paragraph_color,
    fontSize: theme['Paragraph_fontSize_' + variant],
    lineHeight: variant === 'prose' ? theme.Paragraph_lineHeight_prose : theme.Paragraph_lineHeight_normal
  };
});

function Paragraph(_ref2) {
  var children = _ref2.children,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === undefined ? 'ui' : _ref2$variant,
      restProps = _objectWithoutProperties(_ref2, ['children', 'variant']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    _extends({ variant: variant }, restProps),
    children
  );
}

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ComponentDocExample;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Heading__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Link__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LiveProvider__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Markdown__ = __webpack_require__(36);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









var styles = {
  componentDocExample: function componentDocExample(_ref) {
    var theme = _ref.theme;
    return {
      paddingBottom: parseFloat(theme.space_stack_sm) * 8 + 'em',

      '& + &': {
        borderTop: '1px solid ' + theme.borderColor
      }
    };
  },
  description: function description(_ref2) {
    var theme = _ref2.theme;
    return {
      margin: '0 0 ' + theme.space_stack_xl
    };
  },
  title: function title(_ref3) {
    var theme = _ref3.theme;
    return {
      margin: '0 0 ' + Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getNormalizedValue */])(theme.space_stack_xl, theme.fontSize_h3),
      paddingTop: parseFloat(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getNormalizedValue */])(theme.space_stack_sm, theme.fontSize_h3)) * 8 + 'em'
    };
  },
  titleLink: function titleLink(_ref4) {
    var theme = _ref4.theme;
    return {
      color: theme.color_gray_80 // h2
    };
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', styles.componentDocExample);
var Description = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_6__Markdown__["a" /* default */], styles.description);
var Title = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_3__Heading__["a" /* default */], styles.title);
var TitleLink = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_4__Link__["a" /* default */], styles.titleLink);

function ComponentDocExample(_ref5) {
  var backgroundColor = _ref5.backgroundColor,
      description = _ref5.description,
      hideSource = _ref5.hideSource,
      id = _ref5.id,
      scope = _ref5.scope,
      source = _ref5.source,
      title = _ref5.title,
      restProps = _objectWithoutProperties(_ref5, ['backgroundColor', 'description', 'hideSource', 'id', 'scope', 'source', 'title']);

  var rootProps = _extends({}, restProps);
  var liveProviderProps = {
    backgroundColor: backgroundColor,
    hideSource: hideSource,
    scope: scope,
    source: source
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    _jsx(Title, {
      level: 3,
      id: id
    }, void 0, _jsx(TitleLink, {
      to: id
    }, void 0, title)),
    _jsx(Description, {
      scope: { Callout: __WEBPACK_IMPORTED_MODULE_2__Callout__["a" /* default */] }
    }, void 0, description || ''),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LiveProvider__["a" /* default */], liveProviderProps)
  );
}

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LiveProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dedent__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dedent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dedent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_live__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var styles = {
  livePreview: function livePreview(_ref) {
    var backgroundColor = _ref.backgroundColor,
        chromeless = _ref.chromeless,
        theme = _ref.theme;

    return chromeless ? { padding: '1rem' } : {
      backgroundColor: backgroundColor,
      border: '1px solid ' + theme.borderColor,
      padding: theme.space_inset_md
    };
  },
  liveEditor: function liveEditor(_ref2) {
    var theme = _ref2.theme;
    return {
      fontSize: theme.fontSize_ui,
      // Setting the maxHeight equal to, roughly, 20 lines,
      // then subtracting a bit to make it clear there's more beyond the scroll
      maxHeight: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* getNormalizedValue */])(parseFloat(theme.fontSize_ui) * theme.lineHeight * (20 - 0.5) + 'em', theme.fontSize_ui),
      overflow: 'auto'
    };
  },
  liveError: function liveError(_ref3) {
    var theme = _ref3.theme;
    return {
      backgroundColor: '#fce3e3', // color.red_10
      color: theme.color_text_danger,
      fontFamily: theme.fontFamily_monospace,
      fontSize: theme.fontSize_mouse,
      lineHeight: theme.lineHeight_prose,
      overflow: 'auto',
      padding: '0 0.5rem', // Match value of the live-editor from .prism-code
      whiteSpace: 'pre',

      '&:first-line': {
        fontFamily: theme.fontFamily,
        fontWeight: theme.fontWeight_semiBold,
        // Can't use margin/padding here, so this is to space off the heading
        // from the code
        lineHeight: 2 * theme.lineHeight_prose
      }
    };
  }
};

var MyLivePreview = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_2_react_live__["c" /* LivePreview */], styles.livePreview, {
  rootEl: 'div'
});
var MyLiveEditor = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_2_react_live__["a" /* LiveEditor */], styles.liveEditor);
var MyLiveError = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_2_react_live__["b" /* LiveError */], styles.liveError);

var _ref5 = _jsx(MyLiveEditor, {}, 0);

var _ref6 = _jsx(MyLiveError, {}, 1);

function LiveProvider(_ref4) {
  var backgroundColor = _ref4.backgroundColor,
      hideSource = _ref4.hideSource,
      chromeless = _ref4.chromeless,
      scope = _ref4.scope,
      source = _ref4.source;

  return _jsx(__WEBPACK_IMPORTED_MODULE_2_react_live__["d" /* LiveProvider */], {
    code: __WEBPACK_IMPORTED_MODULE_1_dedent___default()(source),
    scope: scope,
    mountStylesheet: false
  }, void 0, _jsx(MyLivePreview, {
    backgroundColor: backgroundColor,
    chromeless: chromeless
  }), !hideSource && [_ref5, _ref6]);
}
LiveProvider.propTypes = {
  backgroundColor: __webpack_require__(0).string,
  hideSource: __webpack_require__(0).bool,
  chromeless: __webpack_require__(0).bool,
  scope: __webpack_require__(0).object.isRequired,
  source: __webpack_require__(0).string.isRequired
};

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = Button;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    Button_backgroundColor: baseTheme.color_gray_20,
    Button_backgroundColor_active: baseTheme.color_gray_30,
    Button_backgroundColor_focus: baseTheme.color_gray_20,
    Button_backgroundColor_hover: baseTheme.color_gray_10,
    Button_backgroundColor_minimal_active: baseTheme.color_gray_20,
    Button_backgroundColor_minimal_hover: baseTheme.color_gray_10,
    Button_backgroundColor_primary: baseTheme.color_theme_60,
    Button_backgroundColor_primary_active: baseTheme.color_theme_70,
    Button_backgroundColor_primary_focus: baseTheme.color_theme_60,
    Button_backgroundColor_primary_hover: baseTheme.color_theme_50,
    Button_borderColor: baseTheme.borderColor,
    Button_borderColor_focus: baseTheme.color_white,
    Button_borderRadius: baseTheme.borderRadius_1,
    Button_borderWidth: 1, // px
    Button_boxShadow_focus: '0 0 0 1px ' + baseTheme.borderColor_focus,
    Button_color_text: baseTheme.color_gray_100,
    Button_color_text_minimal: baseTheme.color_text_primary,
    Button_color_text_primary: baseTheme.color_text_onprimary,
    Button_fontWeight: baseTheme.fontWeight_semiBold,
    Button_paddingHorizontal: baseTheme.space_inset_sm,
    Button_paddingIconOnly_small: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* pxToEm */])(3),
    Button_paddingIconOnly_medium: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* pxToEm */])(7),
    Button_paddingIconOnly_large: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* pxToEm */])(7),
    Button_paddingIconOnly_jumbo: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* pxToEm */])(13),
    Button_height_small: baseTheme.size_small,
    Button_height_medium: baseTheme.size_medium,
    Button_height_large: baseTheme.size_large,
    Button_height_jumbo: baseTheme.size_jumbo,

    ButtonContent_fontSize: baseTheme.fontSize_ui,
    ButtonContent_fontSize_small: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* pxToEm */])(12),

    ButtonIcon_margin: baseTheme.space_inset_sm

  }, baseTheme);
};

var styles = {
  button: function button(props) {
    var theme = componentTheme(props.theme);
    var circular = props.circular,
        disabled = props.disabled,
        fullWidth = props.fullWidth,
        minimal = props.minimal,
        primary = props.primary,
        size = props.size,
        text = props.text,
        variant = props.variant;


    if (variant !== 'regular') {
      // prettier-ignore
      theme = _extends({}, theme, {
        Button_backgroundColor_primary: theme['backgroundColor_' + variant],
        Button_backgroundColor_primary_active: theme['backgroundColor_' + variant + '_active'],
        Button_backgroundColor_primary_focus: theme['backgroundColor_' + variant + '_focus'],
        Button_backgroundColor_primary_hover: theme['backgroundColor_' + variant + '_hover'],
        Button_boxShadow_focus: '0 0 0 1px ' + theme['borderColor_' + variant + '_focus'],
        Button_color_text: theme['color_text_' + variant],
        Button_color_text_minimal: theme['color_text_' + variant],
        Button_color_text_primary: theme['color_text_on' + variant]
      });
    }

    return {
      backgroundColor: function () {
        if (disabled && !minimal) {
          return theme.color_gray_30;
        } else if (primary) {
          return theme.Button_backgroundColor_primary;
        } else if (minimal) {
          return 'transparent';
        } else {
          return theme.Button_backgroundColor;
        }
      }(),
      borderColor: disabled || primary || minimal ? 'transparent' : theme.Button_borderColor,
      borderRadius: circular ? parseFloat(theme['Button_height_' + size]) / 2 + 'em' : theme.Button_borderRadius,
      borderStyle: 'solid',
      borderWidth: theme.Button_borderWidth + 'px',
      color: function () {
        if (disabled) {
          return theme.color_text_disabled;
        } else if (primary) {
          return theme.Button_color_text_primary;
        } else if (minimal) {
          return theme.Button_color_text_minimal;
        } else {
          return theme.Button_color_text;
        }
      }(),
      cursor: disabled ? 'default' : 'pointer',
      fontWeight: theme.Button_fontWeight,
      height: theme['Button_height_' + size],
      // if the user puts in a small icon in a large button
      // we want to force the button to be round/square
      // (really just pertinent on icon-only buttons)
      minWidth: theme['Button_height_' + size],
      padding: text === undefined ? theme['Button_paddingIconOnly_' + size] : '0 ' + theme.Button_paddingHorizontal,
      verticalAlign: 'middle',
      width: fullWidth && '100%',
      '&:focus': {
        backgroundColor: function () {
          if (primary) {
            return theme.Button_backgroundColor_primary_focus;
          } else if (minimal) {
            return theme.Button_backgroundColor_minimal_focus;
          } else {
            return theme.Button_backgroundColor_focus;
          }
        }(),
        borderColor: theme.Button_borderColor_focus,
        boxShadow: theme.Button_boxShadow_focus
      },
      '&:hover': {
        backgroundColor: function () {
          if (!disabled) {
            if (primary) {
              return theme.Button_backgroundColor_primary_hover;
            } else if (minimal) {
              return theme.Button_backgroundColor_minimal_hover;
            } else {
              return theme.Button_backgroundColor_hover;
            }
          }
        }()
      },
      // `:active` must be last, to follow LVHFA order:
      // https://developer.mozilla.org/en-US/docs/Web/CSS/:active
      '&:active': {
        backgroundColor: function () {
          if (!disabled) {
            if (primary) {
              return theme.Button_backgroundColor_primary_active;
            } else if (minimal) {
              return theme.Button_backgroundColor_minimal_active;
            } else {
              return theme.Button_backgroundColor_active;
            }
          }
        }()
      },
      '&::-moz-focus-inner': { border: 0 },

      '& [role="icon"]': {
        boxSizing: 'content-box',
        fill: disabled || primary || minimal || variant !== 'regular' ? 'currentColor' : theme.Button_backgroundColor_primary,
        display: 'block',

        '&:first-child': {
          marginLeft: theme.direction === 'rtl' ? theme.ButtonIcon_margin : null,
          marginRight: theme.direction === 'ltr' ? theme.ButtonIcon_margin : null
        },

        '&:last-child': {
          marginLeft: theme.direction === 'ltr' ? theme.ButtonIcon_margin : null,
          marginRight: theme.direction === 'rtl' ? theme.ButtonIcon_margin : null
        },

        '&:only-child': {
          margin: 0
        }
      }
    };
  },
  content: function content(props) {
    var theme = componentTheme(props.theme);
    var size = props.size;


    var paddings = void 0;

    var fontSize = size === 'small' ? theme.ButtonContent_fontSize_small : theme.ButtonContent_fontSize;

    if (size === undefined || size === 'large' || size === 'jumbo') {
      var padding = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getNormalizedValue */])(theme.Button_paddingHorizontal, fontSize);
      paddings = {
        '&:first-child': {
          paddingLeft: theme.direction === 'ltr' ? padding : null,
          paddingRight: theme.direction === 'rtl' ? padding : null
        },

        '&:last-child': {
          paddingLeft: theme.direction === 'rtl' ? padding : null,
          paddingRight: theme.direction === 'ltr' ? padding : null
        }
      };
    }

    return _extends({
      display: 'inline-block',
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      wordWrap: 'normal'
    }, {

      display: 'block',
      fontSize: fontSize,
      lineHeight: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getNormalizedValue */])(theme['Button_height_' + size], fontSize)
    }, paddings);
  },
  inner: {
    alignItems: 'center',
    display: 'inline-flex',
    justifyContent: 'center',
    maxHeight: '100%',
    width: '100%'
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('button', styles.button, {
  includeStyleReset: true,
  rootEl: 'button'
});
var Content = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('span', styles.content);
var Inner = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('span', styles.inner);

/**
 * The Button component represents a clickable button.
 * Buttons draw attention to actions that can be performed in your app.
 * Buttons are used to trigger any sort of event.
 *
 * Buttons with clear messaging and an appropriate variant applied communicate intention effectively.
 */
function Button(_ref) {
  var children = _ref.children,
      iconStart = _ref.iconStart,
      iconEnd = _ref.iconEnd,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 'large' : _ref$size,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'button' : _ref$type,
      _ref$variant = _ref.variant,
      variant = _ref$variant === undefined ? 'regular' : _ref$variant,
      restProps = _objectWithoutProperties(_ref, ['children', 'iconStart', 'iconEnd', 'size', 'type', 'variant']);

  var rootProps = _extends({ size: size, text: children, type: type, variant: variant }, restProps);

  var iconSize = {
    small: 'medium',
    medium: 'medium',
    large: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* pxToEm */])(24),
    jumbo: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* pxToEm */])(24)
  };
  var startIcon = iconStart ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(iconStart, { size: iconSize[size] }) : null;
  var endIcon = iconEnd ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(iconEnd, { size: iconSize[size] }) : null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    _jsx(Inner, {}, void 0, startIcon, children && _jsx(Content, {
      size: size
    }, void 0, children), endIcon)
  );
}

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = CardBlock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card__ = __webpack_require__(100);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    CardBlock_fontSize: baseTheme.fontSize_prose,
    CardBlock_lineHeight: baseTheme.lineHeight_prose

  }, baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', function (props) {
  var theme = _extends({}, componentTheme(props.theme), Object(__WEBPACK_IMPORTED_MODULE_2__Card__["a" /* componentTheme */])(props.theme));

  // prettier-ignore
  return {
    fontSize: theme.CardBlock_fontSize,
    lineHeight: theme.CardBlock_lineHeight,
    marginBottom: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getNormalizedValue */])(theme.CardRow_margin, theme.CardBlock_fontSize),
    marginTop: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getNormalizedValue */])(theme.CardRow_margin, theme.CardBlock_fontSize),
    paddingLeft: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getNormalizedValue */])(theme.CardRow_padding, theme.CardBlock_fontSize),
    paddingRight: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getNormalizedValue */])(theme.CardRow_padding, theme.CardBlock_fontSize)
  };
}, {
  displayName: 'CardBlock'
});

/**
 * CardBlock is used to normalize font sizes for content and to provide consistent margins and padding.
 */
function CardBlock(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Root, props);
}

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = CardTitle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card__ = __webpack_require__(100);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    CardTitle_fontSize: baseTheme.fontSize_h3,
    CardTitle_fontSize_minor: baseTheme.fontSize_h4,
    CardTitle_fontWeight: baseTheme.fontWeight_semiBold,
    CardTitle_fontWeight_minor: baseTheme.fontWeight_bold,
    CardTitle_marginTop: baseTheme.space_stack_sm,

    CardSubtitle_color: baseTheme.color_gray_80,
    CardSubtitle_fontSize: baseTheme.fontSize_h5,
    CardSubtitle_fontWeight: baseTheme.fontWeight_semiBold,
    CardSubtitle_marginTop: baseTheme.space_stack_sm

  }, baseTheme);
};

var styles = {
  root: function root(props) {
    var theme = _extends({}, componentTheme(props.theme), Object(__WEBPACK_IMPORTED_MODULE_2__Card__["a" /* componentTheme */])(props.theme));

    return {
      marginBottom: theme.CardRow_margin,
      marginTop: theme.CardRow_margin,
      paddingLeft: theme.CardRow_padding,
      paddingRight: theme.CardRow_padding,
      paddingTop: !props.minor && theme.CardTitle_marginTop
    };
  },
  meta: function meta(props) {
    var theme = componentTheme(props.theme);

    return {
      margin: '0 0 ' + Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getNormalizedValue */])(theme.CardSubtitle_marginTop, theme.CardSubtitle_fontSize)
    };
  },
  subtitle: function subtitle(props) {
    var theme = componentTheme(props.theme);

    return {
      color: theme.CardSubtitle_color,
      fontSize: theme.CardSubtitle_fontSize,
      fontWeight: theme.CardSubtitle_fontWeight,
      margin: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getNormalizedValue */])(theme.CardSubtitle_marginTop, theme.CardSubtitle_fontSize) + ' 0 0'
    };
  },
  title: function title(props) {
    var theme = componentTheme(props.theme);

    return {
      fontSize: props.minor ? theme.CardTitle_fontSize_minor : theme.CardTitle_fontSize,
      fontWeight: props.minor ? theme.CardTitle_fontWeight_minor : theme.CardTitle_fontWeight,
      margin: 0
    };
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', styles.root, {
  displayName: 'CardTitle'
});
var Subtitle = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('h4', styles.subtitle);
// CategoryTitle styles Subtitle, so it must break alphabetical order
var Meta = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(Subtitle, styles.meta);
var Title = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('h3', styles.title);

/**
 * CardTitle displays a Card title and an optional subtitle.
 * You can put CardTitle in any order in relation to other root components of [Card]('./card').
 */
function CardTitle(_ref) {
  var children = _ref.children,
      meta = _ref.meta,
      minor = _ref.minor,
      subtitle = _ref.subtitle,
      restProps = _objectWithoutProperties(_ref, ['children', 'meta', 'minor', 'subtitle']);

  var rootProps = _extends({
    minor: minor
  }, restProps);
  var isMinor = minor || Boolean(meta);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    meta && _jsx(Meta, {}, void 0, meta),
    _jsx(Title, {
      minor: isMinor
    }, void 0, children),
    subtitle && _jsx(Subtitle, {}, void 0, subtitle)
  );
}

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PopoverArrow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_popper__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_popper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PopoverContent__ = __webpack_require__(123);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var Root = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_1_react_popper__["Arrow"], function (_ref) {
  var placement = _ref.placement,
      size = _ref.size,
      baseTheme = _ref.theme;

  var theme = Object(__WEBPACK_IMPORTED_MODULE_3__PopoverContent__["a" /* componentTheme */])(baseTheme);
  var arrowShadow = ', 0 3px 1px rgba(0, 0, 0, 0.3)';
  var directionalStyles = void 0;
  var offset = '-' + (parseFloat(size) - 2) + 'px';
  var rotation = 0;

  switch (true) {
    case placement && placement.startsWith('top'):
      // Magic numbers to optically match theme.boxShadow_2
      arrowShadow = ', 0 4px 2px rgba(0, 0, 0, 0.3)';
      directionalStyles = {
        bottom: offset,
        left: 'calc(50% - ' + size + ')',
        marginBottom: 0,
        marginTop: 0
      };
      break;
    case placement && placement.startsWith('bottom'):
      arrowShadow = '';
      directionalStyles = {
        top: offset,
        left: 'calc(50% - ' + size + ')',
        marginBottom: 0,
        marginTop: 0
      };
      rotation = 180;
      break;
    case placement && placement.startsWith('left'):
      offset = '-' + (parseFloat(size) - 3) + 'px';
      directionalStyles = {
        right: offset,
        top: 'calc(50% - ' + size + ')',
        marginLeft: 0,
        marginRight: 0
      };
      rotation = -90;
      break;
    case placement && placement.startsWith('right'):
      offset = '-' + (parseFloat(size) - 3) + 'px';
      directionalStyles = {
        left: offset,
        top: 'calc(50% - ' + size + ')',
        marginLeft: 0,
        marginRight: 0
      };
      rotation = 90;
      break;
    default:
      directionalStyles = {
        display: 'none'
      };
  }

  return _extends({
    color: theme.PopoverContent_backgroundColor,
    display: 'inline-block',
    fontSize: size,
    margin: size,
    position: 'absolute',
    textShadow: '0 2px 0 ' + theme.PopoverContent_borderColor + arrowShadow,
    transform: 'rotate(' + rotation + 'deg) scaleX(2)'
  }, directionalStyles);
}, {
  displayName: 'PopoverArrow',
  rootEl: 'span'
});

/**
 * PopoverArrow component
 */
function PopoverArrow(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    _extends({}, props, { 'aria-hidden': true }),
    '\u25BC'
  );
}
PopoverArrow.propTypes = {
  size: __webpack_require__(0).string.isRequired,
  placement: __webpack_require__(0).oneOf(['auto', 'auto-end', 'auto-start', 'bottom', 'bottom-end', 'bottom-start', 'left', 'left-end', 'left-start', 'right', 'right-end', 'right-start', 'top', 'top-end', 'top-start'])
};

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = VariableTable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_colorable__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_colorable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_colorable__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', function (_ref) {
  var theme = _ref.theme;
  return {
    margin: theme.space_stack_xl + ' 0 0',
    overflowX: 'auto'
  };
});
var Name = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('span', function (_ref2) {
  var theme = _ref2.theme;
  return {
    fontWeight: theme.fontWeight_semiBold
  };
});
var Value = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('span', function (_ref3) {
  var color = _ref3.color,
      theme = _ref3.theme;

  if (color) {
    return {
      border: color === '#fff' ? '1px solid ' + theme.color_gray_50 : 'none',
      backgroundColor: color,
      borderRadius: theme.borderRadius_1,
      color: a11yColor(color),
      display: 'inline-block',
      fontFamily: theme.fontFamily_monospace,
      padding: parseFloat(theme.space_inset_sm) / 2 + 'em ' + theme.space_inset_sm
    };
  } else {
    return {
      fontFamily: theme.fontFamily_monospace
    };
  }
});

var a11yColor = function a11yColor(color) {
  var a11y = __WEBPACK_IMPORTED_MODULE_3_colorable___default()({
    main: color,
    white: '#fff',
    black: '#000',
    compact: true
  });

  var whiteContrast = a11y[0].combinations[0].contrast;
  var blackContrast = a11y[0].combinations[1].contrast;

  return whiteContrast > blackContrast ? 'white' : 'black';
};

var getTableRows = function getTableRows(theme, value, valueColor, baseTheme) {
  return Object.keys(theme).map(function (variable) {
    if (variable !== theme[variable]) {
      return _jsx(__WEBPACK_IMPORTED_MODULE_2__Table__["d" /* TableRow */], {}, variable, _jsx(__WEBPACK_IMPORTED_MODULE_2__Table__["b" /* TableCell */], {}, void 0, _jsx(Name, {}, void 0, variable)), _jsx(__WEBPACK_IMPORTED_MODULE_2__Table__["b" /* TableCell */], {}, void 0, _jsx(Value, {
        color: valueColor(theme, variable, baseTheme)
      }, void 0, value(theme, variable, baseTheme))));
    }
  });
};

var _ref5 = _jsx('thead', {}, void 0, _jsx('tr', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Table__["c" /* TableHeaderCell */], {
  scope: 'col'
}, void 0, 'Variable'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Table__["c" /* TableHeaderCell */], {
  scope: 'col'
}, void 0, 'Value')));

function VariableTable(_ref4) {
  var baseTheme = _ref4.baseTheme,
      theme = _ref4.theme,
      value = _ref4.value,
      valueColor = _ref4.valueColor;

  return _jsx(Root, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Table__["a" /* Table */], {}, void 0, _ref5, _jsx('tbody', {}, void 0, getTableRows(theme, value, valueColor, baseTheme))));
}
VariableTable.propTypes = {
  baseTheme: __webpack_require__(0).object,
  theme: __webpack_require__(0).object.isRequired,
  value: __webpack_require__(0).func.isRequired,
  valueColor: __webpack_require__(0).func.isRequired
};

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createKeyMap;
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function createKeyMap(arr, key) {
  return arr.reduce(function (acc, item) {
    acc[item[key]] = item;
    return acc;
  }, {});
}

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GettingStarted__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Theming__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Color__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Typography__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ComponentStatus__ = __webpack_require__(1558);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







var sections = [{
  heading: 'Guidelines',
  pages: [{
    component: __WEBPACK_IMPORTED_MODULE_0__GettingStarted__["a" /* default */],
    path: '/getting-started',
    title: 'Getting Started'
  }, {
    component: __WEBPACK_IMPORTED_MODULE_2__Color__["a" /* default */],
    path: '/color',
    title: 'Color'
  }, {
    component: __WEBPACK_IMPORTED_MODULE_3__Typography__["a" /* default */],
    path: '/typography',
    title: 'Typography'
  }, {
    component: __WEBPACK_IMPORTED_MODULE_1__Theming__["a" /* default */],
    path: '/theming',
    title: 'Theming'
  }]
}, {
  heading: 'What’s New',
  pages: [{
    component: __WEBPACK_IMPORTED_MODULE_4__ComponentStatus__["a" /* default */],
    path: '/component-status',
    title: 'Component Status'
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (sections);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ColorRampRow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_colorable__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_colorable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_colorable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_readableColor__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_readableColor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_polished_lib_color_readableColor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__themes__ = __webpack_require__(7);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







var styles = {
  row: function row(_ref) {
    var theme = _ref.theme,
        color = _ref.color;
    return {
      backgroundColor: color,
      display: 'flex',
      fontSize: theme.fontSize_mouse,
      justifyContent: 'space-between',
      padding: theme.space_inset_md,
      width: '100%'
    };
  },
  colorName: function colorName(_ref2) {
    var color = _ref2.color,
        theme = _ref2.theme;
    return {
      color: color,
      display: 'block',
      fontWeight: 'bold',
      marginBottom: theme.space_stack_sm
    };
  },
  hsl: function hsl(_ref3) {
    var color = _ref3.color;
    return {
      color: color,
      display: 'block',
      fontWeight: 100,
      whiteSpace: 'nowrap'
    };
  },
  whiteOnBackground: function whiteOnBackground(_ref4) {
    var theme = _ref4.theme;
    return {
      color: 'white',
      display: 'block',
      marginBottom: theme.space_stack_sm
    };
  },
  blackonBackground: { color: __WEBPACK_IMPORTED_MODULE_4__themes__["c" /* color */].black, display: 'block' },
  accessibilityInfo: {
    display: 'block',
    textAlign: 'right',
    whiteSpace: 'nowrap'
  }
};

var Row = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* createStyledComponent */])('div', styles.row);
var BlackOnBackground = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* createStyledComponent */])('span', styles.blackonBackground);
var WhiteOnBackground = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* createStyledComponent */])('span', styles.whiteOnBackground);
var ColorName = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* createStyledComponent */])('span', styles.colorName);
var AccessibilityInfo = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* createStyledComponent */])('div', styles.accessibilityInfo);
var HSL = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* createStyledComponent */])('span', styles.hsl);

function getBestAccessibility(access) {
  if (access.aaa) {
    return 'AAA';
  } else if (access.aa) {
    return 'AA';
  } else if (access.aaaLarge) {
    return 'AAA Large';
  } else if (access.aaLarge) {
    return 'AA Large';
  }

  // this character is a non-breaking space.
  return ' '; // should this be an explicit DNP?
}

function ColorRampRow(_ref5) {
  var name = _ref5.name;

  // the black here is the color from our theme.
  var main = __WEBPACK_IMPORTED_MODULE_4__themes__["c" /* color */][name];
  var readable = __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_readableColor___default()(main);
  var accessibility = __WEBPACK_IMPORTED_MODULE_1_colorable___default()({
    main: main,
    black: __WEBPACK_IMPORTED_MODULE_4__themes__["c" /* color */].black,
    white: '#fff'
  });

  var hsl = accessibility.find(function (result) {
    return result.name === 'main';
  }).values.hsl;
  var blackonBackground = accessibility.find(function (result) {
    return result.name === 'black';
  }).combinations.find(function (combo) {
    return combo.name === 'main';
  });
  var whiteOnBackground = accessibility.find(function (result) {
    return result.name === 'white';
  }).combinations.find(function (combo) {
    return combo.name === 'main';
  });

  return _jsx(Row, {
    color: main
  }, void 0, _jsx('div', {}, void 0, _jsx(ColorName, {
    color: readable
  }, void 0, name), _jsx(HSL, {
    color: readable
  }, void 0, 'hsl(' + hsl[0] + ', ' + hsl[1] + '%, ' + hsl[2] + '%)')), _jsx(AccessibilityInfo, {}, void 0, _jsx(WhiteOnBackground, {}, void 0, getBestAccessibility(whiteOnBackground.accessibility)), _jsx(BlackOnBackground, {}, void 0, getBestAccessibility(blackonBackground.accessibility))));
}
ColorRampRow.propTypes = {
  name: __webpack_require__(0).string.isRequired
};

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = MenuDivider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    MenuDivider_borderColor: baseTheme.borderColor,
    MenuDivider_borderWidth: '1px',
    MenuDivider_margin: baseTheme.space_stack_sm

  }, baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', function (props) {
  var theme = componentTheme(props.theme);

  return {
    backgroundColor: theme.MenuDivider_borderColor,
    height: theme.MenuDivider_borderWidth,
    margin: theme.MenuDivider_margin + ' 0'
  };
}, {
  displayName: 'MenuDivider'
});

/**
 * MenuDividers separate [MenuItems](../menu-item) and [MenuGroups](../menu-group) to establish hierarchy in a [Menu](../menu) with several options.
 *
 * MenuDividers are not merely design elements to visually separate options.
 * Rather, the are a way to logically group choices.
 * Too many dividers will add unnecessary weight to your Menu.
 */
function MenuDivider(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Root, _extends({}, props, { role: 'separator' }));
}

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = MenuGroup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuGroupTitle__ = __webpack_require__(179);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    MenuGroup_margin: baseTheme.space_stack_sm

  }, baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', function (props) {
  var theme = componentTheme(props.theme);

  return {
    margin: theme.MenuGroup_margin + ' 0',
    '&:first-child,& + &': {
      marginTop: 0
    },

    '&:last-child': {
      marginBottom: 0
    }
  };
}, {
  displayName: 'MenuGroup'
});

/**
 * MenuGroups assemble [MenuItems](../menu-items) and can display a title.
 * Grouping Menu options provides context clues to users about related actions.
 * An optional title can be added to reinforce the intent of the grouping.
 */
function MenuGroup(_ref) {
  var children = _ref.children,
      title = _ref.title,
      restProps = _objectWithoutProperties(_ref, ['children', 'title']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    restProps,
    title && _jsx(__WEBPACK_IMPORTED_MODULE_2__MenuGroupTitle__["b" /* default */], {}, void 0, title),
    children
  );
}

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = customRender;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




function customRender(item, props, theme) {
  var isHighlighted = props.isHighlighted,
      disabled = props.disabled,
      restProps = _objectWithoutProperties(props, ['isHighlighted', 'disabled']); // eslint-disable-line react/prop-types

  var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('a', {
    backgroundColor: isHighlighted && theme.color_theme_20,
    display: 'flex',
    padding: theme.MenuItem_paddingVertical + ' ' + theme.MenuItem_paddingHorizontal,
    textDecoration: 'none',

    '&:focus': {
      backgroundColor: !disabled && theme.color_theme_20,
      outline: 0
    },

    '&:hover': {
      backgroundColor: !disabled && theme.color_theme_20
    },

    '&:active': {
      backgroundColor: !disabled && theme.color_theme_40
    }
  }, {
    includeStyleReset: true
  });
  var Avatar = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('img', {
    borderRadius: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* pxToEm */])(16),
    display: 'block',
    flex: '0 0 auto',
    height: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* pxToEm */])(32),
    marginLeft: theme.direction === 'rtl' && theme.MenuItemIcon_margin,
    marginRight: theme.direction === 'ltr' && theme.MenuItemIcon_margin,
    width: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* pxToEm */])(32)
  });
  var Content = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('span', function () {
    var fontSize = theme.MenuItemContent_fontSize;
    var paddingVertical = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* pxToEm */])(7), fontSize);

    return {
      flex: '1 1 auto',
      fontSize: fontSize,
      padding: paddingVertical + ' 0',
      whiteSpace: 'normal',
      wordBreak: 'break-all'
    };
  });

  var rootProps = _extends({
    disabled: disabled,
    tabIndex: 0
  }, restProps);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    item.avatar && _jsx(Avatar, {
      alt: 'Photo of ' + item.text,
      src: item.avatar
    }),
    _jsx(Content, {}, void 0, item.text)
  );
}

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var Root = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('div', {
  position: 'relative'
});

var ScrollArea = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('div', function (_ref) {
  var height = _ref.height;
  return {
    backgroundColor: 'aliceblue',
    height: height + 'px',
    overflow: 'auto',
    position: 'relative'
  };
});

var ScrollContent = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('div', function (_ref2) {
  var scrollAreaHeight = _ref2.scrollAreaHeight;
  return {
    padding: parseInt(scrollAreaHeight) + 200 + 'px 200vw'
  };
});

var Recenter = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_3__Button__["a" /* default */], {
  left: 0,
  position: 'absolute',
  top: 0
});

var ScrollBox = function (_Component) {
  _inherits(ScrollBox, _Component);

  function ScrollBox() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, ScrollBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = ScrollBox.__proto__ || Object.getPrototypeOf(ScrollBox)).call.apply(_ref3, [this].concat(args))), _this), _this.scrollToCenter = function () {
      /* eslint-disable react/no-find-dom-node */
      var scrollArea = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this.scrollArea);
      var scrollTarget = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this.scrollTarget);
      if (scrollArea && scrollTarget && scrollArea instanceof HTMLElement && scrollTarget instanceof HTMLElement) {
        scrollArea.scrollTop = scrollTarget.offsetTop + scrollTarget.clientHeight / 2 - scrollArea.clientHeight / 2;
        scrollArea.scrollLeft = scrollTarget.offsetLeft + scrollTarget.clientWidth / 2 - scrollArea.clientWidth / 2;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ScrollBox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoCenter) {
        this.scrollToCenter();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          height = _props.height;

      var scrollTarget = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children), {
        ref: function ref(node) {
          _this2.scrollTarget = node;
        }
      });

      return _jsx(Root, {}, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        ScrollArea,
        {
          ref: function ref(node) {
            _this2.scrollArea = node;
          },
          height: height },
        _jsx(ScrollContent, {
          scrollAreaHeight: height
        }, void 0, scrollTarget)
      ), _jsx(Recenter, {
        onClick: this.scrollToCenter,
        minimal: true,
        size: 'small'
      }, void 0, 'Re-center'));
    }
  }]);

  return ScrollBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ScrollBox.propTypes = {
  children: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node).isRequired : __webpack_require__(0).any.isRequired,
  autoCenter: __webpack_require__(0).bool,
  height: __webpack_require__(0).number
};
ScrollBox.defaultProps = {
  autoCenter: true,
  height: 360
};
/* harmony default export */ __webpack_exports__["a"] = (ScrollBox);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Icon3DRotation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7.52 21.48A10.487 10.487 0 0 1 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08a1.07 1.07 0 0 1-.4-.24c-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72c.13-.29.2-.61.2-.97 0-.19-.02-.38-.07-.56a1.67 1.67 0 0 0-.23-.51c-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31a2.098 2.098 0 0 0 .89-.75c.1-.15.17-.3.22-.46.05-.16.07-.32.07-.48 0-.36-.06-.68-.18-.96a1.78 1.78 0 0 0-.51-.69c-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34c.11-.09.23-.17.38-.22.15-.05.3-.08.48-.08.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49a.87.87 0 0 1-.25.37c-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4.07.16.1.35.1.57 0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27.45-.18.84-.43 1.16-.76.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57-.18-.47-.43-.87-.75-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.44 4.84 18.29 0 12 0z'
}));

/* eslint-disable prettier/prettier */
function Icon3DRotation(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
Icon3DRotation.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAccessibility;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z'
}));

/* eslint-disable prettier/prettier */
function IconAccessibility(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAccessibility.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAccessible;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('circle', {
  cx: '12',
  cy: '4',
  r: '2'
}), _jsx('path', {
  d: 'M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-6.17 5c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1a5 5 0 1 0 5.9 5.9h-2.07z'
}));

/* eslint-disable prettier/prettier */
function IconAccessible(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAccessible.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAccountBalance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z'
}));

/* eslint-disable prettier/prettier */
function IconAccountBalance(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAccountBalance.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAccountBalanceWallet;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 18v1c0 1.1-.9 2-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14c1.1 0 2 .9 2 2v1h-9a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
}));

/* eslint-disable prettier/prettier */
function IconAccountBalanceWallet(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAccountBalanceWallet.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAccountBox;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 5v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5a2 2 0 0 0-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z'
}));

/* eslint-disable prettier/prettier */
function IconAccountBox(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAccountBox.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAccountCircle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2a7.2 7.2 0 0 1-6-3.22c.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08a7.2 7.2 0 0 1-6 3.22z'
}));

/* eslint-disable prettier/prettier */
function IconAccountCircle(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAccountCircle.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAddShoppingCart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-9.83-3.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z'
}));

/* eslint-disable prettier/prettier */
function IconAddShoppingCart(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAddShoppingCart.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAlarm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 0 0 0-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z'
}));

/* eslint-disable prettier/prettier */
function IconAlarm(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAlarm.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAlarmAdd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 0 0 0-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z'
}));

/* eslint-disable prettier/prettier */
function IconAlarmAdd(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAlarmAdd.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAlarmOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 6c3.87 0 7 3.13 7 7 0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92a9 9 0 0 0-9-9c-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6zm10-.28l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM2.92 2.29L1.65 3.57 2.98 4.9l-1.11.93 1.42 1.42 1.11-.94.8.8A8.964 8.964 0 0 0 3 13c0 4.97 4.02 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.2 2.2 1.27-1.27L3.89 3.27l-.97-.98zm13.55 16.1C15.26 19.39 13.7 20 12 20c-3.87 0-7-3.13-7-7 0-1.7.61-3.26 1.61-4.47l9.86 9.86zM8.02 3.28L6.6 1.86l-.86.71 1.42 1.42.86-.71z'
}));

/* eslint-disable prettier/prettier */
function IconAlarmOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAlarmOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAlarmOn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 0 0 0-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-1.46-5.47L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95z'
}));

/* eslint-disable prettier/prettier */
function IconAlarmOn(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAlarmOn.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAllOut;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16.21 4.16l4 4v-4zm4 12l-4 4h4zm-12 4l-4-4v4zm-4-12l4-4h-4zm12.95-.95c-2.73-2.73-7.17-2.73-9.9 0s-2.73 7.17 0 9.9 7.17 2.73 9.9 0 2.73-7.16 0-9.9zm-1.1 8.8c-2.13 2.13-5.57 2.13-7.7 0s-2.13-5.57 0-7.7 5.57-2.13 7.7 0 2.13 5.57 0 7.7z'
}));

/* eslint-disable prettier/prettier */
function IconAllOut(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAllOut.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAndroid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48A5.84 5.84 0 0 0 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31A5.983 5.983 0 0 0 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z'
}));

/* eslint-disable prettier/prettier */
function IconAndroid(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAndroid.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAnnouncement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z'
}));

/* eslint-disable prettier/prettier */
function IconAnnouncement(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAnnouncement.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAspectRatio;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z'
}));

/* eslint-disable prettier/prettier */
function IconAspectRatio(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAspectRatio.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAssessment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z'
}));

/* eslint-disable prettier/prettier */
function IconAssessment(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAssessment.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAssignmentInd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z'
}));

/* eslint-disable prettier/prettier */
function IconAssignmentInd(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAssignmentInd.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAssignmentLate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 15h-2v-2h2v2zm0-4h-2V8h2v6zm-1-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'
}));

/* eslint-disable prettier/prettier */
function IconAssignmentLate(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAssignmentLate.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAssignmentReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z'
}));

/* eslint-disable prettier/prettier */
function IconAssignmentReturn(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAssignmentReturn.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAssignmentReturned;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 15l-5-5h3V9h4v4h3l-5 5z'
}));

/* eslint-disable prettier/prettier */
function IconAssignmentReturned(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAssignmentReturned.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAssignmentTurnedIn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconAssignmentTurnedIn(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAssignmentTurnedIn.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAutorenew;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8A5.87 5.87 0 0 1 6 12c0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z'
}));

/* eslint-disable prettier/prettier */
function IconAutorenew(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAutorenew.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBackup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z'
}));

/* eslint-disable prettier/prettier */
function IconBackup(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBackup.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBook;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z'
}));

/* eslint-disable prettier/prettier */
function IconBook(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBook.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBookmark;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconBookmark(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBookmark.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBookmarkBorder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z'
}));

/* eslint-disable prettier/prettier */
function IconBookmarkBorder(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBookmarkBorder.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBugReport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 8h-2.81a5.985 5.985 0 0 0-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z'
}));

/* eslint-disable prettier/prettier */
function IconBugReport(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBugReport.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBuild;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z'
}));

/* eslint-disable prettier/prettier */
function IconBuild(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBuild.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCached;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 8l-4 4h3c0 3.31-2.69 6-6 6a5.87 5.87 0 0 1-2.8-.7l-1.46 1.46A7.93 7.93 0 0 0 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46A7.93 7.93 0 0 0 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z'
}));

/* eslint-disable prettier/prettier */
function IconCached(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCached.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCameraEnhance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 3L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3.17L15 3H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-1l1.25-2.75L16 13l-2.75-1.25L12 9l-1.25 2.75L8 13l2.75 1.25z'
}));

/* eslint-disable prettier/prettier */
function IconCameraEnhance(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCameraEnhance.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCardGiftcard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 0 0-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z'
}));

/* eslint-disable prettier/prettier */
function IconCardGiftcard(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCardGiftcard.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCardMembership;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z'
}));

/* eslint-disable prettier/prettier */
function IconCardMembership(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCardMembership.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCardTravel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z'
}));

/* eslint-disable prettier/prettier */
function IconCardTravel(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCardTravel.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconChangeHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z'
}));

/* eslint-disable prettier/prettier */
function IconChangeHistory(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconChangeHistory.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCheckCircle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'
}));

/* eslint-disable prettier/prettier */
function IconCheckCircle(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCheckCircle.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconChromeReaderMode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15h-9V6h9v13z'
}));

/* eslint-disable prettier/prettier */
function IconChromeReaderMode(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconChromeReaderMode.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z'
}));

/* eslint-disable prettier/prettier */
function IconClass(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconClass.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z'
}));

/* eslint-disable prettier/prettier */
function IconCode(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCode.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCompareArrows;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z'
}));

/* eslint-disable prettier/prettier */
function IconCompareArrows(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCompareArrows.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCopyright;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10.08 10.86c.05-.33.16-.62.3-.87s.34-.46.59-.62c.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29s-.4-.73-.7-1.01-.66-.5-1.08-.66-.88-.23-1.39-.23c-.65 0-1.22.11-1.7.34s-.88.53-1.2.92-.56.84-.71 1.36S8 11.29 8 11.87v.27c0 .58.08 1.12.23 1.64s.39.97.71 1.35.72.69 1.2.91 1.05.34 1.7.34c.47 0 .91-.08 1.32-.23s.77-.36 1.08-.63.56-.58.74-.94.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58s-.21.33-.36.46-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23-.25-.16-.45-.37-.59-.62s-.25-.55-.3-.88-.08-.67-.08-1v-.27c0-.35.03-.68.08-1.01zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconCopyright(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCopyright.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCreditCard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z'
}));

/* eslint-disable prettier/prettier */
function IconCreditCard(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCreditCard.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDashboard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z'
}));

/* eslint-disable prettier/prettier */
function IconDashboard(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDashboard.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDateRange;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z'
}));

/* eslint-disable prettier/prettier */
function IconDateRange(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDateRange.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDelete;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z'
}));

/* eslint-disable prettier/prettier */
function IconDelete(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDelete.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDeleteForever;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z'
}));

/* eslint-disable prettier/prettier */
function IconDeleteForever(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDeleteForever.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDescription;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z'
}));

/* eslint-disable prettier/prettier */
function IconDescription(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDescription.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDns;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'
}));

/* eslint-disable prettier/prettier */
function IconDns(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDns.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z'
}));

/* eslint-disable prettier/prettier */
function IconDone(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDone.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDoneAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z'
}));

/* eslint-disable prettier/prettier */
function IconDoneAll(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDoneAll.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDonutLarge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 5.08V2c-5 .5-9 4.81-9 10s4 9.5 9 10v-3.08c-3-.48-6-3.4-6-6.92s3-6.44 6-6.92zM18.97 11H22c-.47-5-4-8.53-9-9v3.08C16 5.51 18.54 8 18.97 11zM13 18.92V22c5-.47 8.53-4 9-9h-3.03c-.43 3-2.97 5.49-5.97 5.92z'
}));

/* eslint-disable prettier/prettier */
function IconDonutLarge(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDonutLarge.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDonutSmall;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 9.16V2c-5 .5-9 4.79-9 10s4 9.5 9 10v-7.16c-1-.41-2-1.52-2-2.84s1-2.43 2-2.84zM14.86 11H22c-.48-4.75-4-8.53-9-9v7.16c1 .3 1.52.98 1.86 1.84zM13 14.84V22c5-.47 8.52-4.25 9-9h-7.14c-.34.86-.86 1.54-1.86 1.84z'
}));

/* eslint-disable prettier/prettier */
function IconDonutSmall(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDonutSmall.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconEject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5 17h14v2H5zm7-12L5.33 15h13.34z'
}));

/* eslint-disable prettier/prettier */
function IconEject(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconEject.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconEuroSymbol;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15 18.5A6.48 6.48 0 0 1 9.24 15H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24A6.491 6.491 0 0 1 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3A8.955 8.955 0 0 0 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06a8.262 8.262 0 0 0 0 2H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z'
}));

/* eslint-disable prettier/prettier */
function IconEuroSymbol(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconEuroSymbol.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z'
}));

/* eslint-disable prettier/prettier */
function IconEvent(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconEvent.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconEventSeat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 18v3h3v-3h10v3h3v-6H4zm15-8h3v3h-3zM2 10h3v3H2zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z'
}));

/* eslint-disable prettier/prettier */
function IconEventSeat(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconEventSeat.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconExitToApp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5a2 2 0 0 0-2 2v4h2V5h14v14H5v-4H3v4a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconExitToApp(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconExitToApp.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconExplore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z'
}));

/* eslint-disable prettier/prettier */
function IconExplore(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconExplore.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconExtension;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5a2.5 2.5 0 0 0-5 0V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5a2.5 2.5 0 0 0 0-5z'
}));

/* eslint-disable prettier/prettier */
function IconExtension(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconExtension.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 11.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zm6 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37a9.974 9.974 0 0 0 10.41 3.97c.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconFace(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFace.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFavoriteBorder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z'
}));

/* eslint-disable prettier/prettier */
function IconFavoriteBorder(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFavoriteBorder.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFeedback;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z'
}));

/* eslint-disable prettier/prettier */
function IconFeedback(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFeedback.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFindInPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 19.59V8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z'
}));

/* eslint-disable prettier/prettier */
function IconFindInPage(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFindInPage.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFindReplace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05A6.976 6.976 0 0 0 11 4c-3.53 0-6.43 2.61-6.92 6H6.1A5 5 0 0 1 11 6zm5.64 9.14A6.89 6.89 0 0 0 17.92 12H15.9a5 5 0 0 1-4.9 4c-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05A6.976 6.976 0 0 0 11 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z'
}));

/* eslint-disable prettier/prettier */
function IconFindReplace(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFindReplace.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFingerprint;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2a.506.506 0 0 1 .2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67a.49.49 0 0 1-.44.28zM3.5 9.72a.499.499 0 0 1-.41-.79c.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25a.5.5 0 0 1-.12.7c-.23.16-.54.11-.7-.12a9.388 9.388 0 0 0-3.39-2.94c-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07a.47.47 0 0 1-.35-.15c-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1a7.297 7.297 0 0 1-2.17-5.22c0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29a11.14 11.14 0 0 1-.73-3.96c0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z'
}));

/* eslint-disable prettier/prettier */
function IconFingerprint(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFingerprint.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFlightLand;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M2.5 19h19v2h-19zm7.18-5.73l4.35 1.16 5.31 1.42c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l1.6.43 5.31 1.43z'
}));

/* eslint-disable prettier/prettier */
function IconFlightLand(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFlightLand.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFlightTakeoff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M2.5 19h19v2h-19zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 1.82 3.16.77 1.33 1.6-.43 5.31-1.42 4.35-1.16L21 11.49c.81-.23 1.28-1.05 1.07-1.85z'
}));

/* eslint-disable prettier/prettier */
function IconFlightTakeoff(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFlightTakeoff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFlipToBack;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8a2 2 0 0 0-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7a2 2 0 0 0 2 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM5 7H3v12a2 2 0 0 0 2 2h12v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z'
}));

/* eslint-disable prettier/prettier */
function IconFlipToBack(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFlipToBack.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFlipToFront;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3a2 2 0 0 0 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z'
}));

/* eslint-disable prettier/prettier */
function IconFlipToFront(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFlipToFront.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGTranslate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 5h-9.12L10 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h7l1 3h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.17 14.59c-2.25 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09c1.04 0 1.99.37 2.74 1.07l.07.06-1.23 1.18-.06-.05c-.29-.27-.78-.59-1.52-.59-1.31 0-2.38 1.09-2.38 2.42s1.07 2.42 2.38 2.42c1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.07c.04.21.05.4.05.61 0 2.35-1.61 4-3.92 4zm6.03-1.71c.33.6.74 1.18 1.19 1.7l-.54.53-.65-2.23zm.77-.76h-.99l-.31-1.04h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7zM21 20c0 .55-.45 1-1 1h-7l2-2-.81-2.77.92-.92L17.79 18l.73-.73-2.71-2.68c.9-1.03 1.6-2.25 1.92-3.51H19v-1.04h-3.64V9h-1.04v1.04h-1.96L11.18 6H20c.55 0 1 .45 1 1v13z'
}));

/* eslint-disable prettier/prettier */
function IconGTranslate(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGTranslate.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGavel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M1 21h12v2H1zM5.245 8.07l2.83-2.827 14.14 14.142-2.828 2.828zM12.317 1l5.657 5.656-2.83 2.83-5.654-5.66zM3.825 9.485l5.657 5.657-2.828 2.828-5.657-5.657z'
}));

/* eslint-disable prettier/prettier */
function IconGavel(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGavel.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGetApp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z'
}));

/* eslint-disable prettier/prettier */
function IconGetApp(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGetApp.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGif;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11.5 9H13v6h-1.5zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1z'
}));

/* eslint-disable prettier/prettier */
function IconGif(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGif.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGrade;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'
}));

/* eslint-disable prettier/prettier */
function IconGrade(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGrade.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGroupWork;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5zM9.5 8a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1-5 0zm6.5 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z'
}));

/* eslint-disable prettier/prettier */
function IconGroupWork(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGroupWork.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHelpOutline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z'
}));

/* eslint-disable prettier/prettier */
function IconHelpOutline(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHelpOutline.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHighlightOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconHighlightOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHighlightOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 3a9 9 0 0 0-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z'
}));

/* eslint-disable prettier/prettier */
function IconHistory(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHistory.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHome;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z'
}));

/* eslint-disable prettier/prettier */
function IconHome(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHome.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHourglassEmpty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z'
}));

/* eslint-disable prettier/prettier */
function IconHourglassEmpty(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHourglassEmpty.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHourglassFull;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z'
}));

/* eslint-disable prettier/prettier */
function IconHourglassFull(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHourglassFull.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHttp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z'
}));

/* eslint-disable prettier/prettier */
function IconHttp(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHttp.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHttps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z'
}));

/* eslint-disable prettier/prettier */
function IconHttps(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHttps.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconImportantDevices;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM20 2H2C.89 2 0 2.89 0 4v12a2 2 0 0 0 2 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4a2 2 0 0 0-2-2zm-8.03 7L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z'
}));

/* eslint-disable prettier/prettier */
function IconImportantDevices(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconImportantDevices.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconInfoOutline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z'
}));

/* eslint-disable prettier/prettier */
function IconInfoOutline(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconInfoOutline.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconInput;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14a2 2 0 0 0-2-2zM11 16l4-4-4-4v3H1v2h10v3z'
}));

/* eslint-disable prettier/prettier */
function IconInput(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconInput.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconInvertColors;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31A7.98 7.98 0 0 0 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z'
}));

/* eslint-disable prettier/prettier */
function IconInvertColors(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconInvertColors.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLabel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z'
}));

/* eslint-disable prettier/prettier */
function IconLabel(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLabel.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLabelOutline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z'
}));

/* eslint-disable prettier/prettier */
function IconLabelOutline(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLabelOutline.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLanguage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95a15.65 15.65 0 0 0-1.38-3.56A8.03 8.03 0 0 1 18.92 8zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56A7.987 7.987 0 0 1 5.08 16zm2.95-8H5.08a7.987 7.987 0 0 1 4.33-3.56A15.65 15.65 0 0 0 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 0 1-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z'
}));

/* eslint-disable prettier/prettier */
function IconLanguage(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLanguage.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLaunch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z'
}));

/* eslint-disable prettier/prettier */
function IconLaunch(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLaunch.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLightbulbOutline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6A4.997 4.997 0 0 1 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z'
}));

/* eslint-disable prettier/prettier */
function IconLightbulbOutline(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLightbulbOutline.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLineStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z'
}));

/* eslint-disable prettier/prettier */
function IconLineStyle(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLineStyle.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLineWeight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z'
}));

/* eslint-disable prettier/prettier */
function IconLineWeight(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLineWeight.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z'
}));

/* eslint-disable prettier/prettier */
function IconList(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconList.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z'
}));

/* eslint-disable prettier/prettier */
function IconLock(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLock.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLockOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z'
}));

/* eslint-disable prettier/prettier */
function IconLockOpen(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLockOpen.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLockOutline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z'
}));

/* eslint-disable prettier/prettier */
function IconLockOutline(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLockOutline.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLoyalty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27A2.5 2.5 0 0 1 10.5 11c.69 0 1.32.28 1.77.74l.73.72.73-.73a2.5 2.5 0 0 1 3.54 3.54z'
}));

/* eslint-disable prettier/prettier */
function IconLoyalty(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLoyalty.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMarkunreadMailbox;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 6H10v6H8V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconMarkunreadMailbox(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMarkunreadMailbox.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMotorcycle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.44 9.03L15.41 5H11v2h3.59l2 2H5c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.46 0 4.45-1.69 4.9-4h1.65l2.77-2.77c-.21.54-.32 1.14-.32 1.77 0 2.8 2.2 5 5 5s5-2.2 5-5c0-2.65-1.97-4.77-4.56-4.97zM7.82 15C7.4 16.15 6.28 17 5 17c-1.63 0-3-1.37-3-3s1.37-3 3-3c1.28 0 2.4.85 2.82 2H5v2h2.82zM19 17c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z'
}));

/* eslint-disable prettier/prettier */
function IconMotorcycle(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMotorcycle.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNoteAdd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z'
}));

/* eslint-disable prettier/prettier */
function IconNoteAdd(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNoteAdd.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconOfflinePin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5 16H7v-2h10v2zm-6.7-4L7 10.7l1.4-1.4 1.9 1.9 5.3-5.3L17 7.3 10.3 14z'
}));

/* eslint-disable prettier/prettier */
function IconOfflinePin(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconOfflinePin.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconOpacity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17.66 8L12 2.35 6.34 8A8.02 8.02 0 0 0 4 13.64c0 2 .78 4.11 2.34 5.67a7.99 7.99 0 0 0 11.32 0c1.56-1.56 2.34-3.67 2.34-5.67S19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z'
}));

/* eslint-disable prettier/prettier */
function IconOpacity(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconOpacity.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconOpenInBrowser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6a2 2 0 0 0-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z'
}));

/* eslint-disable prettier/prettier */
function IconOpenInBrowser(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconOpenInBrowser.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconOpenInNew;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z'
}));

/* eslint-disable prettier/prettier */
function IconOpenInNew(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconOpenInNew.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconOpenWith;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z'
}));

/* eslint-disable prettier/prettier */
function IconOpenWith(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconOpenWith.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPageview;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11.5 9a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 0-5zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.21 14.21l-2.91-2.91c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7 16 9.01 16 11.5c0 .88-.26 1.69-.7 2.39l2.91 2.9-1.42 1.42z'
}));

/* eslint-disable prettier/prettier */
function IconPageview(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPageview.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPanTool;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z'
}));

/* eslint-disable prettier/prettier */
function IconPanTool(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPanTool.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPayment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z'
}));

/* eslint-disable prettier/prettier */
function IconPayment(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPayment.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPermCameraMic;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v-2.09c-2.83-.48-5-2.94-5-5.91h2c0 2.21 1.79 4 4 4s4-1.79 4-4h2c0 2.97-2.17 5.43-5 5.91V21h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-6 8c0 1.1-.9 2-2 2s-2-.9-2-2V9c0-1.1.9-2 2-2s2 .9 2 2v4z'
}));

/* eslint-disable prettier/prettier */
function IconPermCameraMic(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPermCameraMic.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPermContactCalendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z'
}));

/* eslint-disable prettier/prettier */
function IconPermContactCalendar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPermContactCalendar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPermDataSetting;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18.99 11.5c.34 0 .67.03 1 .07L20 0 0 20h11.56c-.04-.33-.07-.66-.07-1 0-4.14 3.36-7.5 7.5-7.5zm3.71 7.99c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83a.26.26 0 0 0 .06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83a3.908 3.908 0 0 0 0 .98l-1.06.83a.26.26 0 0 0-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73a.26.26 0 0 0-.06-.32l-1.07-.83zm-3.71 1.01c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
}));

/* eslint-disable prettier/prettier */
function IconPermDataSetting(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPermDataSetting.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPermDeviceInformation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 7h-2v2h2V7zm0 4h-2v6h2v-6zm4-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z'
}));

/* eslint-disable prettier/prettier */
function IconPermDeviceInformation(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPermDeviceInformation.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPermIdentity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 5.9a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z'
}));

/* eslint-disable prettier/prettier */
function IconPermIdentity(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPermIdentity.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPermMedia;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z'
}));

/* eslint-disable prettier/prettier */
function IconPermMedia(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPermMedia.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPermPhoneMsg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 0 0-1.02.24l-2.2 2.2a15.074 15.074 0 0 1-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z'
}));

/* eslint-disable prettier/prettier */
function IconPermPhoneMsg(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPermPhoneMsg.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPermScanWifi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zm1 13h-2v-6h2v6zm-2-8V6h2v2h-2z'
}));

/* eslint-disable prettier/prettier */
function IconPermScanWifi(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPermScanWifi.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPets;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('circle', {
  cx: '4.5',
  cy: '9.5',
  r: '2.5'
}), _jsx('circle', {
  cx: '9',
  cy: '5.5',
  r: '2.5'
}), _jsx('circle', {
  cx: '15',
  cy: '5.5',
  r: '2.5'
}), _jsx('circle', {
  cx: '19.5',
  cy: '9.5',
  r: '2.5'
}), _jsx('path', {
  d: 'M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z'
}));

/* eslint-disable prettier/prettier */
function IconPets(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPets.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPictureInPicture;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 7h-8v6h8V7zm2-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z'
}));

/* eslint-disable prettier/prettier */
function IconPictureInPicture(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPictureInPicture.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPictureInPictureAlt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 11h-8v6h8v-6zm4 8V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H3V4.97h18v14.05z'
}));

/* eslint-disable prettier/prettier */
function IconPictureInPictureAlt(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPictureInPictureAlt.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPlayForWork;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z'
}));

/* eslint-disable prettier/prettier */
function IconPlayForWork(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPlayForWork.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPolymer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8z'
}));

/* eslint-disable prettier/prettier */
function IconPolymer(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPolymer.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPowerSettingsNew;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42A6.92 6.92 0 0 1 19 12c0 3.87-3.13 7-7 7A6.995 6.995 0 0 1 7.58 6.58L6.17 5.17A8.932 8.932 0 0 0 3 12a9 9 0 0 0 18 0c0-2.74-1.23-5.18-3.17-6.83z'
}));

/* eslint-disable prettier/prettier */
function IconPowerSettingsNew(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPowerSettingsNew.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPregnantWoman;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9a3.285 3.285 0 0 0-2-3c0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z'
}));

/* eslint-disable prettier/prettier */
function IconPregnantWoman(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPregnantWoman.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPrint;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z'
}));

/* eslint-disable prettier/prettier */
function IconPrint(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPrint.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconQueryBuilder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z'
}));

/* eslint-disable prettier/prettier */
function IconQueryBuilder(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconQueryBuilder.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconQuestionAnswer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z'
}));

/* eslint-disable prettier/prettier */
function IconQuestionAnswer(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconQuestionAnswer.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconReceipt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z'
}));

/* eslint-disable prettier/prettier */
function IconReceipt(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconReceipt.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRecordVoiceOver;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('circle', {
  cx: '9',
  cy: '9',
  r: '4'
}), _jsx('path', {
  d: 'M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z'
}));

/* eslint-disable prettier/prettier */
function IconRecordVoiceOver(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRecordVoiceOver.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRedeem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 0 0-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z'
}));

/* eslint-disable prettier/prettier */
function IconRedeem(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRedeem.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRemoveShoppingCart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22.73 22.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38A1.997 1.997 0 0 0 17 22c.67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27zM7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0 0 20 4H6.54l9.01 9zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconRemoveShoppingCart(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRemoveShoppingCart.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconReorder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z'
}));

/* eslint-disable prettier/prettier */
function IconReorder(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconReorder.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconReportProblem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z'
}));

/* eslint-disable prettier/prettier */
function IconReportProblem(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconReportProblem.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRestore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 3a9 9 0 0 0-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z'
}));

/* eslint-disable prettier/prettier */
function IconRestore(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRestore.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRestorePage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-2 16c-2.05 0-3.81-1.24-4.58-3h1.71c.63.9 1.68 1.5 2.87 1.5 1.93 0 3.5-1.57 3.5-3.5S13.93 9.5 12 9.5a3.5 3.5 0 0 0-3.1 1.9l1.6 1.6h-4V9l1.3 1.3C8.69 8.92 10.23 8 12 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z'
}));

/* eslint-disable prettier/prettier */
function IconRestorePage(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRestorePage.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRoom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z'
}));

/* eslint-disable prettier/prettier */
function IconRoom(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRoom.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRoundedCorner;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z'
}));

/* eslint-disable prettier/prettier */
function IconRoundedCorner(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRoundedCorner.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRowing;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z'
}));

/* eslint-disable prettier/prettier */
function IconRowing(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRowing.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSchedule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z'
}));

/* eslint-disable prettier/prettier */
function IconSchedule(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSchedule.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSearch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'
}));

/* eslint-disable prettier/prettier */
function IconSearch(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSearch.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSettings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65A.488.488 0 0 0 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z'
}));

/* eslint-disable prettier/prettier */
function IconSettings(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSettings.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSettingsApplications;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42a.353.353 0 0 1 .08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16a.353.353 0 0 1-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z'
}));

/* eslint-disable prettier/prettier */
function IconSettingsApplications(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSettingsApplications.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSettingsBackupRestore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9a9 9 0 0 0-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7a6.995 6.995 0 0 1-11.06 5.7l-1.42 1.44A9 9 0 1 0 12 3z'
}));

/* eslint-disable prettier/prettier */
function IconSettingsBackupRestore(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSettingsBackupRestore.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSettingsBluetooth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z'
}));

/* eslint-disable prettier/prettier */
function IconSettingsBluetooth(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSettingsBluetooth.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSettingsBrightness;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z'
}));

/* eslint-disable prettier/prettier */
function IconSettingsBrightness(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSettingsBrightness.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSettingsCell;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 16H8V4h8v12z'
}));

/* eslint-disable prettier/prettier */
function IconSettingsCell(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSettingsCell.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSettingsEthernet;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z'
}));

/* eslint-disable prettier/prettier */
function IconSettingsEthernet(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSettingsEthernet.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSettingsInputAntenna;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29a2.5 2.5 0 0 0-5 0c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2a9 9 0 0 1 18 0h2c0-6.07-4.93-11-11-11z'
}));

/* eslint-disable prettier/prettier */
function IconSettingsInputAntenna(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSettingsInputAntenna.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSettingsInputComponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z'
}));

/* eslint-disable prettier/prettier */
function IconSettingsInputComponent(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSettingsInputComponent.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSettingsInputComposite;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z'
}));

/* eslint-disable prettier/prettier */
function IconSettingsInputComposite(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSettingsInputComposite.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSettingsInputHdmi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4z'
}));

/* eslint-disable prettier/prettier */
function IconSettingsInputHdmi(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSettingsInputHdmi.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSettingsInputSvideo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z'
}));

/* eslint-disable prettier/prettier */
function IconSettingsInputSvideo(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSettingsInputSvideo.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSettingsOverscan;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z'
}));

/* eslint-disable prettier/prettier */
function IconSettingsOverscan(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSettingsOverscan.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSettingsPhone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 9h-2v2h2V9zm4 0h-2v2h2V9zm3 6.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 0 0-1.02.24l-2.2 2.2a15.074 15.074 0 0 1-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 9v2h2V9h-2z'
}));

/* eslint-disable prettier/prettier */
function IconSettingsPhone(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSettingsPhone.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSettingsPower;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45A5.969 5.969 0 0 1 18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44A7.961 7.961 0 0 0 4 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z'
}));

/* eslint-disable prettier/prettier */
function IconSettingsPower(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSettingsPower.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSettingsRemote;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7.05 6.05l1.41 1.41a5.022 5.022 0 0 1 7.08 0l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z'
}));

/* eslint-disable prettier/prettier */
function IconSettingsRemote(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSettingsRemote.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSettingsVoice;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 24h2v-2H7v2zm5-11c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1 11h2v-2h-2v2zm4 0h2v-2h-2v2zm4-14h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z'
}));

/* eslint-disable prettier/prettier */
function IconSettingsVoice(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSettingsVoice.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconShop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zM9 18V9l7.5 4L9 18z'
}));

/* eslint-disable prettier/prettier */
function IconShop(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconShop.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconShopTwo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3-5.5 4z'
}));

/* eslint-disable prettier/prettier */
function IconShopTwo(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconShopTwo.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconShoppingBasket;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17.21 9l-4.38-6.56a.993.993 0 0 0-.83-.42c-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'
}));

/* eslint-disable prettier/prettier */
function IconShoppingBasket(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconShoppingBasket.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconShoppingCart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0 0 20 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconShoppingCart(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconShoppingCart.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSpeakerNotes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm7 6h-5v-2h5v2zm3-3h-8V9h8v2zm0-3h-8V6h8v2z'
}));

/* eslint-disable prettier/prettier */
function IconSpeakerNotes(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSpeakerNotes.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSpeakerNotesOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10.54 11l-.54-.54L7.54 8 6 6.46 2.38 2.84 1.27 1.73 0 3l2.01 2.01L2 22l4-4h9l5.73 5.73L22 22.46 17.54 18l-7-7zM8 14H6v-2h2v2zm-2-3V9l2 2H6zm14-9H4.08L10 7.92V6h8v2h-7.92l1 1H18v2h-4.92l6.99 6.99C21.14 17.95 22 17.08 22 16V4c0-1.1-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconSpeakerNotesOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSpeakerNotesOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSpellcheck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z'
}));

/* eslint-disable prettier/prettier */
function IconSpellcheck(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSpellcheck.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconStars;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z'
}));

/* eslint-disable prettier/prettier */
function IconStars(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconStars.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z'
}));

/* eslint-disable prettier/prettier */
function IconStore(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconStore.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSubject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z'
}));

/* eslint-disable prettier/prettier */
function IconSubject(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSubject.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSupervisorAccount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7a2.5 2.5 0 0 0 0 5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z'
}));

/* eslint-disable prettier/prettier */
function IconSupervisorAccount(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSupervisorAccount.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSwapHoriz;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z'
}));

/* eslint-disable prettier/prettier */
function IconSwapHoriz(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSwapHoriz.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSwapVert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z'
}));

/* eslint-disable prettier/prettier */
function IconSwapVert(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSwapVert.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSwapVerticalCircle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm11 6L14 18.5 10.5 15H13v-4h2v4h2.5z'
}));

/* eslint-disable prettier/prettier */
function IconSwapVerticalCircle(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSwapVerticalCircle.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSystemUpdateAlt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconSystemUpdateAlt(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSystemUpdateAlt.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTab;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z'
}));

/* eslint-disable prettier/prettier */
function IconTab(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTab.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTabUnselected;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z'
}));

/* eslint-disable prettier/prettier */
function IconTabUnselected(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTabUnselected.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTheaters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z'
}));

/* eslint-disable prettier/prettier */
function IconTheaters(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTheaters.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconThumbDown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v1.91l.01.01L1 14c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z'
}));

/* eslint-disable prettier/prettier */
function IconThumbDown(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconThumbDown.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconThumbUp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z'
}));

/* eslint-disable prettier/prettier */
function IconThumbUp(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconThumbUp.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconThumbsUpDown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm10.5 4h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5z'
}));

/* eslint-disable prettier/prettier */
function IconThumbsUpDown(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconThumbsUpDown.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTimeline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M23 8c0 1.1-.9 2-2 2a1.7 1.7 0 0 1-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56A1.7 1.7 0 0 1 19 8c0-1.1.9-2 2-2s2 .9 2 2z'
}));

/* eslint-disable prettier/prettier */
function IconTimeline(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTimeline.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconToc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z'
}));

/* eslint-disable prettier/prettier */
function IconToc(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconToc.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconToday;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z'
}));

/* eslint-disable prettier/prettier */
function IconToday(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconToday.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconToll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12a5.99 5.99 0 0 1 4-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09A5.99 5.99 0 0 1 3 12z'
}));

/* eslint-disable prettier/prettier */
function IconToll(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconToll.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTouchApp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 11.24V7.5a2.5 2.5 0 0 1 5 0v3.74c1.21-.81 2-2.18 2-3.74C16 5.01 13.99 3 11.5 3S7 5.01 7 7.5c0 1.56.79 2.93 2 3.74zm9.84 4.63l-4.54-2.26c-.17-.07-.35-.11-.54-.11H13v-6c0-.83-.67-1.5-1.5-1.5S10 6.67 10 7.5v10.74l-3.43-.72c-.08-.01-.15-.03-.24-.03-.31 0-.59.13-.79.33l-.79.8 4.94 4.94c.27.27.65.44 1.06.44h6.79c.75 0 1.33-.55 1.44-1.28l.75-5.27c.01-.07.02-.14.02-.2 0-.62-.38-1.16-.91-1.38z'
}));

/* eslint-disable prettier/prettier */
function IconTouchApp(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTouchApp.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTrackChanges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.07 4.93l-1.41 1.41A8.014 8.014 0 0 1 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z'
}));

/* eslint-disable prettier/prettier */
function IconTrackChanges(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTrackChanges.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTranslate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z'
}));

/* eslint-disable prettier/prettier */
function IconTranslate(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTranslate.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTrendingDown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z'
}));

/* eslint-disable prettier/prettier */
function IconTrendingDown(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTrendingDown.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTrendingFlat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 12l-4-4v3H3v2h15v3z'
}));

/* eslint-disable prettier/prettier */
function IconTrendingFlat(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTrendingFlat.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTrendingUp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z'
}));

/* eslint-disable prettier/prettier */
function IconTrendingUp(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTrendingUp.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTurnedIn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconTurnedIn(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTurnedIn.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTurnedInNot;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z'
}));

/* eslint-disable prettier/prettier */
function IconTurnedInNot(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTurnedInNot.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconUpdate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1a6.875 6.875 0 0 0 0 9.79 7.02 7.02 0 0 0 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58a8.987 8.987 0 0 1 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z'
}));

/* eslint-disable prettier/prettier */
function IconUpdate(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconUpdate.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVerifiedUser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconVerifiedUser(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVerifiedUser.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconViewAgenda;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 13H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm0-10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z'
}));

/* eslint-disable prettier/prettier */
function IconViewAgenda(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconViewAgenda.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconViewArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 18h3V5H4v13zM18 5v13h3V5h-3zM8 18h9V5H8v13z'
}));

/* eslint-disable prettier/prettier */
function IconViewArray(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconViewArray.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconViewCarousel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 19h10V4H7v15zm-5-2h4V6H2v11zM18 6v11h4V6h-4z'
}));

/* eslint-disable prettier/prettier */
function IconViewCarousel(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconViewCarousel.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconViewColumn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z'
}));

/* eslint-disable prettier/prettier */
function IconViewColumn(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconViewColumn.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconViewDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z'
}));

/* eslint-disable prettier/prettier */
function IconViewDay(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconViewDay.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconViewHeadline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z'
}));

/* eslint-disable prettier/prettier */
function IconViewHeadline(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconViewHeadline.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconViewList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z'
}));

/* eslint-disable prettier/prettier */
function IconViewList(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconViewList.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconViewModule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z'
}));

/* eslint-disable prettier/prettier */
function IconViewModule(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconViewModule.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconViewQuilt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z'
}));

/* eslint-disable prettier/prettier */
function IconViewQuilt(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconViewQuilt.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconViewStream;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 18h17v-6H4v6zM4 5v6h17V5H4z'
}));

/* eslint-disable prettier/prettier */
function IconViewStream(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconViewStream.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconViewWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z'
}));

/* eslint-disable prettier/prettier */
function IconViewWeek(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconViewWeek.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVisibility;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z'
}));

/* eslint-disable prettier/prettier */
function IconVisibility(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVisibility.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVisibilityOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46A11.804 11.804 0 0 0 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z'
}));

/* eslint-disable prettier/prettier */
function IconVisibilityOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVisibilityOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWatchLater;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z'
}));

/* eslint-disable prettier/prettier */
function IconWatchLater(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWatchLater.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWork;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z'
}));

/* eslint-disable prettier/prettier */
function IconWork(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWork.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconYoutubeSearchedFor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17.01 14h-.8l-.27-.27a6.451 6.451 0 0 0 1.57-4.23c0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51a4.5 4.5 0 0 1 9 0 4.507 4.507 0 0 1-6.32 4.12L7.71 15.1a6.474 6.474 0 0 0 7.52-.67l.27.27v.79l5.01 4.99L22 19l-4.99-5z'
}));

/* eslint-disable prettier/prettier */
function IconYoutubeSearchedFor(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconYoutubeSearchedFor.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconZoomIn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm2.5-4h-2v2H9v-2H7V9h2V7h1v2h2v1z'
}));

/* eslint-disable prettier/prettier */
function IconZoomIn(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconZoomIn.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconZoomOut;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z'
}));

/* eslint-disable prettier/prettier */
function IconZoomOut(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconZoomOut.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAddAlert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72A6.873 6.873 0 0 0 5.12 11v5.82L3 18.94V20h18v-1.06l-2.12-2.12zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z'
}));

/* eslint-disable prettier/prettier */
function IconAddAlert(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAddAlert.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z'
}));

/* eslint-disable prettier/prettier */
function IconError(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconError.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconErrorOutline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconErrorOutline(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconErrorOutline.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAddToQueue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 0 0-2-2zm0 14H3V5h18v12zm-5-7v2h-3v3h-2v-3H8v-2h3V7h2v3h3z'
}));

/* eslint-disable prettier/prettier */
function IconAddToQueue(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAddToQueue.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAirplay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 22h12l-6-6zM21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconAirplay(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAirplay.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAlbum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zm0-5.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z'
}));

/* eslint-disable prettier/prettier */
function IconAlbum(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAlbum.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconArtTrack;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-1.5 6l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z'
}));

/* eslint-disable prettier/prettier */
function IconArtTrack(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconArtTrack.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAvTimer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9a9 9 0 0 0 0-18h-1zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zM6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z'
}));

/* eslint-disable prettier/prettier */
function IconAvTimer(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAvTimer.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBrandingWatermark;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-9v-6h9v6z'
}));

/* eslint-disable prettier/prettier */
function IconBrandingWatermark(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBrandingWatermark.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCallToAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3v-3h18v3z'
}));

/* eslint-disable prettier/prettier */
function IconCallToAction(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCallToAction.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconClosedCaption;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z'
}));

/* eslint-disable prettier/prettier */
function IconClosedCaption(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconClosedCaption.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconEqualizer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z'
}));

/* eslint-disable prettier/prettier */
function IconEqualizer(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconEqualizer.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconExplicit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h4v2h-4v2h4v2H9V7h6v2z'
}));

/* eslint-disable prettier/prettier */
function IconExplicit(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconExplicit.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFastForward;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z'
}));

/* eslint-disable prettier/prettier */
function IconFastForward(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFastForward.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFastRewind;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z'
}));

/* eslint-disable prettier/prettier */
function IconFastRewind(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFastRewind.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFeaturedPlayList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 8H3V9h9v2zm0-4H3V5h9v2z'
}));

/* eslint-disable prettier/prettier */
function IconFeaturedPlayList(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFeaturedPlayList.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFeaturedVideo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9H3V5h9v7z'
}));

/* eslint-disable prettier/prettier */
function IconFeaturedVideo(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFeaturedVideo.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFiberDvr;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17.5 10.5h2v1h-2zm-13 0h2v3h-2zM21 3H3c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V5c0-1.11-.89-2-2-2zM8 13.5c0 .85-.65 1.5-1.5 1.5H3V9h3.5c.85 0 1.5.65 1.5 1.5v3zm4.62 1.5h-1.5L9.37 9h1.5l1 3.43 1-3.43h1.5l-1.75 6zM21 11.5c0 .6-.4 1.15-.9 1.4L21 15h-1.5l-.85-2H17.5v2H16V9h3.5c.85 0 1.5.65 1.5 1.5v1z'
}));

/* eslint-disable prettier/prettier */
function IconFiberDvr(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFiberDvr.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFiberManualRecord;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('circle', {
  cx: '12',
  cy: '12',
  r: '8'
}));

/* eslint-disable prettier/prettier */
function IconFiberManualRecord(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFiberManualRecord.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFiberNew;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM8.5 15H7.3l-2.55-3.5V15H3.5V9h1.25l2.5 3.5V9H8.5v6zm5-4.74H11v1.12h2.5v1.26H11v1.11h2.5V15h-4V9h4v1.26zm7 3.74c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1V9h1.25v4.51h1.13V9.99h1.25v3.51h1.12V9h1.25v5z'
}));

/* eslint-disable prettier/prettier */
function IconFiberNew(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFiberNew.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFiberPin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5.5 10.5h2v1h-2zM20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM9 11.5c0 .85-.65 1.5-1.5 1.5h-2v2H4V9h3.5c.85 0 1.5.65 1.5 1.5v1zm3.5 3.5H11V9h1.5v6zm7.5 0h-1.2l-2.55-3.5V15H15V9h1.25l2.5 3.5V9H20v6z'
}));

/* eslint-disable prettier/prettier */
function IconFiberPin(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFiberPin.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFiberSmartRecord;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('g', {}, void 0, _jsx('circle', {
  cx: '9',
  cy: '12',
  r: '8'
}), _jsx('path', {
  d: 'M17 4.26v2.09a5.99 5.99 0 0 1 0 11.3v2.09c3.45-.89 6-4.01 6-7.74s-2.55-6.85-6-7.74z'
})));

/* eslint-disable prettier/prettier */
function IconFiberSmartRecord(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFiberSmartRecord.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconForward10;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.8 3H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z'
}));

/* eslint-disable prettier/prettier */
function IconForward10(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconForward10.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconForward30;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9.6 13.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5zM4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconForward30(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconForward30.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconForward5;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.7.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.5.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.6z'
}));

/* eslint-disable prettier/prettier */
function IconForward5(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconForward5.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGames;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z'
}));

/* eslint-disable prettier/prettier */
function IconGames(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGames.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z'
}));

/* eslint-disable prettier/prettier */
function IconHd(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHd.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHearing;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55A3.999 3.999 0 0 0 21 18h-2c0 1.1-.9 2-2 2zM7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0-5 0z'
}));

/* eslint-disable prettier/prettier */
function IconHearing(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHearing.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHighQuality;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 11H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm7-1c0 .55-.45 1-1 1h-.75v1.5h-1.5V15H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v4zm-3.5-.5h2v-3h-2v3z'
}));

/* eslint-disable prettier/prettier */
function IconHighQuality(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHighQuality.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLibraryAdd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z'
}));

/* eslint-disable prettier/prettier */
function IconLibraryAdd(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLibraryAdd.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLibraryBooks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z'
}));

/* eslint-disable prettier/prettier */
function IconLibraryBooks(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLibraryBooks.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLibraryMusic;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 5h-3v5.5a2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1 2.5-2.5c.57 0 1.08.19 1.5.51V5h4v2zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z'
}));

/* eslint-disable prettier/prettier */
function IconLibraryMusic(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLibraryMusic.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLoop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 0 0 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z'
}));

/* eslint-disable prettier/prettier */
function IconLoop(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLoop.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMic;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z'
}));

/* eslint-disable prettier/prettier */
function IconMic(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMic.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMicNone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1.2-9.1c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2-.66 0-1.2-.54-1.2-1.2V4.9zm6.5 6.1c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z'
}));

/* eslint-disable prettier/prettier */
function IconMicNone(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMicNone.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMicOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z'
}));

/* eslint-disable prettier/prettier */
function IconMicOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMicOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMovie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z'
}));

/* eslint-disable prettier/prettier */
function IconMovie(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMovie.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMusicVideo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03A3.003 3.003 0 0 1 11 18c-1.66 0-3-1.34-3-3z'
}));

/* eslint-disable prettier/prettier */
function IconMusicVideo(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMusicVideo.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNewReleases;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z'
}));

/* eslint-disable prettier/prettier */
function IconNewReleases(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNewReleases.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNotInterested;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0 1 12 20zm6.31-3.1L7.1 5.69A7.902 7.902 0 0 1 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z'
}));

/* eslint-disable prettier/prettier */
function IconNotInterested(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNotInterested.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNote;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 10l-6-6H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99l16-.01c1.1 0 2-.89 2-1.99v-8zm-7-4.5l5.5 5.5H15V5.5z'
}));

/* eslint-disable prettier/prettier */
function IconNote(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNote.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPause;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 19h4V5H6v14zm8-14v14h4V5h-4z'
}));

/* eslint-disable prettier/prettier */
function IconPause(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPause.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPauseCircleFilled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z'
}));

/* eslint-disable prettier/prettier */
function IconPauseCircleFilled(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPauseCircleFilled.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPauseCircleOutline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z'
}));

/* eslint-disable prettier/prettier */
function IconPauseCircleOutline(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPauseCircleOutline.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPlayArrow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M8 5v14l11-7z'
}));

/* eslint-disable prettier/prettier */
function IconPlayArrow(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPlayArrow.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPlayCircleFilled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z'
}));

/* eslint-disable prettier/prettier */
function IconPlayCircleFilled(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPlayCircleFilled.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPlayCircleOutline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconPlayCircleOutline(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPlayCircleOutline.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPlaylistAdd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z'
}));

/* eslint-disable prettier/prettier */
function IconPlaylistAdd(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPlaylistAdd.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPlaylistAddCheck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z'
}));

/* eslint-disable prettier/prettier */
function IconPlaylistAddCheck(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPlaylistAddCheck.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPlaylistPlay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 9H2v2h17V9zm0-4H2v2h17V5zM2 15h13v-2H2v2zm15-2v6l5-3-5-3z'
}));

/* eslint-disable prettier/prettier */
function IconPlaylistPlay(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPlaylistPlay.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconQueue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z'
}));

/* eslint-disable prettier/prettier */
function IconQueue(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconQueue.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconQueueMusic;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z'
}));

/* eslint-disable prettier/prettier */
function IconQueueMusic(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconQueueMusic.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconQueuePlayNext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h2v-2H3V5h18v8h2V5a2 2 0 0 0-2-2zm-8 7V7h-2v3H8v2h3v3h2v-3h3v-2h-3zm11 8l-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18z'
}));

/* eslint-disable prettier/prettier */
function IconQueuePlayNext(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconQueuePlayNext.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRadio;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3.24 6.15C2.51 6.43 2 7.17 2 8v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8c0-1.11-.89-2-2-2H8.3l8.26-3.34L15.88 1 3.24 6.15zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-2h-2v2H4V8h16v4z'
}));

/* eslint-disable prettier/prettier */
function IconRadio(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRadio.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRecentActors;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 5v14h2V5h-2zm-4 14h2V5h-2v14zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z'
}));

/* eslint-disable prettier/prettier */
function IconRecentActors(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRecentActors.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRemoveFromQueue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 0 0-2-2zm0 14H3V5h18v12zm-5-7v2H8v-2h8z'
}));

/* eslint-disable prettier/prettier */
function IconRemoveFromQueue(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRemoveFromQueue.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRepeat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z'
}));

/* eslint-disable prettier/prettier */
function IconRepeat(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRepeat.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRepeatOne;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z'
}));

/* eslint-disable prettier/prettier */
function IconRepeatOne(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRepeatOne.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconReplay10;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z'
}));

/* eslint-disable prettier/prettier */
function IconReplay10(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconReplay10.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconReplay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z'
}));

/* eslint-disable prettier/prettier */
function IconReplay(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconReplay.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconReplay30;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-2.4 8.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5c0-.1-.1-.2-.1-.3s-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z'
}));

/* eslint-disable prettier/prettier */
function IconReplay30(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconReplay30.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconReplay5;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.3 8.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.4.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.7z'
}));

/* eslint-disable prettier/prettier */
function IconReplay5(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconReplay5.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconShuffle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z'
}));

/* eslint-disable prettier/prettier */
function IconShuffle(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconShuffle.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSkipNext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z'
}));

/* eslint-disable prettier/prettier */
function IconSkipNext(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSkipNext.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSkipPrevious;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 6h2v12H6zm3.5 6l8.5 6V6z'
}));

/* eslint-disable prettier/prettier */
function IconSkipPrevious(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSkipPrevious.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSnooze;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 0 0 0-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-3-9h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2z'
}));

/* eslint-disable prettier/prettier */
function IconSnooze(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSnooze.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSortByAlpha;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14.94 4.66h-4.72l2.36-2.36zm-4.69 14.71h4.66l-2.33 2.33zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37l1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z'
}));

/* eslint-disable prettier/prettier */
function IconSortByAlpha(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSortByAlpha.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconStop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 6h12v12H6z'
}));

/* eslint-disable prettier/prettier */
function IconStop(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconStop.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSubscriptions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 8H4V6h16v2zm-2-6H6v2h12V2zm4 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-6 4l-6-3.27v6.53L16 16z'
}));

/* eslint-disable prettier/prettier */
function IconSubscriptions(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSubscriptions.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSubtitles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z'
}));

/* eslint-disable prettier/prettier */
function IconSubtitles(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSubtitles.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSurroundSound;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.76 16.24l-1.41 1.41A7.909 7.909 0 0 1 4 12c0-2.05.78-4.1 2.34-5.66l1.41 1.41C6.59 8.93 6 10.46 6 12s.59 3.07 1.76 4.24zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm5.66 1.66l-1.41-1.41C17.41 15.07 18 13.54 18 12s-.59-3.07-1.76-4.24l1.41-1.41A7.909 7.909 0 0 1 20 12c0 2.05-.78 4.1-2.34 5.66zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconSurroundSound(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSurroundSound.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVideoCall;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2z'
}));

/* eslint-disable prettier/prettier */
function IconVideoCall(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVideoCall.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVideoLabel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z'
}));

/* eslint-disable prettier/prettier */
function IconVideoLabel(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVideoLabel.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVideoLibrary;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z'
}));

/* eslint-disable prettier/prettier */
function IconVideoLibrary(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVideoLibrary.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVideocam;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z'
}));

/* eslint-disable prettier/prettier */
function IconVideocam(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVideocam.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVideocamOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z'
}));

/* eslint-disable prettier/prettier */
function IconVideocamOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVideocamOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVolumeDown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18.5 12A4.5 4.5 0 0 0 16 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z'
}));

/* eslint-disable prettier/prettier */
function IconVolumeDown(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVolumeDown.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVolumeMute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 9v6h4l5 5V4l-5 5H7z'
}));

/* eslint-disable prettier/prettier */
function IconVolumeMute(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVolumeMute.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVolumeOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16.5 12A4.5 4.5 0 0 0 14 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 0 0 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z'
}));

/* eslint-disable prettier/prettier */
function IconVolumeOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVolumeOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVolumeUp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z'
}));

/* eslint-disable prettier/prettier */
function IconVolumeUp(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVolumeUp.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWeb;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z'
}));

/* eslint-disable prettier/prettier */
function IconWeb(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWeb.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWebAsset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6a2 2 0 0 0-2-2zm0 14H5V8h14v10z'
}));

/* eslint-disable prettier/prettier */
function IconWebAsset(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWebAsset.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBusiness;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z'
}));

/* eslint-disable prettier/prettier */
function IconBusiness(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBusiness.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCall;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z'
}));

/* eslint-disable prettier/prettier */
function IconCall(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCall.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCallEnd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08a.956.956 0 0 1-.29-.7c0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28a11.27 11.27 0 0 0-2.67-1.85.996.996 0 0 1-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z'
}));

/* eslint-disable prettier/prettier */
function IconCallEnd(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCallEnd.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCallMade;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z'
}));

/* eslint-disable prettier/prettier */
function IconCallMade(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCallMade.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCallMerge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z'
}));

/* eslint-disable prettier/prettier */
function IconCallMerge(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCallMerge.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCallMissed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9z'
}));

/* eslint-disable prettier/prettier */
function IconCallMissed(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCallMissed.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCallMissedOutgoing;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z'
}));

/* eslint-disable prettier/prettier */
function IconCallMissedOutgoing(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCallMissedOutgoing.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCallReceived;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z'
}));

/* eslint-disable prettier/prettier */
function IconCallReceived(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCallReceived.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCallSplit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z'
}));

/* eslint-disable prettier/prettier */
function IconCallSplit(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCallSplit.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconChat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z'
}));

/* eslint-disable prettier/prettier */
function IconChat(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconChat.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconChatBubble;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconChatBubble(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconChatBubble.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconChatBubbleOutline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z'
}));

/* eslint-disable prettier/prettier */
function IconChatBubbleOutline(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconChatBubbleOutline.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconClearAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z'
}));

/* eslint-disable prettier/prettier */
function IconClearAll(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconClearAll.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconComment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z'
}));

/* eslint-disable prettier/prettier */
function IconComment(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconComment.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconContactMail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z'
}));

/* eslint-disable prettier/prettier */
function IconContactMail(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconContactMail.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconContactPhone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.64L21 16l-1.99 1.99A7.512 7.512 0 0 1 16.28 14c-.18-.64-.28-1.31-.28-2s.1-1.36.28-2a7.474 7.474 0 0 1 2.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z'
}));

/* eslint-disable prettier/prettier */
function IconContactPhone(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconContactPhone.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconContacts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 0H4v2h16V0zM4 24h16v-2H4v2zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17z'
}));

/* eslint-disable prettier/prettier */
function IconContacts(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconContacts.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDialerSip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 3h-1v5h1V3zm-2 2h-2V4h2V3h-3v3h2v1h-2v1h3V5zm3-2v5h1V6h2V3h-3zm2 2h-1V4h1v1zm0 10.5c-1.25 0-2.45-.2-3.57-.57a.998.998 0 0 0-1.01.24l-2.2 2.2a15.045 15.045 0 0 1-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z'
}));

/* eslint-disable prettier/prettier */
function IconDialerSip(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDialerSip.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDialpad;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconDialpad(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDialpad.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconEmail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z'
}));

/* eslint-disable prettier/prettier */
function IconEmail(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconEmail.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconForum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z'
}));

/* eslint-disable prettier/prettier */
function IconForum(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconForum.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconImportContacts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z'
}));

/* eslint-disable prettier/prettier */
function IconImportContacts(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconImportContacts.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconImportExport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z'
}));

/* eslint-disable prettier/prettier */
function IconImportExport(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconImportExport.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconInvertColorsOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20.65 20.87l-2.35-2.35-6.3-6.29-3.56-3.57-1.42-1.41L4.27 4.5 3 5.77l2.78 2.78a8.005 8.005 0 0 0 .56 10.69A7.98 7.98 0 0 0 12 21.58c1.79 0 3.57-.59 5.03-1.78l2.7 2.7L21 21.23l-.35-.36zM12 19.59c-1.6 0-3.11-.62-4.24-1.76A5.945 5.945 0 0 1 6 13.59c0-1.32.43-2.57 1.21-3.6L12 14.77v4.82zM12 5.1v4.58l7.25 7.26c1.37-2.96.84-6.57-1.6-9.01L12 2.27l-3.7 3.7 1.41 1.41L12 5.1z'
}));

/* eslint-disable prettier/prettier */
function IconInvertColorsOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconInvertColorsOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLiveHelp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z'
}));

/* eslint-disable prettier/prettier */
function IconLiveHelp(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLiveHelp.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocationOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 6.5A2.5 2.5 0 0 1 14.5 9c0 .74-.33 1.39-.83 1.85l3.63 3.63c.98-1.86 1.7-3.8 1.7-5.48 0-3.87-3.13-7-7-7a7 7 0 0 0-5.04 2.15l3.19 3.19c.46-.52 1.11-.84 1.85-.84zm4.37 9.6l-4.63-4.63-.11-.11L3.27 3 2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21 20 19.73l-3.63-3.63z'
}));

/* eslint-disable prettier/prettier */
function IconLocationOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocationOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocationOn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z'
}));

/* eslint-disable prettier/prettier */
function IconLocationOn(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocationOn.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMailOutline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z'
}));

/* eslint-disable prettier/prettier */
function IconMailOutline(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMailOutline.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z'
}));

/* eslint-disable prettier/prettier */
function IconMessage(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMessage.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNoSim;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z'
}));

/* eslint-disable prettier/prettier */
function IconNoSim(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNoSim.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z'
}));

/* eslint-disable prettier/prettier */
function IconPhone(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhone.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhonelinkErase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconPhonelinkErase(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhonelinkErase.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhonelinkLock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z'
}));

/* eslint-disable prettier/prettier */
function IconPhonelinkLock(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhonelinkLock.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhonelinkRing;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z'
}));

/* eslint-disable prettier/prettier */
function IconPhonelinkRing(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhonelinkRing.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhonelinkSetup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11.8 12.5v-1l1.1-.8c.1-.1.1-.2.1-.3l-1-1.7c-.1-.1-.2-.2-.3-.1l-1.3.4c-.3-.2-.6-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.3-.2H7c-.1 0-.2.1-.3.2l-.2 1.3c-.3.1-.6.3-.9.5l-1.3-.5c-.1 0-.2 0-.3.1l-1 1.7c-.1.1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.2-.1.3-.1.4l1 1.7c.1.1.2.2.3.1l1.4-.4c.3.2.6.4.9.5l.2 1.3c-.1.1.1.2.2.2h2c.1 0 .2-.1.3-.2l.2-1.3c.3-.1.6-.3.9-.5l1.3.5c.1 0 .2 0 .3-.1l1-1.7c.1-.1 0-.2-.1-.3l-1.1-.9zM8 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconPhonelinkSetup(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhonelinkSetup.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPortableWifiOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17.56 14.24c.28-.69.44-1.45.44-2.24 0-3.31-2.69-6-6-6-.79 0-1.55.16-2.24.44l1.62 1.62c.2-.03.41-.06.62-.06a3.999 3.999 0 0 1 3.95 4.63l1.61 1.61zM12 4c4.42 0 8 3.58 8 8 0 1.35-.35 2.62-.95 3.74l1.47 1.47A9.86 9.86 0 0 0 22 12c0-5.52-4.48-10-10-10-1.91 0-3.69.55-5.21 1.47l1.46 1.46C9.37 4.34 10.65 4 12 4zM3.27 2.5L2 3.77l2.1 2.1C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02.01.01 7.51 7.51L21 20.23 4.27 3.5l-1-1z'
}));

/* eslint-disable prettier/prettier */
function IconPortableWifiOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPortableWifiOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPresentToAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z'
}));

/* eslint-disable prettier/prettier */
function IconPresentToAll(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPresentToAll.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRingVolume;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M23.71 16.67A16.971 16.971 0 0 0 12 12C7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71a.99.99 0 0 0-.29-.7zM21.16 6.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM13 2h-2v5h2V2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z'
}));

/* eslint-disable prettier/prettier */
function IconRingVolume(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRingVolume.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRssFeed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('circle', {
  cx: '6.18',
  cy: '17.82',
  r: '2.18'
}), _jsx('path', {
  d: 'M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z'
}));

/* eslint-disable prettier/prettier */
function IconRssFeed(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRssFeed.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconScreenShare;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 6a2 2 0 0 0-2-2H4c-1.11 0-2 .89-2 2v10a2 2 0 0 0 2 2H0v2h24v-2h-4zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z'
}));

/* eslint-disable prettier/prettier */
function IconScreenShare(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconScreenShare.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSpeakerPhone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41A10.963 10.963 0 0 0 12 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z'
}));

/* eslint-disable prettier/prettier */
function IconSpeakerPhone(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSpeakerPhone.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconStayCurrentLandscape;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z'
}));

/* eslint-disable prettier/prettier */
function IconStayCurrentLandscape(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconStayCurrentLandscape.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconStayCurrentPortrait;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z'
}));

/* eslint-disable prettier/prettier */
function IconStayCurrentPortrait(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconStayCurrentPortrait.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconStayPrimaryLandscape;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z'
}));

/* eslint-disable prettier/prettier */
function IconStayPrimaryLandscape(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconStayPrimaryLandscape.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconStayPrimaryPortrait;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z'
}));

/* eslint-disable prettier/prettier */
function IconStayPrimaryPortrait(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconStayPrimaryPortrait.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconStopScreenShare;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21.22 18.02l2 2H24v-2h-2.78zm.77-2l.01-10a2 2 0 0 0-2-2H7.22l5.23 5.23c.18-.04.36-.07.55-.1V7.02l4 3.73-1.58 1.47 5.54 5.54c.61-.33 1.03-.99 1.03-1.74zM2.39 1.73L1.11 3l1.54 1.54c-.4.36-.65.89-.65 1.48v10a2 2 0 0 0 2 2H0v2h18.13l2.71 2.71 1.27-1.27L2.39 1.73zM7 15.02c.31-1.48.92-2.95 2.07-4.06l1.59 1.59c-1.54.38-2.7 1.18-3.66 2.47z'
}));

/* eslint-disable prettier/prettier */
function IconStopScreenShare(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconStopScreenShare.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSwapCalls;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z'
}));

/* eslint-disable prettier/prettier */
function IconSwapCalls(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSwapCalls.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTextsms;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z'
}));

/* eslint-disable prettier/prettier */
function IconTextsms(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTextsms.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVoicemail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z'
}));

/* eslint-disable prettier/prettier */
function IconVoicemail(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVoicemail.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVpnKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12.65 10A5.99 5.99 0 0 0 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6a5.99 5.99 0 0 0 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'
}));

/* eslint-disable prettier/prettier */
function IconVpnKey(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVpnKey.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAdd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z'
}));

/* eslint-disable prettier/prettier */
function IconAdd(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAdd.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAddBox;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z'
}));

/* eslint-disable prettier/prettier */
function IconAddBox(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAddBox.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAddCircle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z'
}));

/* eslint-disable prettier/prettier */
function IconAddCircle(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAddCircle.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAddCircleOutline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconAddCircleOutline(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAddCircleOutline.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconArchive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z'
}));

/* eslint-disable prettier/prettier */
function IconArchive(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconArchive.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBlock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9A7.902 7.902 0 0 1 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1A7.902 7.902 0 0 1 20 12c0 4.42-3.58 8-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconBlock(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBlock.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconClear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
}));

/* eslint-disable prettier/prettier */
function IconClear(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconClear.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconContentCopy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z'
}));

/* eslint-disable prettier/prettier */
function IconContentCopy(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconContentCopy.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconContentCut;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm0 12c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM19 3l-6 6 2 2 7-7V3z'
}));

/* eslint-disable prettier/prettier */
function IconContentCut(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconContentCut.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconContentPaste;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z'
}));

/* eslint-disable prettier/prettier */
function IconContentPaste(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconContentPaste.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCreate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z'
}));

/* eslint-disable prettier/prettier */
function IconCreate(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCreate.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDeleteSweep;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zM14 5h-3l-1-1H6L5 5H2v2h12z'
}));

/* eslint-disable prettier/prettier */
function IconDeleteSweep(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDeleteSweep.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDrafts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z'
}));

/* eslint-disable prettier/prettier */
function IconDrafts(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDrafts.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilterList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z'
}));

/* eslint-disable prettier/prettier */
function IconFilterList(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilterList.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFlag;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z'
}));

/* eslint-disable prettier/prettier */
function IconFlag(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFlag.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFontDownload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z'
}));

/* eslint-disable prettier/prettier */
function IconFontDownload(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFontDownload.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconForward;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 8V4l8 8-8 8v-4H4V8z'
}));

/* eslint-disable prettier/prettier */
function IconForward(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconForward.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGesture;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z'
}));

/* eslint-disable prettier/prettier */
function IconGesture(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGesture.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconInbox;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z'
}));

/* eslint-disable prettier/prettier */
function IconInbox(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconInbox.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z'
}));

/* eslint-disable prettier/prettier */
function IconLink(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLink.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLowPriority;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14 5h8v2h-8zm0 5.5h8v2h-8zm0 5.5h8v2h-8zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z'
}));

/* eslint-disable prettier/prettier */
function IconLowPriority(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLowPriority.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z'
}));

/* eslint-disable prettier/prettier */
function IconMail(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMail.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMarkunread;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z'
}));

/* eslint-disable prettier/prettier */
function IconMarkunread(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMarkunread.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMoveToInbox;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z'
}));

/* eslint-disable prettier/prettier */
function IconMoveToInbox(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMoveToInbox.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNextWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z'
}));

/* eslint-disable prettier/prettier */
function IconNextWeek(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNextWeek.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRedo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16a8.002 8.002 0 0 1 7.6-5.5c1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z'
}));

/* eslint-disable prettier/prettier */
function IconRedo(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRedo.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRemove;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 13H5v-2h14v2z'
}));

/* eslint-disable prettier/prettier */
function IconRemove(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRemove.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRemoveCircle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z'
}));

/* eslint-disable prettier/prettier */
function IconRemoveCircle(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRemoveCircle.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRemoveCircleOutline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconRemoveCircleOutline(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRemoveCircleOutline.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconReply;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z'
}));

/* eslint-disable prettier/prettier */
function IconReply(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconReply.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconReplyAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z'
}));

/* eslint-disable prettier/prettier */
function IconReplyAll(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconReplyAll.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconReport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z'
}));

/* eslint-disable prettier/prettier */
function IconReport(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconReport.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSave;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z'
}));

/* eslint-disable prettier/prettier */
function IconSave(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSave.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSelectAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z'
}));

/* eslint-disable prettier/prettier */
function IconSelectAll(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSelectAll.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSend;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M2.01 21L23 12 2.01 3 2 10l15 2-15 2z'
}));

/* eslint-disable prettier/prettier */
function IconSend(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSend.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSort;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z'
}));

/* eslint-disable prettier/prettier */
function IconSort(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSort.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTextFormat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z'
}));

/* eslint-disable prettier/prettier */
function IconTextFormat(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTextFormat.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconUnarchive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20.55 5.22l-1.39-1.68A1.51 1.51 0 0 0 18 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28zM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5zM5.12 5l.82-1h12l.93 1H5.12z'
}));

/* eslint-disable prettier/prettier */
function IconUnarchive(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconUnarchive.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconUndo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z'
}));

/* eslint-disable prettier/prettier */
function IconUndo(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconUndo.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWeekend;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 10c-1.1 0-2 .9-2 2v3H5v-3c0-1.1-.9-2-2-2s-2 .9-2 2v5c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2zm-3-5H6c-1.1 0-2 .9-2 2v2.15c1.16.41 2 1.51 2 2.82V14h12v-2.03c0-1.3.84-2.4 2-2.82V7c0-1.1-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconWeekend(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWeekend.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAccessAlarm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 0 0 0-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z'
}));

/* eslint-disable prettier/prettier */
function IconAccessAlarm(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAccessAlarm.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAccessAlarms;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z'
}));

/* eslint-disable prettier/prettier */
function IconAccessAlarms(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAccessAlarms.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAccessTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z'
}));

/* eslint-disable prettier/prettier */
function IconAccessTime(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAccessTime.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAddAlarm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 0 0 0-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z'
}));

/* eslint-disable prettier/prettier */
function IconAddAlarm(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAddAlarm.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAirplanemodeActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z'
}));

/* eslint-disable prettier/prettier */
function IconAirplanemodeActive(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAirplanemodeActive.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAirplanemodeInactive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 9V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v3.68l7.83 7.83L21 16v-2l-8-5zM3 5.27l4.99 4.99L2 14v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-3.73L18.73 21 20 19.73 4.27 4 3 5.27z'
}));

/* eslint-disable prettier/prettier */
function IconAirplanemodeInactive(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAirplanemodeInactive.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBattery20;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z'
}), _jsx('path', {
  fillOpacity: '.3',
  d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z'
}));

/* eslint-disable prettier/prettier */
function IconBattery20(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBattery20.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBattery30;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z'
}), _jsx('path', {
  d: 'M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z'
}));

/* eslint-disable prettier/prettier */
function IconBattery30(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBattery30.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBattery50;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z'
}), _jsx('path', {
  d: 'M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z'
}));

/* eslint-disable prettier/prettier */
function IconBattery50(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBattery50.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBattery60;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z'
}), _jsx('path', {
  d: 'M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z'
}));

/* eslint-disable prettier/prettier */
function IconBattery60(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBattery60.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBattery80;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z'
}), _jsx('path', {
  d: 'M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z'
}));

/* eslint-disable prettier/prettier */
function IconBattery80(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBattery80.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBattery90;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z'
}), _jsx('path', {
  d: 'M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z'
}));

/* eslint-disable prettier/prettier */
function IconBattery90(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBattery90.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBatteryAlert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z'
}));

/* eslint-disable prettier/prettier */
function IconBatteryAlert(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBatteryAlert.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBatteryCharging20;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 20v-3H7v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17h-4.4L11 20z'
}), _jsx('path', {
  fillOpacity: '.3',
  d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h4v-2.5H9L13 7v5.5h2L12.6 17H17V5.33C17 4.6 16.4 4 15.67 4z'
}));

/* eslint-disable prettier/prettier */
function IconBatteryCharging20(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBatteryCharging20.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBatteryCharging30;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v9.17h2L13 7v5.5h2l-1.07 2H17V5.33C17 4.6 16.4 4 15.67 4z'
}), _jsx('path', {
  d: 'M11 20v-5.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07L11 20z'
}));

/* eslint-disable prettier/prettier */
function IconBatteryCharging30(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBatteryCharging30.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBatteryCharging50;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14.47 13.5L11 20v-5.5H9l.53-1H7v7.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13.5h-2.53z'
}), _jsx('path', {
  fillOpacity: '.3',
  d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v8.17h2.53L13 7v5.5h2l-.53 1H17V5.33C17 4.6 16.4 4 15.67 4z'
}));

/* eslint-disable prettier/prettier */
function IconBatteryCharging50(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBatteryCharging50.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBatteryCharging60;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h3.87L13 7v4h4V5.33C17 4.6 16.4 4 15.67 4z'
}), _jsx('path', {
  d: 'M13 12.5h2L11 20v-5.5H9l1.87-3.5H7v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11h-4v1.5z'
}));

/* eslint-disable prettier/prettier */
function IconBatteryCharging60(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBatteryCharging60.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBatteryCharging80;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h4.93L13 7v2h4V5.33C17 4.6 16.4 4 15.67 4z'
}), _jsx('path', {
  d: 'M13 12.5h2L11 20v-5.5H9L11.93 9H7v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9h-4v3.5z'
}));

/* eslint-disable prettier/prettier */
function IconBatteryCharging80(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBatteryCharging80.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBatteryCharging90;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h5.47L13 7v1h4V5.33C17 4.6 16.4 4 15.67 4z'
}), _jsx('path', {
  d: 'M13 12.5h2L11 20v-5.5H9L12.47 8H7v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8h-4v4.5z'
}));

/* eslint-disable prettier/prettier */
function IconBatteryCharging90(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBatteryCharging90.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBatteryChargingFull;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z'
}));

/* eslint-disable prettier/prettier */
function IconBatteryChargingFull(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBatteryChargingFull.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBatteryFull;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z'
}));

/* eslint-disable prettier/prettier */
function IconBatteryFull(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBatteryFull.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBatteryStd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z'
}));

/* eslint-disable prettier/prettier */
function IconBatteryStd(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBatteryStd.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBatteryUnknown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zm-2.72 13.95h-1.9v-1.9h1.9v1.9zm1.35-5.26s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94A1.498 1.498 0 0 0 12 9.5c-.83 0-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z'
}));

/* eslint-disable prettier/prettier */
function IconBatteryUnknown(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBatteryUnknown.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBluetooth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z'
}));

/* eslint-disable prettier/prettier */
function IconBluetooth(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBluetooth.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBluetoothConnected;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconBluetoothConnected(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBluetoothConnected.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBluetoothDisabled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z'
}));

/* eslint-disable prettier/prettier */
function IconBluetoothDisabled(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBluetoothDisabled.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBluetoothSearching;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2a9.936 9.936 0 0 0 1.54-5.31c-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z'
}));

/* eslint-disable prettier/prettier */
function IconBluetoothSearching(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBluetoothSearching.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBrightnessAuto;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10.85 12.65h2.3L12 9l-1.15 3.65zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9z'
}));

/* eslint-disable prettier/prettier */
function IconBrightnessAuto(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBrightnessAuto.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBrightnessHigh;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z'
}));

/* eslint-disable prettier/prettier */
function IconBrightnessHigh(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBrightnessHigh.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBrightnessLow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z'
}));

/* eslint-disable prettier/prettier */
function IconBrightnessLow(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBrightnessLow.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBrightnessMedium;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z'
}));

/* eslint-disable prettier/prettier */
function IconBrightnessMedium(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBrightnessMedium.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDataUsage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53A6.95 6.95 0 0 1 12 19z'
}));

/* eslint-disable prettier/prettier */
function IconDataUsage(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDataUsage.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDeveloperMode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z'
}));

/* eslint-disable prettier/prettier */
function IconDeveloperMode(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDeveloperMode.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDevices;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z'
}));

/* eslint-disable prettier/prettier */
function IconDevices(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDevices.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDvr;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z'
}));

/* eslint-disable prettier/prettier */
function IconDvr(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDvr.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGpsFixed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z'
}));

/* eslint-disable prettier/prettier */
function IconGpsFixed(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGpsFixed.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGpsNotFixed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20.94 11A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z'
}));

/* eslint-disable prettier/prettier */
function IconGpsNotFixed(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGpsNotFixed.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGpsOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20.94 11A8.994 8.994 0 0 0 13 3.06V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5A6.995 6.995 0 0 1 19 12c0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04A8.914 8.914 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27a6.995 6.995 0 0 1-9.81-9.81l9.81 9.81z'
}));

/* eslint-disable prettier/prettier */
function IconGpsOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGpsOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGraphicEq;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z'
}));

/* eslint-disable prettier/prettier */
function IconGraphicEq(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGraphicEq.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocationDisabled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20.94 11A8.994 8.994 0 0 0 13 3.06V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5A6.995 6.995 0 0 1 19 12c0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04A8.914 8.914 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27a6.995 6.995 0 0 1-9.81-9.81l9.81 9.81z'
}));

/* eslint-disable prettier/prettier */
function IconLocationDisabled(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocationDisabled.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocationSearching;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20.94 11A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z'
}));

/* eslint-disable prettier/prettier */
function IconLocationSearching(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocationSearching.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNetworkCell;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M2 22h20V2z'
}), _jsx('path', {
  d: 'M17 7L2 22h15z'
}));

/* eslint-disable prettier/prettier */
function IconNetworkCell(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNetworkCell.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNetworkWifi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z'
}), _jsx('path', {
  d: 'M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z'
}));

/* eslint-disable prettier/prettier */
function IconNetworkWifi(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNetworkWifi.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNfc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z'
}));

/* eslint-disable prettier/prettier */
function IconNfc(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNfc.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconScreenLockLandscape;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1a2 2 0 1 0-4 0v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1z'
}));

/* eslint-disable prettier/prettier */
function IconScreenLockLandscape(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconScreenLockLandscape.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconScreenLockPortrait;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1a2 2 0 1 0-4 0v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z'
}));

/* eslint-disable prettier/prettier */
function IconScreenLockPortrait(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconScreenLockPortrait.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconScreenLockRotation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M23.25 12.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L4.51 8.17l5.66-5.66 2.1 2.1 1.41-1.41L11.23.75a1.49 1.49 0 0 0-2.12 0L2.75 7.11a1.49 1.49 0 0 0 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM8.47 20.48A10.487 10.487 0 0 1 2.5 12H1c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.82-1.33 1.33zM16 9h5c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1v-.5a2.5 2.5 0 0 0-5 0V3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V3h-3.4v-.5z'
}));

/* eslint-disable prettier/prettier */
function IconScreenLockRotation(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconScreenLockRotation.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconScreenRotation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77a1.49 1.49 0 0 0-2.12 0L1.75 8.11a1.49 1.49 0 0 0 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29A10.487 10.487 0 0 1 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z'
}));

/* eslint-disable prettier/prettier */
function IconScreenRotation(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconScreenRotation.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSdStorage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z'
}));

/* eslint-disable prettier/prettier */
function IconSdStorage(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSdStorage.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSettingsSystemDaydream;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 16h6.5a2.5 2.5 0 0 0 0-5h-.05c-.24-1.69-1.69-3-3.45-3-1.4 0-2.6.83-3.16 2.02h-.16A2.994 2.994 0 0 0 6 13c0 1.66 1.34 3 3 3zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z'
}));

/* eslint-disable prettier/prettier */
function IconSettingsSystemDaydream(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSettingsSystemDaydream.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalCellular0Bar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M2 22h20V2z'
}));

/* eslint-disable prettier/prettier */
function IconSignalCellular0Bar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalCellular0Bar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalCellular1Bar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M2 22h20V2z'
}), _jsx('path', {
  d: 'M12 12L2 22h10z'
}));

/* eslint-disable prettier/prettier */
function IconSignalCellular1Bar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalCellular1Bar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalCellular2Bar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M2 22h20V2z'
}), _jsx('path', {
  d: 'M14 10L2 22h12z'
}));

/* eslint-disable prettier/prettier */
function IconSignalCellular2Bar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalCellular2Bar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalCellular3Bar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M2 22h20V2z'
}), _jsx('path', {
  d: 'M17 7L2 22h15z'
}));

/* eslint-disable prettier/prettier */
function IconSignalCellular3Bar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalCellular3Bar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalCellular4Bar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M2 22h20V2z'
}));

/* eslint-disable prettier/prettier */
function IconSignalCellular4Bar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalCellular4Bar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalCellularConnectedNoInternet0Bar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M22 8V2L2 22h16V8z'
}), _jsx('path', {
  d: 'M20 22h2v-2h-2v2zm0-12v8h2v-8h-2z'
}));

/* eslint-disable prettier/prettier */
function IconSignalCellularConnectedNoInternet0Bar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalCellularConnectedNoInternet0Bar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalCellularConnectedNoInternet1Bar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M22 8V2L2 22h16V8z'
}), _jsx('path', {
  d: 'M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z'
}));

/* eslint-disable prettier/prettier */
function IconSignalCellularConnectedNoInternet1Bar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalCellularConnectedNoInternet1Bar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalCellularConnectedNoInternet2Bar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M22 8V2L2 22h16V8z'
}), _jsx('path', {
  d: 'M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z'
}));

/* eslint-disable prettier/prettier */
function IconSignalCellularConnectedNoInternet2Bar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalCellularConnectedNoInternet2Bar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalCellularConnectedNoInternet3Bar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M22 8V2L2 22h16V8z'
}), _jsx('path', {
  d: 'M17 22V7L2 22h15zm3-12v8h2v-8h-2zm0 12h2v-2h-2v2z'
}));

/* eslint-disable prettier/prettier */
function IconSignalCellularConnectedNoInternet3Bar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalCellularConnectedNoInternet3Bar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalCellularConnectedNoInternet4Bar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z'
}));

/* eslint-disable prettier/prettier */
function IconSignalCellularConnectedNoInternet4Bar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalCellularConnectedNoInternet4Bar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalCellularNoSim;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z'
}));

/* eslint-disable prettier/prettier */
function IconSignalCellularNoSim(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalCellularNoSim.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalCellularNull;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z'
}));

/* eslint-disable prettier/prettier */
function IconSignalCellularNull(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalCellularNull.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalCellularOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 1l-8.59 8.59L21 18.18V1zM4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73 4.77 4.5z'
}));

/* eslint-disable prettier/prettier */
function IconSignalCellularOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalCellularOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalWifi0Bar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z'
}));

/* eslint-disable prettier/prettier */
function IconSignalWifi0Bar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalWifi0Bar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalWifi1Bar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z'
}), _jsx('path', {
  d: 'M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z'
}));

/* eslint-disable prettier/prettier */
function IconSignalWifi1Bar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalWifi1Bar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalWifi1BarLock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z'
}), _jsx('path', {
  d: 'M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z',
  opacity: '.3'
}), _jsx('path', {
  d: 'M6.7 14.9l5.3 6.6 3.5-4.3v-2.6c0-.2 0-.5.1-.7-.9-.5-2.2-.9-3.6-.9-3 0-5.1 1.7-5.3 1.9z'
}));

/* eslint-disable prettier/prettier */
function IconSignalWifi1BarLock(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalWifi1BarLock.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalWifi2Bar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z'
}), _jsx('path', {
  d: 'M4.79 12.52l7.2 8.98H12l.01-.01 7.2-8.98C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z'
}));

/* eslint-disable prettier/prettier */
function IconSignalWifi2Bar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalWifi2Bar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalWifi2BarLock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z'
}), _jsx('path', {
  d: 'M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z',
  opacity: '.3'
}), _jsx('path', {
  d: 'M4.8 12.5l7.2 9 3.5-4.4v-2.6c0-1.3.5-2.5 1.4-3.4C15.6 10.5 14 10 12 10c-4.1 0-6.8 2.2-7.2 2.5z'
}));

/* eslint-disable prettier/prettier */
function IconSignalWifi2BarLock(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalWifi2BarLock.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalWifi3Bar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.3',
  d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z'
}), _jsx('path', {
  d: 'M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z'
}));

/* eslint-disable prettier/prettier */
function IconSignalWifi3Bar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalWifi3Bar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalWifi3BarLock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  opacity: '.3',
  d: 'M12 3C5.3 3 .8 6.7.4 7l3.2 3.9L12 21.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7.3-.1.5-.2.8-.2.3-.1.6-.1.9-.1.4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4z'
}), _jsx('path', {
  d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-10 5.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7C17.3 9 14.9 8 12 8c-4.8 0-8 2.6-8.5 2.9'
}));

/* eslint-disable prettier/prettier */
function IconSignalWifi3BarLock(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalWifi3BarLock.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalWifi4Bar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z'
}));

/* eslint-disable prettier/prettier */
function IconSignalWifi4Bar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalWifi4Bar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalWifi4BarLock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-6.5-1.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.4v-2.6z'
}));

/* eslint-disable prettier/prettier */
function IconSignalWifi4BarLock(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalWifi4BarLock.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSignalWifiOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8 23.64 7zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27-3.46-3.46z'
}));

/* eslint-disable prettier/prettier */
function IconSignalWifiOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSignalWifiOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconStorage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z'
}));

/* eslint-disable prettier/prettier */
function IconStorage(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconStorage.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconUsb;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2 0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95a2.2 2.2 0 0 0 4.4 0c0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z'
}));

/* eslint-disable prettier/prettier */
function IconUsb(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconUsb.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWallpaper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z'
}));

/* eslint-disable prettier/prettier */
function IconWallpaper(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWallpaper.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWidgets;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z'
}));

/* eslint-disable prettier/prettier */
function IconWidgets(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWidgets.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWifiLock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20.5 9.5c.28 0 .55.04.81.08L24 6c-3.34-2.51-7.5-4-12-4S3.34 3.49 0 6l12 16 3.5-4.67V14.5c0-2.76 2.24-5 5-5zM23 16v-1.5a2.5 2.5 0 0 0-5 0V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z'
}));

/* eslint-disable prettier/prettier */
function IconWifiLock(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWifiLock.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWifiTethering;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z'
}));

/* eslint-disable prettier/prettier */
function IconWifiTethering(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWifiTethering.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAttachFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 0 1 5 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 0 0 5 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z'
}));

/* eslint-disable prettier/prettier */
function IconAttachFile(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAttachFile.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAttachMoney;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z'
}));

/* eslint-disable prettier/prettier */
function IconAttachMoney(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAttachMoney.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBorderAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z'
}));

/* eslint-disable prettier/prettier */
function IconBorderAll(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBorderAll.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBorderBottom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z'
}));

/* eslint-disable prettier/prettier */
function IconBorderBottom(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBorderBottom.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBorderClear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 5h2V3H7v2zm0 8h2v-2H7v2zm0 8h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm-8 0h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2V7H3v2zm0-4h2V3H3v2zm8 8h2v-2h-2v2zm8 4h2v-2h-2v2zm0-4h2v-2h-2v2zm0 8h2v-2h-2v2zm0-12h2V7h-2v2zm-8 0h2V7h-2v2zm8-6v2h2V3h-2zm-8 2h2V3h-2v2zm4 16h2v-2h-2v2zm0-8h2v-2h-2v2zm0-8h2V3h-2v2z'
}));

/* eslint-disable prettier/prettier */
function IconBorderClear(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBorderClear.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBorderColor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96a.996.996 0 0 0 0-1.41L18.37.29a.996.996 0 0 0-1.41 0L15 2.25 18.75 6l1.96-1.96z'
}), _jsx('path', {
  fillOpacity: '.36',
  d: 'M0 20h24v4H0z'
}));

/* eslint-disable prettier/prettier */
function IconBorderColor(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBorderColor.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBorderHorizontal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 21h2v-2H3v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zm4 4h2v-2H7v2zM5 3H3v2h2V3zm4 0H7v2h2V3zm8 0h-2v2h2V3zm-4 4h-2v2h2V7zm0-4h-2v2h2V3zm6 14h2v-2h-2v2zm-8 4h2v-2h-2v2zm-8-8h18v-2H3v2zM19 3v2h2V3h-2zm0 6h2V7h-2v2zm-8 8h2v-2h-2v2zm4 4h2v-2h-2v2zm4 0h2v-2h-2v2z'
}));

/* eslint-disable prettier/prettier */
function IconBorderHorizontal(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBorderHorizontal.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBorderInner;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3zm6 18h2v-2h-2v2zm0-4h2v-2h-2v2z'
}));

/* eslint-disable prettier/prettier */
function IconBorderInner(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBorderInner.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBorderLeft;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z'
}));

/* eslint-disable prettier/prettier */
function IconBorderLeft(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBorderLeft.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBorderOuter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z'
}));

/* eslint-disable prettier/prettier */
function IconBorderOuter(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBorderOuter.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBorderRight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z'
}));

/* eslint-disable prettier/prettier */
function IconBorderRight(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBorderRight.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBorderStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z'
}));

/* eslint-disable prettier/prettier */
function IconBorderStyle(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBorderStyle.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBorderTop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z'
}));

/* eslint-disable prettier/prettier */
function IconBorderTop(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBorderTop.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBorderVertical;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-8 4h2V3h-2v18zm8 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z'
}));

/* eslint-disable prettier/prettier */
function IconBorderVertical(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBorderVertical.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBubbleChart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('circle', {
  cx: '7.2',
  cy: '14.4',
  r: '3.2'
}), _jsx('circle', {
  cx: '14.8',
  cy: '18',
  r: '2'
}), _jsx('circle', {
  cx: '15.2',
  cy: '8.8',
  r: '4.8'
}));

/* eslint-disable prettier/prettier */
function IconBubbleChart(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBubbleChart.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDragHandle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 9H4v2h16V9zM4 15h16v-2H4v2z'
}));

/* eslint-disable prettier/prettier */
function IconDragHandle(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDragHandle.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatAlignCenter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z'
}));

/* eslint-disable prettier/prettier */
function IconFormatAlignCenter(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatAlignCenter.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatAlignJustify;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z'
}));

/* eslint-disable prettier/prettier */
function IconFormatAlignJustify(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatAlignJustify.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatAlignLeft;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z'
}));

/* eslint-disable prettier/prettier */
function IconFormatAlignLeft(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatAlignLeft.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatAlignRight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z'
}));

/* eslint-disable prettier/prettier */
function IconFormatAlignRight(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatAlignRight.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatBold;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z'
}));

/* eslint-disable prettier/prettier */
function IconFormatBold(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatBold.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatClear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z'
}));

/* eslint-disable prettier/prettier */
function IconFormatClear(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatClear.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatColorFill;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15a1.49 1.49 0 0 0 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z'
}), _jsx('path', {
  fillOpacity: '.36',
  d: 'M0 20h24v4H0z'
}));

/* eslint-disable prettier/prettier */
function IconFormatColorFill(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatColorFill.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatColorReset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 14c0-4-6-10.8-6-10.8s-1.33 1.51-2.73 3.52l8.59 8.59c.09-.42.14-.86.14-1.31zm-.88 3.12L12.5 12.5 5.27 5.27 4 6.55l3.32 3.32C6.55 11.32 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.96-1.5l2.63 2.63 1.27-1.27-2.74-2.74z'
}));

/* eslint-disable prettier/prettier */
function IconFormatColorReset(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatColorReset.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatColorText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  fillOpacity: '.36',
  d: 'M0 20h24v4H0z'
}), _jsx('path', {
  d: 'M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z'
}));

/* eslint-disable prettier/prettier */
function IconFormatColorText(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatColorText.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatIndentDecrease;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z'
}));

/* eslint-disable prettier/prettier */
function IconFormatIndentDecrease(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatIndentDecrease.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatIndentIncrease;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z'
}));

/* eslint-disable prettier/prettier */
function IconFormatIndentIncrease(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatIndentIncrease.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatItalic;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z'
}));

/* eslint-disable prettier/prettier */
function IconFormatItalic(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatItalic.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatLineSpacing;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z'
}));

/* eslint-disable prettier/prettier */
function IconFormatLineSpacing(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatLineSpacing.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatListBulleted;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z'
}));

/* eslint-disable prettier/prettier */
function IconFormatListBulleted(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatListBulleted.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatListNumbered;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z'
}));

/* eslint-disable prettier/prettier */
function IconFormatListNumbered(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatListNumbered.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatPaint;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3z'
}));

/* eslint-disable prettier/prettier */
function IconFormatPaint(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatPaint.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatQuote;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z'
}));

/* eslint-disable prettier/prettier */
function IconFormatQuote(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatQuote.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatShapes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z'
}));

/* eslint-disable prettier/prettier */
function IconFormatShapes(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatShapes.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z'
}));

/* eslint-disable prettier/prettier */
function IconFormatSize(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatSize.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatStrikethrough;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z'
}));

/* eslint-disable prettier/prettier */
function IconFormatStrikethrough(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatStrikethrough.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatTextdirectionLToR;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4zm12 8l-4-4v3H5v2h12v3l4-4z'
}));

/* eslint-disable prettier/prettier */
function IconFormatTextdirectionLToR(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatTextdirectionLToR.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatTextdirectionRToL;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4zm-2 7v-3l-4 4 4 4v-3h12v-2H8z'
}));

/* eslint-disable prettier/prettier */
function IconFormatTextdirectionRToL(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatTextdirectionRToL.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFormatUnderlined;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z'
}));

/* eslint-disable prettier/prettier */
function IconFormatUnderlined(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFormatUnderlined.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFunctions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z'
}));

/* eslint-disable prettier/prettier */
function IconFunctions(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFunctions.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHighlight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 14l3 3v5h6v-5l3-3V9H6zm5-12h2v3h-2zM3.5 5.875L4.914 4.46l2.12 2.122L5.62 7.997zm13.46.71l2.123-2.12 1.414 1.414L18.375 8z'
}));

/* eslint-disable prettier/prettier */
function IconHighlight(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHighlight.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconInsertChart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z'
}));

/* eslint-disable prettier/prettier */
function IconInsertChart(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconInsertChart.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconInsertComment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z'
}));

/* eslint-disable prettier/prettier */
function IconInsertComment(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconInsertComment.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconInsertDriveFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z'
}));

/* eslint-disable prettier/prettier */
function IconInsertDriveFile(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconInsertDriveFile.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconInsertEmoticon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z'
}));

/* eslint-disable prettier/prettier */
function IconInsertEmoticon(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconInsertEmoticon.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconInsertInvitation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z'
}));

/* eslint-disable prettier/prettier */
function IconInsertInvitation(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconInsertInvitation.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconInsertLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z'
}));

/* eslint-disable prettier/prettier */
function IconInsertLink(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconInsertLink.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconInsertPhoto;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z'
}));

/* eslint-disable prettier/prettier */
function IconInsertPhoto(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconInsertPhoto.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLinearScale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5a2.5 2.5 0 0 0 0 5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5a2.5 2.5 0 0 0 0-5z'
}));

/* eslint-disable prettier/prettier */
function IconLinearScale(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLinearScale.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMergeType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z'
}));

/* eslint-disable prettier/prettier */
function IconMergeType(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMergeType.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconModeComment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z'
}));

/* eslint-disable prettier/prettier */
function IconModeComment(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconModeComment.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconModeEdit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z'
}));

/* eslint-disable prettier/prettier */
function IconModeEdit(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconModeEdit.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMonetizationOn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z'
}));

/* eslint-disable prettier/prettier */
function IconMonetizationOn(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMonetizationOn.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMoneyOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.53.12-1.03.3-1.48.54l1.47 1.47c.41-.17.91-.27 1.51-.27zM5.33 4.06L4.06 5.33 7.5 8.77c0 2.08 1.56 3.21 3.91 3.91l3.51 3.51c-.34.48-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.82-.55 2.45-1.12l2.22 2.22 1.27-1.27L5.33 4.06z'
}));

/* eslint-disable prettier/prettier */
function IconMoneyOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMoneyOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMultilineChart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z'
}));

/* eslint-disable prettier/prettier */
function IconMultilineChart(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMultilineChart.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPieChart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z'
}));

/* eslint-disable prettier/prettier */
function IconPieChart(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPieChart.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPieChartOutlined;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 2.07c3.61.45 6.48 3.33 6.93 6.93H13V4.07zM4 12c0-4.06 3.07-7.44 7-7.93v15.87c-3.93-.5-7-3.88-7-7.94zm9 7.93V13h6.93A8.002 8.002 0 0 1 13 19.93z'
}));

/* eslint-disable prettier/prettier */
function IconPieChartOutlined(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPieChartOutlined.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPublish;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z'
}));

/* eslint-disable prettier/prettier */
function IconPublish(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPublish.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconShortText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 9h16v2H4zm0 4h10v2H4z'
}));

/* eslint-disable prettier/prettier */
function IconShortText(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconShortText.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconShowChart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z'
}));

/* eslint-disable prettier/prettier */
function IconShowChart(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconShowChart.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSpaceBar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 9v4H6V9H4v6h16V9z'
}));

/* eslint-disable prettier/prettier */
function IconSpaceBar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSpaceBar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconStrikethroughS;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7.24 8.75c-.26-.48-.39-1.03-.39-1.67 0-.61.13-1.16.4-1.67.26-.5.63-.93 1.11-1.29a5.73 5.73 0 0 1 1.7-.83c.66-.19 1.39-.29 2.18-.29.81 0 1.54.11 2.21.34.66.22 1.23.54 1.69.94.47.4.83.88 1.08 1.43.25.55.38 1.15.38 1.81h-3.01c0-.31-.05-.59-.15-.85-.09-.27-.24-.49-.44-.68-.2-.19-.45-.33-.75-.44-.3-.1-.66-.16-1.06-.16-.39 0-.74.04-1.03.13-.29.09-.53.21-.72.36-.19.16-.34.34-.44.55-.1.21-.15.43-.15.66 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.05-.08-.11-.17-.15-.25zM21 12v-2H3v2h9.62c.18.07.4.14.55.2.37.17.66.34.87.51.21.17.35.36.43.57.07.2.11.43.11.69 0 .23-.05.45-.14.66-.09.2-.23.38-.42.53-.19.15-.42.26-.71.35-.29.08-.63.13-1.01.13-.43 0-.83-.04-1.18-.13s-.66-.23-.91-.42c-.25-.19-.45-.44-.59-.75-.14-.31-.25-.76-.25-1.21H6.4c0 .55.08 1.13.24 1.58.16.45.37.85.65 1.21.28.35.6.66.98.92.37.26.78.48 1.22.65.44.17.9.3 1.38.39.48.08.96.13 1.44.13.8 0 1.53-.09 2.18-.28s1.21-.45 1.67-.79c.46-.34.82-.77 1.07-1.27s.38-1.07.38-1.71c0-.6-.1-1.14-.31-1.61-.05-.11-.11-.23-.17-.33H21z'
}));

/* eslint-disable prettier/prettier */
function IconStrikethroughS(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconStrikethroughS.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTextFields;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z'
}));

/* eslint-disable prettier/prettier */
function IconTextFields(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTextFields.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTitle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5 4v3h5.5v12h3V7H19V4z'
}));

/* eslint-disable prettier/prettier */
function IconTitle(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTitle.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVerticalAlignBottom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z'
}));

/* eslint-disable prettier/prettier */
function IconVerticalAlignBottom(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVerticalAlignBottom.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVerticalAlignCenter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z'
}));

/* eslint-disable prettier/prettier */
function IconVerticalAlignCenter(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVerticalAlignCenter.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVerticalAlignTop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z'
}));

/* eslint-disable prettier/prettier */
function IconVerticalAlignTop(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVerticalAlignTop.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWrapText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z'
}));

/* eslint-disable prettier/prettier */
function IconWrapText(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWrapText.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAttachment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5a2.5 2.5 0 0 1 0-5H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z'
}));

/* eslint-disable prettier/prettier */
function IconAttachment(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAttachment.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCloudCircle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14H8c-1.66 0-3-1.34-3-3s1.34-3 3-3l.14.01A3.98 3.98 0 0 1 12 7c2.21 0 4 1.79 4 4h.5a2.5 2.5 0 0 1 0 5z'
}));

/* eslint-disable prettier/prettier */
function IconCloudCircle(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCloudCircle.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCloudDone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41L10 17z'
}));

/* eslint-disable prettier/prettier */
function IconCloudDone(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCloudDone.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCloudDownload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z'
}));

/* eslint-disable prettier/prettier */
function IconCloudDownload(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCloudDownload.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCloudOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.35 10.04A7.49 7.49 0 0 0 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46a5.497 5.497 0 0 1 8.05 4.87v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z'
}));

/* eslint-disable prettier/prettier */
function IconCloudOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCloudOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCloudQueue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z'
}));

/* eslint-disable prettier/prettier */
function IconCloudQueue(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCloudQueue.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCloudUpload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z'
}));

/* eslint-disable prettier/prettier */
function IconCloudUpload(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCloudUpload.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCreateNewFolder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z'
}));

/* eslint-disable prettier/prettier */
function IconCreateNewFolder(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCreateNewFolder.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFileDownload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z'
}));

/* eslint-disable prettier/prettier */
function IconFileDownload(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFileDownload.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFileUpload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z'
}));

/* eslint-disable prettier/prettier */
function IconFileUpload(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFileUpload.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFolder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconFolder(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFolder.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFolderOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z'
}));

/* eslint-disable prettier/prettier */
function IconFolderOpen(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFolderOpen.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFolderShared;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z'
}));

/* eslint-disable prettier/prettier */
function IconFolderShared(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFolderShared.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCast;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2a9 9 0 0 1 9 9h2c0-6.08-4.93-11-11-11z'
}));

/* eslint-disable prettier/prettier */
function IconCast(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCast.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCastConnected;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2a9 9 0 0 1 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconCastConnected(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCastConnected.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconComputer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z'
}));

/* eslint-disable prettier/prettier */
function IconComputer(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconComputer.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDesktopMac;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z'
}));

/* eslint-disable prettier/prettier */
function IconDesktopMac(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDesktopMac.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDesktopWindows;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z'
}));

/* eslint-disable prettier/prettier */
function IconDesktopWindows(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDesktopWindows.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDeveloperBoard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6zm6-6h4v3h-4zM6 7h5v5H6zm6 4h4v6h-4z'
}));

/* eslint-disable prettier/prettier */
function IconDeveloperBoard(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDeveloperBoard.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDeviceHub;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z'
}));

/* eslint-disable prettier/prettier */
function IconDeviceHub(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDeviceHub.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDevicesOther;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22s.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z'
}));

/* eslint-disable prettier/prettier */
function IconDevicesOther(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDevicesOther.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M8 23h8v-2H8v2zm8-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z'
}));

/* eslint-disable prettier/prettier */
function IconDock(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDock.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGamepad;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z'
}));

/* eslint-disable prettier/prettier */
function IconGamepad(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGamepad.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHeadset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 1a9 9 0 0 0-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7a9 9 0 0 0-9-9z'
}));

/* eslint-disable prettier/prettier */
function IconHeadset(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHeadset.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHeadsetMic;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 1a9 9 0 0 0-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10a9 9 0 0 0-9-9z'
}));

/* eslint-disable prettier/prettier */
function IconHeadsetMic(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHeadsetMic.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconKeyboard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z'
}));

/* eslint-disable prettier/prettier */
function IconKeyboard(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconKeyboard.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconKeyboardArrowDown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z'
}));

/* eslint-disable prettier/prettier */
function IconKeyboardArrowDown(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconKeyboardArrowDown.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconKeyboardArrowLeft;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z'
}));

/* eslint-disable prettier/prettier */
function IconKeyboardArrowLeft(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconKeyboardArrowLeft.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconKeyboardArrowRight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z'
}));

/* eslint-disable prettier/prettier */
function IconKeyboardArrowRight(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconKeyboardArrowRight.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconKeyboardArrowUp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z'
}));

/* eslint-disable prettier/prettier */
function IconKeyboardArrowUp(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconKeyboardArrowUp.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconKeyboardBackspace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z'
}));

/* eslint-disable prettier/prettier */
function IconKeyboardBackspace(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconKeyboardBackspace.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconKeyboardCapslock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z'
}));

/* eslint-disable prettier/prettier */
function IconKeyboardCapslock(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconKeyboardCapslock.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconKeyboardHide;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 3h2v2h-2V6zm0 3h2v2h-2V9zM8 6h2v2H8V6zm0 3h2v2H8V9zm-1 2H5V9h2v2zm0-3H5V6h2v2zm9 7H8v-2h8v2zm0-4h-2V9h2v2zm0-3h-2V6h2v2zm3 3h-2V9h2v2zm0-3h-2V6h2v2zm-7 15l4-4H8l4 4z'
}));

/* eslint-disable prettier/prettier */
function IconKeyboardHide(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconKeyboardHide.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconKeyboardReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z'
}));

/* eslint-disable prettier/prettier */
function IconKeyboardReturn(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconKeyboardReturn.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconKeyboardTab;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z'
}));

/* eslint-disable prettier/prettier */
function IconKeyboardTab(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconKeyboardTab.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconKeyboardVoice;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.42 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z'
}));

/* eslint-disable prettier/prettier */
function IconKeyboardVoice(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconKeyboardVoice.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLaptop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z'
}));

/* eslint-disable prettier/prettier */
function IconLaptop(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLaptop.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLaptopChromebook;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z'
}));

/* eslint-disable prettier/prettier */
function IconLaptopChromebook(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLaptopChromebook.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLaptopMac;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'
}));

/* eslint-disable prettier/prettier */
function IconLaptopMac(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLaptopMac.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLaptopWindows;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z'
}));

/* eslint-disable prettier/prettier */
function IconLaptopWindows(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLaptopWindows.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMemory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z'
}));

/* eslint-disable prettier/prettier */
function IconMemory(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMemory.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMouse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93zM4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4zm7-13.93C7.05 1.56 4 4.92 4 9h7V1.07z'
}));

/* eslint-disable prettier/prettier */
function IconMouse(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMouse.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhoneAndroid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z'
}));

/* eslint-disable prettier/prettier */
function IconPhoneAndroid(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhoneAndroid.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhoneIphone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.5 1h-8A2.5 2.5 0 0 0 5 3.5v17A2.5 2.5 0 0 0 7.5 23h8a2.5 2.5 0 0 0 2.5-2.5v-17A2.5 2.5 0 0 0 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z'
}));

/* eslint-disable prettier/prettier */
function IconPhoneIphone(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhoneIphone.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhonelink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z'
}));

/* eslint-disable prettier/prettier */
function IconPhonelink(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhonelink.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhonelinkOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 6V4H6.82l2 2H22zM1.92 1.65L.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.27-1.27L3.89 3.62 1.92 1.65zM4 6.27L14.73 17H4V6.27zM23 8h-6c-.55 0-1 .45-1 1v4.18l2 2V10h4v7h-2.18l3 3H23c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z'
}));

/* eslint-disable prettier/prettier */
function IconPhonelinkOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhonelinkOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPowerInput;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z'
}));

/* eslint-disable prettier/prettier */
function IconPowerInput(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPowerInput.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20.2 5.9l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7zm-.9.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1 .9 0 1.8.3 2.5 1l.8-.8zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM8 18H6v-2h2v2zm3.5 0h-2v-2h2v2zm3.5 0h-2v-2h2v2z'
}));

/* eslint-disable prettier/prettier */
function IconRouter(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRouter.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconScanner;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM7 17H5v-2h2v2zm12 0H9v-2h10v2z'
}));

/* eslint-disable prettier/prettier */
function IconScanner(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconScanner.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSecurity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z'
}));

/* eslint-disable prettier/prettier */
function IconSecurity(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSecurity.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSimCard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.99 4c0-1.1-.89-2-1.99-2h-8L4 8v12c0 1.1.9 2 2 2h12.01c1.1 0 1.99-.9 1.99-2l-.01-16zM9 19H7v-2h2v2zm8 0h-2v-2h2v2zm-8-4H7v-4h2v4zm4 4h-2v-4h2v4zm0-6h-2v-2h2v2zm4 2h-2v-4h2v4z'
}));

/* eslint-disable prettier/prettier */
function IconSimCard(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSimCard.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSmartphone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z'
}));

/* eslint-disable prettier/prettier */
function IconSmartphone(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSmartphone.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSpeaker;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 2c1.1 0 2 .9 2 2s-.9 2-2 2a2 2 0 1 1 0-4zm0 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z'
}));

/* eslint-disable prettier/prettier */
function IconSpeaker(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSpeaker.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSpeakerGroup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM14 3c1.1 0 2 .89 2 2s-.9 2-2 2-2-.89-2-2 .9-2 2-2zm0 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z'
}), _jsx('circle', {
  cx: '14',
  cy: '12.5',
  r: '2.5'
}), _jsx('path', {
  d: 'M6 5H4v16a2 2 0 0 0 2 2h10v-2H6V5z'
}));

/* eslint-disable prettier/prettier */
function IconSpeakerGroup(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSpeakerGroup.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTablet;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z'
}));

/* eslint-disable prettier/prettier */
function IconTablet(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTablet.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTabletAndroid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z'
}));

/* eslint-disable prettier/prettier */
function IconTabletAndroid(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTabletAndroid.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTabletMac;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18.5 0h-14A2.5 2.5 0 0 0 2 2.5v19A2.5 2.5 0 0 0 4.5 24h14a2.5 2.5 0 0 0 2.5-2.5v-19A2.5 2.5 0 0 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z'
}));

/* eslint-disable prettier/prettier */
function IconTabletMac(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTabletMac.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconToys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 12c0-3 2.5-5.5 5.5-5.5S23 9 23 12H12zm0 0c0 3-2.5 5.5-5.5 5.5S1 15 1 12h11zm0 0c-3 0-5.5-2.5-5.5-5.5S9 1 12 1v11zm0 0c3 0 5.5 2.5 5.5 5.5S15 23 12 23V12z'
}));

/* eslint-disable prettier/prettier */
function IconToys(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconToys.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTv;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z'
}));

/* eslint-disable prettier/prettier */
function IconTv(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTv.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVideogameAsset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
}));

/* eslint-disable prettier/prettier */
function IconVideogameAsset(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVideogameAsset.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWatch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 12c0-2.54-1.19-4.81-3.04-6.27L16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73A7.976 7.976 0 0 0 20 12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z'
}));

/* eslint-disable prettier/prettier */
function IconWatch(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWatch.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAddAPhoto;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z'
}));

/* eslint-disable prettier/prettier */
function IconAddAPhoto(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAddAPhoto.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAddToPhotos;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z'
}));

/* eslint-disable prettier/prettier */
function IconAddToPhotos(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAddToPhotos.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAdjust;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z'
}));

/* eslint-disable prettier/prettier */
function IconAdjust(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAdjust.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAssistant;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11l-4.12 1.88z'
}));

/* eslint-disable prettier/prettier */
function IconAssistant(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAssistant.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAssistantPhoto;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z'
}));

/* eslint-disable prettier/prettier */
function IconAssistantPhoto(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAssistantPhoto.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAudiotrack;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 3v9.28a4.39 4.39 0 0 0-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z'
}));

/* eslint-disable prettier/prettier */
function IconAudiotrack(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAudiotrack.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBlurCircular;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z'
}));

/* eslint-disable prettier/prettier */
function IconBlurCircular(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBlurCircular.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBlurLinear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z'
}));

/* eslint-disable prettier/prettier */
function IconBlurLinear(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBlurLinear.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBlurOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-.2 4.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm11 7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8 8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-4 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM2.5 5.27l3.78 3.78L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81A.875.875 0 0 0 14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78L20 20.23 3.77 4 2.5 5.27zM10 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm11-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z'
}));

/* eslint-disable prettier/prettier */
function IconBlurOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBlurOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBlurOn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z'
}));

/* eslint-disable prettier/prettier */
function IconBlurOn(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBlurOn.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBrightness1;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('circle', {
  cx: '12',
  cy: '12',
  r: '10'
}));

/* eslint-disable prettier/prettier */
function IconBrightness1(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBrightness1.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBrightness2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z'
}));

/* eslint-disable prettier/prettier */
function IconBrightness2(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBrightness2.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBrightness3;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z'
}));

/* eslint-disable prettier/prettier */
function IconBrightness3(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBrightness3.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBrightness4;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6z'
}));

/* eslint-disable prettier/prettier */
function IconBrightness4(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBrightness4.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBrightness5;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z'
}));

/* eslint-disable prettier/prettier */
function IconBrightness5(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBrightness5.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBrightness6;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z'
}));

/* eslint-disable prettier/prettier */
function IconBrightness6(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBrightness6.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBrightness7;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z'
}));

/* eslint-disable prettier/prettier */
function IconBrightness7(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBrightness7.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBrokenImage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z'
}));

/* eslint-disable prettier/prettier */
function IconBrokenImage(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBrokenImage.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBrush;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34a.996.996 0 0 0-1.41 0L9 12.25 11.75 15l8.96-8.96a.996.996 0 0 0 0-1.41z'
}));

/* eslint-disable prettier/prettier */
function IconBrush(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBrush.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBurstMode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM11 17l2.5-3.15L15.29 16l2.5-3.22L21 17H11z'
}));

/* eslint-disable prettier/prettier */
function IconBurstMode(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBurstMode.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCamera;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9.4 10.5l4.77-8.26a9.984 9.984 0 0 0-8.49 2.01l3.66 6.35.06-.1zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66zm.26 1h-7.49l.29.5 4.76 8.25A9.91 9.91 0 0 0 22 12c0-.69-.07-1.35-.2-2zM8.54 12l-3.9-6.75A9.958 9.958 0 0 0 2.2 14h7.49l-1.15-2zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46zm11.27 0l-3.9 6.76a9.984 9.984 0 0 0 8.49-2.01l-3.66-6.35-.93 1.6z'
}));

/* eslint-disable prettier/prettier */
function IconCamera(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCamera.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCameraAlt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('circle', {
  cx: '12',
  cy: '12',
  r: '3.2'
}), _jsx('path', {
  d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z'
}));

/* eslint-disable prettier/prettier */
function IconCameraAlt(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCameraAlt.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCameraFront;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zM12 8c1.1 0 2-.9 2-2s-.9-2-2-2-1.99.9-1.99 2S10.9 8 12 8zm5-8H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM7 2h10v10.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2z'
}));

/* eslint-disable prettier/prettier */
function IconCameraFront(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCameraFront.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCameraRear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-5 6c-1.11 0-2-.9-2-2s.89-2 1.99-2 2 .9 2 2C14 5.1 13.1 6 12 6z'
}));

/* eslint-disable prettier/prettier */
function IconCameraRear(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCameraRear.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCameraRoll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm-2 13h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2z'
}));

/* eslint-disable prettier/prettier */
function IconCameraRoll(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCameraRoll.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCenterFocusStrong;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z'
}));

/* eslint-disable prettier/prettier */
function IconCenterFocusStrong(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCenterFocusStrong.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCenterFocusWeak;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'
}));

/* eslint-disable prettier/prettier */
function IconCenterFocusWeak(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCenterFocusWeak.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCollections;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z'
}));

/* eslint-disable prettier/prettier */
function IconCollections(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCollections.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCollectionsBookmark;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z'
}));

/* eslint-disable prettier/prettier */
function IconCollectionsBookmark(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCollectionsBookmark.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconColorLens;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 3a9 9 0 0 0 0 18c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
}));

/* eslint-disable prettier/prettier */
function IconColorLens(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconColorLens.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconColorize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20.71 5.63l-2.34-2.34a.996.996 0 0 0-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z'
}));

/* eslint-disable prettier/prettier */
function IconColorize(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconColorize.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCompare;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconCompare(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCompare.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconControlPoint;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconControlPoint(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconControlPoint.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconControlPointDuplicate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16A6.99 6.99 0 0 1 2 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z'
}));

/* eslint-disable prettier/prettier */
function IconControlPointDuplicate(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconControlPointDuplicate.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCrop169;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z'
}));

/* eslint-disable prettier/prettier */
function IconCrop169(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCrop169.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCrop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z'
}));

/* eslint-disable prettier/prettier */
function IconCrop(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCrop.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCrop32;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z'
}));

/* eslint-disable prettier/prettier */
function IconCrop32(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCrop32.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCrop54;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z'
}));

/* eslint-disable prettier/prettier */
function IconCrop54(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCrop54.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCrop75;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z'
}));

/* eslint-disable prettier/prettier */
function IconCrop75(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCrop75.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCropDin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z'
}));

/* eslint-disable prettier/prettier */
function IconCropDin(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCropDin.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCropFree;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconCropFree(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCropFree.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCropLandscape;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z'
}));

/* eslint-disable prettier/prettier */
function IconCropLandscape(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCropLandscape.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCropOriginal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z'
}));

/* eslint-disable prettier/prettier */
function IconCropOriginal(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCropOriginal.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCropPortrait;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z'
}));

/* eslint-disable prettier/prettier */
function IconCropPortrait(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCropPortrait.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCropRotate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V8a2 2 0 0 0-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8a2 2 0 0 0 2 2h8v2h2v-2h2v-2H8z'
}));

/* eslint-disable prettier/prettier */
function IconCropRotate(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCropRotate.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCropSquare;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z'
}));

/* eslint-disable prettier/prettier */
function IconCropSquare(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCropSquare.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDehaze;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z'
}));

/* eslint-disable prettier/prettier */
function IconDehaze(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDehaze.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDetails;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z'
}));

/* eslint-disable prettier/prettier */
function IconDetails(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDetails.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconEdit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z'
}));

/* eslint-disable prettier/prettier */
function IconEdit(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconEdit.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconExposure;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15 17v2h2v-2h2v-2h-2v-2h-2v2h-2v2h2zm5-15H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 5h6v2H5V5zm15 15H4L20 4v16z'
}));

/* eslint-disable prettier/prettier */
function IconExposure(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconExposure.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconExposureNeg1;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z'
}));

/* eslint-disable prettier/prettier */
function IconExposureNeg1(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconExposureNeg1.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconExposureNeg2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17s.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71A5.72 5.72 0 0 0 16.47 5c-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 11v2h8v-2H2z'
}));

/* eslint-disable prettier/prettier */
function IconExposureNeg2(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconExposureNeg2.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconExposurePlus1;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z'
}));

/* eslint-disable prettier/prettier */
function IconExposurePlus1(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconExposurePlus1.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconExposurePlus2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71A5.72 5.72 0 0 0 17.47 5c-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z'
}));

/* eslint-disable prettier/prettier */
function IconExposurePlus2(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconExposurePlus2.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconExposureZero;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16.14 12.5c0 1-.1 1.85-.3 2.55-.2.7-.48 1.27-.83 1.7-.36.44-.79.75-1.3.95-.51.2-1.07.3-1.7.3-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95-.36-.44-.65-1.01-.85-1.7-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19-.32 0-.61.06-.86.18s-.47.31-.64.58c-.17.27-.31.62-.4 1.06s-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19c.33 0 .62-.06.87-.19s.46-.33.63-.61c.17-.28.3-.64.39-1.09.09-.45.13-.99.13-1.62v-2.66z'
}));

/* eslint-disable prettier/prettier */
function IconExposureZero(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconExposureZero.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilter1;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z'
}));

/* eslint-disable prettier/prettier */
function IconFilter1(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilter1.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilter2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-4-4h-4v-2h2a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4v2h4v2h-2a2 2 0 0 0-2 2v4h6v-2z'
}));

/* eslint-disable prettier/prettier */
function IconFilter2(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilter2.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z'
}));

/* eslint-disable prettier/prettier */
function IconFilter(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilter.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilter3;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7a2 2 0 0 0-2-2h-4v2h4v2h-2v2h2v2h-4v2h4a2 2 0 0 0 2-2z'
}));

/* eslint-disable prettier/prettier */
function IconFilter3(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilter3.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilter4;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm12 10h2V5h-2v4h-2V5h-2v6h4v4zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z'
}));

/* eslint-disable prettier/prettier */
function IconFilter4(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilter4.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilter5;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2a2 2 0 0 0-2-2h-2V7h4V5h-6v6h4v2h-4v2h4a2 2 0 0 0 2-2z'
}));

/* eslint-disable prettier/prettier */
function IconFilter5(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilter5.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilter6;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2V7h4V5h-4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2zm0-4h2v2h-2v-2z'
}));

/* eslint-disable prettier/prettier */
function IconFilter6(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilter6.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilter7;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z'
}));

/* eslint-disable prettier/prettier */
function IconFilter7(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilter7.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilter8;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2a2 2 0 0 0 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13a2 2 0 0 0 2 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z'
}));

/* eslint-disable prettier/prettier */
function IconFilter8(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilter8.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilter9;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM15 5h-2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v2h-4v2h4a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 4h-2V7h2v2z'
}));

/* eslint-disable prettier/prettier */
function IconFilter9(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilter9.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilter9Plus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1v1H9v2h3a2 2 0 0 0 2-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z'
}));

/* eslint-disable prettier/prettier */
function IconFilter9Plus(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilter9Plus.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilterBAndW;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z'
}));

/* eslint-disable prettier/prettier */
function IconFilterBAndW(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilterBAndW.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilterCenterFocus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z'
}));

/* eslint-disable prettier/prettier */
function IconFilterCenterFocus(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilterCenterFocus.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilterDrama;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.35 10.04A7.49 7.49 0 0 0 12 4a7.48 7.48 0 0 0-6.64 4.04A5.996 5.996 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z'
}));

/* eslint-disable prettier/prettier */
function IconFilterDrama(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilterDrama.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilterFrames;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM18 8H6v10h12'
}));

/* eslint-disable prettier/prettier */
function IconFilterFrames(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilterFrames.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilterHdr;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z'
}));

/* eslint-disable prettier/prettier */
function IconFilterHdr(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilterHdr.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilterNone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z'
}));

/* eslint-disable prettier/prettier */
function IconFilterNone(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilterNone.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilterTiltShift;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69A7.941 7.941 0 0 1 11 4.07zm7.32.19A9.949 9.949 0 0 0 13 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1a7.941 7.941 0 0 1 1.62 3.9zM5.69 7.1L4.26 5.68A9.949 9.949 0 0 0 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43A7.868 7.868 0 0 1 4.07 13zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.31 4.9l1.43 1.43a9.981 9.981 0 0 0 2.21-5.32h-2.02a7.945 7.945 0 0 1-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-7.32-.19A9.981 9.981 0 0 0 11 21.95v-2.02a7.941 7.941 0 0 1-3.9-1.62l-1.42 1.43z'
}));

/* eslint-disable prettier/prettier */
function IconFilterTiltShift(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilterTiltShift.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFilterVintage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18.7 12.4a6.06 6.06 0 0 0-.86-.4c.29-.11.58-.24.86-.4a6.012 6.012 0 0 0 3-5.19 6.007 6.007 0 0 0-6 0c-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55a6.008 6.008 0 0 0-6 0 5.97 5.97 0 0 0 3 5.19c.28.16.57.29.86.4-.29.11-.58.24-.86.4a6.012 6.012 0 0 0-3 5.19 6.007 6.007 0 0 0 6 0c.28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54a6.008 6.008 0 0 0 6 0 6.012 6.012 0 0 0-3-5.19zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z'
}));

/* eslint-disable prettier/prettier */
function IconFilterVintage(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFilterVintage.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFlare;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z'
}));

/* eslint-disable prettier/prettier */
function IconFlare(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFlare.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFlashAuto;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z'
}));

/* eslint-disable prettier/prettier */
function IconFlashAuto(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFlashAuto.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFlashOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3.27 3L2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73 3.27 3zM17 10h-4l4-8H7v2.18l8.46 8.46L17 10z'
}));

/* eslint-disable prettier/prettier */
function IconFlashOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFlashOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFlashOn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 2v11h3v9l7-12h-4l4-8z'
}));

/* eslint-disable prettier/prettier */
function IconFlashOn(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFlashOn.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFlip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z'
}));

/* eslint-disable prettier/prettier */
function IconFlip(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFlip.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGradient;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z'
}));

/* eslint-disable prettier/prettier */
function IconGradient(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGradient.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGrain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconGrain(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGrain.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGridOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M8 4v1.45l2 2V4h4v4h-3.45l2 2H14v1.45l2 2V10h4v4h-3.45l2 2H20v1.45l2 2V4c0-1.1-.9-2-2-2H4.55l2 2H8zm8 0h4v4h-4V4zM1.27 1.27L0 2.55l2 2V20c0 1.1.9 2 2 2h15.46l2 2 1.27-1.27L1.27 1.27zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.54V20zm2 0v-1.46L17.46 20H16z'
}));

/* eslint-disable prettier/prettier */
function IconGridOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGridOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGridOn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z'
}));

/* eslint-disable prettier/prettier */
function IconGridOn(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGridOn.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHdrOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.2.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.9l1.1 1.1h.4zm0-4.5h2v1h-2v-1zm-4.5 0v.4l1.5 1.5v-1.9c0-.8-.7-1.5-1.5-1.5h-1.9l1.5 1.5h.4zm-3.5-1l-7-7-1.1 1L6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.1-1.1-12.1-12z'
}));

/* eslint-disable prettier/prettier */
function IconHdrOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHdrOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHdrOn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z'
}));

/* eslint-disable prettier/prettier */
function IconHdrOn(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHdrOn.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHdrStrong;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'
}));

/* eslint-disable prettier/prettier */
function IconHdrStrong(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHdrStrong.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHdrWeak;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z'
}));

/* eslint-disable prettier/prettier */
function IconHdrWeak(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHdrWeak.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHealing;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17.73 12.02l3.98-3.98a.996.996 0 0 0 0-1.41l-4.34-4.34a.996.996 0 0 0-1.41 0l-3.98 3.98L8 2.29a1.001 1.001 0 0 0-1.41 0L2.25 6.63a.996.996 0 0 0 0 1.41l3.98 3.98L2.25 16a.996.996 0 0 0 0 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34a.996.996 0 0 0 0-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z'
}));

/* eslint-disable prettier/prettier */
function IconHealing(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHealing.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconImage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z'
}));

/* eslint-disable prettier/prettier */
function IconImage(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconImage.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconImageAspectRatio;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z'
}));

/* eslint-disable prettier/prettier */
function IconImageAspectRatio(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconImageAspectRatio.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconIso;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z'
}));

/* eslint-disable prettier/prettier */
function IconIso(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconIso.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLandscape;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z'
}));

/* eslint-disable prettier/prettier */
function IconLandscape(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLandscape.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLeakAdd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 3H3v3c1.66 0 3-1.34 3-3zm8 0h-2a9 9 0 0 1-9 9v2c6.08 0 11-4.93 11-11zm-4 0H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7zm0 18h2a9 9 0 0 1 9-9v-2c-6.07 0-11 4.93-11 11zm8 0h3v-3c-1.66 0-3 1.34-3 3zm-4 0h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z'
}));

/* eslint-disable prettier/prettier */
function IconLeakAdd(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLeakAdd.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLeakRemove;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 3H8c0 .37-.04.72-.12 1.06l1.59 1.59C9.81 4.84 10 3.94 10 3zM3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97A8.99 8.99 0 0 1 3 12v2c2.71 0 5.19-.99 7.11-2.62l2.5 2.5A11.044 11.044 0 0 0 10 21h2c0-2.16.76-4.14 2.03-5.69l1.43 1.43A6.922 6.922 0 0 0 14 21h2c0-1.06.33-2.03.89-2.84L19.73 21 21 19.73 4.27 3 3 4.27zM14 3h-2c0 1.5-.37 2.91-1.02 4.16l1.46 1.46C13.42 6.98 14 5.06 14 3zm5.94 13.12c.34-.08.69-.12 1.06-.12v-2c-.94 0-1.84.19-2.66.52l1.6 1.6zm-4.56-4.56l1.46 1.46A8.98 8.98 0 0 1 21 12v-2c-2.06 0-3.98.58-5.62 1.56z'
}));

/* eslint-disable prettier/prettier */
function IconLeakRemove(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLeakRemove.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLens;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z'
}));

/* eslint-disable prettier/prettier */
function IconLens(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLens.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLinkedCamera;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('circle', {
  cx: '12',
  cy: '14',
  r: '3.2'
}), _jsx('path', {
  d: 'M16 3.33c2.58 0 4.67 2.09 4.67 4.67H22c0-3.31-2.69-6-6-6v1.33M16 6c1.11 0 2 .89 2 2h1.33c0-1.84-1.49-3.33-3.33-3.33V6'
}), _jsx('path', {
  d: 'M17 9c0-1.11-.89-2-2-2V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-5zm-5 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z'
}));

/* eslint-disable prettier/prettier */
function IconLinkedCamera(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLinkedCamera.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLooks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z'
}));

/* eslint-disable prettier/prettier */
function IconLooks(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLooks.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLooks3;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.01 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 7.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V15a2 2 0 0 1-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4a2 2 0 0 1 2 2v1.5z'
}));

/* eslint-disable prettier/prettier */
function IconLooks3(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLooks3.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLooks4;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 14h-2v-4H9V7h2v4h2V7h2v10z'
}));

/* eslint-disable prettier/prettier */
function IconLooks4(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLooks4.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLooks5;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H9v-2h4v-2H9V7h6v2z'
}));

/* eslint-disable prettier/prettier */
function IconLooks5(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLooks5.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLooks6;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 15h2v-2h-2v2zm8-12H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h4v2z'
}));

/* eslint-disable prettier/prettier */
function IconLooks6(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLooks6.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLooksOne;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z'
}));

/* eslint-disable prettier/prettier */
function IconLooksOne(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLooksOne.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLooksTwo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8a2 2 0 0 1-2 2h-2v2h4v2H9v-4a2 2 0 0 1 2-2h2V9H9V7h4a2 2 0 0 1 2 2v2z'
}));

/* eslint-disable prettier/prettier */
function IconLooksTwo(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLooksTwo.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLoupe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconLoupe(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLoupe.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMonochromePhotos;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 5h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z'
}));

/* eslint-disable prettier/prettier */
function IconMonochromePhotos(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMonochromePhotos.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMovieCreation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z'
}));

/* eslint-disable prettier/prettier */
function IconMovieCreation(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMovieCreation.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMovieFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 4l2 3h-3l-2-3h-2l2 3h-3l-2-3H8l2 3H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm-6.75 11.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25zm5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94z'
}));

/* eslint-disable prettier/prettier */
function IconMovieFilter(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMovieFilter.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMusicNote;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z'
}));

/* eslint-disable prettier/prettier */
function IconMusicNote(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMusicNote.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNature;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 16.12a7 7 0 0 0 6.17-6.95c0-3.87-3.13-7-7-7s-7 3.13-7 7A6.98 6.98 0 0 0 11 16.06V20H5v2h14v-2h-6v-3.88z'
}));

/* eslint-disable prettier/prettier */
function IconNature(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNature.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNaturePeople;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7A6.98 6.98 0 0 0 14 16.06V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88a7 7 0 0 0 6.17-6.95zM4.5 11c.83 0 1.5-.67 1.5-1.5S5.33 8 4.5 8 3 8.67 3 9.5 3.67 11 4.5 11z'
}));

/* eslint-disable prettier/prettier */
function IconNaturePeople(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNaturePeople.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNavigateBefore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z'
}));

/* eslint-disable prettier/prettier */
function IconNavigateBefore(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNavigateBefore.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNavigateNext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'
}));

/* eslint-disable prettier/prettier */
function IconNavigateNext(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNavigateNext.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPalette;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 3a9 9 0 0 0 0 18c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
}));

/* eslint-disable prettier/prettier */
function IconPalette(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPalette.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPanorama;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z'
}));

/* eslint-disable prettier/prettier */
function IconPanorama(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPanorama.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPanoramaFishEye;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconPanoramaFishEye(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPanoramaFishEye.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPanoramaHorizontal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16-2.72 0-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7c-3.09 0-6.18-.55-9.12-1.64A.94.94 0 0 0 2.57 4c-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64 3.09 0 6.18.55 9.12 1.64.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z'
}));

/* eslint-disable prettier/prettier */
function IconPanoramaHorizontal(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPanoramaHorizontal.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPanoramaVertical;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12 0-3.09.55-6.18 1.64-9.12a.94.94 0 0 0 .06-.31c0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12c0 3.09-.55 6.18-1.64 9.12-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8 0-2.72-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8 0 2.72.39 5.4 1.16 8H6.54z'
}));

/* eslint-disable prettier/prettier */
function IconPanoramaVertical(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPanoramaVertical.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPanoramaWideAngle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 6c2.45 0 4.71.2 7.29.64A21 21 0 0 1 20 12a21 21 0 0 1-.71 5.36c-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64A21 21 0 0 1 4 12a21 21 0 0 1 .71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z'
}));

/* eslint-disable prettier/prettier */
function IconPanoramaWideAngle(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPanoramaWideAngle.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhoto;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z'
}));

/* eslint-disable prettier/prettier */
function IconPhoto(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhoto.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhotoAlbum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4zm0 15l3-3.86 2.14 2.58 3-3.86L18 19H6z'
}));

/* eslint-disable prettier/prettier */
function IconPhotoAlbum(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhotoAlbum.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhotoCamera;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('circle', {
  cx: '12',
  cy: '12',
  r: '3.2'
}), _jsx('path', {
  d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z'
}));

/* eslint-disable prettier/prettier */
function IconPhotoCamera(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhotoCamera.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhotoFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.02 10v9H5V5h9V3H5.02c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zM17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7l2.06.94zm-3.75.75L12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12z'
}));

/* eslint-disable prettier/prettier */
function IconPhotoFilter(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhotoFilter.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhotoLibrary;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z'
}));

/* eslint-disable prettier/prettier */
function IconPhotoLibrary(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhotoLibrary.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhotoSizeSelectActual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z'
}));

/* eslint-disable prettier/prettier */
function IconPhotoSizeSelectActual(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhotoSizeSelectActual.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhotoSizeSelectLarge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z'
}));

/* eslint-disable prettier/prettier */
function IconPhotoSizeSelectLarge(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhotoSizeSelectLarge.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhotoSizeSelectSmall;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z'
}));

/* eslint-disable prettier/prettier */
function IconPhotoSizeSelectSmall(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhotoSizeSelectSmall.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPictureAsPdf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z'
}));

/* eslint-disable prettier/prettier */
function IconPictureAsPdf(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPictureAsPdf.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPortrait;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 12.25c1.24 0 2.25-1.01 2.25-2.25S13.24 7.75 12 7.75 9.75 8.76 9.75 10s1.01 2.25 2.25 2.25zm4.5 4c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9v-.75zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z'
}));

/* eslint-disable prettier/prettier */
function IconPortrait(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPortrait.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRemoveRedEye;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z'
}));

/* eslint-disable prettier/prettier */
function IconRemoveRedEye(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRemoveRedEye.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRotate90DegreesCcw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26A8.95 8.95 0 0 0 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05a7.007 7.007 0 0 1 0 9.9 6.973 6.973 0 0 1-7.79 1.44l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64a8.98 8.98 0 0 0 0-12.72z'
}));

/* eslint-disable prettier/prettier */
function IconRotate90DegreesCcw(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRotate90DegreesCcw.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRotateLeft;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z'
}));

/* eslint-disable prettier/prettier */
function IconRotateLeft(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRotateLeft.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRotateRight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11a7.906 7.906 0 0 0-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z'
}));

/* eslint-disable prettier/prettier */
function IconRotateRight(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRotateRight.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSlideshow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z'
}));

/* eslint-disable prettier/prettier */
function IconSlideshow(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSlideshow.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconStraighten;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z'
}));

/* eslint-disable prettier/prettier */
function IconStraighten(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconStraighten.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98a2.013 2.013 0 0 0-1.81-1.23c-.26 0-.53.04-.79.15L7.1 5.95a1.999 1.999 0 0 0-1.08 2.6l4.96 11.97a1.998 1.998 0 0 0 2.6 1.08l7.36-3.05a1.994 1.994 0 0 0 1.09-2.6zM7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2 11c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z'
}));

/* eslint-disable prettier/prettier */
function IconStyle(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconStyle.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSwitchCamera;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z'
}));

/* eslint-disable prettier/prettier */
function IconSwitchCamera(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSwitchCamera.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSwitchVideo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 9.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zm-5 6V13H7v2.5L3.5 12 7 8.5V11h6V8.5l3.5 3.5-3.5 3.5z'
}));

/* eslint-disable prettier/prettier */
function IconSwitchVideo(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSwitchVideo.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTagFaces;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z'
}));

/* eslint-disable prettier/prettier */
function IconTagFaces(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTagFaces.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTexture;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.51 3.08L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.88 3L3 11.88v2.83L14.71 3h-2.83zM5 3c-1.1 0-2 .9-2 2v2l4-4H5zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83L21 12.12V9.29L9.29 21z'
}));

/* eslint-disable prettier/prettier */
function IconTexture(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTexture.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTimelapse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16.24 7.76A5.974 5.974 0 0 0 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0a5.99 5.99 0 0 0-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconTimelapse(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTimelapse.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTimer10;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M0 7.72V9.4l3-1V18h2V6h-.25L0 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38a6.64 6.64 0 0 1-.87-.23 2.61 2.61 0 0 1-.55-.25.717.717 0 0 1-.28-.3.978.978 0 0 1 .01-.8c.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95a2.517 2.517 0 0 0-.93-1.97c-.3-.25-.66-.44-1.09-.59C21.49 9.07 21 9 20.46 9c-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24a1.333 1.333 0 0 1-.59-1.11h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27-.58 0-1.11.09-1.59.27-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89.48.18 1.01.28 1.59.28.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89.34-.41.6-.94.78-1.6.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53-.08.42-.2.76-.36 1.02-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02-.09-.42-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52.09-.41.21-.74.38-1 .16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99.08.41.13.92.13 1.52v2.51z'
}));

/* eslint-disable prettier/prettier */
function IconTimer10(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTimer10.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTimer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0 0 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a8.994 8.994 0 0 0 7.03-14.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z'
}));

/* eslint-disable prettier/prettier */
function IconTimer(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTimer.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTimer3;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11.61 12.97c-.16-.24-.36-.46-.62-.65a3.38 3.38 0 0 0-.93-.48c.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33.22-.08.46-.12.73-.12.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57-.17.16-.38.28-.63.37-.25.09-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36-.17-.16-.3-.34-.39-.56-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23.49-.15.91-.38 1.26-.68.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38a6.64 6.64 0 0 1-.87-.23 2.61 2.61 0 0 1-.55-.25.717.717 0 0 1-.28-.3c-.05-.11-.08-.24-.08-.39a.946.946 0 0 1 .36-.75c.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95a2.517 2.517 0 0 0-.93-1.97c-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.68.23.96c.15.28.37.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24a1.333 1.333 0 0 1-.59-1.11h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z'
}));

/* eslint-disable prettier/prettier */
function IconTimer3(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTimer3.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTimerOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.04 4.55l-1.42 1.42a9.012 9.012 0 0 0-10.57-.49l1.46 1.46C9.53 6.35 10.73 6 12 6c3.87 0 7 3.13 7 7 0 1.27-.35 2.47-.94 3.49l1.45 1.45A8.878 8.878 0 0 0 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42-1.41-1.42zM15 1H9v2h6V1zm-4 8.44l2 2V8h-2v1.44zM3.02 4L1.75 5.27 4.5 8.03A8.905 8.905 0 0 0 3 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.27-1.27-7.71-7.71L3.02 4zM12 20c-3.87 0-7-3.13-7-7 0-1.28.35-2.48.95-3.52l9.56 9.56c-1.03.61-2.23.96-3.51.96z'
}));

/* eslint-disable prettier/prettier */
function IconTimerOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTimerOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTonality;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z'
}));

/* eslint-disable prettier/prettier */
function IconTonality(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTonality.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTransform;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z'
}));

/* eslint-disable prettier/prettier */
function IconTransform(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTransform.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTune;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z'
}));

/* eslint-disable prettier/prettier */
function IconTune(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTune.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconViewComfy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 9h4V5H3v4zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM3 19h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h4v-4h-4v4zm0-14v4h4V5h-4z'
}));

/* eslint-disable prettier/prettier */
function IconViewComfy(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconViewComfy.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconViewCompact;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 19h6v-7H3v7zm7 0h12v-7H10v7zM3 5v6h19V5H3z'
}));

/* eslint-disable prettier/prettier */
function IconViewCompact(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconViewCompact.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVignette;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z'
}));

/* eslint-disable prettier/prettier */
function IconVignette(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVignette.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWbAuto;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6.85 12.65h2.3L8 9l-1.15 3.65zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76C12.77 5.17 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c3.13 0 5.84-1.81 7.15-4.43l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-11.7 9l-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9h-1.9z'
}));

/* eslint-disable prettier/prettier */
function IconWbAuto(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWbAuto.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWbCloudy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.36 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96z'
}));

/* eslint-disable prettier/prettier */
function IconWbCloudy(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWbCloudy.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWbIncandescent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8zM11 22.45h2V19.5h-2v2.95zM4 10.5H1v2h3v-2zm11-4.19V1.5H9v4.81C7.21 7.35 6 9.28 6 11.5c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19zm5 4.19v2h3v-2h-3zm-2.76 7.66l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4z'
}));

/* eslint-disable prettier/prettier */
function IconWbIncandescent(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWbIncandescent.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWbIridescent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5 14.5h14v-6H5v6zM11 .55V3.5h2V.55h-2zm8.04 2.5l-1.79 1.79 1.41 1.41 1.8-1.79-1.42-1.41zM13 22.45V19.5h-2v2.95h2zm7.45-3.91l-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42zM3.55 4.46l1.79 1.79 1.41-1.41-1.79-1.79-1.41 1.41zm1.41 15.49l1.79-1.8-1.41-1.41-1.79 1.79 1.41 1.42z'
}));

/* eslint-disable prettier/prettier */
function IconWbIridescent(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWbIridescent.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWbSunny;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z'
}));

/* eslint-disable prettier/prettier */
function IconWbSunny(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWbSunny.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAddLocation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm4 8h-3v3h-2v-3H8V8h3V5h2v3h3v2z'
}));

/* eslint-disable prettier/prettier */
function IconAddLocation(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAddLocation.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBeenhere;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-9 15l-5-5 1.41-1.41L10 13.17l7.59-7.59L19 7l-9 9z'
}));

/* eslint-disable prettier/prettier */
function IconBeenhere(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBeenhere.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDirections;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21.71 11.29l-9-9a.996.996 0 0 0-1.41 0l-9 9a.996.996 0 0 0 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9a.996.996 0 0 0 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z'
}));

/* eslint-disable prettier/prettier */
function IconDirections(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDirections.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDirectionsBike;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z'
}));

/* eslint-disable prettier/prettier */
function IconDirectionsBike(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDirectionsBike.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDirectionsBoat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99a8.752 8.752 0 0 0 8 0c1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42a1.007 1.007 0 0 0-.66 1.28L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z'
}));

/* eslint-disable prettier/prettier */
function IconDirectionsBoat(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDirectionsBoat.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDirectionsBus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z'
}));

/* eslint-disable prettier/prettier */
function IconDirectionsBus(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDirectionsBus.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDirectionsCar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z'
}));

/* eslint-disable prettier/prettier */
function IconDirectionsCar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDirectionsCar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDirectionsRailway;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z'
}));

/* eslint-disable prettier/prettier */
function IconDirectionsRailway(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDirectionsRailway.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDirectionsRun;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z'
}));

/* eslint-disable prettier/prettier */
function IconDirectionsRun(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDirectionsRun.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDirectionsSubway;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z'
}));

/* eslint-disable prettier/prettier */
function IconDirectionsSubway(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDirectionsSubway.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDirectionsTransit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z'
}));

/* eslint-disable prettier/prettier */
function IconDirectionsTransit(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDirectionsTransit.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDirectionsWalk;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7'
}));

/* eslint-disable prettier/prettier */
function IconDirectionsWalk(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDirectionsWalk.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconEditLocation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm-1.56 10H9v-1.44l3.35-3.34 1.43 1.43L10.44 12zm4.45-4.45l-.7.7-1.44-1.44.7-.7a.38.38 0 0 1 .54 0l.9.9c.15.15.15.39 0 .54z'
}));

/* eslint-disable prettier/prettier */
function IconEditLocation(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconEditLocation.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconEvStation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 0 0 2.5 2.5c.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5a2.5 2.5 0 0 0 5 0V9c0-.69-.28-1.32-.73-1.77zM18 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM8 18v-4.5H6L10 6v5h2l-4 7z'
}));

/* eslint-disable prettier/prettier */
function IconEvStation(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconEvStation.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFlight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z'
}));

/* eslint-disable prettier/prettier */
function IconFlight(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFlight.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHotel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z'
}));

/* eslint-disable prettier/prettier */
function IconHotel(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHotel.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLayers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z'
}));

/* eslint-disable prettier/prettier */
function IconLayers(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLayers.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLayersClear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.81 14.99l1.19-.92-1.43-1.43-1.19.92 1.43 1.43zm-.45-4.72L21 9l-9-7-2.91 2.27 7.87 7.88 2.4-1.88zM3.27 1L2 2.27l4.22 4.22L3 9l1.63 1.27L12 16l2.1-1.63 1.43 1.43L12 18.54l-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21 22 19.73 3.27 1z'
}));

/* eslint-disable prettier/prettier */
function IconLayersClear(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLayersClear.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalActivity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z'
}));

/* eslint-disable prettier/prettier */
function IconLocalActivity(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalActivity.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalAirport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z'
}));

/* eslint-disable prettier/prettier */
function IconLocalAirport(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalAirport.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalAtm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z'
}));

/* eslint-disable prettier/prettier */
function IconLocalAtm(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalAtm.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalBar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM7.43 7L5.66 5h12.69l-1.78 2H7.43z'
}));

/* eslint-disable prettier/prettier */
function IconLocalBar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalBar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalCafe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM2 21h18v-2H2v2z'
}));

/* eslint-disable prettier/prettier */
function IconLocalCafe(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalCafe.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalCarWash;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 5c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zM7 5c.83 0 1.5-.67 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5zm11.92 3.01C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01L3 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 18c-.83 0-1.5-.67-1.5-1.5S5.67 15 6.5 15s1.5.67 1.5 1.5S7.33 18 6.5 18zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 13l1.5-4.5h11L19 13H5z'
}));

/* eslint-disable prettier/prettier */
function IconLocalCarWash(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalCarWash.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalConvenienceStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3zm-8 3H9v1h2v1H8V9h2V8H8V7h3v3zm5 2h-1v-2h-2V7h1v2h1V7h1v5z'
}));

/* eslint-disable prettier/prettier */
function IconLocalConvenienceStore(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalConvenienceStore.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalDining;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M8.1 13.34l2.83-2.83L3.91 3.5a4.008 4.008 0 0 0 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z'
}));

/* eslint-disable prettier/prettier */
function IconLocalDining(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalDining.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalDrink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z'
}));

/* eslint-disable prettier/prettier */
function IconLocalDrink(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalDrink.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalFlorist;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 22a9 9 0 0 0 9-9 9 9 0 0 0-9 9zM5.6 10.25a2.5 2.5 0 0 0 3.92 2.06l-.02.19a2.5 2.5 0 0 0 5 0l-.02-.19c.4.28.89.44 1.42.44a2.5 2.5 0 0 0 2.5-2.5c0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25a2.5 2.5 0 0 0-3.92-2.06l.02-.19a2.5 2.5 0 0 0-5 0l.02.19c-.4-.28-.89-.44-1.42-.44a2.5 2.5 0 0 0-2.5 2.5c0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25zM12 5.5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5zM3 13a9 9 0 0 0 9 9 9 9 0 0 0-9-9z'
}));

/* eslint-disable prettier/prettier */
function IconLocalFlorist(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalFlorist.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalGasStation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 0 0 2.5 2.5c.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5a2.5 2.5 0 0 0 5 0V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'
}));

/* eslint-disable prettier/prettier */
function IconLocalGasStation(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalGasStation.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalGroceryStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0 0 20 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconLocalGroceryStore(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalGroceryStore.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalHospital;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z'
}));

/* eslint-disable prettier/prettier */
function IconLocalHospital(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalHospital.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalHotel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z'
}));

/* eslint-disable prettier/prettier */
function IconLocalHotel(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalHotel.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalLibrary;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 11.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z'
}));

/* eslint-disable prettier/prettier */
function IconLocalLibrary(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalLibrary.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalMall;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z'
}));

/* eslint-disable prettier/prettier */
function IconLocalMall(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalMall.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalMovies;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z'
}));

/* eslint-disable prettier/prettier */
function IconLocalMovies(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalMovies.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalParking;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z'
}));

/* eslint-disable prettier/prettier */
function IconLocalParking(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalParking.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalPharmacy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z'
}));

/* eslint-disable prettier/prettier */
function IconLocalPharmacy(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalPharmacy.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalPhone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z'
}));

/* eslint-disable prettier/prettier */
function IconLocalPhone(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalPhone.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalPizza;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zM7 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm5 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'
}));

/* eslint-disable prettier/prettier */
function IconLocalPizza(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalPizza.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalPostOffice;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z'
}));

/* eslint-disable prettier/prettier */
function IconLocalPostOffice(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalPostOffice.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalPrintshop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z'
}));

/* eslint-disable prettier/prettier */
function IconLocalPrintshop(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalPrintshop.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalSee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('circle', {
  cx: '12',
  cy: '12',
  r: '3.2'
}), _jsx('path', {
  d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z'
}));

/* eslint-disable prettier/prettier */
function IconLocalSee(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalSee.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalShipping;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
}));

/* eslint-disable prettier/prettier */
function IconLocalShipping(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalShipping.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocalTaxi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z'
}));

/* eslint-disable prettier/prettier */
function IconLocalTaxi(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocalTaxi.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z'
}));

/* eslint-disable prettier/prettier */
function IconMap(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMap.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMyLocation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z'
}));

/* eslint-disable prettier/prettier */
function IconMyLocation(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMyLocation.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNavigation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z'
}));

/* eslint-disable prettier/prettier */
function IconNavigation(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNavigation.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNearMe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z'
}));

/* eslint-disable prettier/prettier */
function IconNearMe(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNearMe.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPersonPin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 3.3c1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7-1.49 0-2.7-1.21-2.7-2.7 0-1.49 1.21-2.7 2.7-2.7zM18 16H6v-.9c0-2 4-3.1 6-3.1s6 1.1 6 3.1v.9z'
}));

/* eslint-disable prettier/prettier */
function IconPersonPin(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPersonPin.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPersonPinCircle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm0 2a2 2 0 1 1 .001 4.001A2 2 0 0 1 12 4zm0 10c-1.67 0-3.14-.85-4-2.15.02-1.32 2.67-2.05 4-2.05s3.98.73 4 2.05A4.783 4.783 0 0 1 12 14z'
}));

/* eslint-disable prettier/prettier */
function IconPersonPinCircle(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPersonPinCircle.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPinDrop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2a2 2 0 1 1-4 0zM5 20v2h14v-2H5z'
}));

/* eslint-disable prettier/prettier */
function IconPinDrop(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPinDrop.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPlace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z'
}));

/* eslint-disable prettier/prettier */
function IconPlace(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPlace.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRateReview;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z'
}));

/* eslint-disable prettier/prettier */
function IconRateReview(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRateReview.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRestaurant;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z'
}));

/* eslint-disable prettier/prettier */
function IconRestaurant(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRestaurant.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRestaurantMenu;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M8.1 13.34l2.83-2.83L3.91 3.5a4.008 4.008 0 0 0 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z'
}));

/* eslint-disable prettier/prettier */
function IconRestaurantMenu(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRestaurantMenu.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSatellite;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.99h3C8 6.65 6.66 8 5 8V4.99zM5 12v-2c2.76 0 5-2.25 5-5.01h2C12 8.86 8.87 12 5 12zm0 6l3.5-4.5 2.5 3.01L14.5 12l4.5 6H5z'
}));

/* eslint-disable prettier/prettier */
function IconSatellite(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSatellite.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSubway;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('circle', {
  cx: '15.5',
  cy: '16',
  r: '1'
}), _jsx('circle', {
  cx: '8.5',
  cy: '16',
  r: '1'
}), _jsx('path', {
  d: 'M7.01 9h10v5h-10zM17.8 2.8C16 2.09 13.86 2 12 2c-1.86 0-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zm.2 13.08c0 1.45-1.18 2.62-2.63 2.62l1.13 1.12V20H15l-1.5-1.5h-2.83L9.17 20H7.5v-.38l1.12-1.12C7.18 18.5 6 17.32 6 15.88V9c0-2.63 3-3 6-3 3.32 0 6 .38 6 3v6.88z'
}));

/* eslint-disable prettier/prettier */
function IconSubway(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSubway.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTerrain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z'
}));

/* eslint-disable prettier/prettier */
function IconTerrain(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTerrain.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTraffic;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-8 9a2 2 0 1 1-.001-3.999A2 2 0 0 1 12 19zm0-5a2 2 0 1 1-.001-3.999A2 2 0 0 1 12 14zm0-5a2 2 0 0 1-2-2c0-1.11.89-2 2-2a2 2 0 1 1 0 4z'
}));

/* eslint-disable prettier/prettier */
function IconTraffic(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTraffic.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTrain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
}));

/* eslint-disable prettier/prettier */
function IconTrain(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTrain.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTram;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 16.94V8.5c0-2.79-2.61-3.4-6.01-3.49l.76-1.51H17V2H7v1.5h4.75l-.76 1.52C7.86 5.11 5 5.73 5 8.5v8.44c0 1.45 1.19 2.66 2.59 2.97L6 21.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 20h-.08c1.69 0 2.58-1.37 2.58-3.06zm-7 1.56c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5-4.5H7V9h10v5z'
}));

/* eslint-disable prettier/prettier */
function IconTram(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTram.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTransferWithinAStation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5zm3.02 4.25H14v1.5h5.51V23L22 20.5 19.51 18zM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75'
}));

/* eslint-disable prettier/prettier */
function IconTransferWithinAStation(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTransferWithinAStation.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconZoomOutMap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z'
}));

/* eslint-disable prettier/prettier */
function IconZoomOutMap(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconZoomOutMap.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconApps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z'
}));

/* eslint-disable prettier/prettier */
function IconApps(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconApps.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconArrowDownward;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z'
}));

/* eslint-disable prettier/prettier */
function IconArrowDownward(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconArrowDownward.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconArrowDropDown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 10l5 5 5-5z'
}));

/* eslint-disable prettier/prettier */
function IconArrowDropDown(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconArrowDropDown.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconArrowDropDownCircle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 12l-4-4h8l-4 4z'
}));

/* eslint-disable prettier/prettier */
function IconArrowDropDownCircle(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconArrowDropDownCircle.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconArrowDropUp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 14l5-5 5 5z'
}));

/* eslint-disable prettier/prettier */
function IconArrowDropUp(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconArrowDropUp.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconArrowForward;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z'
}));

/* eslint-disable prettier/prettier */
function IconArrowForward(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconArrowForward.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconArrowUpward;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconArrowUpward(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconArrowUpward.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCancel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z'
}));

/* eslint-disable prettier/prettier */
function IconCancel(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCancel.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconChevronLeft;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z'
}));

/* eslint-disable prettier/prettier */
function IconChevronLeft(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconChevronLeft.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconChevronRight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'
}));

/* eslint-disable prettier/prettier */
function IconChevronRight(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconChevronRight.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconClose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
}));

/* eslint-disable prettier/prettier */
function IconClose(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconClose.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconExpandLess;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z'
}));

/* eslint-disable prettier/prettier */
function IconExpandLess(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconExpandLess.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconExpandMore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z'
}));

/* eslint-disable prettier/prettier */
function IconExpandMore(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconExpandMore.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFirstPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z'
}));

/* eslint-disable prettier/prettier */
function IconFirstPage(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFirstPage.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFullscreen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z'
}));

/* eslint-disable prettier/prettier */
function IconFullscreen(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFullscreen.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFullscreenExit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z'
}));

/* eslint-disable prettier/prettier */
function IconFullscreenExit(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFullscreenExit.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLastPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z'
}));

/* eslint-disable prettier/prettier */
function IconLastPage(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLastPage.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMoreHoriz;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconMoreHoriz(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMoreHoriz.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMoreVert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconMoreVert(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMoreVert.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSubdirectoryArrowLeft;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z'
}));

/* eslint-disable prettier/prettier */
function IconSubdirectoryArrowLeft(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSubdirectoryArrowLeft.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSubdirectoryArrowRight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z'
}));

/* eslint-disable prettier/prettier */
function IconSubdirectoryArrowRight(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSubdirectoryArrowRight.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconUnfoldLess;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z'
}));

/* eslint-disable prettier/prettier */
function IconUnfoldLess(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconUnfoldLess.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconUnfoldMore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z'
}));

/* eslint-disable prettier/prettier */
function IconUnfoldMore(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconUnfoldMore.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAdb;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z'
}));

/* eslint-disable prettier/prettier */
function IconAdb(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAdb.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAirlineSeatFlat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 11v2H9V7h9c2.21 0 4 1.79 4 4zM2 14v2h6v2h8v-2h6v-2H2zm5.14-1.9a3 3 0 0 0-.04-4.24 3 3 0 0 0-4.24.04 3 3 0 0 0 .04 4.24 3 3 0 0 0 4.24-.04z'
}));

/* eslint-disable prettier/prettier */
function IconAirlineSeatFlat(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAirlineSeatFlat.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAirlineSeatFlatAngled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22.25 14.29l-.69 1.89L9.2 11.71l2.08-5.66 8.56 3.09a4 4 0 0 1 2.41 5.15zM1.5 12.14L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86-.69 1.89zm5.8-1.94a3.01 3.01 0 0 0 1.41-4A3.005 3.005 0 0 0 4.7 4.8a2.99 2.99 0 0 0-1.4 4 2.99 2.99 0 0 0 4 1.4z'
}));

/* eslint-disable prettier/prettier */
function IconAirlineSeatFlatAngled(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAirlineSeatFlatAngled.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAirlineSeatIndividualSuite;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3zm12-6h-8v7H3V7H1v10h22v-6c0-2.21-1.79-4-4-4z'
}));

/* eslint-disable prettier/prettier */
function IconAirlineSeatIndividualSuite(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAirlineSeatIndividualSuite.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAirlineSeatLegroomExtra;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M4 12V3H2v9c0 2.76 2.24 5 5 5h6v-2H7c-1.66 0-3-1.34-3-3zm18.83 5.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98a2.01 2.01 0 0 0-1.79-1.12L11 9V3H5v8c0 1.66 1.34 3 3 3h7l3.41 7 3.72-1.7c.77-.36 1.1-1.3.7-2.06z'
}));

/* eslint-disable prettier/prettier */
function IconAirlineSeatLegroomExtra(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAirlineSeatLegroomExtra.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAirlineSeatLegroomNormal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5 12V3H3v9c0 2.76 2.24 5 5 5h6v-2H8c-1.66 0-3-1.34-3-3zm15.5 6H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v7h4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z'
}));

/* eslint-disable prettier/prettier */
function IconAirlineSeatLegroomNormal(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAirlineSeatLegroomNormal.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAirlineSeatLegroomReduced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z'
}));

/* eslint-disable prettier/prettier */
function IconAirlineSeatLegroomReduced(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAirlineSeatLegroomReduced.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAirlineSeatReclineExtra;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l1.99 9.76A5.01 5.01 0 0 0 8.94 21H16v-2zm.23-4h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38a2.21 2.21 0 0 0-.99-.06h-.02a2.268 2.268 0 0 0-1.84 2.61l1.35 5.92A3.008 3.008 0 0 0 9.83 18h6.85l3.82 3 1.5-1.5-5.77-4.5z'
}));

/* eslint-disable prettier/prettier */
function IconAirlineSeatReclineExtra(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAirlineSeatReclineExtra.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAirlineSeatReclineNormal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7.59 5.41c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0 .78.78.78 2.05 0 2.83-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z'
}));

/* eslint-disable prettier/prettier */
function IconAirlineSeatReclineNormal(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAirlineSeatReclineNormal.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBluetoothAudio;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2a9.936 9.936 0 0 0 1.54-5.31c-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z'
}));

/* eslint-disable prettier/prettier */
function IconBluetoothAudio(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBluetoothAudio.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconConfirmationNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 10V6a2 2 0 0 0-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z'
}));

/* eslint-disable prettier/prettier */
function IconConfirmationNumber(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconConfirmationNumber.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDiscFull;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 16h2v-2h-2v2zm0-9v5h2V7h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'
}));

/* eslint-disable prettier/prettier */
function IconDiscFull(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDiscFull.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDoNotDisturb;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0 1 12 20zm6.31-3.1L7.1 5.69A7.902 7.902 0 0 1 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z'
}));

/* eslint-disable prettier/prettier */
function IconDoNotDisturb(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDoNotDisturb.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDoNotDisturbAlt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconDoNotDisturbAlt(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDoNotDisturbAlt.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDoNotDisturbOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 11v2h-1.46l4.68 4.68A9.92 9.92 0 0 0 22 12c0-5.52-4.48-10-10-10-2.11 0-4.07.66-5.68 1.78L13.54 11H17zM2.27 2.27L1 3.54l2.78 2.78A9.92 9.92 0 0 0 2 12c0 5.52 4.48 10 10 10 2.11 0 4.07-.66 5.68-1.78L20.46 23l1.27-1.27L11 11 2.27 2.27zM7 13v-2h1.46l2 2H7z'
}));

/* eslint-disable prettier/prettier */
function IconDoNotDisturbOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDoNotDisturbOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDoNotDisturbOn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z'
}));

/* eslint-disable prettier/prettier */
function IconDoNotDisturbOn(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDoNotDisturbOn.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDriveEta;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z'
}));

/* eslint-disable prettier/prettier */
function IconDriveEta(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDriveEta.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconEnhancedEncryption;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM16 16h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z'
}));

/* eslint-disable prettier/prettier */
function IconEnhancedEncryption(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconEnhancedEncryption.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconEventAvailable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z'
}));

/* eslint-disable prettier/prettier */
function IconEventAvailable(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconEventAvailable.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconEventBusy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9.31 17l2.44-2.44L14.19 17l1.06-1.06-2.44-2.44 2.44-2.44L14.19 10l-2.44 2.44L9.31 10l-1.06 1.06 2.44 2.44-2.44 2.44L9.31 17zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z'
}));

/* eslint-disable prettier/prettier */
function IconEventBusy(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconEventBusy.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconEventNote;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z'
}));

/* eslint-disable prettier/prettier */
function IconEventNote(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconEventNote.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFolderSpecial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2.06 11L15 15.28 12.06 17l.78-3.33-2.59-2.24 3.41-.29L15 8l1.34 3.14 3.41.29-2.59 2.24.78 3.33z'
}));

/* eslint-disable prettier/prettier */
function IconFolderSpecial(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFolderSpecial.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLiveTv;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 6h-7.59l3.29-3.29L16 2l-4 4-4-4-.71.71L10.59 6H3a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8a2 2 0 0 0-2-2zm0 14H3V8h18v12zM9 10v8l7-4z'
}));

/* eslint-disable prettier/prettier */
function IconLiveTv(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLiveTv.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMms;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 14l3.5-4.5 2.5 3.01L14.5 8l4.5 6H5z'
}));

/* eslint-disable prettier/prettier */
function IconMms(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMms.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
}));

/* eslint-disable prettier/prettier */
function IconMore(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMore.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNetworkCheck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5zM1 9l2 2c2.88-2.88 6.79-4.08 10.53-3.62l1.19-2.68C9.89 3.84 4.74 5.27 1 9zm20 2l2-2a15.367 15.367 0 0 0-5.59-3.57l-.53 2.82c1.5.62 2.9 1.53 4.12 2.75zm-4 4l2-2c-.8-.8-1.7-1.42-2.66-1.89l-.55 2.92c.42.27.83.59 1.21.97zM5 13l2 2a7.1 7.1 0 0 1 4.03-2l1.28-2.88c-2.63-.08-5.3.87-7.31 2.88z'
}));

/* eslint-disable prettier/prettier */
function IconNetworkCheck(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNetworkCheck.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNetworkLocked;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19.5 10c.17 0 .33.03.5.05V1L1 20h13v-3c0-.89.39-1.68 1-2.23v-.27c0-2.48 2.02-4.5 4.5-4.5zm2.5 6v-1.5a2.5 2.5 0 0 0-5 0V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z'
}));

/* eslint-disable prettier/prettier */
function IconNetworkLocked(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNetworkLocked.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNoEncryption;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 21.78L4.22 5 3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12c.23 0 .45-.05.66-.12L19.78 23 21 21.78zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H9.66L20 18.34V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.56 0-4.64 1.93-4.94 4.4L8.9 7.24V6z'
}));

/* eslint-disable prettier/prettier */
function IconNoEncryption(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNoEncryption.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconOndemandVideo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 0 0-2-2zm0 14H3V5h18v12zm-5-6l-7 4V7z'
}));

/* eslint-disable prettier/prettier */
function IconOndemandVideo(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconOndemandVideo.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPersonalVideo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 0 0-2-2zm0 14H3V5h18v12z'
}));

/* eslint-disable prettier/prettier */
function IconPersonalVideo(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPersonalVideo.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhoneBluetoothSpeaker;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71zM18 2.91l.94.94-.94.94V2.91zm0 4.3l.94.94-.94.94V7.21zm2 8.29c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 0 0-1.02.24l-2.2 2.2a15.045 15.045 0 0 1-6.59-6.59l2.2-2.21a.96.96 0 0 0 .25-1A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z'
}));

/* eslint-disable prettier/prettier */
function IconPhoneBluetoothSpeaker(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhoneBluetoothSpeaker.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhoneForwarded;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 11l5-5-5-5v3h-4v4h4v3zm2 4.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 0 0-1.02.24l-2.2 2.2a15.045 15.045 0 0 1-6.59-6.59l2.2-2.21a.96.96 0 0 0 .25-1A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z'
}));

/* eslint-disable prettier/prettier */
function IconPhoneForwarded(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhoneForwarded.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhoneInTalk;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 0 0-1.02.24l-2.2 2.2a15.045 15.045 0 0 1-6.59-6.59l2.2-2.21a.96.96 0 0 0 .25-1A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 12h2a9 9 0 0 0-9-9v2c3.87 0 7 3.13 7 7zm-4 0h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3z'
}));

/* eslint-disable prettier/prettier */
function IconPhoneInTalk(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhoneInTalk.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhoneLocked;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 0 0-1.02.24l-2.2 2.2a15.045 15.045 0 0 1-6.59-6.59l2.2-2.21a.96.96 0 0 0 .25-1A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM20 4v-.5a2.5 2.5 0 0 0-5 0V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4z'
}));

/* eslint-disable prettier/prettier */
function IconPhoneLocked(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhoneLocked.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhoneMissed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6.5 5.5L12 11l7-7-1-1-6 6-4.5-4.5H11V3H5v6h1.5V5.5zm17.21 11.17A16.971 16.971 0 0 0 12 12C7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71s.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.12-.52-.3-.7z'
}));

/* eslint-disable prettier/prettier */
function IconPhoneMissed(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhoneMissed.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPhonePaused;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 3h-2v7h2V3zm3 12.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 0 0-1.02.24l-2.2 2.2a15.045 15.045 0 0 1-6.59-6.59l2.2-2.21a.96.96 0 0 0 .25-1A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 3v7h2V3h-2z'
}));

/* eslint-disable prettier/prettier */
function IconPhonePaused(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPhonePaused.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPower;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16.01 7L16 3h-2v4h-4V3H8v4h-.01C7 6.99 6 7.99 6 8.99v5.49L9.5 18v3h5v-3l3.5-3.51v-5.5c0-1-1-2-1.99-1.99z'
}));

/* eslint-disable prettier/prettier */
function IconPower(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPower.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPriorityHigh;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('circle', {
  cx: '12',
  cy: '19',
  r: '2'
}), _jsx('path', {
  d: 'M10 3h4v12h-4z'
}));

/* eslint-disable prettier/prettier */
function IconPriorityHigh(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPriorityHigh.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRvHookup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3z'
}));

/* eslint-disable prettier/prettier */
function IconRvHookup(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRvHookup.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSdCard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z'
}));

/* eslint-disable prettier/prettier */
function IconSdCard(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSdCard.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSimCardAlert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 15h-2v-2h2v2zm0-4h-2V8h2v5z'
}));

/* eslint-disable prettier/prettier */
function IconSimCardAlert(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSimCardAlert.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSms;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z'
}));

/* eslint-disable prettier/prettier */
function IconSms(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSms.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSmsFailed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z'
}));

/* eslint-disable prettier/prettier */
function IconSmsFailed(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSmsFailed.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSync;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 0 0 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z'
}));

/* eslint-disable prettier/prettier */
function IconSync(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSync.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSyncDisabled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33zm-7.14-.94l2.36 2.36a7.925 7.925 0 0 0 1.14 9.87L4 20h6v-6l-2.24 2.24A6.003 6.003 0 0 1 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14 2.86 5.41zM20 4h-6v6l2.24-2.24A6.003 6.003 0 0 1 18 12c0 1-.25 1.94-.68 2.77l1.46 1.46a7.925 7.925 0 0 0-1.14-9.87L20 4z'
}));

/* eslint-disable prettier/prettier */
function IconSyncDisabled(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSyncDisabled.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSyncProblem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24A6.003 6.003 0 0 1 5 12a5.99 5.99 0 0 1 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24A6.003 6.003 0 0 1 19 12a5.99 5.99 0 0 1-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z'
}));

/* eslint-disable prettier/prettier */
function IconSyncProblem(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSyncProblem.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSystemUpdate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z'
}));

/* eslint-disable prettier/prettier */
function IconSystemUpdate(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSystemUpdate.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTapAndPlay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2a9 9 0 0 1 9 9h2c0-6.08-4.92-11-11-11zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z'
}));

/* eslint-disable prettier/prettier */
function IconTapAndPlay(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTapAndPlay.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconTimeToLeave;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z'
}));

/* eslint-disable prettier/prettier */
function IconTimeToLeave(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconTimeToLeave.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVibration;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M0 15h2V9H0v6zm3 2h2V7H3v10zm19-8v6h2V9h-2zm-3 8h2V7h-2v10zM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14z'
}));

/* eslint-disable prettier/prettier */
function IconVibration(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVibration.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVoiceChat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12l-4-3.2V14H6V6h8v3.2L18 6v8z'
}));

/* eslint-disable prettier/prettier */
function IconVoiceChat(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVoiceChat.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconVpnLock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 4v-.5a2.5 2.5 0 0 0-5 0V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4zm-2.28 8c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93z'
}));

/* eslint-disable prettier/prettier */
function IconVpnLock(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconVpnLock.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63A2.01 2.01 0 0 0 16.56 7h-.12a2 2 0 0 0-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z'
}));

/* eslint-disable prettier/prettier */
function IconWc(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWc.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWifi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3a4.237 4.237 0 0 0-6 0zm-4-4l2 2a7.074 7.074 0 0 1 10 0l2-2C15.14 9.14 8.87 9.14 5 13z'
}));

/* eslint-disable prettier/prettier */
function IconWifi(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWifi.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAcUnit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z'
}));

/* eslint-disable prettier/prettier */
function IconAcUnit(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAcUnit.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAirportShuttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M17 5H3a2 2 0 0 0-2 2v9h2c0 1.65 1.34 3 3 3s3-1.35 3-3h5.5c0 1.65 1.34 3 3 3s3-1.35 3-3H23v-5l-6-6zM3 11V7h4v4H3zm3 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7-6.5H9V7h4v4zm4.5 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM15 11V7h1l4 4h-5z'
}));

/* eslint-disable prettier/prettier */
function IconAirportShuttle(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAirportShuttle.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAllInclusive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L12 10.66 10.48 12h.01L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2A5.37 5.37 0 0 0 5.4 6.62C2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l2.83-2.5.01.01L13.52 12h-.01l2.69-2.39c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12a5.386 5.386 0 0 0 3.82 1.57c2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z'
}));

/* eslint-disable prettier/prettier */
function IconAllInclusive(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconAllInclusive.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBeachAccess;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13.127 14.56l1.43-1.43 6.44 6.443L19.57 21zm4.293-5.73l2.86-2.86c-3.95-3.95-10.35-3.96-14.3-.02 3.93-1.3 8.31-.25 11.44 2.88zM5.95 5.98c-3.94 3.95-3.93 10.35.02 14.3l2.86-2.86C5.7 14.29 4.65 9.91 5.95 5.98zm.02-.02l-.01.01c-.38 3.01 1.17 6.88 4.3 10.02l5.73-5.73c-3.13-3.13-7.01-4.68-10.02-4.3z'
}));

/* eslint-disable prettier/prettier */
function IconBeachAccess(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBeachAccess.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconBusinessCenter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4zm10-9h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-6 0h-4V5h4v2z'
}));

/* eslint-disable prettier/prettier */
function IconBusinessCenter(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconBusinessCenter.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCasino;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18zm0-9C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-9c-.83 0-1.5-.67-1.5-1.5S15.67 6 16.5 6s1.5.67 1.5 1.5S17.33 9 16.5 9z'
}));

/* eslint-disable prettier/prettier */
function IconCasino(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCasino.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconChildCare;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('circle', {
  cx: '14.5',
  cy: '10.5',
  r: '1.25'
}), _jsx('circle', {
  cx: '9.5',
  cy: '10.5',
  r: '1.25'
}), _jsx('path', {
  d: 'M22.94 12.66c.04-.21.06-.43.06-.66s-.02-.45-.06-.66a4.008 4.008 0 0 0-2.81-3.17 9.114 9.114 0 0 0-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91a3.994 3.994 0 0 0-2.81 3.17c-.04.21-.06.43-.06.66s.02.45.06.66a4.008 4.008 0 0 0 2.81 3.17 8.977 8.977 0 0 0 2.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89a3.998 3.998 0 0 0 2.8-3.17zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2zM7.5 14c.76 1.77 2.49 3 4.5 3s3.74-1.23 4.5-3h-9z'
}));

/* eslint-disable prettier/prettier */
function IconChildCare(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconChildCare.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconChildFriendly;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13 2v8h8c0-4.42-3.58-8-8-8zm6.32 13.89A7.948 7.948 0 0 0 21 11H6.44l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20z'
}));

/* eslint-disable prettier/prettier */
function IconChildFriendly(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconChildFriendly.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFitnessCenter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z'
}));

/* eslint-disable prettier/prettier */
function IconFitnessCenter(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFitnessCenter.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFreeBreakfast;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2a2 2 0 0 0 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z'
}));

/* eslint-disable prettier/prettier */
function IconFreeBreakfast(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconFreeBreakfast.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGolfCourse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('circle', {
  cx: '19.5',
  cy: '19.5',
  r: '1.5'
}), _jsx('path', {
  d: 'M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z'
}));

/* eslint-disable prettier/prettier */
function IconGolfCourse(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGolfCourse.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconHotTub;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('circle', {
  cx: '7',
  cy: '6',
  r: '2'
}), _jsx('path', {
  d: 'M11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zm-.35-14.14l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm-4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71z'
}));

/* eslint-disable prettier/prettier */
function IconHotTub(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconHotTub.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconKitchen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 2.01L6 2a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99zM18 20H6v-9.02h12V20zm0-11H6V4h12v5zM8 5h2v3H8zm0 7h2v5H8z'
}));

/* eslint-disable prettier/prettier */
function IconKitchen(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconKitchen.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPool;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 21c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.08.64-2.19.64-1.11 0-1.73-.37-2.18-.64-.37-.23-.6-.36-1.15-.36s-.78.13-1.15.36c-.46.27-1.08.64-2.19.64v-2c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36v2zm0-4.5c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36s-.78.13-1.15.36c-.47.27-1.09.64-2.2.64v-2c.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36v2zM8.67 12c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36z'
}), _jsx('circle', {
  cx: '16.5',
  cy: '5.5',
  r: '2.5'
}));

/* eslint-disable prettier/prettier */
function IconPool(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPool.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRoomService;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M2 17h20v2H2zm11.84-9.21A2.006 2.006 0 0 0 12 5a2.006 2.006 0 0 0-1.84 2.79C6.25 8.6 3.27 11.93 3 16h18c-.27-4.07-3.25-7.4-7.16-8.21z'
}));

/* eslint-disable prettier/prettier */
function IconRoomService(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRoomService.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSmokeFree;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M2 6l6.99 7H2v3h9.99l7 7 1.26-1.25-17-17zm18.5 7H22v3h-1.5zM18 13h1.5v3H18zm.85-8.12c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.92c0-2.23-1.28-4.15-3.15-5.04zM14.5 8.7h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.59c0-1.8-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75V2a3.35 3.35 0 0 0 0 6.7zm2.5 7.23V13h-2.93z'
}));

/* eslint-disable prettier/prettier */
function IconSmokeFree(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSmokeFree.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSmokingRooms;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M2 16h15v3H2zm18.5 0H22v3h-1.5zM18 16h1.5v3H18zm.85-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03zm-2.82 2.47H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5a3.35 3.35 0 0 0 0 6.7h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16z'
}));

/* eslint-disable prettier/prettier */
function IconSmokingRooms(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSmokingRooms.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSpa;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M8.55 12zm10.43-1.61z'
}), _jsx('path', {
  d: 'M15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63a12.188 12.188 0 0 0-3.55 7.63c1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM12 15.45C9.85 12.17 6.18 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45z'
}));

/* eslint-disable prettier/prettier */
function IconSpa(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSpa.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCake;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 6a2 2 0 0 0 2-2c0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z'
}));

/* eslint-disable prettier/prettier */
function IconCake(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCake.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDomain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z'
}));

/* eslint-disable prettier/prettier */
function IconDomain(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDomain.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGroup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z'
}));

/* eslint-disable prettier/prettier */
function IconGroup(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGroup.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconGroupAdd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z'
}));

/* eslint-disable prettier/prettier */
function IconGroupAdd(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconGroupAdd.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLocationCity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z'
}));

/* eslint-disable prettier/prettier */
function IconLocationCity(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconLocationCity.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMood;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z'
}));

/* eslint-disable prettier/prettier */
function IconMood(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMood.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMoodBad;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 3c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z'
}));

/* eslint-disable prettier/prettier */
function IconMoodBad(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconMoodBad.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNotifications;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 22c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconNotifications(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNotifications.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNotificationsActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2a8.445 8.445 0 0 1 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43a8.495 8.495 0 0 1 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z'
}));

/* eslint-disable prettier/prettier */
function IconNotificationsActive(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNotificationsActive.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNotificationsNone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z'
}));

/* eslint-disable prettier/prettier */
function IconNotificationsNone(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNotificationsNone.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNotificationsOff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 18.69L7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72l-1-1.03zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2zm6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.42.12-.1.03-.2.07-.3.11h-.01c-.01 0-.01 0-.02.01-.23.09-.46.2-.68.31 0 0-.01 0-.01.01L18 14.68z'
}));

/* eslint-disable prettier/prettier */
function IconNotificationsOff(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNotificationsOff.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconNotificationsPaused;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 22c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.93 6 11v5l-2 2v1h16v-1l-2-2zm-3.5-6.2l-2.8 3.4h2.8V15h-5v-1.8l2.8-3.4H9.5V8h5v1.8z'
}));

/* eslint-disable prettier/prettier */
function IconNotificationsPaused(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconNotificationsPaused.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPages;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 5v6h5L7 7l4 1V3H5c-1.1 0-2 .9-2 2zm5 8H3v6c0 1.1.9 2 2 2h6v-5l-4 1 1-4zm9 4l-4-1v5h6c1.1 0 2-.9 2-2v-6h-5l1 4zm2-14h-6v5l4-1-1 4h5V5c0-1.1-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconPages(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPages.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPartyMode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 3c1.63 0 3.06.79 3.98 2H12c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H7.1A5.002 5.002 0 0 1 12 7zm0 10c-1.63 0-3.06-.79-3.98-2H12c1.66 0 3-1.34 3-3 0-.35-.07-.69-.18-1h2.08a5.002 5.002 0 0 1-4.9 6z'
}));

/* eslint-disable prettier/prettier */
function IconPartyMode(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPartyMode.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPeople;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z'
}));

/* eslint-disable prettier/prettier */
function IconPeople(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPeople.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPeopleOutline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z'
}));

/* eslint-disable prettier/prettier */
function IconPeopleOutline(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPeopleOutline.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPerson;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'
}));

/* eslint-disable prettier/prettier */
function IconPerson(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPerson.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPersonAdd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'
}));

/* eslint-disable prettier/prettier */
function IconPersonAdd(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPersonAdd.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPersonOutline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 5.9a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z'
}));

/* eslint-disable prettier/prettier */
function IconPersonOutline(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPersonOutline.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPlusOne;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 8H8v4H4v2h4v4h2v-4h4v-2h-4zm4.5-1.92V7.9l2.5-.5V18h2V5z'
}));

/* eslint-disable prettier/prettier */
function IconPlusOne(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPlusOne.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPoll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z'
}));

/* eslint-disable prettier/prettier */
function IconPoll(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPoll.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconPublic;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z'
}));

/* eslint-disable prettier/prettier */
function IconPublic(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconPublic.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSchool;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z'
}));

/* eslint-disable prettier/prettier */
function IconSchool(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSchool.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSentimentDissatisfied;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('circle', {
  cx: '15.5',
  cy: '9.5',
  r: '1.5'
}), _jsx('circle', {
  cx: '8.5',
  cy: '9.5',
  r: '1.5'
}), _jsx('path', {
  d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z'
}));

/* eslint-disable prettier/prettier */
function IconSentimentDissatisfied(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSentimentDissatisfied.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSentimentNeutral;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 14h6v1.5H9z'
}), _jsx('circle', {
  cx: '15.5',
  cy: '9.5',
  r: '1.5'
}), _jsx('circle', {
  cx: '8.5',
  cy: '9.5',
  r: '1.5'
}), _jsx('path', {
  d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconSentimentNeutral(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSentimentNeutral.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSentimentVeryDissatisfied;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4.18-12.24l-1.06 1.06-1.06-1.06L13 8.82l1.06 1.06L13 10.94 14.06 12l1.06-1.06L16.18 12l1.06-1.06-1.06-1.06 1.06-1.06zM7.82 12l1.06-1.06L9.94 12 11 10.94 9.94 9.88 11 8.82 9.94 7.76 8.88 8.82 7.82 7.76 6.76 8.82l1.06 1.06-1.06 1.06zM12 14c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z'
}));

/* eslint-disable prettier/prettier */
function IconSentimentVeryDissatisfied(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSentimentVeryDissatisfied.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSentimentVerySatisfied;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12zm-4.12 0L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11zM12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z'
}));

/* eslint-disable prettier/prettier */
function IconSentimentVerySatisfied(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSentimentVerySatisfied.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconShare;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z'
}));

/* eslint-disable prettier/prettier */
function IconShare(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconShare.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWhatshot;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z'
}));

/* eslint-disable prettier/prettier */
function IconWhatshot(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWhatshot.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCheckBox;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'
}));

/* eslint-disable prettier/prettier */
function IconCheckBox(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCheckBox.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCheckBoxOutlineBlank;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconCheckBoxOutlineBlank(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconCheckBoxOutlineBlank.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconIndeterminateCheckBox;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z'
}));

/* eslint-disable prettier/prettier */
function IconIndeterminateCheckBox(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconIndeterminateCheckBox.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRadioButtonChecked;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconRadioButtonChecked(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRadioButtonChecked.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconRadioButtonUnchecked;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z'
}));

/* eslint-disable prettier/prettier */
function IconRadioButtonUnchecked(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconRadioButtonUnchecked.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconStar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'
}));

/* eslint-disable prettier/prettier */
function IconStar(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconStar.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconStarBorder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z'
}));

/* eslint-disable prettier/prettier */
function IconStarBorder(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconStarBorder.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconStarHalf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z'
}));

/* eslint-disable prettier/prettier */
function IconStarHalf(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconStarHalf.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('code', function (_ref) {
  var theme = _ref.theme;
  return {
    backgroundColor: theme.color_gray_20,
    borderRadius: theme.borderRadius_1,
    fontFamily: theme.fontFamily_monospace,
    padding: theme.space_inset_xs,
    wordBreak: 'break-all'
  };
}));

/***/ }),
/* 1228 */,
/* 1229 */,
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_int8_array__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_int8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_int8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_array__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_clamped_array__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_clamped_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_clamped_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_int16_array__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_int16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_int16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_uint16_array__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_uint16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_uint16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_int32_array__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_int32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_int32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_uint32_array__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_uint32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_uint32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float32_array__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float64_array__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float64_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float64_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_map__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_set__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_map__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_set__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_apply__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_apply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_apply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_define_property__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_delete_property__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_own_property_descriptor__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_prototype_of__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_has__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_is_extensible__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_own_keys__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_own_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_own_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_prevent_extensions__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set_prototype_of__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_promise__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_symbol__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_assign__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_is__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_set_prototype_of__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_function_name__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_string_raw__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_string_raw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_string_raw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_string_from_code_point__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_string_code_point_at__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_string_code_point_at___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_string_code_point_at__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_string_repeat__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_string_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_string_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_string_starts_with__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_string_ends_with__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_string_ends_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_string_ends_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_string_includes__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_regexp_flags__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_regexp_flags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_regexp_flags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_regexp_match__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_regexp_replace__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_regexp_split__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_regexp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_regexp_search__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_regexp_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_regexp_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_array_from__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_array_of__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_array_copy_within__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_array_copy_within___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_array_copy_within__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_array_find__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_array_find_index__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_array_fill__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_array_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_array_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_array_iterator__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_array_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_array_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_number_is_finite__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_number_is_integer__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_number_is_safe_integer__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_number_is_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_number_is_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_number_is_nan__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_number_epsilon__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_number_min_safe_integer__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_number_min_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_number_min_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_number_max_safe_integer__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_math_acosh__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_math_acosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_math_acosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_math_asinh__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_math_asinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_math_asinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_math_atanh__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_math_atanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_math_atanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_math_cbrt__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_math_cbrt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_math_cbrt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_math_clz32__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_math_clz32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_math_clz32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_math_cosh__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_math_cosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_math_cosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_math_expm1__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_math_expm1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_math_expm1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_math_fround__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_math_fround___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_math_fround__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_math_hypot__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_math_hypot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_math_hypot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_math_imul__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_math_imul___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_math_imul__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_log1p__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_log1p___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_log1p__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_log10__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_log2__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_sign__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_sinh__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_sinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_sinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_tanh__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_tanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_tanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_trunc__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es7_array_includes__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es7_object_values__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es7_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77_core_js_modules_es7_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es7_object_entries__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es7_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78_core_js_modules_es7_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es7_object_get_own_property_descriptors__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es7_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79_core_js_modules_es7_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es7_string_pad_start__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es7_string_pad_start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80_core_js_modules_es7_string_pad_start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es7_string_pad_end__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es7_string_pad_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81_core_js_modules_es7_string_pad_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_web_timers__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_web_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82_core_js_modules_web_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_web_immediate__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_web_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83_core_js_modules_web_immediate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_web_dom_iterable__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_regenerator_runtime_runtime__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_react_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_react_router_dom__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_glamor__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_glamor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89_glamor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__app_App__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__app_demos__ = __webpack_require__(1562);























































































var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









__webpack_require__(1709);
__webpack_require__(1712);

// Enable Glamor simulate helper
Object(__WEBPACK_IMPORTED_MODULE_89_glamor__["simulations"])(true);

Object(__WEBPACK_IMPORTED_MODULE_87_react_dom__["render"])(_jsx(__WEBPACK_IMPORTED_MODULE_88_react_router_dom__["a" /* BrowserRouter */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_90__themes__["a" /* ThemeProvider */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_91__app_App__["a" /* default */], {
  demos: __WEBPACK_IMPORTED_MODULE_92__app_demos__["a" /* default */]
}))), document.getElementById('app'));

/***/ }),
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createColorRamp__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styleVariables__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var grays = Object(__WEBPACK_IMPORTED_MODULE_1__createColorRamp__["a" /* default */])('gray', 'gray', __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */]);
var primaries = Object(__WEBPACK_IMPORTED_MODULE_1__createColorRamp__["a" /* default */])('dusk', 'theme', __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (_extends({}, __WEBPACK_IMPORTED_MODULE_2__styleVariables__["a" /* default */], primaries, grays, {

  color_black: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].black,
  color_white: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,

  backgroundColor_disabled: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_20,
  backgroundColor_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  backgroundColor_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  backgroundColor_danger_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_30,
  backgroundColor_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  backgroundColor_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_50,
  backgroundColor_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  backgroundColor_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  backgroundColor_success_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_30,
  backgroundColor_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  backgroundColor_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_70,
  backgroundColor_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  backgroundColor_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  backgroundColor_warning_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_30,
  backgroundColor_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  backgroundColor_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_50,

  backgroundColor_input_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_10,
  backgroundColor_input_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_10,
  backgroundColor_input_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_10,

  backgroundColor_link_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_30,

  borderColor: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_40,
  borderColor_active: primaries.color_theme_50,
  borderColor_focus: primaries.color_theme_80,
  borderColor_hover: primaries.color_theme_60,
  borderColor_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_80,
  borderColor_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_100,
  borderColor_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  borderColor_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  borderColor_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  borderColor_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_100,
  borderColor_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  borderColor_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_60,
  borderColor_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_70,
  borderColor_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_100,
  borderColor_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  borderColor_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_60,

  color_caption: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_80,

  color_placeholder: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_60,

  color_text: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_100,
  color_text_disabled: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_50,
  color_text_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  color_text_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  color_text_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  color_text_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_50,
  color_text_ondanger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_primary: primaries.color_theme_60,
  color_text_primary_active: primaries.color_theme_70,
  color_text_primary_focus: primaries.color_theme_60,
  color_text_primary_hover: primaries.color_theme_50,
  color_text_onprimary: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  color_text_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_100,
  color_text_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  color_text_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  color_text_onsuccess: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  color_text_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_80,
  color_text_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  color_text_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  color_text_onwarning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white
}));

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createColorRamp__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styleVariables__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var grays = Object(__WEBPACK_IMPORTED_MODULE_1__createColorRamp__["a" /* default */])('gray', 'gray', __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */]);
var primaries = Object(__WEBPACK_IMPORTED_MODULE_1__createColorRamp__["a" /* default */])('indigo', 'theme', __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (_extends({}, __WEBPACK_IMPORTED_MODULE_2__styleVariables__["a" /* default */], primaries, grays, {

  color_black: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].black,
  color_white: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,

  backgroundColor_disabled: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_20,
  backgroundColor_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  backgroundColor_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  backgroundColor_danger_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_30,
  backgroundColor_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  backgroundColor_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_50,
  backgroundColor_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  backgroundColor_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  backgroundColor_success_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_30,
  backgroundColor_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  backgroundColor_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_70,
  backgroundColor_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  backgroundColor_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  backgroundColor_warning_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_30,
  backgroundColor_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  backgroundColor_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_50,

  backgroundColor_input_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_10,
  backgroundColor_input_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_10,
  backgroundColor_input_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_10,

  backgroundColor_link_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_30,

  borderColor: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_40,
  borderColor_active: primaries.color_theme_50,
  borderColor_focus: primaries.color_theme_80,
  borderColor_hover: primaries.color_theme_60,
  borderColor_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_80,
  borderColor_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_100,
  borderColor_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  borderColor_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  borderColor_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  borderColor_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_100,
  borderColor_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  borderColor_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_60,
  borderColor_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_70,
  borderColor_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_100,
  borderColor_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  borderColor_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_60,

  color_caption: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_80,

  color_placeholder: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_60,

  color_text: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_100,
  color_text_disabled: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_50,
  color_text_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  color_text_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  color_text_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  color_text_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_50,
  color_text_ondanger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_primary: primaries.color_theme_60,
  color_text_primary_active: primaries.color_theme_70,
  color_text_primary_focus: primaries.color_theme_60,
  color_text_primary_hover: primaries.color_theme_50,
  color_text_onprimary: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  color_text_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_100,
  color_text_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  color_text_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  color_text_onsuccess: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  color_text_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_80,
  color_text_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  color_text_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  color_text_onwarning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white
}));

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createColorRamp__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styleVariables__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var grays = Object(__WEBPACK_IMPORTED_MODULE_1__createColorRamp__["a" /* default */])('gray', 'gray', __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */]);
var primaries = Object(__WEBPACK_IMPORTED_MODULE_1__createColorRamp__["a" /* default */])('lime', 'theme', __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (_extends({}, __WEBPACK_IMPORTED_MODULE_2__styleVariables__["a" /* default */], primaries, grays, {

  color_black: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].black,
  color_white: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,

  backgroundColor_disabled: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_20,
  backgroundColor_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  backgroundColor_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  backgroundColor_danger_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_30,
  backgroundColor_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  backgroundColor_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_50,
  backgroundColor_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  backgroundColor_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  backgroundColor_success_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_30,
  backgroundColor_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  backgroundColor_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_70,
  backgroundColor_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  backgroundColor_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  backgroundColor_warning_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_30,
  backgroundColor_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  backgroundColor_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_50,

  backgroundColor_input_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_10,
  backgroundColor_input_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_10,
  backgroundColor_input_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_10,

  backgroundColor_link_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_30,

  borderColor: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_40,
  borderColor_active: primaries.color_theme_50,
  borderColor_focus: primaries.color_theme_80,
  borderColor_hover: primaries.color_theme_60,
  borderColor_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_80,
  borderColor_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_100,
  borderColor_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  borderColor_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  borderColor_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  borderColor_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_100,
  borderColor_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  borderColor_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_60,
  borderColor_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_70,
  borderColor_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_100,
  borderColor_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  borderColor_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_60,

  color_caption: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_80,

  color_placeholder: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_60,

  color_text: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_100,
  color_text_disabled: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_50,
  color_text_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  color_text_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  color_text_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  color_text_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_50,
  color_text_ondanger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_primary: primaries.color_theme_60,
  color_text_primary_active: primaries.color_theme_70,
  color_text_primary_focus: primaries.color_theme_60,
  color_text_primary_hover: primaries.color_theme_50,
  color_text_onprimary: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].black,
  color_text_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  color_text_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_100,
  color_text_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  color_text_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  color_text_onsuccess: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  color_text_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_80,
  color_text_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  color_text_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  color_text_onwarning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white
}));

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createColorRamp__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styleVariables__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var grays = Object(__WEBPACK_IMPORTED_MODULE_1__createColorRamp__["a" /* default */])('gray', 'gray', __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */]);
var primaries = Object(__WEBPACK_IMPORTED_MODULE_1__createColorRamp__["a" /* default */])('purple', 'theme', __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (_extends({}, __WEBPACK_IMPORTED_MODULE_2__styleVariables__["a" /* default */], primaries, grays, {

  color_black: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].black,
  color_white: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,

  backgroundColor_disabled: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_20,
  backgroundColor_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  backgroundColor_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  backgroundColor_danger_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_30,
  backgroundColor_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  backgroundColor_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_50,
  backgroundColor_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  backgroundColor_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  backgroundColor_success_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_30,
  backgroundColor_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  backgroundColor_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_70,
  backgroundColor_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  backgroundColor_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  backgroundColor_warning_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_30,
  backgroundColor_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  backgroundColor_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_50,

  backgroundColor_input_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_10,
  backgroundColor_input_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_10,
  backgroundColor_input_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_10,

  backgroundColor_link_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_30,

  borderColor: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_40,
  borderColor_active: primaries.color_theme_50,
  borderColor_focus: primaries.color_theme_80,
  borderColor_hover: primaries.color_theme_60,
  borderColor_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_80,
  borderColor_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_100,
  borderColor_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  borderColor_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  borderColor_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  borderColor_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_100,
  borderColor_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  borderColor_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_60,
  borderColor_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_70,
  borderColor_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_100,
  borderColor_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  borderColor_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_60,

  color_caption: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_80,

  color_placeholder: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_60,

  color_text: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_100,
  color_text_disabled: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_50,
  color_text_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  color_text_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  color_text_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  color_text_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_50,
  color_text_ondanger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_primary: primaries.color_theme_60,
  color_text_primary_active: primaries.color_theme_70,
  color_text_primary_focus: primaries.color_theme_60,
  color_text_primary_hover: primaries.color_theme_50,
  color_text_onprimary: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  color_text_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_100,
  color_text_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  color_text_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  color_text_onsuccess: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  color_text_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_80,
  color_text_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  color_text_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  color_text_onwarning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white
}));

/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createColorRamp__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styleVariables__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var grays = Object(__WEBPACK_IMPORTED_MODULE_1__createColorRamp__["a" /* default */])('gray', 'gray', __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */]);
var primaries = Object(__WEBPACK_IMPORTED_MODULE_1__createColorRamp__["a" /* default */])('sky', 'theme', __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (_extends({}, __WEBPACK_IMPORTED_MODULE_2__styleVariables__["a" /* default */], primaries, grays, {

  color_black: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].black,
  color_white: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,

  backgroundColor_disabled: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_20,
  backgroundColor_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  backgroundColor_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  backgroundColor_danger_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_30,
  backgroundColor_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  backgroundColor_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_50,
  backgroundColor_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  backgroundColor_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  backgroundColor_success_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_30,
  backgroundColor_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  backgroundColor_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_70,
  backgroundColor_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  backgroundColor_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  backgroundColor_warning_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_30,
  backgroundColor_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  backgroundColor_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_50,

  backgroundColor_input_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_10,
  backgroundColor_input_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_10,
  backgroundColor_input_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_10,

  backgroundColor_link_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_30,

  borderColor: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_40,
  borderColor_active: primaries.color_theme_50,
  borderColor_focus: primaries.color_theme_80,
  borderColor_hover: primaries.color_theme_60,
  borderColor_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_80,
  borderColor_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_100,
  borderColor_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  borderColor_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  borderColor_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  borderColor_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_100,
  borderColor_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  borderColor_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_60,
  borderColor_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_70,
  borderColor_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_100,
  borderColor_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  borderColor_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_60,

  color_caption: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_80,

  color_placeholder: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_60,

  color_text: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_100,
  color_text_disabled: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_50,
  color_text_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  color_text_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  color_text_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  color_text_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_50,
  color_text_ondanger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_primary: primaries.color_theme_60,
  color_text_primary_active: primaries.color_theme_70,
  color_text_primary_focus: primaries.color_theme_60,
  color_text_primary_hover: primaries.color_theme_50,
  color_text_onprimary: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].black,
  color_text_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  color_text_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_100,
  color_text_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  color_text_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  color_text_onsuccess: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  color_text_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_80,
  color_text_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  color_text_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  color_text_onwarning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white
}));

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createColorRamp__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styleVariables__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var grays = Object(__WEBPACK_IMPORTED_MODULE_1__createColorRamp__["a" /* default */])('gray', 'gray', __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */]);
var primaries = Object(__WEBPACK_IMPORTED_MODULE_1__createColorRamp__["a" /* default */])('slate', 'theme', __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (_extends({}, __WEBPACK_IMPORTED_MODULE_2__styleVariables__["a" /* default */], primaries, grays, {

  color_black: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].black,
  color_white: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,

  backgroundColor_disabled: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_20,
  backgroundColor_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  backgroundColor_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  backgroundColor_danger_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_30,
  backgroundColor_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  backgroundColor_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_50,
  backgroundColor_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  backgroundColor_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  backgroundColor_success_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_30,
  backgroundColor_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  backgroundColor_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_70,
  backgroundColor_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  backgroundColor_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  backgroundColor_warning_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_30,
  backgroundColor_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  backgroundColor_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_50,

  backgroundColor_input_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_10,
  backgroundColor_input_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_10,
  backgroundColor_input_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_10,

  backgroundColor_link_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_30,

  borderColor: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_40,
  borderColor_active: primaries.color_theme_50,
  borderColor_focus: primaries.color_theme_80,
  borderColor_hover: primaries.color_theme_60,
  borderColor_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_80,
  borderColor_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_100,
  borderColor_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  borderColor_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  borderColor_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  borderColor_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_100,
  borderColor_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  borderColor_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_60,
  borderColor_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_70,
  borderColor_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_100,
  borderColor_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  borderColor_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_60,

  color_caption: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_80,

  color_placeholder: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_60,

  color_text: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_100,
  color_text_disabled: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_50,
  color_text_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  color_text_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  color_text_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  color_text_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_50,
  color_text_ondanger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_primary: primaries.color_theme_60,
  color_text_primary_active: primaries.color_theme_70,
  color_text_primary_focus: primaries.color_theme_60,
  color_text_primary_hover: primaries.color_theme_50,
  color_text_onprimary: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].black,
  color_text_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  color_text_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_100,
  color_text_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  color_text_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  color_text_onsuccess: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  color_text_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_80,
  color_text_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  color_text_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  color_text_onwarning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white
}));

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createColorRamp__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styleVariables__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var grays = Object(__WEBPACK_IMPORTED_MODULE_1__createColorRamp__["a" /* default */])('gray', 'gray', __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */]);
var primaries = Object(__WEBPACK_IMPORTED_MODULE_1__createColorRamp__["a" /* default */])('teal', 'theme', __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (_extends({}, __WEBPACK_IMPORTED_MODULE_2__styleVariables__["a" /* default */], primaries, grays, {

  color_black: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].black,
  color_white: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,

  backgroundColor_disabled: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_20,
  backgroundColor_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  backgroundColor_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  backgroundColor_danger_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_30,
  backgroundColor_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  backgroundColor_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_50,
  backgroundColor_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  backgroundColor_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  backgroundColor_success_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_30,
  backgroundColor_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  backgroundColor_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_70,
  backgroundColor_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  backgroundColor_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  backgroundColor_warning_activeMuted: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_30,
  backgroundColor_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  backgroundColor_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_50,

  backgroundColor_input_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_10,
  backgroundColor_input_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_10,
  backgroundColor_input_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_10,

  backgroundColor_link_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_30,

  borderColor: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_40,
  borderColor_active: primaries.color_theme_50,
  borderColor_focus: primaries.color_theme_80,
  borderColor_hover: primaries.color_theme_60,
  borderColor_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_80,
  borderColor_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_100,
  borderColor_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  borderColor_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  borderColor_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  borderColor_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_100,
  borderColor_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  borderColor_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_60,
  borderColor_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_70,
  borderColor_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_100,
  borderColor_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  borderColor_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].yellow_60,

  color_caption: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_80,

  color_placeholder: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_60,

  color_text: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_100,
  color_text_disabled: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].gray_50,
  color_text_danger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  color_text_danger_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_70,
  color_text_danger_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_60,
  color_text_danger_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].red_50,
  color_text_ondanger: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_primary: primaries.color_theme_60,
  color_text_primary_active: primaries.color_theme_70,
  color_text_primary_focus: primaries.color_theme_60,
  color_text_primary_hover: primaries.color_theme_50,
  color_text_onprimary: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].black,
  color_text_success: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  color_text_success_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_100,
  color_text_success_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_90,
  color_text_success_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].green_80,
  color_text_onsuccess: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white,
  color_text_warning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  color_text_warning_active: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_80,
  color_text_warning_focus: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_70,
  color_text_warning_hover: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].orange_60,
  color_text_onwarning: __WEBPACK_IMPORTED_MODULE_0__color__["a" /* default */].white
}));

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_exenv__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_exenv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_ComponentDoc__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_createKeyMap__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Footer__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Nav__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Router__ = __webpack_require__(1561);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */












var styles = {
  app: function app(_ref) {
    var theme = _ref.theme;
    return {
      fontFamily: theme.fontFamily_system
    };
  },
  nav: function nav(_ref2) {
    var theme = _ref2.theme;
    return {
      backgroundColor: theme.color_gray_10,
      border: '0 solid ' + theme.borderColor,
      borderBottomWidth: '1px',

      '@media(min-width: 45em)': {
        borderBottomWidth: '0',
        borderRightWidth: '1px',
        height: '100vh',
        overflow: 'auto',
        position: 'fixed',
        width: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* pxToEm */])(256)
      }
    };
  },
  main: function main(_ref3) {
    var theme = _ref3.theme;
    return {
      padding: theme.space_inset_md,

      '@media(min-width: 45em)': {
        marginLeft: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* pxToEm */])(256),
        padding: parseFloat(theme.space_inset_sm) * 8 + 'em\n        ' + parseFloat(theme.space_inset_sm) * 16 + 'em\n        ' + parseFloat(theme.space_inset_sm) * 4 + 'em'
      }
    };
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* createStyledComponent */])('div', styles.app, {
  includeStyleReset: true
});
var Nav = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_8__Nav__["a" /* default */], styles.nav);
var Main = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* createStyledComponent */])('main', styles.main);

var _ref6 = _jsx(__WEBPACK_IMPORTED_MODULE_7__Footer__["a" /* default */], {});

var App = function (_Component) {
  _inherits(App, _Component);

  function App(props) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    if (true) {
      // Analytics tracking of push state page views
      props.history.listen(function (location, action) {
        if (__WEBPACK_IMPORTED_MODULE_3_exenv__["canUseDOM"] && action === 'PUSH') {
          global.window.gtag('config', "UA-107538931-1", {
            page_path: location.pathname
          });
        }
      });
    }
    return _this;
  }

  _createClass(App, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (__WEBPACK_IMPORTED_MODULE_3_exenv__["canUseDOM"] && this.props.location !== prevProps.location) {
        global.window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          demos = _props.demos;


      if (!Array.isArray(demos) && demos.slug) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__pages_ComponentDoc__["a" /* default */], demos);
      }

      var siteDemos = Array.isArray(demos) ? Object(__WEBPACK_IMPORTED_MODULE_6__utils_createKeyMap__["a" /* default */])(demos, 'slug') : demos;

      var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_9__Router__["a" /* default */], {
        demos: siteDemos
      });

      var _ref5 = _jsx(Root, {
        className: className
      }, void 0, _jsx(Nav, {
        demos: siteDemos
      }), _jsx(Main, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__Router__["a" /* default */], {
        demos: siteDemos
      }), _ref6));

      return _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Switch */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */], {
        exact: true,
        strict: true,
        path: '/:url*',
        render: function render(props) {
          return _jsx(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */], {
            to: props.location.pathname + '/'
          });
        }
      }), _jsx(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */], {
        render: function render(route) {
          var isChromeless = route.location.search === '?chromeless';
          return isChromeless ? _ref4 : _ref5;
        }
      })));
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

App.propTypes = {
  children: __webpack_require__(0).any,
  className: __webpack_require__(0).string,
  demos: __webpack_require__(0).oneOfType([__webpack_require__(0).object, __webpack_require__(0).arrayOf(__webpack_require__(0).object)]).isRequired,
  history: __webpack_require__(0).object.isRequired,
  location: __webpack_require__(0).any
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* withRouter */])(App));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(35)))

/***/ }),
/* 1470 */,
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStyledComponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamorous__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__componentStyleReset__ = __webpack_require__(1472);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




function createStyledComponent(element, styles) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var includeStyleReset = options.includeStyleReset,
      restOptions = _objectWithoutProperties(options, ['includeStyleReset']);

  var outStyles = void 0;

  if (includeStyleReset) {
    outStyles = function outStyles(props, context) {
      var componentStyles = typeof styles === 'function' ? styles(props, context) : styles;

      return _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1__componentStyleReset__["a" /* default */])(props), componentStyles);
    };
  } else {
    outStyles = styles;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_glamorous__["b" /* default */])(element, restOptions)(outStyles);
}

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var theme = _ref.theme;

  return {
    boxSizing: 'border-box',
    color: theme.color_text,
    fontFamily: theme.fontFamily + ', ' + theme.fontFamily_system,
    fontSize: theme.fontSize_base + 'px',
    lineHeight: theme.lineHeight,
    outline: 0,
    '& *,& *::before,& *::after': {
      boxSizing: 'inherit'
    }
  };
});

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createThemedComponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_glamorous__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes_ThemeProvider__ = __webpack_require__(263);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





function getComponentDisplayName(Component) {
  return typeof Component === 'string' ? Component : Component.displayName || Component.name || 'Component';
}

function createThemedComponent(ComponentToTheme, theme) {
  var ThemedComponent = function ThemedComponent(props, context) {
    var outTheme = typeof theme === 'function' ? theme(props, context) : theme;

    var ignore = props.theme,
        outProps = _objectWithoutProperties(props, ['theme']);

    return _jsx(__WEBPACK_IMPORTED_MODULE_2__themes_ThemeProvider__["a" /* default */], {
      theme: outTheme
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentToTheme, outProps));
  };

  ThemedComponent.propTypes = ComponentToTheme.propTypes;

  ThemedComponent.displayName = 'Themed(' + getComponentDisplayName(ComponentToTheme) + ')';

  return Object(__WEBPACK_IMPORTED_MODULE_1_glamorous__["c" /* withTheme */])(ThemedComponent);
}

/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNormalizedValue;
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
  * Helper to normalize a theme variable (defined in ems) against the applied
  * fontSize (also defined in ems), so that the resulting value renders correctly
  */
function getNormalizedValue(value, base) {
  return parseFloat(value) / parseFloat(base) + "em";
}

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateId;
/* unused harmony export resetId */
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var currentId = 0;

function generateId() {
  currentId += 1;
  return currentId.toString();
}

function resetId() {
  currentId = 0;
}

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function composeEventHandlers() {
  for (var _len = arguments.length, handlers = Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }

  var fns = handlers.filter(function (fn) {
    return Boolean(fn);
  });

  if (fns.length === 0) {
    return undefined;
  } else if (fns.length === 1) {
    return fns[0];
  } else {
    return function (event) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return fns.some(function (fn) {
        fn.apply(undefined, [event].concat(args));
        return event.defaultPrevented;
      });
    };
  }
}

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DocBestPractices;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Heading__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Section__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DocPractice__ = __webpack_require__(1478);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







var styles = {
  grid: function grid(_ref) {
    var theme = _ref.theme;
    return {
      '@media(min-width: 45em)': {
        display: 'grid',
        gridAutoFlow: 'column',
        gridTemplateColumns: '1fr 1fr',
        gridColumnGap: theme.space_inline_xl
      }
    };
  },
  practice: function practice(_ref2) {
    var theme = _ref2.theme,
        type = _ref2.type;
    return {
      gridColumnStart: type === 'do' ? 1 : 2,
      marginBottom: parseFloat(theme.space_stack_xl) * 2 + 'em'
    };
  }
};

var Grid = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', styles.grid);
var Practice = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_4__DocPractice__["a" /* default */], styles.practice);

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_2__Heading__["a" /* default */], {
  level: 3,
  id: 'best-practices'
}, void 0, 'Best Practices');

function DocBestPractices(_ref3) {
  var practices = _ref3.practices;

  return _jsx(__WEBPACK_IMPORTED_MODULE_3__Section__["a" /* default */], {}, void 0, _ref4, _jsx(Grid, {}, void 0, practices.map(function (practice, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Practice,
      _extends({ key: index }, practice),
      practice.description
    );
  })));
}
DocBestPractices.propTypes = {
  practices: __webpack_require__(0).arrayOf(__webpack_require__(0).object).isRequired
};

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DocPractice;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Markdown__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Heading__ = __webpack_require__(31);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var Example = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', function (_ref) {
  var backgroundColor = _ref.backgroundColor,
      theme = _ref.theme;
  return {
    backgroundColor: backgroundColor,
    border: '1px solid ' + theme.borderColor,
    marginBottom: theme.space_stack_md,
    padding: theme.space_inset_md
  };
});
var Title = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_3__Heading__["a" /* default */], function (_ref2) {
  var type = _ref2.type,
      theme = _ref2.theme;
  return {
    borderBottom: '2px solid ' + (type === 'do' ? theme.borderColor_success : theme.borderColor_danger),
    paddingBottom: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getNormalizedValue */])(theme.space_stack_sm, theme.fontSize_h4),

    '& strong': {
      fontSize: theme.fontSize_h2,
      fontWeight: 'inherit'
    }
  };
});

var _ref4 = _jsx('strong', {}, void 0, 'DO');

var _ref5 = _jsx('strong', {}, void 0, 'DON\u2019T');

var _ref6 = _jsx('br', {});

function DocPractice(_ref3) {
  var backgroundColor = _ref3.backgroundColor,
      children = _ref3.children,
      className = _ref3.className,
      example = _ref3.example,
      title = _ref3.title,
      type = _ref3.type;

  return _jsx('div', {
    className: className
  }, void 0, _jsx(Title, {
    level: 4,
    type: type
  }, void 0, type === 'do' ? _ref4 : _ref5, _ref6, title), _jsx(Example, {
    backgroundColor: backgroundColor
  }, void 0, typeof example === 'string' ? _jsx(__WEBPACK_IMPORTED_MODULE_2__Markdown__["a" /* default */], {}, void 0, example) : example), _jsx(__WEBPACK_IMPORTED_MODULE_2__Markdown__["a" /* default */], {}, void 0, children));
}
DocPractice.propTypes = {
  backgroundColor: __webpack_require__(0).string,
  children: __webpack_require__(0).string,
  className: __webpack_require__(0).string,
  example: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node) : __webpack_require__(0).any,
  title: __webpack_require__(0).string.isRequired,
  type: __webpack_require__(0).oneOf(['do', 'dont']).isRequired
};

/***/ }),
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MarkdownTable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tableCellTransforms__ = __webpack_require__(1485);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





function MarkdownTable(_ref) {
  var children = _ref.children;

  // we're going to assume there's a table header here
  var _children = _slicedToArray(children, 2),
      head = _children[0],
      body = _children[1];

  // a bunch of the elements returned by marksy are null,
  // so there's a lot of filtering and finding with the identity


  var headNode = head.find(function (element) {
    return element;
  });
  var headRow = headNode && headNode.props.children.find(function (row) {
    return row;
  });
  var headCells = headRow && headRow.props.children.filter(function (cell) {
    return cell;
  }).map(function (cell, index) {
    return _jsx(__WEBPACK_IMPORTED_MODULE_1__Table__["c" /* TableHeaderCell */], {}, index, cell.props.children);
  });
  var bodyNode = body.find(function (element) {
    return element;
  });
  var bodyRows = bodyNode && bodyNode.props.children.filter(function (row) {
    return row;
  }).map(function (row) {
    var rowCells = row.props.children.filter(function (cell) {
      return cell;
    }).map(function (cell) {
      var cellReactChildren = cell.props.children;

      if (cellReactChildren == null) {
        return _jsx(__WEBPACK_IMPORTED_MODULE_1__Table__["b" /* TableCell */], {}, cell.key);
      }

      var transforms = [__WEBPACK_IMPORTED_MODULE_2__tableCellTransforms__["a" /* isAvailable */], __WEBPACK_IMPORTED_MODULE_2__tableCellTransforms__["b" /* isExperimental */], __WEBPACK_IMPORTED_MODULE_2__tableCellTransforms__["c" /* isInDevelopment */], __WEBPACK_IMPORTED_MODULE_2__tableCellTransforms__["d" /* isNew */], __WEBPACK_IMPORTED_MODULE_2__tableCellTransforms__["e" /* isPlanned */]];

      var enhancedChildren = cellReactChildren.filter(function (child) {
        return child;
      })
      // all the transforms return a (possibly modified) node,
      // which is passed to the next transform
      .map(function (child) {
        return transforms.reduce(function (node, transform) {
          return transform(node);
        }, child);
      });

      return _jsx(__WEBPACK_IMPORTED_MODULE_1__Table__["b" /* TableCell */], {}, cell.key, enhancedChildren);
    });

    // Sometimes marksy returns null if the cell actually contains empty string.
    // Pad out the length of the rowCells array so there are at least as many
    // columns as defined in the header
    while (headCells && rowCells.length < headCells.length) {
      rowCells.push(_jsx(__WEBPACK_IMPORTED_MODULE_1__Table__["b" /* TableCell */], {}, 'emptyCell_' + rowCells.length));
    }

    return _jsx(__WEBPACK_IMPORTED_MODULE_1__Table__["d" /* TableRow */], {}, row.key, rowCells);
  });

  return _jsx(__WEBPACK_IMPORTED_MODULE_1__Table__["a" /* Table */], {}, void 0, _jsx('thead', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Table__["d" /* TableRow */], {}, void 0, headCells)), _jsx('tbody', {}, void 0, bodyRows));
}
MarkdownTable.propTypes = {
  children: __webpack_require__(0).arrayOf(__webpack_require__(0).any).isRequired
};

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isNew; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isExperimental; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isInDevelopment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isPlanned; });
/* unused harmony export isDeprecated */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon_IconCheck__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon_IconAssignment__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconSlowMotionVideo__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon_IconWarning__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Label__ = __webpack_require__(1486);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */










// a tilde surrounded by some spaces and "new"
var REGEX_LABEL_NEW = /^\s+?~\s+?(new)/;
// a tilde surrounded by some spaces and "experimental"
var REGEX_LABEL_EXPERIMENTAL = /^\s+?~\s+?(experimental)/;

var styles = {
  label: function label(_ref) {
    var theme = _ref.theme;
    return { marginLeft: theme.space_inline_md };
  },
  icon: {
    '& svg': {
      verticalAlign: 'text-top'
    },
    '& span': {
      border: 0,
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      width: 1
    }
  }
};

var Label = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_7__Label__["a" /* default */], styles.label);
var Available = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('span', styles.icon);
var InDevelopment = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('span', styles.icon);
var Planned = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('span', styles.icon);
var Deprecated = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('span', styles.icon);

var isNew = function isNew(child, index) {
  if (typeof child !== 'string' || !child.match(REGEX_LABEL_NEW)) {
    return child;
  }

  return _jsx(Label, {
    variant: 'success'
  }, 'label-' + index, child.replace(REGEX_LABEL_NEW, '$1'));
};

var isExperimental = function isExperimental(child, index) {
  if (typeof child !== 'string' || !child.match(REGEX_LABEL_EXPERIMENTAL)) {
    return child;
  }

  return _jsx(Label, {
    variant: 'warning'
  }, 'label-' + index, child.replace(REGEX_LABEL_EXPERIMENTAL, '$1'));
};

var _ref2 = _jsx('span', {}, void 0, 'available');

var isAvailable = function isAvailable(child, index) {
  if (typeof child !== 'string' || !child.includes('[available]')) {
    return child;
  }

  return _jsx(Available, {}, 'icon-' + index, _jsx(__WEBPACK_IMPORTED_MODULE_3__Icon_IconCheck__["a" /* default */], {
    color: __WEBPACK_IMPORTED_MODULE_2__themes__["c" /* color */].green_60,
    size: 'large',
    title: 'available'
  }), _ref2);
};

var _ref3 = _jsx('span', {}, void 0, 'in development');

var isInDevelopment = function isInDevelopment(child, index) {
  if (typeof child !== 'string' || !child.includes('[in development]')) {
    return child;
  }

  return _jsx(InDevelopment, {}, 'icon-' + index, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_IconSlowMotionVideo__["a" /* default */], {
    color: __WEBPACK_IMPORTED_MODULE_2__themes__["c" /* color */].yellow_60,
    size: 'large',
    title: 'in development'
  }), _ref3);
};

var _ref4 = _jsx('span', {}, void 0, 'planned');

var isPlanned = function isPlanned(child, index) {
  if (typeof child !== 'string' || !child.includes('[planned]')) {
    return child;
  }

  return _jsx(Planned, {}, 'icon-' + index, _jsx(__WEBPACK_IMPORTED_MODULE_4__Icon_IconAssignment__["a" /* default */], {
    size: 'large',
    color: __WEBPACK_IMPORTED_MODULE_2__themes__["c" /* color */].blue_60,
    title: 'in review'
  }), _ref4);
};

var _ref5 = _jsx('span', {}, void 0, 'deprecated');

var isDeprecated = function isDeprecated(child, index) {
  if (typeof child !== 'string' || !child.includes('[deprecated]')) {
    return child;
  }

  return _jsx(Deprecated, {}, 'icon-' + index, _jsx(__WEBPACK_IMPORTED_MODULE_6__Icon_IconWarning__["a" /* default */], {
    color: __WEBPACK_IMPORTED_MODULE_2__themes__["c" /* color */].red_60,
    size: 'large',
    title: 'deprecated'
  }), _ref5);
};

/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Label;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('span', function (_ref) {
  var theme = _ref.theme,
      variant = _ref.variant;

  var backgroundColor = variant === 'regular' ? theme.color_gray_50 : theme['backgroundColor_' + variant];

  var color = variant === 'regular' ? theme.color_text : theme['color_text_on' + variant];

  return {
    backgroundColor: backgroundColor,
    borderRadius: theme.borderRadius_1,
    color: color,
    fontSize: theme.fontSize_mouse,
    lineHeight: theme.lineHeight_prose,
    padding: parseFloat(theme.space_inset_sm) / 2 + 'em\n      ' + theme.space_inset_sm,
    textTransform: 'uppercase',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
  };
});

function Label(_ref2) {
  var children = _ref2.children,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === undefined ? 'regular' : _ref2$variant,
      restProps = _objectWithoutProperties(_ref2, ['children', 'variant']);

  var rootProps = _extends({ variant: variant }, restProps);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    children
  );
}

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs_components_prism_core__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs_components_prism_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs_components_prism_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismjs_components_prism_bash__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismjs_components_prism_bash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prismjs_components_prism_bash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prismjs_components_prism_clike__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prismjs_components_prism_clike___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prismjs_components_prism_clike__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prismjs_components_prism_javascript__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prismjs_components_prism_javascript___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prismjs_components_prism_javascript__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prismjs_components_prism_markup__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prismjs_components_prism_markup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prismjs_components_prism_markup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prismjs_components_prism_jsx__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prismjs_components_prism_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prismjs_components_prism_jsx__);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






// Prism errors out if this is imported before prism-markup ???


var prism = function prism(code) {
  var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'jsx';
  return Object(__WEBPACK_IMPORTED_MODULE_0_prismjs_components_prism_core__["highlight"])(code, __WEBPACK_IMPORTED_MODULE_0_prismjs_components_prism_core__["languages"][language]);
};

/* harmony default export */ __webpack_exports__["a"] = (prism);

/***/ }),
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DocExamples;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ComponentDocExample__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Section__ = __webpack_require__(98);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





function DocExamples(_ref) {
  var examples = _ref.examples;

  if (true) {
    examples = examples.filter(function (example) {
      return !example.hideFromProd;
    });
  }
  return _jsx(__WEBPACK_IMPORTED_MODULE_2__Section__["a" /* default */], {}, void 0, examples.map(function (example, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ComponentDocExample__["a" /* default */], _extends({ key: index }, example));
  }));
}
DocExamples.propTypes = {
  examples: __webpack_require__(0).arrayOf(__webpack_require__(0).shape({
    backgroundColor: __webpack_require__(0).string,
    description: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node) : __webpack_require__(0).any,
    hideFromProd: __webpack_require__(0).bool,
    hideSource: __webpack_require__(0).bool,
    id: __webpack_require__(0).string.isRequired,
    propValues: __webpack_require__(0).object,
    scope: __webpack_require__(0).object.isRequired,
    source: __webpack_require__(0).string.isRequired,
    title: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node).isRequired : __webpack_require__(0).any.isRequired
  })).isRequired
};

/***/ }),
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DocHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Heading__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Markdown__ = __webpack_require__(36);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







var styles = {
  header: function header(_ref) {
    var theme = _ref.theme;
    return {
      marginBottom: theme.space_stack_xl,
      paddingTop: theme.space_stack_md
    };
  },
  lede: function lede(_ref2) {
    var theme = _ref2.theme;
    return {
      fontSize: theme.fontSize_h3,
      lineHeight: theme.lineHeight_prose,
      margin: '0',
      '& p': {
        marginBottom: theme.space_stack_md
      }
    };
  },
  navElement: function navElement(_ref3) {
    var theme = _ref3.theme;
    return {
      display: 'inline-block',
      marginRight: theme.space_inline_lg,
      marginBottom: theme.space_stack_sm,
      borderBottom: '3px solid transparent',
      cursor: 'pointer'
    };
  },
  subnav: function subnav(_ref4) {
    var theme = _ref4.theme;
    return {
      borderBottom: '1px solid ' + theme.borderColor,
      marginTop: theme.space_stack_md,
      marginBottom: 0
    };
  },
  title: function title(_ref5) {
    var theme = _ref5.theme;
    return {
      marginRight: 'auto',
      paddingRight: theme.space_inline_sm
    };
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('header', styles.header);
var Lede = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_4__Markdown__["a" /* default */], styles.lede);
var NavElement = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], styles.navElement);
var SubNav = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('nav', styles.subnav);
var Title = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_2__Heading__["a" /* default */], styles.title);

var _ref7 = _jsx(NavElement, {
  href: '#api-and-theme'
}, 'api-and-theme', 'API & Theme');

var _ref8 = _jsx(NavElement, {
  href: '#usage'
}, 'usage', 'Usage');

function DocHeader(_ref6) {
  var bestPractices = _ref6.bestPractices,
      children = _ref6.children,
      className = _ref6.className,
      examples = _ref6.examples,
      props = _ref6.props,
      title = _ref6.title,
      whenHowToUse = _ref6.whenHowToUse;

  // there is no Examples h2, so we just link to the first example.
  var firstExampleId = 'examples';
  if (examples && examples.length > 0) {
    firstExampleId = examples[0].id;
  }

  var navElements = []; // only show the tabs menu if there is more than one tab
  if (examples && examples.length > 0) {
    navElements.push(_jsx(NavElement, {
      href: '#' + firstExampleId
    }, 'examples', 'Examples'));
  }

  if (props) {
    navElements.push(_ref7);
  }

  if (whenHowToUse || bestPractices) {
    navElements.push(_ref8);
  }

  return _jsx(Root, {
    className: className
  }, void 0, _jsx(Title, {
    level: 1
  }, void 0, title), _jsx(Lede, {}, void 0, children), navElements.length > 1 && _jsx(SubNav, {}, void 0, navElements));
}
DocHeader.propTypes = {
  bestPractices: __webpack_require__(0).arrayOf(__webpack_require__(0).object),
  children: __webpack_require__(0).string,
  className: __webpack_require__(0).string,
  examples: __webpack_require__(0).arrayOf(__webpack_require__(0).any),
  props: __webpack_require__(0).bool,
  title: __webpack_require__(0).string.isRequired,
  whenHowToUse: __webpack_require__(0).string
};

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DocProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Heading__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTable__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Section__ = __webpack_require__(98);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








// prettier-ignore
var styles = {
  propsComment: {
    fontStyle: 'italic'
  },
  title: function title(_ref) {
    var theme = _ref.theme;
    return {
      margin: parseFloat(theme.space_stack_sm) * 8 + 'em 0 ' + theme.space_stack_xl
    };
  }
};

var PropsComment = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('p', styles.propsComment);
var Title = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_3__Heading__["a" /* default */], styles.title);

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_3__Heading__["a" /* default */], {
  level: 2,
  id: 'api-and-theme'
}, void 0, 'API & Theme');

var _ref4 = _jsx(PropsComment, {}, void 0, 'Undocumented properties will be applied to the root element.');

function DocProps(_ref2) {
  var propDoc = _ref2.propDoc,
      title = _ref2.title;

  return _jsx(__WEBPACK_IMPORTED_MODULE_5__Section__["a" /* default */], {}, void 0, _ref3, _jsx(Title, {
    level: 3,
    id: 'props'
  }, void 0, title + ' Props'), propDoc ? _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__PropTable__["a" /* default */], {
    propDoc: propDoc
  }), _ref4) : _jsx(__WEBPACK_IMPORTED_MODULE_2__Callout__["a" /* default */], {
    title: 'Note'
  }, void 0, title + ' does not have properties of its own. Undocumented properties will be applied to the root element.'));
}
DocProps.propTypes = {
  propDoc: __webpack_require__(0).object,
  title: __webpack_require__(0).string.isRequired
};

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PropTable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_IconInfo__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Popover__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Markdown__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table__ = __webpack_require__(118);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









var styles = {
  codeValue: function codeValue(_ref) {
    var theme = _ref.theme;
    return {
      fontFamily: theme.fontFamily_monospace
    };
  },
  propName: function propName(_ref2) {
    var theme = _ref2.theme;
    return {
      fontWeight: theme.fontWeight_semiBold
    };
  },
  propP: {
    '& p': {
      margin: 0
    }
  },
  propRequired: function propRequired(_ref3) {
    var theme = _ref3.theme;
    return {
      backgroundColor: theme.backgroundColor_danger,
      borderRadius: theme.borderRadius_1,
      color: theme.color_white,
      display: 'inline-block',
      fontFamily: theme.fontFamily_monospace,
      padding: parseFloat(theme.space_inset_sm) / 2 + 'em ' + theme.space_inset_sm
    };
  },
  propType: function propType(_ref4) {
    var theme = _ref4.theme;
    return {
      color: theme.color_theme_90,
      fontFamily: theme.fontFamily_monospace
    };
  },
  propTypeButton: function propTypeButton(_ref5) {
    var theme = _ref5.theme;
    return {
      fontFamily: 'inherit',
      height: 'auto',
      padding: 0,

      '& > span > span': {
        lineHeight: theme.lineHeight,
        paddingLeft: theme.direction === 'ltr' ? 0 : null,
        paddingRight: theme.direction === 'rtl' ? 0 : null
      }
    };
  },
  propTypePopoverContent: function propTypePopoverContent(_ref6) {
    var theme = _ref6.theme;
    return {
      fontFamily: theme.fontFamily_monospace,
      fontSize: theme.fontSize_ui,
      maxWidth: '80vw',
      overflowX: 'auto',
      whiteSpace: 'pre'
    };
  },
  propValue: function propValue(_ref7) {
    var theme = _ref7.theme;
    return {
      border: '1px solid ' + theme.borderColor,
      height: '100%',
      resize: 'vertical',
      width: '100%'
    };
  },
  root: function root(_ref8) {
    var theme = _ref8.theme;
    return {
      margin: theme.space_stack_xl + ' 0 0',
      overflowX: 'auto'
    };
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', styles.root);
var CodeValue = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('span', styles.codeValue);
var PropName = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('span', styles.propName);
var PropP = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_5__Markdown__["a" /* default */], styles.propP);
var PropRequired = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('span', styles.propRequired);
var PropType = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('span', styles.propType);
var PropTypeButton = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_3__Button__["a" /* default */], styles.propTypeButton);
var PropTypePopoverContent = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', styles.propTypePopoverContent);

var _ref10 = _jsx(PropRequired, {}, void 0, 'required');

function DefaultValue(_ref9) {
  var defaultValue = _ref9.defaultValue,
      required = _ref9.required;

  return required ? _ref10 : _jsx(CodeValue, {}, void 0, defaultValue);
}

DefaultValue.propTypes = {
  defaultValue: __webpack_require__(0).any,
  required: __webpack_require__(0).bool
};
function getDefaultValue(propDescription) {
  var _propDescription$defa = propDescription.defaultValue;
  _propDescription$defa = _propDescription$defa === undefined ? {} : _propDescription$defa;
  var value = _propDescription$defa.value;

  return value;
}

var _ref11 = _jsx(__WEBPACK_IMPORTED_MODULE_2__Icon_IconInfo__["a" /* default */], {});

function getFlowType(propDescription) {
  var flowType = propDescription.flowType;
  var name = flowType.name,
      raw = flowType.raw,
      type = flowType.type;

  var usePopover = raw && raw.length > 25;

  if (name === 'Array') {
    type = 'Array';
  } else if (name === 'signature' && type === 'function') {
    type = 'Function';
  } else if (name === 'signature' && type === 'object') {
    type = 'Object';
  } else if (name === 'union') {
    type = 'Union';
    usePopover = flowType.elements.length > 4 || raw.startsWith('|');
    raw = raw.startsWith('|') ? raw.split('\n| ').join(',\n').replace('| ', '') : raw.split(' | ').join(',\n');
  } else if (name === 'undefined') {
    return 'unknown';
  } else {
    raw = name;
  }

  return usePopover ? _jsx(__WEBPACK_IMPORTED_MODULE_4__Popover__["a" /* default */], {
    content: _jsx(PropTypePopoverContent, {}, void 0, raw)
  }, void 0, _jsx(PropTypeButton, {
    iconEnd: _ref11,
    minimal: true,
    size: 'medium'
  }, void 0, type)) : raw;
}

function getPropTableRows(propDoc) {
  return Object.keys(propDoc).sort().map(function (name) {
    var propDescription = propDoc[name];

    // Filter out private props
    if (propDescription.description.startsWith('@Private')) {
      return null;
    }

    return _jsx(PropTableRow, {
      defaultValue: getDefaultValue(propDescription),
      description: propDescription.description,
      name: name,
      required: propDescription.required,
      type: getFlowType(propDescription)
    }, name);
  });
}

function PropTableRow(_ref12) {
  var defaultValue = _ref12.defaultValue,
      description = _ref12.description,
      name = _ref12.name,
      required = _ref12.required,
      type = _ref12.type;

  return _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["d" /* TableRow */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["b" /* TableCell */], {}, void 0, _jsx(PropName, {}, void 0, name)), _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["b" /* TableCell */], {}, void 0, _jsx(PropType, {}, void 0, type)), _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["b" /* TableCell */], {}, void 0, _jsx(DefaultValue, {
    defaultValue: defaultValue,
    required: required
  })), _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["b" /* TableCell */], {}, void 0, _jsx(PropP, {}, void 0, description)));
}

PropTableRow.propTypes = {
  defaultValue: __webpack_require__(0).any,
  description: __webpack_require__(0).string,
  name: __webpack_require__(0).string.isRequired,
  type: __webpack_require__(0).any.isRequired,
  required: __webpack_require__(0).bool
};

var _ref14 = _jsx('thead', {}, void 0, _jsx('tr', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["c" /* TableHeaderCell */], {
  width: 10
}, 'prop', 'Name'), _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["c" /* TableHeaderCell */], {
  width: 15
}, 'type', 'Type'), _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["c" /* TableHeaderCell */], {
  width: 10
}, 'default', 'Default'), _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["c" /* TableHeaderCell */], {}, 'description', 'Description')));

function PropTable(_ref13) {
  var _ref13$propDoc = _ref13.propDoc,
      propDoc = _ref13$propDoc === undefined ? {} : _ref13$propDoc;

  return _jsx(Root, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["a" /* Table */], {}, void 0, _ref14, _jsx('tbody', {}, void 0, getPropTableRows(propDoc))));
}
PropTable.propTypes = {
  propDoc: __webpack_require__(0).object.isRequired
};

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_popper__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_popper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EventListener__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PopoverTrigger__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PopoverContent__ = __webpack_require__(123);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









var Root = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_2_react_popper__["Manager"], {
  display: 'inline-block'
}, {
  displayName: 'Popover',
  rootEl: 'div'
});

/**
 * Popovers hold supporting information or user controls.
 * Popovers will float over page content.
 * Placement, scroll behavior and focus management can all be controlled to customize your implementation.
 * Popovers can be toggled on a user action or a state change.
 */

var Popover = function (_Component) {
  _inherits(Popover, _Component);

  function Popover() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popover);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popover.__proto__ || Object.getPrototypeOf(Popover)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: Boolean(_this.props.defaultIsOpen)
    }, _this.id = 'popover-' + Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* generateId */])(), _this.close = function (event) {
      if (_this.isControlled()) {
        _this.closeActions(event);
      } else {
        _this.setState(function () {
          return { isOpen: false };
        }, function () {
          _this.closeActions(event);
        });
      }
    }, _this.closeActions = function (event) {
      _this.props.onClose && _this.props.onClose(event);

      var _ref2 = _this.isControlled() ? _this.props : _this.state,
          isOpen = _ref2.isOpen;

      !isOpen && _this.focusTrigger();
    }, _this.focusTrigger = function () {
      var node = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this.popoverTrigger); // eslint-disable-line react/no-find-dom-node
      if (node && node.firstChild && node.firstChild instanceof HTMLElement) {
        node.firstChild.focus();
      }
    }, _this.handleDocumentClick = function (event) {
      if (_this.isClickOutsideComponent(event)) {
        _this.close(event);
      }
    }, _this.handleDocumentKeydown = function (event) {
      if (event.key === 'Escape') {
        _this.close(event);
      }
    }, _this.isClickOutsideComponent = function (event) {
      var node = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this); // eslint-disable-line react/no-find-dom-node
      return node && node instanceof HTMLElement && event.target && event.target instanceof HTMLElement && !node.contains(event.target);
    }, _this.isControlled = function () {
      return _this.props.isOpen !== undefined;
    }, _this.open = function (event) {
      if (_this.isControlled()) {
        _this.openActions(event);
      } else {
        _this.setState(function () {
          return { isOpen: true };
        }, function () {
          _this.openActions(event);
        });
      }
    }, _this.openActions = function (event) {
      _this.focusTrigger();
      _this.props.onOpen && _this.props.onOpen(event);
    }, _this.toggleOpenState = function (event) {
      var _ref3 = _this.isControlled() ? _this.props : _this.state,
          isOpen = _ref3.isOpen;

      if (isOpen) {
        _this.close(event);
      } else {
        _this.open(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popover, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          content = _props.content,
          disabled = _props.disabled,
          getTriggerProps = _props.getTriggerProps,
          hasArrow = _props.hasArrow,
          modifiers = _props.modifiers,
          placement = _props.placement,
          subtitle = _props.subtitle,
          title = _props.title,
          triggerRef = _props.triggerRef,
          wrapContent = _props.wrapContent,
          restProps = _objectWithoutProperties(_props, ['children', 'content', 'disabled', 'getTriggerProps', 'hasArrow', 'modifiers', 'placement', 'subtitle', 'title', 'triggerRef', 'wrapContent']);

      var _ref4 = this.isControlled() ? this.props : this.state,
          isOpen = _ref4.isOpen;

      var rootProps = _extends({}, restProps);
      var contentId = this.id + '-popoverContent';

      var popoverTriggerProps = {
        contentId: contentId,
        children: children,
        disabled: disabled,
        isOpen: isOpen,
        onClick: !disabled ? this.toggleOpenState : undefined,
        ref: function ref(node) {
          _this2.popoverTrigger = node;
          triggerRef && triggerRef(node);
        }
      };

      popoverTriggerProps = _extends({}, popoverTriggerProps, getTriggerProps && getTriggerProps(popoverTriggerProps));

      var popoverContent = void 0;
      if (isOpen) {
        if (wrapContent) {
          var popoverContentProps = {
            hasArrow: hasArrow,
            id: contentId,
            modifiers: modifiers,
            placement: placement,
            subtitle: subtitle,
            title: title
          };

          popoverContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__PopoverContent__["b" /* default */],
            popoverContentProps,
            content
          );
        } else {
          popoverContent = content;
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Root,
        rootProps,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PopoverTrigger__["a" /* default */], popoverTriggerProps),
        isOpen && popoverContent,
        isOpen && _jsx(__WEBPACK_IMPORTED_MODULE_4__EventListener__["a" /* default */], {
          listeners: [{
            target: 'document',
            event: 'click',
            handler: this.handleDocumentClick,
            options: true
          }, {
            target: 'document',
            event: 'keydown',
            handler: this.handleDocumentKeydown,
            options: true
          }]
        })
      );
    }
  }]);

  return Popover;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Popover.propTypes = {
  children: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node).isRequired : __webpack_require__(0).any.isRequired,
  content: typeof $FlowFixMe === 'function' ? __webpack_require__(0).instanceOf($FlowFixMe).isRequired : __webpack_require__(0).any.isRequired,
  disabled: __webpack_require__(0).bool,
  hasArrow: __webpack_require__(0).bool,
  isOpen: __webpack_require__(0).bool,
  modifiers: __webpack_require__(0).object,
  onClose: __webpack_require__(0).func,
  onOpen: __webpack_require__(0).func,
  defaultIsOpen: __webpack_require__(0).bool,
  getTriggerProps: __webpack_require__(0).func,
  placement: __webpack_require__(0).oneOf(['auto', 'auto-end', 'auto-start', 'bottom', 'bottom-end', 'bottom-start', 'left', 'left-end', 'left-start', 'right', 'right-end', 'right-start', 'top', 'top-end', 'top-start']),
  subtitle: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node) : __webpack_require__(0).any,
  title: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node) : __webpack_require__(0).any,
  triggerRef: __webpack_require__(0).func,
  wrapContent: __webpack_require__(0).bool
};
Popover.defaultProps = {
  hasArrow: true,
  placement: 'bottom',
  wrapContent: true
};
/* harmony default export */ __webpack_exports__["a"] = (Popover);

/***/ }),
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventListener__ = __webpack_require__(1511);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EventListener__["a"]; });
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_exenv__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_exenv__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




/** Declarative event listener component */
var EventListener = function (_Component) {
  _inherits(EventListener, _Component);

  function EventListener() {
    _classCallCheck(this, EventListener);

    return _possibleConstructorReturn(this, (EventListener.__proto__ || Object.getPrototypeOf(EventListener)).apply(this, arguments));
  }

  _createClass(EventListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addEventListeners();
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      this.removeEventListeners();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.addEventListeners();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }, {
    key: 'getTargetNode',
    value: function getTargetNode(target) {
      if (__WEBPACK_IMPORTED_MODULE_1_exenv__["canUseDOM"]) {
        return global[target] || global.document.querySelector(target);
      }
    }
  }, {
    key: 'addEventListeners',
    value: function addEventListeners() {
      var _this2 = this;

      if (__WEBPACK_IMPORTED_MODULE_1_exenv__["canUseEventListeners"]) {
        this.props.listeners.forEach(function (_ref) {
          var target = _ref.target,
              event = _ref.event,
              handler = _ref.handler,
              options = _ref.options;

          var node = _this2.getTargetNode(target);
          node && node.addEventListener(event, handler, options);
        });
      }
    }
  }, {
    key: 'removeEventListeners',
    value: function removeEventListeners() {
      var _this3 = this;

      if (__WEBPACK_IMPORTED_MODULE_1_exenv__["canUseEventListeners"]) {
        this.props.listeners.forEach(function (_ref2) {
          var target = _ref2.target,
              event = _ref2.event,
              handler = _ref2.handler,
              options = _ref2.options;

          var node = _this3.getTargetNode(target);
          node && node.removeEventListener(event, handler, options);
        });
      }
    }
  }]);

  return EventListener;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

EventListener.propTypes = {
  listeners: __webpack_require__(0).arrayOf(__webpack_require__(0).shape({
    target: __webpack_require__(0).string.isRequired,
    event: __webpack_require__(0).string.isRequired,
    handler: __webpack_require__(0).func.isRequired,
    options: __webpack_require__(0).oneOfType([__webpack_require__(0).bool, __webpack_require__(0).object])
  })).isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (EventListener);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(35)))

/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardImage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card__ = __webpack_require__(100);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('img', function (props) {
  var theme = Object(__WEBPACK_IMPORTED_MODULE_2__Card__["a" /* componentTheme */])(props.theme);

  return {
    display: 'block',
    marginBottom: theme.CardRow_margin,
    marginTop: theme.CardRow_margin,
    maxWidth: '100%',

    '&:first-child': {
      borderRadius: theme.Card_borderRadius + ' ' + theme.Card_borderRadius + ' 0 0',
      marginTop: 0
    },

    '&:last-child': {
      borderRadius: '0 0 ' + theme.Card_borderRadius + ' ' + theme.Card_borderRadius,
      marginBottom: '-' + theme.Card_paddingBottom
    }
  };
}, {
  displayName: 'CardImage',
  rootEl: 'img'
});

/**
 * CardImage renders images full-bleed inside of a [Card](../card).
 * Use CardImage to display static media.
 */
function CardImage(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Root, props);
}

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DocThemeVariables;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Heading__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Markdown__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Section__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VariableTable__ = __webpack_require__(278);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








var Title = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_2__Heading__["a" /* default */], function (_ref) {
  var theme = _ref.theme;
  return {
    margin: parseFloat(theme.space_stack_sm) * 8 + 'em 0 ' + theme.space_stack_xl
  };
});

var createKeyMirror = function createKeyMirror(obj) {
  var mirror = {};
  Object.keys(obj).forEach(function (key) {
    mirror[key] = '' + key;
  });
  return mirror;
};

var REGEX_IS_COLOR = /color|fill/i;

var getColor = function getColor(theme, variable, baseTheme) {
  return REGEX_IS_COLOR.test(variable) && baseTheme && baseTheme[theme[variable]];
};

var getValue = function getValue(theme, variable, baseTheme) {
  var baseThemeKeys = baseTheme && createKeyMirror(baseTheme);
  if (baseThemeKeys && baseThemeKeys[theme[variable]]) {
    return 'theme.' + theme[variable];
  } else if (typeof theme[variable] === 'number' && !RegExp(/lineHeight/i).test(variable)) {
    return theme[variable] + 'px';
  } else {
    return theme[variable];
  }
};

function DocThemeVariables(_ref2) {
  var baseTheme = _ref2.baseTheme,
      componentTheme = _ref2.componentTheme,
      title = _ref2.title;

  var baseThemeKeys = createKeyMirror(baseTheme);

  var theme = void 0;
  if (Array.isArray(componentTheme)) {
    theme = componentTheme.reduce(function (acc, themeFn) {
      return _extends({}, acc, themeFn(baseThemeKeys));
    }, {});
  } else {
    theme = componentTheme(baseThemeKeys);
  }

  return _jsx(__WEBPACK_IMPORTED_MODULE_4__Section__["a" /* default */], {}, void 0, _jsx(Title, {
    level: 3,
    id: 'theme-variables'
  }, void 0, title + ' Theme Variables'), _jsx(__WEBPACK_IMPORTED_MODULE_3__Markdown__["a" /* default */], {}, void 0, 'These variables can be used as hooks to override this component\u2019s\n          style at either a [global](/components/theme-provider) or\n          [local](/components/utils#create-themed-component) level. The\n          `theme` referenced below is whatever theme is available from props\n          to the instance of this component.'), _jsx(__WEBPACK_IMPORTED_MODULE_5__VariableTable__["a" /* default */], {
    baseTheme: baseTheme,
    theme: theme,
    value: getValue,
    valueColor: getColor
  }));
}
DocThemeVariables.propTypes = {
  baseTheme: __webpack_require__(0).object.isRequired,
  componentTheme: __webpack_require__(0).oneOfType([typeof Theme === 'function' ? __webpack_require__(0).instanceOf(Theme) : __webpack_require__(0).any, __webpack_require__(0).arrayOf(typeof Theme === 'function' ? __webpack_require__(0).instanceOf(Theme) : __webpack_require__(0).any)]).isRequired,
  title: __webpack_require__(0).string.isRequired
};

/***/ }),
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DocWhenHowToUse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Heading__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Markdown__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Section__ = __webpack_require__(98);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







var Title = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_2__Heading__["a" /* default */], function (_ref) {
  var theme = _ref.theme;
  return {
    margin: parseFloat(theme.space_stack_sm) * 8 + 'em 0 ' + theme.space_stack_xl
  };
});

var _ref3 = _jsx(Title, {
  level: 3,
  id: 'when-how-to-use'
}, void 0, 'When/How to Use');

function DocWhenHowToUse(_ref2) {
  var content = _ref2.content;

  return _jsx(__WEBPACK_IMPORTED_MODULE_4__Section__["a" /* default */], {}, void 0, _ref3, _jsx(__WEBPACK_IMPORTED_MODULE_3__Markdown__["a" /* default */], {}, void 0, content));
}
DocWhenHowToUse.propTypes = {
  content: __webpack_require__(0).string.isRequired
};

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Footer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(52);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', function (_ref) {
  var theme = _ref.theme;
  return {
    borderTop: '2px solid ' + theme.borderColor,
    color: theme.color_caption,
    fontSize: theme.fontSize_mouse,
    marginTop: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getNormalizedValue */])(parseFloat(theme.space_stack_sm) * 8 + 'em', theme.fontSize_mouse),
    paddingTop: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getNormalizedValue */])(parseFloat(theme.space_stack_sm) * 4 + 'em', theme.fontSize_mouse),

    '@media(min-width: 32em)': {
      display: 'flex',

      '& > :last-child': {
        marginLeft: 'auto'
      }
    }
  };
});

var _ref2 = _jsx('div', {}, void 0, 'Copyright \xA9 2017 CA');

var _ref3 = _jsx('div', {}, void 0, 'We welcome feedback and contributions on ', ' ', _jsx(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], {
  href: 'https://github.com/mineral-ui/mineral-ui'
}, void 0, 'GitHub'));

function Footer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    props,
    _ref2,
    _ref3
  );
}
Footer.propTypes = {};

/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Nav;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages__ = __webpack_require__(280);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var styles = {
  heading: function heading(_ref) {
    var theme = _ref.theme;
    return {
      margin: '0',
      fontSize: theme.fontSize_h4
    };
  },
  logo: function logo(_ref2) {
    var theme = _ref2.theme;
    return {
      alignItems: 'center',
      borderBottom: '1px solid ' + theme.borderColor,
      display: 'flex',
      height: 50,
      margin: '0 0 ' + theme.space_stack_md,
      paddingBottom: theme.space_stack_md,
      textDecoration: 'none',

      '&:hover,&:focus': {
        textDecoration: 'none'
      },

      '& > :first-child': {
        display: 'block',
        marginRight: 10,
        borderRadius: 20,
        width: 40,
        height: 40,
        backgroundColor: theme.color_white,
        color: 'orange',
        textAlign: 'center',
        fontSize: '2em'
      },
      '& > :last-child': {
        fontSize: theme.fontSize_h4,
        fontWeight: theme.fontWeight_bold
      }
    };
  },
  list: {
    listStyle: 'none',
    paddingLeft: '0'
  },
  listItem: function listItem(_ref3) {
    var isSubcomponent = _ref3.isSubcomponent,
        theme = _ref3.theme;
    return {
      paddingLeft: isSubcomponent && theme.space_inline_sm,

      '& + li': {
        marginTop: theme.space_stack_sm
      }
    };
  },
  nav: function nav(_ref4) {
    var theme = _ref4.theme;
    return {
      padding: theme.space_inset_md,
      backgroundColor: theme.slate_10
    };
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('nav', styles.nav);
var Heading = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('h2', styles.heading);
var List = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('ol', styles.list);
var ListItem = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('li', styles.listItem);
var Logo = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], styles.logo);

var _ref6 = _jsx(Logo, {
  to: '/'
}, void 0, _jsx('span', {}, void 0, 'M'), _jsx('h1', {}, void 0, 'Mineral UI'));

var _ref7 = _jsx(Heading, {}, void 0, 'Components');

function Nav(_ref5) {
  var demos = _ref5.demos,
      restProps = _objectWithoutProperties(_ref5, ['demos']);

  var rootProps = _extends({}, restProps);

  var demoLinks = Object.keys(demos).map(function (slug) {
    var demo = demos[slug];
    return _jsx(ListItem, {
      isSubcomponent: demo.subcomponent
    }, slug, _jsx(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], {
      to: '/components/' + slug
    }, void 0, demo.title));
  });

  var nav = __WEBPACK_IMPORTED_MODULE_3__pages__["a" /* default */].map(function (section, index) {
    return _jsx('div', {}, index, _jsx(Heading, {}, void 0, section.heading), _jsx(List, {}, void 0, section.pages.map(function (page) {
      return !page.hiddenInNav && _jsx(ListItem, {}, page.title, _jsx(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], {
        to: page.path
      }, void 0, page.title));
    })));
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    _ref6,
    nav,
    _ref7,
    _jsx(List, {}, void 0, demoLinks)
  );
}

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GettingStarted;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Callout__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Markdown__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gettingStarted_md__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gettingStarted_md___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__gettingStarted_md__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GuidelinePage__ = __webpack_require__(101);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







function GettingStarted() {
  return _jsx(__WEBPACK_IMPORTED_MODULE_4__GuidelinePage__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Markdown__["a" /* default */], {
    scope: { Callout: __WEBPACK_IMPORTED_MODULE_1__Callout__["a" /* default */] }
  }, void 0, __WEBPACK_IMPORTED_MODULE_3__gettingStarted_md___default.a));
}

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

module.exports = "# Getting Started\n\nMineral UI helps you quickly build React apps with high-quality, accessible components.\nUse npm or yarn to get components and themes that have been tested across modern browsers.\n\nBelow are a few simple steps to apply consistent styling and hierarchy to your app,\nso you can focus on solving business problems.\nMineral UI is an open source project and welcomes all contributions.\n\n## Installation\n\nInstall the [Mineral UI package](https://www.npmjs.com/package/mineral-ui):\n\n```bash\nnpm install --save mineral-ui\n```\n\nor\n\n```bash\nyarn add mineral-ui\n```\n\nThen install any missing peer dependencies reported by `npm` or `yarn`.\n\n## Usage\n\n```jsx\nimport React from 'react';\nimport { render } from 'react-dom';\nimport Button from 'mineral-ui/Button';\nimport ThemeProvider from 'mineral-ui/ThemeProvider';\n\nfunction App() {\n  return (\n    <ThemeProvider>\n      <Button>\n        Hello World\n      </Button>\n    </ThemeProvider>\n  );\n}\n\nrender(<App />, document.getElementById('app'));\n```\n\n<Callout title=\"Note\">\n  <p key=\"one\">Your app must be wrapped in a <code key=\"two\">ThemeProvider</code> at its root\n  in order for the styles to apply correctly.</p>\n\n  <p key=\"three\">Also, please see our <a key=\"four\" href=\"https://github.com/mineral-ui/mineral-ui/tree/master/docs/import-syntax.md\">import syntax guidelines</a>.</p>\n</Callout>\n\n### Open Sans Font\n\nMineral UI was designed around\n[Open Sans](https://fonts.google.com/specimen/Open+Sans). To get the\ncomponents to look their best, you will need to include this font in your\nproject yourself or our styles will fall back to system fonts. To\nquickly include this font in your app, copy this code into the \\`head\\`\nof your HTML document.\n\n```html\n<link href=\"https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i,800,800i\" rel=\"stylesheet\">\n```\n\nFor more options loading this font from Google, check out the \"Family Selected\"\npopup in the [specimen](https://fonts.google.com/specimen/Open+Sans?selection.family=Open+Sans).\nYou can also download the font file and serve it yourself if you’d like,\nbut we’ll leave that to you.\n\n### Styling\n\nThis project uses [Glamorous](https://github.com/paypal/glamorous) for\nits styling. Please see our\n[documentation](https://github.com/mineral-ui/mineral-ui/blob/master/docs/styling.md)\nfor details.\n\n### Theming\n\nTheming is a core concept in Mineral UI. Refer to the\n[documentation](/guidelines/theming) for details.\n\n## Contributing\n\nWe welcome all contributors who abide by our\n[Code of Conduct](https://github.com/mineral-ui/mineral-ui/blob/master/CODE_OF_CONDUCT.md).\nPlease see the [Contributors Guide](https://github.com/mineral-ui/mineral-ui/blob/master/CONTRIBUTING.md)\nand [Developer Docs](https://github.com/mineral-ui/mineral-ui/blob/master/docs/README.md)\nfor more details on submitting a PR, setting up a local dev environment,\nrunning tests, etc...\n\n## Browser Support\n\nMineral UI supports the latest versions of\n\n- Chrome\n- Firefox\n- Safari\n- Edge\n- Internet Explorer 11\n"

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Theming;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GuidelinePage__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Markdown__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VariableTable__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__theming_md__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__theming_md___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__theming_md__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








var REGEX_IS_COLOR = /color|fill/i;

var getColor = function getColor(theme, variable) {
  return REGEX_IS_COLOR.test(variable) && theme[variable];
};

var getValue = function getValue(theme, variable) {
  return theme[variable];
};

var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_2__GuidelinePage__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3__Markdown__["a" /* default */], {}, void 0, __WEBPACK_IMPORTED_MODULE_5__theming_md___default.a), _jsx(__WEBPACK_IMPORTED_MODULE_4__VariableTable__["a" /* default */], {
  theme: __WEBPACK_IMPORTED_MODULE_1__themes__["g" /* mineralTheme */],
  value: getValue,
  valueColor: getColor
}));

function Theming() {
  return _ref;
}

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

module.exports = "# Theming\n\nTheming is a core concept in Mineral UI.\nThemes provide a consistent look and feel across pages with varied functionality.\nMineral UI makes it simple to implement and maintain theming across your app.\n\nThe theme system is flexible enough to be applied globally or at a component level.\nThis page lists of all Mineral UI theme variables for your reference.\n\n\n## Implementation\n\nConsider the signature of [createStyledComponent](/components/utils#create-styled-component):\n\n```jsx\nconst MyComponent = createStyledComponent('div', props => ({\n  backgroundColor: props.theme.color_primary\n}));\n```\n\nThe [ThemeProvider](/components/theme-provider)(s) in\nyour app provides the theme to other Mineral UI and/or Glamorous\ncomponents within that ThemeProvider. Your app\n[must have a ThemeProvider at its root](/getting-started) and can\noptionally nest additional ThemeProviders to apply a custom theme to sections\nof your app. Nested ThemeProviders shallowly merge their theme\nwith the parent theme.\n\nThe theme itself (see the default mineral theme below for an example) is\na simple shallow object of variables that are shared across components.\n\nEach component can also have a “theme”, which is not a file, but rather\na set of variables available to override default values. E.g., if\nMineral UI’s [Button](/components/button) component looked like this:\n\n```jsx\nconst Button = createStyledComponent('button', props => ({\n  color: props.theme.Button_color || props.theme.color_primary\n}));\n```\n\nThe themes distributed as part of Mineral UI include a value for\n`color_primary` but do not include a value for `Button_color`. In\nour component code, we leave the component-level variable\n`Button_color` as a hook for you to define if you’d like.\nComponent-level theme variables start with the capitalized component\nname to differentiate from the global variables. When you’d like to\noverride the Mineral UI theme at a component level in your app, you can\nuse [createThemedComponent](/components/utils#create-themed-component):\n\n```jsx\nconst MyButton = createThemedComponent(Button, {\n  Button_color: 'tomato'\n});\n```\n\n## Theme Variables\n\nThemes in Mineral UI are made of the following variables. The values\nbelow come from the default mineral theme. Note the naming convention:\n‘property_target_variant_state’.\n\n<!-- Table of theme variables here -->\n"

/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Color;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Markdown__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Callout__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColorRamp__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RampLegend__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Variants__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GuidelinePage__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__color_md__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__color_md___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__color_md__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */











var ramps = ['red', 'magenta', 'purple', 'indigo', 'blue', 'sky', 'teal', 'green', 'lime', 'yellow', 'orange', 'slate', 'dusk', 'gray', 'black'];

var RampHolder = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', {
  display: 'flex',
  flexWrap: 'wrap'
});

var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_5__RampLegend__["a" /* default */], {});

function Color() {
  return _jsx(__WEBPACK_IMPORTED_MODULE_7__GuidelinePage__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Markdown__["a" /* default */], {
    scope: { Callout: __WEBPACK_IMPORTED_MODULE_3__Callout__["a" /* default */], Variants: __WEBPACK_IMPORTED_MODULE_6__Variants__["a" /* default */] }
  }, void 0, __WEBPACK_IMPORTED_MODULE_8__color_md___default.a), _ref, _jsx(RampHolder, {}, void 0, ramps.map(function (ramp) {
    return _jsx(__WEBPACK_IMPORTED_MODULE_4__ColorRamp__["a" /* default */], {
      ramp: ramp
    }, ramp);
  })));
}

/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ColorRamp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColorRampRow__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_range__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_range__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'inline-block',
    marginRight: theme.space_inline_sm,
    marginBottom: theme.space_stack_sm,
    width: '12em',
    padding: 0,
    '@media(max-width: 60em)': {
      width: '100%',
      marginRight: 0
    }
  };
});

function ColorRamp(_ref2) {
  var ramp = _ref2.ramp;

  return _jsx(Root, {}, void 0, ramp === 'black' ? _jsx(__WEBPACK_IMPORTED_MODULE_2__ColorRampRow__["a" /* default */], {
    name: ramp
  }, ramp) : __WEBPACK_IMPORTED_MODULE_3_lodash_range___default()(10, 110, 10).map(function (step) {
    return _jsx(__WEBPACK_IMPORTED_MODULE_2__ColorRampRow__["a" /* default */], {
      name: ramp + '_' + step
    }, step);
  }));
}
ColorRamp.propTypes = {
  ramp: __webpack_require__(0).string.isRequired
};

/***/ }),
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RampLegend;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ColorRampRow__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var getBadges = function getBadges() {
  return [1, 2, 3, 4].map(function (num) {
    var Badge = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('span', function (_ref) {
      var theme = _ref.theme;
      return {
        backgroundColor: theme.color_gray_30,
        borderRadius: theme.size_small,
        fontSize: theme.fontSize_mouse,
        height: theme.size_small,
        lineHeight: theme.fontSize_mouse,
        paddingTop: Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* pxToEm */])(6),
        position: 'absolute',
        textAlign: 'center',
        width: theme.size_small,
        top: num === 1 || num === 2 ? 'calc(50% - 50px)' : undefined,
        right: num === 2 || num === 3 ? 0 : undefined,
        bottom: num === 3 || num === 4 ? 'calc(50% - 50px)' : undefined,
        left: num === 1 || num === 4 ? 0 : undefined,
        '@media(min-width: 60em)': {
          display: 'none'
        }
      };
    });

    return _jsx(Badge, {}, num, num);
  });
};

var legendBackground = 'blue_60';

var styles = {
  root: function root(_ref2) {
    var theme = _ref2.theme;
    return {
      display: 'flex',
      marginBottom: theme.space_stack_xl,
      '@media(max-width: 60em)': {
        flexDirection: 'column',
        marginTop: parseFloat(theme.space_stack_sm) * 6 + 'em'
      }
    };
  },
  black: {
    '&::after': {
      left: 0,
      top: 15
    }
  },
  centerColumn: {
    alignItems: 'center',
    display: 'flex',
    flex: '1 0 auto',
    position: 'relative'
  },
  column: function column(_ref3) {
    var theme = _ref3.theme;
    return {
      display: 'flex',
      flexDirection: 'column',
      width: 'calc(50% - 6em)',
      '& > *': {
        minHeight: 100,
        height: '50%',
        margin: 0,
        fontSize: theme.fontSize_mouse,
        padding: theme.space_inset_md + ' ' + parseFloat(theme.space_inset_md) * 2 + 'em',
        position: 'relative'
      },
      '& > *::after': {
        borderBottom: '1px solid ' + theme.borderColor_danger_hover,
        content: '\'\'',
        position: 'absolute',
        width: theme.space_inline_lg
      },
      '@media(max-width: 60em)': {
        display: 'none'
      }
    };
  },
  hsl: {
    textAlign: 'right',
    '&::after': {
      top: 15,
      right: 0
    }
  },
  mobileList: function mobileList(_ref4) {
    var theme = _ref4.theme;
    return {
      fontSize: theme.fontSize_mouse,
      marginTop: parseFloat(theme.space_stack_sm) * 6 + 'em',
      paddingLeft: theme.space_inline_sm,
      ' li': {
        marginBottom: theme.space_stack_sm
      },
      '@media(min-width: 60em)': {
        display: 'none'
      }
    };
  },
  name: function name(_ref5) {
    var theme = _ref5.theme;
    return {
      textAlign: 'right',
      '&::after': {
        right: 0,
        bottom: 15
      },
      '& > p': {
        position: 'absolute',
        bottom: 0,
        right: theme.space_inline_xl
      }
    };
  },
  white: function white(_ref6) {
    var theme = _ref6.theme;
    return {
      '&::after': {
        bottom: 15,
        left: 0
      },
      '& > p': {
        position: 'absolute',
        bottom: 0,
        left: theme.space_inline_xl
      }
    };
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('div', styles.root);
var Black = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('p', styles.black);
var Column = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('div', styles.column);
var CenterColumn = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('div', styles.centerColumn);
var HSL = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('p', styles.hsl);
var MobileList = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('ol', styles.mobileList);
var Name = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('div', styles.name);
var White = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('div', styles.white);

var _ref7 = _jsx(__WEBPACK_IMPORTED_MODULE_1__ColorRampRow__["a" /* default */], {
  name: legendBackground
});

var _ref8 = _jsx('strong', {}, void 0, '<theme>_<value>');

var _ref9 = _jsx('strong', {}, void 0, 'White Accessibility Rating');

var _ref10 = _jsx('strong', {}, void 0, 'Black Accessibility Rating');

var _ref11 = _jsx('strong', {}, void 0, 'hsl(H, S%, L%)');

function RampLegend() {
  var themeName = 'The name of the hue in the Mineral UI theme.';
  var hslDefinition = 'The CSS Hue, Saturation & Lightness value. Hue is set by the wavelength of light, saturation is how gray the color is, and lightness is the light/dark value.';
  var whiteAccessibilityDefinition = 'The a11y rating of white on top of this color. AA and AAA denote the minimum contrast ratio.';
  var blackAccessibilityDefinition = 'The a11y rating of black on top of this color';

  return _jsx(Root, {}, void 0, _jsx(Column, {}, void 0, _jsx(Name, {}, void 0, _jsx('p', {}, void 0, themeName)), _jsx(HSL, {}, void 0, hslDefinition)), _jsx(CenterColumn, {}, void 0, _ref7, getBadges()), _jsx(Column, {}, void 0, _jsx(White, {}, void 0, _jsx('p', {}, void 0, whiteAccessibilityDefinition)), _jsx(Black, {}, void 0, blackAccessibilityDefinition)), _jsx(MobileList, {}, void 0, _jsx('li', {}, void 0, _ref8, ' ', themeName), _jsx('li', {}, void 0, _ref9, ' ', whiteAccessibilityDefinition), _jsx('li', {}, void 0, _ref10, ' ', blackAccessibilityDefinition), _jsx('li', {}, void 0, _ref11, ' ', hslDefinition)));
}

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Variants;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', function (_ref) {
  var theme = _ref.theme;
  return {
    '& > button': {
      marginRight: theme.space_inline_sm,
      marginBottom: theme.space_stack_sm
    }
  };
});

var _ref2 = _jsx(Root, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */], {
  variant: 'success',
  primary: true
}, void 0, 'Success'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */], {
  variant: 'warning',
  primary: true
}, void 0, 'Warning'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */], {
  variant: 'danger',
  primary: true
}, void 0, 'Danger'));

function Variants() {
  return _ref2;
}

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

module.exports = "# Color\n\nMineral UI color provides themes built on inspiring hues and grounded in usable grays.\nMineral UI is committed to providing an easy path to creating accessible palettes and themes.\n\n## Guidelines\n\nColor is used to establish focal points or highlight important information.\nMineral UI uses color as a tool for communication and secondarily as decoration.\nOveruse of color will overload the viewer and undermine any effect it had in creating a visual hierarchy.\n\nTake care when overriding individual theme values, since they enable consistent styling through automatic application of tone and shadowing.\n\n## Themes\n\nA **theme** is composed of a hue color ramp and the base gray ramp. Every theme uses the base gray ramp.  \n\nYou can create your own theme:\n  - `<value>_60` represents the base color for the theme.\n  - Hue ramps are generated from 10 points placed on a Bezier curve with 3 anchors.\n  - The top point represents `<value>_10`.\n  - The middle point represents `<value>_60`.\n  - The final point represents `<value>_100`.\n  - Each value is evenly distributed. Some manual adjustment might be necessary.\n  - Depending on the mood and tone for the theme, some curves are steeper and some more shallow. The theme will appear brighter and more saturated with shallower curves.\n\n![color swatch](/images/color-swatch.png)\n\n## Variants\n\n**Variants** are used in Mineral UI to aid users' understanding of the status of different callouts, actions, buttons etc.\n\nThe color system features three variants to represent intention:\n- **Success:** confirming actions or messages that were successful, or will begin a successful action.\n- **Warning:** actions or messages that indicate a warning or may produce an undesirable result.\n- **Destructive:** actions or messages that indicate errors or potential to destroy/remove data.\n\n<Variants />\n\n## Accessibility (a11y)\n\nAlways consider customers who are color blind or visually impaired when choosing colors.\nColor ramp values have similar accessibility values even when themes are switched out.\n\nMost themes are [WCAG AA+](https://www.w3.org/TR/WCAG20/) accessible. If a higher level of accessibility is required, allow the user to activate an accessible theme as a user preference.\n\n**AA** has a contrast level of 4.5:1 or higher, and **AAA** has a contrast of at least 7:1.\n**AA Large** means the font size must be at least [18 points or 14 points bolded](https://developer.paciellogroup.com/blog/2012/05/whats-large-text-in-wcag-2-0-parlance/) to be AA accessible.\n\n## Ramps\n\nYou can choose one of these ramps to create a theme.\nThe default Mineral UI theme is built from \"blue\".\n"

/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Typography;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_colorable__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_colorable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_colorable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Markdown__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Table__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FontDemo__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GuidelinePage__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__typography_md__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__typography_md___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__typography_md__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__examples__ = __webpack_require__(1557);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */











var a11yColor = function a11yColor(color) {
  var a11y = __WEBPACK_IMPORTED_MODULE_1_colorable___default()({
    main: color,
    white: '#fff',
    black: '#000',
    compact: true
  });

  var whiteContrast = a11y[0].combinations[0].contrast;
  var blackContrast = a11y[0].combinations[1].contrast;

  return whiteContrast > blackContrast ? 'white' : 'black';
};

var styles = {
  colorValue: function colorValue(_ref) {
    var theme = _ref.theme,
        color = _ref.color;

    return {
      backgroundColor: theme[color],
      borderRadius: theme.borderRadius_1,
      color: a11yColor(theme[color]),
      padding: parseFloat(theme.space_inset_sm) / 2 + 'em ' + theme.space_inset_sm
    };
  },
  overflowContainer: {
    '@media(max-width: 60em)': {
      overflowX: 'auto'
    }
  },
  table: {
    fontFamily: 'Open Sans'
  },
  valueCell: function valueCell(_ref2) {
    var theme = _ref2.theme;
    return {
      fontFamily: theme.fontFamily_monospace,
      verticalAlign: 'middle'
    };
  }
};

var ColorValue = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('span', styles.colorValue);
var OverflowContainer = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('div', styles.overflowContainer);
var Table = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_4__Table__["a" /* Table */], styles.table);
var ValueCell = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_4__Table__["b" /* TableCell */], styles.valueCell);

var _ref3 = _jsx('thead', {}, void 0, _jsx('tr', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__Table__["c" /* TableHeaderCell */], {
  width: 20,
  scope: 'col'
}, void 0, 'Example'), _jsx(__WEBPACK_IMPORTED_MODULE_4__Table__["c" /* TableHeaderCell */], {
  width: 8,
  scope: 'col'
}, void 0, 'Value'), _jsx(__WEBPACK_IMPORTED_MODULE_4__Table__["c" /* TableHeaderCell */], {
  scope: 'col'
}, void 0, 'Color Value'), _jsx(__WEBPACK_IMPORTED_MODULE_4__Table__["c" /* TableHeaderCell */], {
  scope: 'col'
}, void 0, 'Font (px/rem)')));

function Typography() {
  return _jsx(__WEBPACK_IMPORTED_MODULE_6__GuidelinePage__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3__Markdown__["a" /* default */], {
    scope: { FontDemo: __WEBPACK_IMPORTED_MODULE_5__FontDemo__["a" /* default */] }
  }, void 0, __WEBPACK_IMPORTED_MODULE_7__typography_md___default.a), __WEBPACK_IMPORTED_MODULE_8__examples__["a" /* default */].map(function (section, index) {
    return _jsx('section', {}, 'section_' + index, section.heading, section.description, _jsx(OverflowContainer, {}, void 0, _jsx(Table, {}, void 0, _ref3, _jsx('tbody', {}, void 0, section.examples.map(function (_ref4) {
      var content = _ref4.content,
          value = _ref4.value,
          color = _ref4.color,
          font = _ref4.font;
      return _jsx(__WEBPACK_IMPORTED_MODULE_4__Table__["d" /* TableRow */], {}, value, _jsx(__WEBPACK_IMPORTED_MODULE_4__Table__["b" /* TableCell */], {}, void 0, content), _jsx(ValueCell, {}, void 0, value), _jsx(ValueCell, {}, void 0, _jsx(ColorValue, {
        color: color
      }, void 0, 'theme.' + color)), _jsx(ValueCell, {}, void 0, font));
    })))));
  }));
}

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FontDemo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Heading__ = __webpack_require__(31);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var styles = {
  root: {
    display: 'flex',
    '& div': {
      flex: '1 0 50%'
    }
  },
  openSans: function openSans(_ref) {
    var theme = _ref.theme;
    return {
      fontFamily: 'Open Sans',
      '& p': {
        fontSize: theme.fontSize_h1,
        margin: '0 0 ' + theme.space_stack_xs
      }
    };
  },
  systemFont: function systemFont(_ref2) {
    var theme = _ref2.theme;
    return {
      '& h5': { textAlign: 'right' },
      '& p': {
        direction: 'rtl',
        margin: '0 0 ' + theme.space_stack_sm
      }
    };
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', styles.root);
var OpenSans = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', styles.openSans);
var SystemFont = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', styles.systemFont);

var _ref3 = _jsx(Root, {}, void 0, _jsx(OpenSans, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Heading__["a" /* default */], {
  level: 5
}, void 0, 'Open Sans (Latin, Cyrillic, Greek)'), _jsx('p', {}, void 0, 'Open Sans'), _jsx('p', {}, void 0, '\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0431\u0435\u0437'), _jsx('p', {}, void 0, '\u200B\u200C\u0391\u03BD\u03BF\u200B\u200C\u03B9\u03BA\u03C4\u200B\u200C\u03CC Sans')), _jsx(SystemFont, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Heading__["a" /* default */], {
  level: 5
}, void 0, 'System Font (Asian Syllabic, Abjad, Indic)'), _jsx('p', {}, void 0, '\u52A0\u5B66\u4F4F\u7121\u805E\u56E3\u89A7\u554F\u4F1A\u56E0\u7981\u6E96\u8457\u8A18\u7D4C\u3002\u8A03\u5148\u5E83\u5FDC\u65BD\u5F70\u9053\u4F59\u4E16\u6B4C\u5927\u6728\u3002\u89E3\u53F0\u623F\u9AD8\u66AE\u6CBB\u9759\u4E00\u6881\u72AF\u5927\u4E0B\u6D3E\u3002\u5BB9\u5B9A\u91CE\u64CD\u5F8C\u60C5\u66F4\u63A5\u5024\u611F\u7A3F\u6F14\u521D\u793C\u73FE\u5F8C\u60D1\u89AA\u8CC7\u8CEA\u3002\u90FD\u5927\u68EE\u5E74\u671F\u6240\u793A\u6C42\u7530\u5CA1\u753B\u6211\u8A17\u738B\u8CEA\u4E8B\u3002\u5272\u8857\u5B9A\u8F09\u795E\u914D\u82B8\u7406\u6642\u7D42\u5B89\u56FD\u3002\u4F5C\u70B9\u8C37\u6B63\u7D99\u4EF6\u8A03\u4F9B\u91D1\u756A\u63B2\u8003\u6B73\u7D04\u4EE5\u6B62\u4EBA\u5168\u81EA\u3002\u8CEA\u554F\u8F09\u8B77\u6B73\u7A3F\u5929\u61F2\u7981\u5370\u969C\u5229\u793C\u5C4B\u9020\u5009\u591A\u7684\u88DC\u3002\u793E\u8FC5\u5317\u8A0E\u6C0F\u9996\u697D\u5E02\u8996\u5C02\u6A29\u70B9\u4EE3\u63A8\u63B2\u672C\u85E4\u3002'), _jsx('p', {}, void 0, '\u0648\u0623\u0632\u064A\u0632 \u0623\u0635\u0642\u0627\u0639 \u0627\u0644\u062F\u0648\u0644\u0627\u0631\u0627\u062A \u0639\u0646 \u0644\u0645\u0651, \u064A\u062A\u0645 \u0627\u0644\u062D\u0631\u0629 \u0641\u0631\u0646\u0633\u0627 \u0627\u0644\u0628\u0634\u0631\u064A\u0629\u064B \u0623\u064A. \u0639\u062F\u062F \u0642\u062F \u062D\u0643\u0648\u0645\u0629 \u0627\u0644\u0636\u0631\u0648\u0631\u064A \u0627\u0644\u062D\u064A\u0644\u0648\u0644\u0629, \u0623\u0639\u0644\u0646\u062A \u0648\u0627\u0633\u062A\u0645\u0631 \u0627\u0644\u062D\u062F\u0648\u062F \u062A\u0645 \u062A\u062D\u062A, \u0623\u0645 \u0645\u0643\u0646 \u0623\u062D\u062F\u062B \u0627\u0644\u062B\u0627\u0646\u064A\u0629 \u0627\u0644\u062A\u062E\u0637\u064A\u0637. \u0623\u0646 \u0628\u0644\u0627 \u0648\u0628\u0639\u0636 \u063A\u0631\u0651\u0629\u060C \u0623\u0639\u0645\u0627\u0644. \u062A\u0627\u0631\u064A\u062E \u0648\u0628\u062D\u0644\u0648\u0644 \u0648\u0627\u062A\u0651\u062C\u0647 \u0628\u0644 \u0630\u0644\u0643. \u0647\u0648 \u0633\u0627\u0628\u0642 \u0647\u064F\u0632\u0645 \u0627\u0644\u0625\u0645\u062F\u0627\u062F \u062F\u0648\u0644. \u0633\u064A\u0627\u0633\u0629 \u0644\u0623\u062F\u0627\u0621 \u0627\u0644\u0648\u0631\u0627\u0621 \u0648 \u0639\u0631\u0636, \u0645\u0643\u0646 \u0648 \u0648\u062D\u062A\u0651\u0649 \u0627\u062A\u0641\u0627\u0642\u064A\u0629.'), _jsx('p', {}, void 0, '\u092A\u094D\u0930\u0938\u094D\u0924\u093E\u0935 \u092A\u0930 \u091A\u0930\u094D\u091A\u093E \u0936\u0941\u0930\u0942 \u0915\u0930\u0928\u0947 \u0938\u0947 \u092A\u0939\u0932\u0947 \u092E\u0948 \u0906\u092A \u0938\u092D\u0940 \u0915\u0947 \u0938\u093E\u092E\u0928\u0947 \u090F\u0915 \u092F\u093E \u0926\u094B \u092C\u093E\u0924 \u0930\u0916\u0928\u093E \u091A\u093E\u0939\u0942\u0901\u0917\u093E, \u092E\u0948 \u0926\u094B \u092C\u093E\u0924\u094B \u0915\u094B \u0938\u093E\u095E-\u0938\u093E\u095E \u0938\u092E\u091D\u0928\u093E \u091A\u093E\u0939\u0924\u093E \u0939\u0942\u0901 \u0914\u0930 \u0909\u0928 \u0926\u094B \u092C\u093E\u0924\u094B \u0915\u094B \u092E\u0948 \u0939\u092E \u0938\u092D\u0940 \u0915\u0947 \u0932\u093F\u092F\u0947 \u092E\u0939\u0924\u094D\u0935\u092A\u0942\u0930\u094D\u0923 \u092D\u0940 \u092E\u093E\u0928\u0924\u093E \u0939\u0942\u0901\u0964 \u092E\u0948 \u091A\u093E\u0939\u0924\u093E \u0939\u0942\u0901 \u0915\u0940 \u0906\u092A \u0938\u092C \u092D\u0940 \u0909\u0928 \u0926\u094B \u092C\u093E\u0924\u094B \u0915\u094B \u092E\u0947\u0930\u0947 \u0928\u091C\u0930\u093F\u092F\u0947 \u0938\u0947 \u0939\u0940 \u0926\u0947\u0916\u0947, \u0915\u094D\u092F\u094B\u0915\u093F \u092F\u0926\u093F \u0906\u092A\u0928\u0947 \u0909\u0928 \u0926\u094B \u092C\u093E\u0924\u094B \u0915\u094B \u0905\u092A\u0928\u093E \u0932\u093F\u092F\u093E \u0924\u094B \u0906\u092A \u0939\u092E\u0947\u0936\u093E \u0906\u0928\u0902\u0926\u093F\u0924 \u0930\u0939\u094B\u0902\u0917\u0947\u0964')));

function FontDemo() {
  return _ref3;
}

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

module.exports = "# Typography\n\nMineral UI provides a simple set of typographic elements to easily apply structure to your interface.\nUsing consistent typographic styles will create clear paths for users to move through your application.\n\n## Font Usage\n\nMineral UI uses [Open Sans](https://fonts.google.com/specimen/Open+Sans), a humanist sans-serif typeface with good legibility and warmth.\nFeaturing a tall x-height and open forms, it is ideal for on-screen consumption.\nOpen Sans supports ISO Latin 1, Latin CE, Greek and Cyrillic character sets.\n\nFor Internationalization, support is included for RTL (right-to-left) languages. Asian Syllabic, Abjad, Indic and other script languages will be supported by sans-serif system font.\n\n<FontDemo />\n\n## Type Sizing\n\nConsistent application of typography helps the user understand information hierarchy.\n- Type sizing is based on a [typescale](http://spencermortensen.com/articles/typographic-scale/).\n- Type basis defines `16px` as `1rem`.\n- Type sizing is based on a `1.25` (4:5 Major-Third) scale. This ratio balances vertical density with an expression of clear hierarchy.\n- The root base (default text size) is `14px`.\n\n## Relative Line Spacing\n\nLinespacing is consistently set at `1.25` for all type sizes, except for prose text, which has a line height of `1.5` to increase readability for long-form text.\n\n## Hierarchy and Intent\n\nConsistency is key to creating an easily scannable interface for users.\nEach level in the Mineral UI type hierarchy is defined with a specific color and intent.\nAssociating the typographic style to the intent in the interface provides a visual pattern that is easy for users to skim.\n\nThe variations help keep type styles to a minimum, so consistency is easier to achieve. Too many type styles make a layout unbalanced and difficult to manage.\n"

/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Heading__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Paragraph__ = __webpack_require__(271);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var styles = {
  description: function description(_ref) {
    var theme = _ref.theme;
    return {
      margin: '0 0 ' + theme.space_stack_xl
    };
  },
  list: function list(_ref2) {
    var theme = _ref2.theme;
    return {
      listStyle: 'square',
      paddingLeft: theme.space_inline_lg
    };
  }
};

var List = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('ul', styles.list);
var Description = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_3__Paragraph__["a" /* default */], styles.description);

var examples = [{
  heading: _jsx(__WEBPACK_IMPORTED_MODULE_2__Heading__["a" /* default */], {
    level: 2,
    id: 'long-form-text'
  }, void 0, 'Long-form Text'),
  description: _jsx(Description, {
    variant: 'prose'
  }, void 0, 'Default text and caption styles are intended for sections of content that provide description and assistance. ', ' ', _jsx('strong', {}, void 0, 'Paragraph text'), ' is primarily used for content sections.', ' ', _jsx('strong', {}, void 0, 'Caption Text'), ' is used to highlight or offset content, such as inline help or when captioning dashboard content.'),
  examples: [{
    content: _jsx(__WEBPACK_IMPORTED_MODULE_3__Paragraph__["a" /* default */], {
      type: 'ui'
    }, void 0, 'Paragraph UI'),
    value: '<p>, <li>',
    color: 'color_gray_100',
    font: 'Bold (14/0.875)'
  }, {
    content: _jsx(List, {}, void 0, _jsx('li', {}, void 0, 'Alpha'), _jsx('li', {}, void 0, 'Bravo'), _jsx('li', {}, void 0, 'Charlie')),
    // the design notes have <ol> here as well,
    // but list-style will override any numbers shown on <ol> list items
    value: '<ul>, <ol>',
    color: 'color_gray_100',
    font: 'Bold (14)'
  }, {
    content: _jsx(__WEBPACK_IMPORTED_MODULE_3__Paragraph__["a" /* default */], {
      variant: 'prose'
    }, void 0, 'Paragraph (Long Form)'),
    value: '<p.long>',
    color: 'color_gray_100',
    font: 'Regular (16/1)'
  }, {
    content: _jsx(__WEBPACK_IMPORTED_MODULE_3__Paragraph__["a" /* default */], {
      variant: 'mouse'
    }, void 0, 'Paragraph (Mousetype)'),
    value: '<p.mouse>',
    color: 'color_gray_100',
    font: 'Regular (11/0.6875)'
  }, {
    content: _jsx(__WEBPACK_IMPORTED_MODULE_2__Heading__["a" /* default */], {
      level: 5
    }, void 0, 'Caption - Strong'),
    value: '<h5>',
    color: 'color_gray_100',
    font: 'Bold (14/0.875)'
  }, {
    content: _jsx(__WEBPACK_IMPORTED_MODULE_2__Heading__["a" /* default */], {
      level: 6
    }, void 0, 'Caption - Light'),
    value: '<h6>',
    color: 'color_gray_80',
    font: 'Regular (14/0.875)'
  }]
}, {
  heading: _jsx(__WEBPACK_IMPORTED_MODULE_2__Heading__["a" /* default */], {
    level: 2,
    id: 'display-text'
  }, void 0, 'Display Text'),
  description: _jsx(Description, {
    variant: 'prose'
  }, void 0, _jsx('strong', {}, void 0, 'Display text'), ' makes a bold statement, and is useful to draw attention to different sections in an application view. Display text is for short titles and section divisions. They should be used sparingly \u2013 they aren\u2019t for long-form content.', ' '),
  examples: [{
    content: _jsx(__WEBPACK_IMPORTED_MODULE_2__Heading__["a" /* default */], {
      level: 1
    }, void 0, 'Page Title'),
    value: '<h1>',
    color: 'color_gray_100',
    font: 'ExtraBold (34/2.125)'
  }, {
    content: _jsx(__WEBPACK_IMPORTED_MODULE_2__Heading__["a" /* default */], {
      level: 2
    }, void 0, 'Large Section Header'),
    value: '<h2>',
    color: 'color_gray_80',
    font: 'SemiBold (28/1.75)'
  }, {
    content: _jsx(__WEBPACK_IMPORTED_MODULE_2__Heading__["a" /* default */], {
      level: 3
    }, void 0, 'Medium Section Header'),
    value: '<h3>',
    color: 'color_gray_80',
    font: 'SemiBold (22/1.375)'
  }, {
    content: _jsx(__WEBPACK_IMPORTED_MODULE_2__Heading__["a" /* default */], {
      level: 4
    }, void 0, 'Small Section Header'),
    value: '<h4>',
    color: 'color_gray_80',
    font: 'Bold (14/0.875)'
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (examples);

/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ComponentStatus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GuidelinePage__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Markdown__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Legend__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__componentStatus_md__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__componentStatus_md___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__componentStatus_md__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








var Layout = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_2__GuidelinePage__["a" /* default */], function (_ref) {
  var theme = _ref.theme;
  return {
    '& table': {
      maxWidth: '40em'
    },
    '& th:last-child, & td:last-child': {
      textAlign: 'center',
      width: '6em'
    },
    // This will have to be updated if there are more intro paragraphs
    // in the markdown for this page
    '& p:nth-of-type(2)': {
      marginBottom: theme.space_stack_xxl,
      '@media(max-width: 45em)': {
        marginBottom: theme.space_stack_lg
      }
    }
  };
});

function ComponentStatus() {
  return _jsx(Layout, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3__Markdown__["a" /* default */], {
    scope: { Legend: __WEBPACK_IMPORTED_MODULE_4__Legend__["a" /* default */] }
  }, void 0, __WEBPACK_IMPORTED_MODULE_5__componentStatus_md___default.a));
}

/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Legend;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon_IconAssignment__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon_IconCheck__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconSlowMotionVideo__ = __webpack_require__(121);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








var styles = {
  list: function list(_ref) {
    var theme = _ref.theme;
    return {
      paddingLeft: 0,
      margin: '0 0 ' + theme.space_stack_xl,
      '& li': {
        display: 'inline-block',
        marginRight: theme.space_inline_xl,
        '@media(max-width: 45em)': {
          display: 'block'
        }
      }
    };
  },
  icon: {
    verticalAlign: 'text-top'
  }
};

var Available = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_4__Icon_IconCheck__["a" /* default */], styles.icon);
var InDevelopment = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_5__Icon_IconSlowMotionVideo__["a" /* default */], styles.icon);
var Planned = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_3__Icon_IconAssignment__["a" /* default */], styles.icon);
var List = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('ul', styles.list);

function Legend() {
  return _jsx(List, {
    'aria-hidden': 'true'
  }, void 0, _jsx('li', {}, void 0, _jsx(Available, {
    color: __WEBPACK_IMPORTED_MODULE_2__themes__["c" /* color */].green_60,
    size: 'large'
  }), ' Available'), _jsx('li', {}, void 0, _jsx(InDevelopment, {
    color: __WEBPACK_IMPORTED_MODULE_2__themes__["c" /* color */].yellow_60,
    size: 'large'
  }), ' In Development'), _jsx('li', {}, void 0, _jsx(Planned, {
    color: __WEBPACK_IMPORTED_MODULE_2__themes__["c" /* color */].blue_60,
    size: 'large'
  }), ' Planned'));
}

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

module.exports = "# Component Status\n\nCheck back here anytime to see current component status information.\nIf you have a suggestion for a new component not listed here, [create an issue on GitHub](https://github.com/mineral-ui/mineral-ui/issues) to let us know!\n\nSee more detailed progress on our [Waffle.io board](https://waffle.io/mineral-ui/mineral-ui).\n\n<Legend />\n\n<!--\n\nLabels:\n~ new\n~ experimental\n\nStatuses:\n[available]\n[planned]\n[in development]\n[deprecated]\n\n-->\n\n| Component | Status |\n|---|---|\n| [Button](/components/button) | [available] |\n| [Card](/components/card) | [available] |\n| [Dropdown](/components/dropdown) ~ new | [available] |\n| [Icon](/components/icon) | [available] |\n| [Link](/components/link) | [available] |\n| [Menu](/components/menu) ~ new | [available] |\n| [Popover](/components/popover) | [available] |\n| [ThemeProvider](/components/theme-provider) | [available] |\n| [Utils](/components/utils) | [available] |\n| NumericInput | [planned] |\n| Select | [planned] |\n| TextArea | [planned] |\n| TextInput | [planned] |\n| Tooltip | [planned] |\n| DataTable | |\n| DateInput | |\n| Grid | |\n| Navigation | |\n"

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Router;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_IconArrowBack__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_ComponentDoc__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ComponentDocExample__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Link__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LiveProvider__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages__ = __webpack_require__(280);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */










var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_2__Icon_IconArrowBack__["a" /* default */], {
  color: 'currentColor',
  size: 'small'
});

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */], {
  from: '/',
  to: '/getting-started'
});

function Router(_ref) {
  var demos = _ref.demos;

  var routes = __WEBPACK_IMPORTED_MODULE_7__pages__["a" /* default */].map(function (section) {
    return section.pages;
  })
  // flatten array of pages arrays
  .reduce(function (acc, pages) {
    return [].concat(_toConsumableArray(acc), _toConsumableArray(pages));
  }, []).map(function (page, index) {
    var _ref2 = _jsx(page.component, {});

    return _jsx(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], {
      path: page.path,
      render: function render() {
        return _ref2;
      }
    }, 'page-' + index);
  });

  return _jsx(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Switch */], {}, void 0, routes, _jsx(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], {
    path: '/components/:componentId/:exampleId',
    render: function render(route) {
      var _route$match$params = route.match.params,
          componentId = _route$match$params.componentId,
          exampleId = _route$match$params.exampleId;

      var selectedDemo = demos[componentId];
      var selectedExample = selectedDemo.examples.filter(function (example) {
        return example.id === exampleId;
      })[0];
      var chromeless = route.location.search === '?chromeless';
      return chromeless ? _jsx(__WEBPACK_IMPORTED_MODULE_6__LiveProvider__["a" /* default */], {
        hideSource: true,
        chromeless: true,
        scope: selectedExample.scope,
        source: selectedExample.source
      }) : _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Link__["a" /* default */], {
        to: '../'
      }, void 0, _ref3, ' ', selectedDemo.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentDocExample__["a" /* default */], selectedExample));
    }
  }), _jsx(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], {
    path: '/components/:componentId',
    render: function render(route) {
      var componentId = route.match.params.componentId;
      var selectedDemo = demos[componentId];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__pages_ComponentDoc__["a" /* default */], selectedDemo);
    }
  }), _ref4);
}
Router.propTypes = {
  demos: __webpack_require__(0).object.isRequired
};

/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flatten__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createKeyMap__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dropdown__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Link__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Menu__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Popover__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ThemeProvider__ = __webpack_require__(1695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__themes__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(1704);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */














var demos = __WEBPACK_IMPORTED_MODULE_0_lodash_flatten___default()([__WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__Card__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__Dropdown__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__Icon__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__Link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__Menu__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__Popover__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__ThemeProvider__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__themes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */]]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createKeyMap__["a" /* default */])(demos, 'slug'));

/***/ }),
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button_Button__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bestPractices__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples__ = __webpack_require__(1572);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var doc = __webpack_require__(1583);

/* harmony default export */ __webpack_exports__["a"] = ({
  bestPractices: __WEBPACK_IMPORTED_MODULE_1__bestPractices__["a" /* default */],
  doc: doc,
  examples: __WEBPACK_IMPORTED_MODULE_2__examples__["a" /* default */],
  slug: 'button',
  componentTheme: __WEBPACK_IMPORTED_MODULE_0__Button_Button__["a" /* componentTheme */],
  title: 'Button',
  whenHowToUse: 'A Button should be used whenever you need to trigger an action in your app.\nButtons should have concise labeling indicating to your user what will happen when the Button is clicked.\nThe color of the button should be chosen according to the intent of the action.\n\nFor example, if clicking a Button will make a potentially destructive action, use `variant="danger"` instead of `"success"`.'
});

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




/* harmony default export */ __webpack_exports__["a"] = ([{
  type: 'do',
  title: 'use the appropriate variant for your intent',
  example: _jsx(__WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], {
    variant: 'danger',
    primary: true
  }, void 0, 'Drop Users Table'),
  description: 'Match Mineral UI\'s pre-defined Button variants with semantic purpose.'
}, {
  type: 'do',
  title: 'use clear labeling for button messaging',
  example: _jsx(__WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], {
    primary: true
  }, void 0, 'Save Changes'),
  description: 'Button actions should be predictable for frictionless interaction.\nExceptions would include "Ok", "Cancel", etc. which should be used sparingly.\nLabels should be structured: `<verb> <noun>`.'
}, {
  type: 'dont',
  title: 'cause confusion with the wrong variant',
  example: _jsx(__WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], {
    variant: 'success',
    primary: true
  }, void 0, 'Delete Database'),
  description: 'Using the wrong variant can cause confusion, or undue stress for users.'
}, {
  type: 'dont',
  title: 'use "click me" or other vague messaging',
  example: _jsx(__WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], {
    primary: true
  }, void 0, 'Click Me'),
  description: 'Users should know exactly what will happen when they click a Button.'
}]);

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__regular__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__circular__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__iconOnly__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__minimal__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__primary__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rtl__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sizes__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__states__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__truncation__ = __webpack_require__(1582);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */












/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_5__primary__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__regular__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__minimal__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__sizes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__iconOnly__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__circular__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__truncation__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__rtl__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__states__["a" /* default */]]);

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(6);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('div', {
  '& > button': {
    marginRight: '0.5rem'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'default',
  title: 'Default',
  description: 'Regular Buttons are good for secondary actions when grouped with another [primary](#primary) button.\nThese Buttons are not impactful enough to represent the primary action in a container.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], DemoLayout: DemoLayout },
  source: '\n    <DemoLayout>\n      <Button>Default</Button>\n      <Button variant="success">Success</Button>\n      <Button variant="warning">Warning</Button>\n      <Button variant="danger">Danger</Button>\n      <Button disabled>Disabled</Button>\n    </DemoLayout>'
});

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_IconCloud__ = __webpack_require__(39);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('div', {
  '& > button': {
    marginRight: '0.5rem'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'circular',
  title: 'Circular Buttons',
  description: 'Buttons can be made circular. Such Buttons should not have any text.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], IconCloud: __WEBPACK_IMPORTED_MODULE_2__Icon_IconCloud__["a" /* default */], DemoLayout: DemoLayout },
  source: '\n    () => {\n      const icon = <IconCloud />;\n\n      return (\n        <DemoLayout>\n          <Button iconStart={icon} circular aria-label="Cloud" />\n          {/* primary */}\n          <Button iconStart={icon} circular primary aria-label="Cloud" />\n          {/* minimal */}\n          <Button iconStart={icon} circular minimal aria-label="Cloud" />\n          {/* small */}\n          <Button iconStart={icon} circular size="small" aria-label="Cloud" />\n          {/* large */}\n          <Button iconStart={icon} circular size="medium" aria-label="Cloud" />\n          {/* jumbo */}\n          <Button iconStart={icon} circular size="jumbo" aria-label="Cloud" />\n        </DemoLayout>\n      );\n    }'
});

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_IconCloud__ = __webpack_require__(39);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('div', {
  '& > button': {
    marginRight: '0.5rem'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'icons',
  title: 'Buttons with Icons',
  description: 'Buttons can contain [Icons](../icon) at their start, end, or both.\n\n`small` Buttons use small Icons; `medium` and `large` Buttons use medium Icons; `jumbo` Buttons use large Icons.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], IconCloud: __WEBPACK_IMPORTED_MODULE_2__Icon_IconCloud__["a" /* default */], DemoLayout: DemoLayout },
  source: '\n    () => {\n      const icon = <IconCloud />;\n\n      return (\n        <DemoLayout>\n          <Button iconStart={icon}>Start icon</Button>\n          <Button iconEnd={icon}>End icon</Button>\n          <Button iconStart={icon} iconEnd={icon}>Both icons</Button>\n          <br /><br />\n          <Button iconStart={icon} primary>Primary</Button>\n          <Button iconStart={icon} minimal>Minimal</Button>\n          <Button iconStart={icon} variant="danger">Danger</Button>\n          <Button iconStart={icon} variant="success">Success</Button>\n          <Button iconStart={icon} variant="warning">Warning</Button>\n          <Button iconStart={icon} disabled>Disabled</Button>\n          <br /><br />\n          <Button iconStart={icon} size="small">Small</Button>\n          <Button iconStart={icon} size="medium">Medium</Button>\n          <Button iconStart={icon}>Large</Button>\n          <Button iconStart={icon} size="jumbo">Jumbo</Button>\n        </DemoLayout>\n      );\n    }'
});

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_IconCloud__ = __webpack_require__(39);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('div', {
  '& > button': {
    marginRight: '0.5rem'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'icon-only',
  title: 'Icon-Only Buttons',
  description: 'Buttons that contain only [Icons](../icon) can use either `iconStart` or `iconEnd` props and must have an `aria-label` provided.\n\nUse icon-only Buttons sparingly. The meaning of the Button can be diluted without a visual label.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], IconCloud: __WEBPACK_IMPORTED_MODULE_2__Icon_IconCloud__["a" /* default */], DemoLayout: DemoLayout },
  source: '\n    () => {\n      const icon = <IconCloud />;\n\n      return (\n        <DemoLayout>\n          {/* Icon as prop; no text. aria-label applied to Button. */}\n          <Button iconStart={icon} aria-label="Cloud" />\n          {/* primary */}\n          <Button iconStart={icon} primary aria-label="Cloud" />\n          {/* minimal */}\n          <Button iconStart={icon} minimal aria-label="Cloud" />\n          {/* small */}\n          <Button iconStart={icon} size="small" aria-label="Cloud" />\n          {/* large */}\n          <Button iconStart={icon} size="medium" aria-label="Cloud" />\n          {/* jumbo */}\n          <Button iconStart={icon} size="jumbo" aria-label="Cloud" />\n        </DemoLayout>\n      );\n    }'
});

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(6);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('div', {
  '& > button': {
    marginRight: '0.5rem'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'minimal',
  title: 'Minimal',
  description: 'Use for less-important actions, or if there are a lot of other buttons on screen.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], DemoLayout: DemoLayout },
  source: '<DemoLayout>\n    <Button minimal>Default</Button>\n    <Button variant="success" minimal>Success</Button>\n    <Button variant="warning" minimal>Warning</Button>\n    <Button variant="danger" minimal>Danger</Button>\n    <Button disabled minimal>Disabled</Button>\n  </DemoLayout>'
});

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(6);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('div', {
  '& > button': {
    marginRight: '0.5rem'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'primary',
  title: 'Example',
  description: 'Buttons trigger different actions around the page. Primary Buttons are used once per container, usually as the main call to action for the page.\n    Overuse of primary buttons could make the interface feel too busy.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], DemoLayout: DemoLayout },
  source: '<DemoLayout>\n    <Button primary>Default</Button>\n    <Button variant="success" primary>Success</Button>\n    <Button variant="warning" primary>Warning</Button>\n    <Button variant="danger" primary>Danger</Button>\n    <Button primary disabled>Disabled</Button>\n  </DemoLayout>'
});

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_IconBackspace__ = __webpack_require__(177);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'rtl',
  title: 'RTL Support',
  description: 'Buttons with Icons are reversed when the `rtl` prop is set.\nA subset of Icons that [convey directionality](../icon#rtl) will be reversed.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], IconBackspace: __WEBPACK_IMPORTED_MODULE_2__Icon_IconBackspace__["a" /* default */], ThemeProvider: __WEBPACK_IMPORTED_MODULE_0__themes__["a" /* ThemeProvider */] },
  source: '\n    <div dir="rtl">\n      <ThemeProvider theme={{ direction: \'rtl\' }}>\n        <Button iconStart={<IconBackspace />}>\u0642\u0645 \u0628\u0639\u0645\u0644 \u0645\u0627</Button>\n      </ThemeProvider>\n    </div>'
});

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(6);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('div', function (_ref) {
  var theme = _ref.theme;
  return {
    '& > button': {
      marginRight: '0.5rem'
    },
    ' button:last-of-type': {
      marginTop: theme.space_stack_md
    }
  };
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'sizes',
  description: 'To provide hierarchy to actions on your page, change Button impact with the `size` attribute.\n\nFor a Button whose width is defined by its container, use `fullWidth`.',
  title: 'Sizes',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], DemoLayout: DemoLayout },
  source: '\n    <DemoLayout>\n      <Button size="small">Small</Button>\n      <Button size="medium">Medium</Button>\n      <Button>Large</Button>\n      <Button size="jumbo">Jumbo</Button>\n      <Button fullWidth>Full Width</Button>\n    </DemoLayout>'
});

/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamor__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_glamor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(6);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', {
  '& > button': {
    marginRight: '0.5rem',
    width: '8rem'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'states',
  title: 'States',
  hideFromProd: true,
  hideSource: true,
  scope: { Button: __WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */], DemoLayout: DemoLayout, simulate: __WEBPACK_IMPORTED_MODULE_0_glamor__["simulate"] },
  source: '\n    <DemoLayout>\n      <Button>Regular</Button>\n      <Button primary>Primary</Button>\n      <Button minimal>Minimal</Button>\n      <br /><br />\n      <Button {...simulate(\'hover\')}>Hover</Button>\n      <Button {...simulate(\'hover\')} primary>Hover</Button>\n      <Button {...simulate(\'hover\')} minimal>Hover</Button>\n      <br /><br />\n      <Button {...simulate(\'focus\')}>Focus</Button>\n      <Button {...simulate(\'focus\')} primary>Focus</Button>\n      <Button {...simulate(\'focus\')} minimal>Focus</Button>\n      <br /><br />\n      <Button {...simulate(\'focus\', \'hover\')}>Focus & Hover</Button>\n      <Button {...simulate(\'focus\', \'hover\')} primary>Focus & Hover</Button>\n      <Button {...simulate(\'focus\', \'hover\')} minimal>Focus & Hover</Button>\n      <br /><br />\n      <Button {...simulate(\'focus\', \'active\')}>Focus & Active</Button>\n      <Button {...simulate(\'focus\', \'active\')} primary>Focus & Active</Button>\n      <Button {...simulate(\'focus\', \'active\')} minimal>Focus & Active</Button>\n      <br /><br />\n      <Button {...simulate(\'active\')}>Active</Button>\n      <Button {...simulate(\'active\')} primary>Active</Button>\n      <Button {...simulate(\'active\')} minimal>Active</Button>\n      <br /><br />\n      <Button disabled>Disabled</Button>\n      <Button disabled primary>Disabled</Button>\n      <Button disabled minimal>Disabled</Button>\n      <br /><br /><br />\n\n      <Button variant="danger">Regular</Button>\n      <Button variant="danger" primary>Primary</Button>\n      <Button variant="danger" minimal>Minimal</Button>\n      <br /><br />\n      <Button {...simulate(\'hover\')} variant="danger">Hover</Button>\n      <Button {...simulate(\'hover\')} variant="danger" primary>Hover</Button>\n      <Button {...simulate(\'hover\')} variant="danger" minimal>Hover</Button>\n      <br /><br />\n      <Button {...simulate(\'focus\')} variant="danger">Focus</Button>\n      <Button {...simulate(\'focus\')} variant="danger" primary>Focus</Button>\n      <Button {...simulate(\'focus\')} variant="danger" minimal>Focus</Button>\n      <br /><br />\n      <Button {...simulate(\'focus\', \'hover\')} variant="danger">\n        Focus & Hover\n      </Button>\n      <Button {...simulate(\'focus\', \'hover\')} variant="danger" primary>\n        Focus & Hover\n      </Button>\n      <Button {...simulate(\'focus\', \'hover\')} variant="danger" minimal>\n        Focus & Hover\n      </Button>\n      <br /><br />\n      <Button {...simulate(\'focus\', \'active\')} variant="danger">\n        Focus & Active\n      </Button>\n      <Button {...simulate(\'focus\', \'active\')} variant="danger" primary>\n        Focus & Active\n      </Button>\n      <Button {...simulate(\'focus\', \'active\')} variant="danger" minimal>\n        Focus & Active\n      </Button>\n      <br /><br />\n      <Button {...simulate(\'active\')} variant="danger">Active</Button>\n      <Button {...simulate(\'active\')} variant="danger" primary>Active</Button>\n      <Button {...simulate(\'active\')} variant="danger" minimal>Active</Button>\n      <br /><br />\n      <Button disabled variant="danger">Disabled</Button>\n      <Button disabled variant="danger" primary>Disabled</Button>\n      <Button disabled variant="danger" minimal>Disabled</Button>\n      <br /><br /><br />\n\n      <Button variant="success">Regular</Button>\n      <Button variant="success" primary>Primary</Button>\n      <Button variant="success" minimal>Minimal</Button>\n      <br /><br />\n      <Button {...simulate(\'hover\')} variant="success">Hover</Button>\n      <Button {...simulate(\'hover\')} variant="success" primary>Hover</Button>\n      <Button {...simulate(\'hover\')} variant="success" minimal>Hover</Button>\n      <br /><br />\n      <Button {...simulate(\'focus\')} variant="success">Focus</Button>\n      <Button {...simulate(\'focus\')} variant="success" primary>Focus</Button>\n      <Button {...simulate(\'focus\')} variant="success" minimal>Focus</Button>\n      <br /><br />\n      <Button {...simulate(\'focus\', \'hover\')} variant="success">\n        Focus & Hover\n      </Button>\n      <Button {...simulate(\'focus\', \'hover\')} variant="success" primary>\n        Focus & Hover\n      </Button>\n      <Button {...simulate(\'focus\', \'hover\')} variant="success" minimal>\n        Focus & Hover\n      </Button>\n      <br /><br />\n      <Button {...simulate(\'focus\', \'active\')} variant="success">\n        Focus & Active\n      </Button>\n      <Button {...simulate(\'focus\', \'active\')} variant="success" primary>\n        Focus & Active\n      </Button>\n      <Button {...simulate(\'focus\', \'active\')} variant="success" minimal>\n        Focus & Active\n      </Button>\n      <br /><br />\n      <Button {...simulate(\'active\')} variant="success">Active</Button>\n      <Button {...simulate(\'active\')} variant="success" primary>Active</Button>\n      <Button {...simulate(\'active\')} variant="success" minimal>Active</Button>\n      <br /><br />\n      <Button disabled variant="danger">Disabled</Button>\n      <Button disabled variant="danger" primary>Disabled</Button>\n      <Button disabled variant="danger" minimal>Disabled</Button>\n      <br /><br /><br />\n\n      <Button variant="warning">Regular</Button>\n      <Button variant="warning" primary>Primary</Button>\n      <Button variant="warning" minimal>Minimal</Button>\n      <br /><br />\n      <Button {...simulate(\'hover\')} variant="warning">Hover</Button>\n      <Button {...simulate(\'hover\')} variant="warning" primary>Hover</Button>\n      <Button {...simulate(\'hover\')} variant="warning" minimal>Hover</Button>\n      <br /><br />\n      <Button {...simulate(\'focus\')} variant="warning">Focus</Button>\n      <Button {...simulate(\'focus\')} variant="warning" primary>Focus</Button>\n      <Button {...simulate(\'focus\')} variant="warning" minimal>Focus</Button>\n      <br /><br />\n      <Button {...simulate(\'focus\', \'hover\')} variant="warning">\n        Focus & Hover\n      </Button>\n      <Button {...simulate(\'focus\', \'hover\')} variant="warning" primary>\n        Focus & Hover\n      </Button>\n      <Button {...simulate(\'focus\', \'hover\')} variant="warning" minimal>\n        Focus & Hover\n      </Button>\n      <br /><br />\n      <Button {...simulate(\'focus\', \'active\')} variant="warning">\n        Focus & Active\n      </Button>\n      <Button {...simulate(\'focus\', \'active\')} variant="warning" primary>\n        Focus & Active\n      </Button>\n      <Button {...simulate(\'focus\', \'active\')} variant="warning" minimal>\n        Focus & Active\n      </Button>\n      <br /><br />\n      <Button {...simulate(\'active\')} variant="warning">Active</Button>\n      <Button {...simulate(\'active\')} variant="warning" primary>Active</Button>\n      <Button {...simulate(\'active\')} variant="warning" minimal>Active</Button>\n      <br /><br />\n      <Button disabled variant="danger">Disabled</Button>\n      <Button disabled variant="danger" primary>Disabled</Button>\n      <Button disabled variant="danger" minimal>Disabled</Button>\n      <br /><br />\n    </DemoLayout>'
});

/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(6);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var FixedWidthLayout = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('div', {
  '& > button': {
    width: '10rem'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'truncation',
  title: 'Truncation',
  description: 'Long button text is truncated when necessary.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], FixedWidthLayout: FixedWidthLayout },
  source: '\n    <FixedWidthLayout>\n      <Button>Supercalifragilisticexpialidocious</Button>\n    </FixedWidthLayout>'
});

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

module.exports = {
	"description": "The Button component represents a clickable button.\nButtons draw attention to actions that can be performed in your app.\nButtons are used to trigger any sort of event.\n\nButtons with clear messaging and an appropriate variant applied communicate intention effectively.",
	"methods": [],
	"props": {
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "Rendered content of the component"
		},
		"circular": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Displays a circular Button"
		},
		"disabled": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Disables the Button"
		},
		"fullWidth": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Stretch Button to fill its container"
		},
		"iconEnd": {
			"flowType": {
				"name": "React$Element",
				"elements": [
					{
						"name": "unknown"
					}
				],
				"raw": "React$Element<*>"
			},
			"required": false,
			"description": "Icon that goes after the children"
		},
		"iconStart": {
			"flowType": {
				"name": "React$Element",
				"elements": [
					{
						"name": "unknown"
					}
				],
				"raw": "React$Element<*>"
			},
			"required": false,
			"description": "Icon that goes before the children"
		},
		"minimal": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Display a minimal Button"
		},
		"onClick": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(event: SyntheticEvent<>) => void",
				"signature": {
					"arguments": [
						{
							"name": "event",
							"type": {
								"name": "SyntheticEvent",
								"elements": [],
								"raw": "SyntheticEvent<>"
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "Called with the click event"
		},
		"primary": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Display a primary Button"
		},
		"size": {
			"flowType": {
				"name": "union",
				"raw": "'small' | 'medium' | 'large' | 'jumbo'",
				"elements": [
					{
						"name": "literal",
						"value": "'small'"
					},
					{
						"name": "literal",
						"value": "'medium'"
					},
					{
						"name": "literal",
						"value": "'large'"
					},
					{
						"name": "literal",
						"value": "'jumbo'"
					}
				]
			},
			"required": false,
			"description": "Available sizes",
			"defaultValue": {
				"value": "'large'",
				"computed": false
			}
		},
		"type": {
			"flowType": {
				"name": "union",
				"raw": "'button' | 'submit'",
				"elements": [
					{
						"name": "literal",
						"value": "'button'"
					},
					{
						"name": "literal",
						"value": "'submit'"
					}
				]
			},
			"required": false,
			"description": "Available types",
			"defaultValue": {
				"value": "'button'",
				"computed": false
			}
		},
		"variant": {
			"flowType": {
				"name": "union",
				"raw": "'regular' | 'danger' | 'success' | 'warning'",
				"elements": [
					{
						"name": "literal",
						"value": "'regular'"
					},
					{
						"name": "literal",
						"value": "'danger'"
					},
					{
						"name": "literal",
						"value": "'success'"
					},
					{
						"name": "literal",
						"value": "'warning'"
					}
				]
			},
			"required": false,
			"description": "Available variants",
			"defaultValue": {
				"value": "'regular'",
				"computed": false
			}
		}
	}
}

/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card_Card__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Card_CardBlock__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card_CardTitle__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__examples_card__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__examples_card_block__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__examples_card_image__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__examples_card_title__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bestPractices__ = __webpack_require__(1604);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









var cardDoc = __webpack_require__(1600);
var cardBlockDoc = __webpack_require__(1601);
var cardImageDoc = __webpack_require__(1602);
var cardTitleDoc = __webpack_require__(1603);



/* harmony default export */ __webpack_exports__["a"] = ([{
  bestPractices: __WEBPACK_IMPORTED_MODULE_7__bestPractices__["a" /* default */].card,
  componentTheme: __WEBPACK_IMPORTED_MODULE_0__Card_Card__["a" /* componentTheme */],
  doc: cardDoc,
  examples: __WEBPACK_IMPORTED_MODULE_3__examples_card__["a" /* default */],
  slug: 'card',
  title: 'Card',
  whenHowToUse: 'Cards are used when you need to group different kinds of elements with actions attached.\nCards are used to contain content of variable length that might not fit neatly into a table row or grid cell.\nThey\'re often used to show a collection of related but different types of information.\n\nDon\'t put too much information in a single card.\nCards represent a gateway to more detailed information in another app view.'
}, {
  bestPractices: __WEBPACK_IMPORTED_MODULE_7__bestPractices__["a" /* default */].cardBlock,
  componentTheme: __WEBPACK_IMPORTED_MODULE_1__Card_CardBlock__["a" /* componentTheme */],
  doc: cardBlockDoc,
  examples: __WEBPACK_IMPORTED_MODULE_4__examples_card_block__["a" /* default */],
  slug: 'card-block',
  subcomponent: true,
  title: 'CardBlock',
  whenHowToUse: 'CardBlock is used to help lay out content that\'s not a [title](../card-title) or an [image](../card-image) in the body of the [Card](../card).\n\nTry not to put inline links in your content. Create purposeful calls to action with [Buttons](../button) at the bottom of the Card.'
}, {
  bestPractices: __WEBPACK_IMPORTED_MODULE_7__bestPractices__["a" /* default */].cardImage,
  doc: cardImageDoc,
  examples: __WEBPACK_IMPORTED_MODULE_5__examples_card_image__["a" /* default */],
  slug: 'card-image',
  subcomponent: true,
  title: 'CardImage',
  whenHowToUse: 'CardImage is used when you want to reinforce the intent of the Card.\nImages shouldn\'t be used alone in a Card, but should be paired with a call to action and/or a [CardTitle](../card-title).\n\nIf you are putting text over top of the CardImage, use a solid color or an image with sufficient contrast to the text.'
}, {
  bestPractices: __WEBPACK_IMPORTED_MODULE_7__bestPractices__["a" /* default */].cardTitle,
  componentTheme: __WEBPACK_IMPORTED_MODULE_2__Card_CardTitle__["a" /* componentTheme */],
  doc: cardTitleDoc,
  examples: __WEBPACK_IMPORTED_MODULE_6__examples_card_title__["a" /* default */],
  slug: 'card-title',
  subcomponent: true,
  title: 'CardTitle',
  whenHowToUse: 'Use a CardTitle when you need a consistently styled headings for your [Card](../card).\nUse a subtitle to provide supporting information for the data displayed in the Card.'
}]);

/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arbitraryChildren__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clickable__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orderOfSections__ = __webpack_require__(1589);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_0__card__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__clickable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__arbitraryChildren__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__orderOfSections__["a" /* default */]]);

/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DemoLayout__ = __webpack_require__(40);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'basic',
  title: 'Example',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'Card content should be neither too simple nor too complex.\nCards are used as a gateway to more detailed content, not merely as a widget container.\nCards contain one [CardTitle](../card-title), an optional [CardImage](../card-image), and one or more [CardBlocks](../card-block).\n\n<Callout title="Note">\n  Cards normally occupy the full available width of their container. The Cards here are width-constrained for illustration purposes.\n</Callout>',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], Card: __WEBPACK_IMPORTED_MODULE_2__Card__["d" /* default */], CardBlock: __WEBPACK_IMPORTED_MODULE_2__Card__["a" /* CardBlock */], CardImage: __WEBPACK_IMPORTED_MODULE_2__Card__["b" /* CardImage */], CardTitle: __WEBPACK_IMPORTED_MODULE_2__Card__["c" /* CardTitle */], DemoLayout: __WEBPACK_IMPORTED_MODULE_3__components_DemoLayout__["a" /* default */] },
  source: '\n    <DemoLayout>\n      <Card>\n        <CardTitle>Card Title</CardTitle>\n        <CardImage src="/images/500x500.png" alt="gradient placeholder" />\n        <CardBlock>\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis\n          pretium massa. Aliquam erat volutpat. Nulla facilisi.\n        </CardBlock>\n      </Card>\n    </DemoLayout>'
});

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DemoLayout__ = __webpack_require__(40);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







var CustomContent = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('div', function (_ref) {
  var theme = _ref.theme;
  return {
    backgroundColor: theme.color_gray_20,
    margin: theme.space_stack_md + ' 0',
    padding: theme.space_inset_lg,

    '&:last-child': {
      borderRadius: '0 0 ' + theme.borderRadius_1 + ' ' + theme.borderRadius_1,
      marginBottom: '-' + theme.space_stack_md
    }
  };
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'children',
  title: 'Arbitrary Children',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'A Card will render any children.\n\nFor best results, please ensure content matches the top/bottom margin and left/right padding of the other `<Card*/>` components, or use [CardBlock](\'./card-block\').',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */], Card: __WEBPACK_IMPORTED_MODULE_3__Card__["d" /* default */], CardTitle: __WEBPACK_IMPORTED_MODULE_3__Card__["c" /* CardTitle */], CustomContent: CustomContent, DemoLayout: __WEBPACK_IMPORTED_MODULE_4__components_DemoLayout__["a" /* default */] },
  source: '\n    <DemoLayout>\n      <Card>\n        <CardTitle>Card title</CardTitle>\n        <CustomContent>\n          <Button fullWidth>Button</Button>\n        </CustomContent>\n      </Card>\n    </DemoLayout>'
});

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__ = __webpack_require__(40);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'clickable',
  title: 'Clickable',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'If an `onClick` callback is provided, the entire Card becomes clickable and keyboard actionable.\nUse this feature when only one action can be taken per Card.\nThis simplifies the interface by not requiring an extra [Button](../button).',
  scope: { Card: __WEBPACK_IMPORTED_MODULE_1__Card__["d" /* default */], CardBlock: __WEBPACK_IMPORTED_MODULE_1__Card__["a" /* CardBlock */], CardTitle: __WEBPACK_IMPORTED_MODULE_1__Card__["c" /* CardTitle */], DemoLayout: __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__["a" /* default */] },
  source: '\n    <DemoLayout>\n      <Card onClick={event => console.log(event)}>\n        <CardTitle>Card Title</CardTitle>\n        <CardBlock>\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis\n          pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate\n          interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque.\n        </CardBlock>\n      </Card>\n    </DemoLayout>'
});

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card__ = __webpack_require__(26);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('div', {
  alignItems: 'flex-start',
  display: 'flex',
  flexWrap: 'wrap',
  fontSize: __WEBPACK_IMPORTED_MODULE_1__themes__["g" /* mineralTheme */].fontSize_base,
  margin: '-2em',

  '& > *': {
    flex: '1 1 25%',
    margin: '2em',
    maxWidth: '30em'
  },

  '& img': {
    width: '100%'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'order',
  title: 'Order of Sections',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'There is no \'one true way\' to lay out a Card. Cards are flexible enough to accept different component arrangements.',
  scope: { Card: __WEBPACK_IMPORTED_MODULE_2__Card__["d" /* default */], CardBlock: __WEBPACK_IMPORTED_MODULE_2__Card__["a" /* CardBlock */], CardImage: __WEBPACK_IMPORTED_MODULE_2__Card__["b" /* CardImage */], CardTitle: __WEBPACK_IMPORTED_MODULE_2__Card__["c" /* CardTitle */], DemoLayout: DemoLayout },
  source: '\n    <DemoLayout>\n      <Card>\n        <CardImage src="/images/500x500.png" alt="gradient image" />\n        <CardTitle minor>Card Title</CardTitle>\n        <CardBlock>\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis\n          pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate\n          interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque.\n        </CardBlock>\n      </Card>\n\n      <Card>\n        <CardTitle>Card Title</CardTitle>\n        <CardImage src="/images/500x500.png" alt="gradient image" />\n        <CardBlock>\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis\n          pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate\n          interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque.\n        </CardBlock>\n      </Card>\n\n      <Card>\n        <CardTitle>Card Title</CardTitle>\n        <CardBlock>\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis\n          pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate\n          interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque.\n        </CardBlock>\n        <CardImage src="/images/690x690.png" alt="gradient image" />\n      </Card>\n    </DemoLayout>'
});

/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardBlock__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arbitraryChildren__ = __webpack_require__(1592);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_0__cardBlock__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__arbitraryChildren__["a" /* default */]]);

/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DemoLayout__ = __webpack_require__(40);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var CardBlock = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_2__Card__["a" /* CardBlock */], function (_ref) {
  var theme = _ref.theme;
  return {
    position: 'relative',

    '&::before': {
      borderColor: theme.color_theme_10,
      borderStyle: 'solid',
      borderWidth: Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* getNormalizedValue */])(theme.space_inset_md, theme.fontSize_prose) + ' ' + Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* getNormalizedValue */])(theme.space_inset_lg, theme.fontSize_prose),
      bottom: '-' + Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* getNormalizedValue */])(theme.space_inset_md, theme.fontSize_prose),
      content: '""',
      left: 0,
      position: 'absolute',
      right: 0,
      top: '-' + Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* getNormalizedValue */])(theme.space_inset_md, theme.fontSize_prose)
    }
  };
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'consistent-spacing',
  title: 'Example',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'CardBlock provides uniform top/bottom margin & left/right padding (highlighted here in light blue).',
  scope: { Card: __WEBPACK_IMPORTED_MODULE_2__Card__["d" /* default */], CardBlock: CardBlock, CardTitle: __WEBPACK_IMPORTED_MODULE_2__Card__["c" /* CardTitle */], DemoLayout: __WEBPACK_IMPORTED_MODULE_3__components_DemoLayout__["a" /* default */] },
  source: '\n    <DemoLayout>\n      <Card>\n        <CardTitle>Card Title</CardTitle>\n        <CardBlock>\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis\n          pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate\n          interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque.\n        </CardBlock>\n      </Card>\n    </DemoLayout>'
});

/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DemoLayout__ = __webpack_require__(40);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







var CustomContent = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('div', function (_ref) {
  var theme = _ref.theme;
  return {
    backgroundColor: theme.color_gray_20,
    padding: theme.space_stack_md + ' 0'
  };
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'children',
  title: 'Arbitrary Children',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'A Card will render any children.\n\nFor best results, please ensure content matches the top/bottom margin and left/right padding of the other `<Card*/>` components, or use [CardBlock](\'./card-block\').',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */], Card: __WEBPACK_IMPORTED_MODULE_3__Card__["d" /* default */], CardBlock: __WEBPACK_IMPORTED_MODULE_3__Card__["a" /* CardBlock */], CardTitle: __WEBPACK_IMPORTED_MODULE_3__Card__["c" /* CardTitle */], CustomContent: CustomContent, DemoLayout: __WEBPACK_IMPORTED_MODULE_4__components_DemoLayout__["a" /* default */] },
  source: '\n    <DemoLayout>\n      <Card>\n        <CardTitle>Card Title</CardTitle>\n        <CardBlock>\n          <CustomContent>\n            <Button fullWidth>Button</Button>\n          </CustomContent>\n        </CardBlock>\n      </Card>\n    </DemoLayout>'
});

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withImage__ = __webpack_require__(1594);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_0__withImage__["a" /* default */]]);

/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__ = __webpack_require__(40);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'with-image',
  title: 'Example',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'CardImages should provide an `alt` attribute.',
  scope: { Card: __WEBPACK_IMPORTED_MODULE_1__Card__["d" /* default */], CardBlock: __WEBPACK_IMPORTED_MODULE_1__Card__["a" /* CardBlock */], CardImage: __WEBPACK_IMPORTED_MODULE_1__Card__["b" /* CardImage */], CardTitle: __WEBPACK_IMPORTED_MODULE_1__Card__["c" /* CardTitle */], DemoLayout: __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__["a" /* default */] },
  source: '\n    <DemoLayout>\n      <Card>\n        <CardImage src="/images/500x281.png" alt="gradient image" />\n        <CardTitle minor>Minor Card Title</CardTitle>\n        <CardBlock>\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis\n          pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate\n          interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque.\n        </CardBlock>\n      </Card>\n    </DemoLayout>'
});

/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__complexTitle__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__withMetaInfo__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withSubtitle__ = __webpack_require__(1598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__minor__ = __webpack_require__(1599);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_2__withSubtitle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__complexTitle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__minor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__withMetaInfo__["a" /* default */]]);

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DemoLayout__ = __webpack_require__(40);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'complex-title',
  title: 'Complex Title and Subtitle',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'Both the title and subtitle can contain a simple string or any HTML/React elements.',
  scope: { Card: __WEBPACK_IMPORTED_MODULE_2__Card__["d" /* default */], CardTitle: __WEBPACK_IMPORTED_MODULE_2__Card__["c" /* CardTitle */], CardBlock: __WEBPACK_IMPORTED_MODULE_2__Card__["a" /* CardBlock */], createStyledComponent: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */], DemoLayout: __WEBPACK_IMPORTED_MODULE_3__components_DemoLayout__["a" /* default */] },
  source: '\n    () => {\n      const Status = createStyledComponent(\'span\', {\n        color: \'red\',\n        fontSize: \'0.6em\',\n\n        \'&:before\': {\n          backgroundColor: \'red\',\n          borderRadius: \'0.8em\',\n          content: \'""\',\n          display: \'inline-block\',\n          height: \'0.8em\',\n          marginRight: \'0.5em\',\n          position: \'relative\',\n          top: \'0.1em\',\n          width: \'0.8em\'\n        }\n      });\n\n      return (\n        <DemoLayout>\n          <Card>\n            <CardTitle subtitle={<em>Subtitle here</em>}>\n              Card Title<br />\n              <Status>Status alert</Status>\n            </CardTitle>\n            <CardBlock>\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis\n              pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate\n              interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque.\n            </CardBlock>\n          </Card>\n        </DemoLayout>\n      );\n    }'
});

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__ = __webpack_require__(40);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'meta',
  title: 'With Meta Information',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'When you must provide information that doesn\'t belong to every Card in a set, supply it as `meta` information.\nThe information will display above the title, which will automatically display in the minor style.\nIf information is in every card in the set, consider using the `subtitle` attribute.',
  scope: { Card: __WEBPACK_IMPORTED_MODULE_1__Card__["d" /* default */], CardBlock: __WEBPACK_IMPORTED_MODULE_1__Card__["a" /* CardBlock */], CardTitle: __WEBPACK_IMPORTED_MODULE_1__Card__["c" /* CardTitle */], DemoLayout: __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__["a" /* default */] },
  source: '\n    <DemoLayout>\n      <Card>\n        <CardTitle meta="Meta Information for This Card">Card Title</CardTitle>\n        <CardBlock>\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis\n          pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate\n          interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque.\n        </CardBlock>\n      </Card>\n    </DemoLayout>'
});

/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__ = __webpack_require__(40);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'subtitle',
  title: 'Example',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'In addition to a title, a Card can display a subtitle.',
  scope: { Card: __WEBPACK_IMPORTED_MODULE_1__Card__["d" /* default */], CardBlock: __WEBPACK_IMPORTED_MODULE_1__Card__["a" /* CardBlock */], CardTitle: __WEBPACK_IMPORTED_MODULE_1__Card__["c" /* CardTitle */], DemoLayout: __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__["a" /* default */] },
  source: '\n    <DemoLayout>\n      <Card>\n        <CardTitle subtitle="Subtitle here">Card Title</CardTitle>\n        <CardBlock>\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis\n          pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate\n          interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque.\n        </CardBlock>\n      </Card>\n    </DemoLayout>'
});

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Card__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__ = __webpack_require__(40);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'minor-title',
  title: 'Minor Title',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'The Card title can be rendered in a minor style. Use this style whenever placing a CardTitle immediately after a CardImage.',
  scope: { Card: __WEBPACK_IMPORTED_MODULE_1__Card__["d" /* default */], CardBlock: __WEBPACK_IMPORTED_MODULE_1__Card__["a" /* CardBlock */], CardImage: __WEBPACK_IMPORTED_MODULE_1__Card__["b" /* CardImage */], CardTitle: __WEBPACK_IMPORTED_MODULE_1__Card__["c" /* CardTitle */], DemoLayout: __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__["a" /* default */] },
  source: '\n    <DemoLayout>\n      <Card>\n        <CardImage src="/images/500x200.png" alt="gradient image" />\n        <CardTitle minor>Minor Card Title</CardTitle>\n        <CardBlock>\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis\n          pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate\n          interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque.\n        </CardBlock>\n      </Card>\n    </DemoLayout>'
});

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

module.exports = {
	"description": "Cards are used to group conceptually related content.\nCards represent a gateway to more detailed information in another app view.\nYou can use Cards to provide detail about a feature in your app, or to represent data with which your users can interact.",
	"methods": [],
	"props": {
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": true,
			"description": "Content of the Card. Can be anything, but see [CardBlock](../card-block), [CardImage](../card-image), and [CardTitle](../card-title)."
		},
		"onClick": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(event: SyntheticEvent<>) => void",
				"signature": {
					"arguments": [
						{
							"name": "event",
							"type": {
								"name": "SyntheticEvent",
								"elements": [],
								"raw": "SyntheticEvent<>"
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "Called with the click event"
		}
	}
}

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

module.exports = {
	"description": "CardBlock is used to normalize font sizes for content and to provide consistent margins and padding.",
	"methods": []
}

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

module.exports = {
	"description": "CardImage renders images full-bleed inside of a [Card](../card).\nUse CardImage to display static media.",
	"methods": []
}

/***/ }),
/* 1603 */
/***/ (function(module, exports) {

module.exports = {
	"description": "CardTitle displays a Card title and an optional subtitle.\nYou can put CardTitle in any order in relation to other root components of [Card]('./card').",
	"methods": [],
	"props": {
		"meta": {
			"flowType": {
				"name": "string"
			},
			"required": false,
			"description": "Information displayed above the title"
		},
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": true,
			"description": "Title of the Card"
		},
		"minor": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Displays the title in a less important style"
		},
		"subtitle": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "Subtitle displayed under the title"
		}
	}
}

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card__ = __webpack_require__(26);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var CardList = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', function (_ref) {
  var theme = _ref.theme;
  return {
    '& > div': {
      marginBottom: theme.space_stack_sm
    }
  };
});

/* harmony default export */ __webpack_exports__["a"] = ({
  card: [{
    type: 'do',
    title: 'Use a Card',
    example: _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["b" /* CardImage */], {
      src: '/images/500x281.png',
      alt: 'gradient placeholder'
    }), _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["c" /* CardTitle */], {
      minor: true,
      subtitle: 'Card subtitle'
    }, void 0, 'Card Title'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["a" /* CardBlock */], {}, void 0, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis pretium massa. Aliquam erat volutpat. Nulla facilisi.')),
    description: 'Use a Card when you have different kinds of related content representing one data object.'
  }, {
    type: 'dont',
    title: 'use a Card when a list item would do',
    example: _jsx(CardList, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["c" /* CardTitle */], {}, void 0, 'Friedrich Mohs')), _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["c" /* CardTitle */], {}, void 0, 'Marie Tharp')), _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["c" /* CardTitle */], {}, void 0, 'Alfred Wegener'))),
    description: 'Cards group elements. Using a List for single pieces of information is a more efficent design.'
  }],
  cardBlock: [{
    type: 'do',
    title: 'use the CardBlock component',
    example: _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["c" /* CardTitle */], {}, void 0, 'Card Title'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["a" /* CardBlock */], {}, void 0, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate interdum sollicitudin.')),
    description: 'Use the CardBlock component to add formatting to content in your Cards.'
  }, {
    type: 'dont',
    title: 'forget to use a CardBlock',
    example: _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["c" /* CardTitle */], {
      minor: true
    }, void 0, 'Minor Card Title'), _jsx('p', {}, void 0, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate interdum sollicitudin.'), _jsx('img', {
      src: '/images/200x200.png',
      alt: 'gradient placeholder'
    })),
    description: 'Content placed into a Card outside the CardBlock will not have formatting applied.'
  }],
  cardImage: [{
    type: 'do',
    title: 'use the CardImage component',
    example: _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["b" /* CardImage */], {
      src: '/images/690x690.png',
      alt: 'gradient placeholder'
    }), _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["c" /* CardTitle */], {
      minor: true
    }, void 0, 'Minor Card Title'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["a" /* CardBlock */], {}, void 0, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate interdum sollicitudin.')),
    description: 'Use the CardImage component with `src` and `alt` attributes.'
  }, {
    type: 'dont',
    title: 'put multiple images loose in a Card',
    example: _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["d" /* default */], {}, void 0, _jsx('img', {
      src: '/images/125x125.png',
      alt: 'gradient placeholder'
    }), _jsx('img', {
      src: '/images/125x125.png',
      alt: 'gradient placeholder'
    }), _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["c" /* CardTitle */], {
      minor: true
    }, void 0, 'Minor Card Title'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["a" /* CardBlock */], {}, void 0, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate interdum sollicitudin.')),
    description: 'Using regular `<img />` tags will result in unformatted content.'
  }],
  cardTitle: [{
    type: 'do',
    title: 'use the CardTitle component',
    example: _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["c" /* CardTitle */], {
      minor: true
    }, void 0, 'Minor Card Title'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["a" /* CardBlock */], {}, void 0, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate interdum sollicitudin.')),
    description: 'Use the CardTitle component to add headings to your Cards.'
  }, {
    type: 'dont',
    title: 'use custom heading sizes',
    example: _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["d" /* default */], {}, void 0, _jsx('h1', {}, void 0, 'Heading element'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Card__["a" /* CardBlock */], {}, void 0, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis pretium massa. Aliquam erat volutpat.')),
    description: 'Regular `<h1>, <h2>` etc. will not be formatted automatically.'
  }]
});

/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropdown_DropdownContent__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bestPractices__ = __webpack_require__(1620);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var doc = __webpack_require__(1621);

/* harmony default export */ __webpack_exports__["a"] = ({
  bestPractices: __WEBPACK_IMPORTED_MODULE_2__bestPractices__["a" /* default */],
  componentTheme: __WEBPACK_IMPORTED_MODULE_0__Dropdown_DropdownContent__["a" /* componentTheme */],
  doc: doc,
  examples: __WEBPACK_IMPORTED_MODULE_1__examples__["a" /* default */],
  slug: 'dropdown',
  title: 'Dropdown',
  whenHowToUse: 'Dropdowns can change their available MenuItems depending on the state of your app.\nYou can remove options that don\'t make sense in the current context, or show them as `disabled` if certain conditions need to be met.\n\nUse Dropdown for extra functionality, not for primary actions, since the options are hidden from the user until interaction.\nEnsure that option labeling clearly describes the action the user can take.'
});

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Menu;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(18);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var Root = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', {}, {
  displayName: 'Menu',
  includeStyleReset: true
});

/**
 * A Menu presents a list of options representing actions or navigation.
 * Composed of [MenuItems](../menu-item), Menu is usually combined with [Popover](../popover) to create a [Dropdown](../dropdown).
 *
 * Menus are great for collecting actions in one place so your users don't need to scan the entire document to find a feature.
 */
function Menu(_ref) {
  var children = _ref.children,
      data = _ref.data,
      getItemProps = _ref.getItemProps,
      restProps = _objectWithoutProperties(_ref, ['children', 'data', 'getItemProps']);

  var rootProps = _extends({}, restProps);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    data ? renderFromData(data, getItemProps) : children
  );
}

function renderFromData(data, getItemProps) {
  return data.reduce(function (acc, group, groupIndex) {
    acc.groups.push(renderMenuGroup(group, groupIndex, getItemProps, acc));
    return acc;
  }, { groups: [], itemIndex: 0 }).groups;
}

function renderMenuGroup(group, groupIndex, getItemProps, acc) {
  return group.items && group.items.length ? _jsx(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* MenuGroup */], {
    title: group.title
  }, groupIndex, group.items.map(function (item, itemIndex) {
    return renderMenuItem(item, itemIndex, getItemProps, acc);
  })) : null;
}

function renderMenuItem(item, itemIndex, getItemProps, acc) {
  if (item.divider) {
    return _jsx(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* MenuDivider */], {}, itemIndex);
  } else {
    var index = acc.itemIndex++; // Excludes MenuDividers

    var _text = item.text,
        restItemProps = _objectWithoutProperties(item, ['text']);

    var itemProps = getItemProps ? getItemProps(_extends({}, restItemProps, {
      item: item
    }), { index: index, item: item }) : _extends({}, restItemProps, {
      item: item
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__index__["c" /* MenuItem */],
      _extends({ key: itemIndex }, itemProps),
      _text
    );
  }
}

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDanger;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {
  fill: 'none',
  fillRule: 'evenodd'
}, void 0, _jsx('path', {
  d: 'M0 0h24v24H0'
}), _jsx('path', {
  d: 'M3.94 19.49h16.118c.552 0 1-.447 1-1 0-.174-.046-.347-.134-.498l-8.06-13.99c-.274-.48-.886-.644-1.364-.368-.153.088-.28.214-.368.367L3.074 17.993c-.276.478-.112 1.09.367 1.365.153.088.325.134.5.134zM12 17c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1zm1-3.503h-2v-5h2v5z',
  fill: 'currentColor',
  fillRule: 'nonzero'
}));

function IconDanger(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconDanger.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSuccess;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {
  fill: 'none',
  fillRule: 'evenodd'
}, void 0, _jsx('path', {
  d: 'M0 0h24v24H0'
}), _jsx('path', {
  d: 'M12 3c4.968 0 9 4.032 9 9s-4.032 9-9 9-9-4.032-9-9 4.032-9 9-9zm-4.247 8.445L6.5 12.698l3.838 3.838 7.198-7.198-1.253-1.254-5.945 5.945-2.585-2.585z',
  fill: 'currentColor',
  fillRule: 'nonzero'
}));

function IconSuccess(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconSuccess.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWarning;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {
  fill: 'none',
  fillRule: 'evenodd'
}, void 0, _jsx('path', {
  d: 'M0 0h24v24H0'
}), _jsx('path', {
  d: 'M13.414 2.718l7.868 7.868c.78.78.78 2.047 0 2.828l-7.868 7.868c-.78.78-2.047.78-2.828 0l-7.868-7.868c-.78-.78-.78-2.047 0-2.828l7.868-7.868c.78-.78 2.047-.78 2.828 0zM12 17c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1zm1-3.958V8h-2v5.042h2z',
  fill: 'currentColor',
  fillRule: 'nonzero'
}));

function IconWarning(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["b" /* default */],
    iconProps,
    _ref
  );
}
IconWarning.propTypes = {
  size: __webpack_require__(0).oneOfType([__webpack_require__(0).string, __webpack_require__(0).oneOf(['small']), __webpack_require__(0).oneOf(['medium']), __webpack_require__(0).oneOf(['large'])]),
  color: __webpack_require__(0).string,
  rtl: __webpack_require__(0).bool,
  title: __webpack_require__(0).string
};

/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controlled__ = __webpack_require__(1611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__disabled__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dropdown__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__onOpenClose__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__placement__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scrolling__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__wide__ = __webpack_require__(1619);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */










/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_3__dropdown__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__data__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__wide__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__placement__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__scrolling__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__onOpenClose__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__disabled__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__controlled__["a" /* default */]]);

/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dropdown__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Menu_components_menuData__ = __webpack_require__(78);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('div', {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between'
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'controlled',
  description: 'Dropdown controls its own state by default,\nand can optionally be managed by the application as a controlled component through the `isOpen` prop.\nCallbacks for `onOpen` and `onClose` are also provided.',
  title: 'Controlled',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_3__Button__["a" /* default */], Component: __WEBPACK_IMPORTED_MODULE_0_react__["Component"], data: __WEBPACK_IMPORTED_MODULE_5__Menu_components_menuData__["a" /* default */], DemoLayout: DemoLayout, Dropdown: __WEBPACK_IMPORTED_MODULE_4__Dropdown__["a" /* default */], findDOMNode: __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"] },
  source: '\n    class App extends Component {\n      constructor(props) {\n        super(props);\n\n        this.state = {\n          isOpen: false\n        };\n\n        this.onOpen = this.onOpen.bind(this);\n        this.onClose = this.onClose.bind(this);\n        this.toggleDropdown = this.toggleDropdown.bind(this);\n      }\n\n      onOpen(event) {\n        this.setState({ isOpen: true });\n      }\n\n      onClose(event) {\n        // Prevent extra call to toggleDropdown when clicking the controlling button.\n        // Also avoid interactions with other dropdowns.\n        const demoLayoutNode = findDOMNode(this.demoLayout);\n        if (\n          !event.nativeEvent &&\n          demoLayoutNode &&\n          demoLayoutNode.contains(event.target)\n        ) {\n          event.stopImmediatePropagation();\n        }\n\n        this.setState({ isOpen: false });\n      }\n\n\n      toggleDropdown(event) {\n        if (this.state.isOpen) {\n          this.onClose(event);\n        } else {\n          this.onOpen(event);\n        }\n      }\n\n      render() {\n        const label = this.state.isOpen ? \'Close Dropdown\' : \'Open Dropdown\';\n        return (\n          <DemoLayout ref={node => { this.demoLayout = node }}>\n            <Dropdown\n              data={data}\n              isOpen={this.state.isOpen}\n              onOpen={this.onOpen}\n              onClose={this.onClose}>\n              <Button>{label}</Button>\n            </Dropdown>\n            <Button onClick={this.toggleDropdown}>{label}</Button>\n          </DemoLayout>\n        );\n      }\n    }'
});

/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Popover__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DropdownContent__ = __webpack_require__(178);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/**
 * Dropdown provides a transitory list of actions that appears upon user interaction with a trigger.
 */
var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      highlightedIndex: null,
      isOpen: Boolean(_this.props.defaultIsOpen)
    }, _this._isMounted = false, _this.id = 'dropdown-' + Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* generateId */])(), _this.getTriggerProps = function (props) {
      var contentId = _this.id + '-dropdownContent';
      var isOpen = props.isOpen;


      return _extends({}, props, {
        'aria-activedescendant': isOpen ? _this.selectedItemId || contentId + '-menu' : undefined,
        'aria-haspopup': true,
        contentId: contentId,
        onKeyDown: _this.onTriggerKeyDown
      });
    }, _this.getItems = function () {
      return _this.props.data.reduce(function (acc, group) {
        return group.items && group.items.length ? acc.concat(group.items.filter(function (item) {
          return !item.divider;
        })) : acc;
      }, []);
    }, _this.onTriggerKeyDown = function (event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        _this.setState(function (prevState) {
          return {
            highlightedIndex: prevState.highlightedIndex === null || prevState.highlightedIndex === _this.getItems().length - 1 ? 0 : prevState.highlightedIndex + 1
          };
        });
        _this.open(event);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        _this.setState(function (prevState) {
          return {
            highlightedIndex: prevState.highlightedIndex === null || prevState.highlightedIndex === 0 ? _this.getItems().length - 1 : prevState.highlightedIndex - 1
          };
        });
        _this.open(event);
      } else if (event.key === 'Enter' || event.key === ' ') {
        var _ref2 = _this.isControlled() ? _this.props : _this.state,
            _isOpen = _ref2.isOpen;

        if (!_isOpen || !_this._isMounted || !_this.selectedItemId) {
          return;
        }

        event.preventDefault(); // Prevent from reopening due to event on trigger

        var selectedItemNode = global.document.getElementById(_this.selectedItemId);
        selectedItemNode && selectedItemNode.click();
      }
    }, _this.open = function (event) {
      if (_this.isControlled()) {
        _this.openActions(event);
      } else {
        _this.setState(function () {
          return { isOpen: true };
        }, function () {
          _this.openActions(event);
        });
      }
    }, _this.openActions = function (event) {
      _this.props.onOpen && _this.props.onOpen(event);
    }, _this.close = function (event) {
      _this.setState({ highlightedIndex: null });

      if (_this.isControlled()) {
        _this.closeActions(event);
      } else {
        _this.setState(function () {
          return { isOpen: false };
        }, function () {
          _this.closeActions(event);
        });
      }
    }, _this.closeActions = function (event) {
      _this.props.onClose && _this.props.onClose(event);
    }, _this.isControlled = function () {
      return _this.props.isOpen !== undefined;
    }, _this.getItemProps = function (props, scope) {
      var index = scope.index,
          item = scope.item;


      return _extends({}, props, {
        'aria-disabled': props.disabled,
        id: _this.id + '-menuItem-' + index,
        isHighlighted: _this.state.highlightedIndex === index,
        onClick: _this.itemOnClick.bind(null, item),
        role: 'menuitem',
        tabIndex: null // Unset tabIndex because we use arrow keys to navigate instead
      });
    }, _this.itemOnClick = function (item, event) {
      var onClick = item.onClick;


      onClick && onClick(event);
      _this.close(event);
      _this.focusTrigger();
    }, _this.focusTrigger = function () {
      var node = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this.dropdownTrigger); // eslint-disable-line react/no-find-dom-node
      if (node && node.firstChild && node.firstChild instanceof HTMLElement) {
        node.firstChild.focus();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          data = _props.data,
          modifiers = _props.modifiers,
          placement = _props.placement,
          wide = _props.wide,
          restProps = _objectWithoutProperties(_props, ['children', 'data', 'modifiers', 'placement', 'wide']);

      var _ref3 = this.isControlled() ? this.props : this.state,
          isOpen = _ref3.isOpen;

      if (isOpen) {
        this.selectedItemId = this.state.highlightedIndex === null ? undefined : this.id + '-menuItem-' + this.state.highlightedIndex;
      }

      var dropdownContentProps = {
        data: data,
        id: this.id + '-dropdownContent',
        getItemProps: this.getItemProps,
        modifiers: modifiers,
        placement: placement,
        wide: wide
      };

      var rootProps = _extends({
        id: this.id
      }, restProps, {
        content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DropdownContent__["b" /* default */], dropdownContentProps),
        getTriggerProps: this.getTriggerProps,
        isOpen: isOpen,
        onClose: this.close,
        onOpen: this.open,
        triggerRef: function triggerRef(node) {
          _this2.dropdownTrigger = node;
        },
        wrapContent: false
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__Popover__["a" /* default */],
        rootProps,
        children
      );
    }
  }]);

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Dropdown.propTypes = {
  children: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node).isRequired : __webpack_require__(0).any.isRequired,
  defaultIsOpen: __webpack_require__(0).bool,
  disabled: __webpack_require__(0).bool,
  data: __webpack_require__(0).arrayOf(__webpack_require__(0).shape({
    items: __webpack_require__(0).arrayOf(__webpack_require__(0).shape({
      iconEnd: typeof React$Element === 'function' ? __webpack_require__(0).instanceOf(React$Element) : __webpack_require__(0).any,
      iconStart: typeof React$Element === 'function' ? __webpack_require__(0).instanceOf(React$Element) : __webpack_require__(0).any,
      disabled: __webpack_require__(0).bool,
      divider: __webpack_require__(0).bool,
      onClick: __webpack_require__(0).func,
      render: __webpack_require__(0).func,
      secondaryText: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node) : __webpack_require__(0).any,
      text: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node) : __webpack_require__(0).any,
      variant: __webpack_require__(0).oneOf(['regular', 'danger', 'success', 'warning'])
    })).isRequired,
    title: typeof React$Node === 'function' ? __webpack_require__(0).instanceOf(React$Node) : __webpack_require__(0).any
  })).isRequired,
  isOpen: __webpack_require__(0).bool,
  modifiers: __webpack_require__(0).object,
  onClose: __webpack_require__(0).func,
  onOpen: __webpack_require__(0).func,
  placement: __webpack_require__(0).oneOf(['bottom-end', 'bottom-start', 'left-end', 'left-start', 'right-end', 'right-start', 'top-end', 'top-start']),
  wide: __webpack_require__(0).bool
};
Dropdown.defaultProps = {
  placement: 'bottom-start'
};
/* harmony default export */ __webpack_exports__["a"] = (Dropdown);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(35)))

/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon_IconCloud__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dropdown__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Menu_components_CustomRender__ = __webpack_require__(284);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'data',
  title: 'Data-Driven',
  description: 'Dropdown content can also be defined by an array of data, with the structure shown in the code example below.\nObject properties in the `items` array(s) will be passed on to the [MenuItem](../menu-item).\n\nA new [MenuGroup](../menu-group) will be created for each array object that has an `items` property defined.\n[MenuDividers](../menu-divider) are created simply by passing `{divider: true}` as an item.',
  scope: {
    Button: __WEBPACK_IMPORTED_MODULE_0__Button__["a" /* default */],
    CustomRender: __WEBPACK_IMPORTED_MODULE_3__Menu_components_CustomRender__["a" /* default */],
    Dropdown: __WEBPACK_IMPORTED_MODULE_2__Dropdown__["a" /* default */],
    IconCloud: __WEBPACK_IMPORTED_MODULE_1__Icon_IconCloud__["a" /* default */]
  },
  source: '\n    () => {\n      const data = [\n        {\n          items: [\n            {\n              text: \'Menu item with onClick\',\n              onClick: event => { console.log(event); }\n            },\n            {\n              text: \'Menu item\',\n              secondaryText: \'Secondary text\'\n            }\n          ]\n        },\n        {\n          title: \'Group Title\',\n          items: [\n            {\n              text: \'Icon at start\',\n              iconStart: <IconCloud />\n            },\n            {\n              text: \'Icon at end\',\n              iconEnd: <IconCloud />\n            },\n            {\n              divider: true\n            },\n            {\n              text: \'Danger variant\',\n              variant: \'danger\' // \'danger\' | \'success\' | \'warning\'\n            },\n            {\n              text: \'Disabled menu item\',\n              onClick: () => { console.log(\'onClick is not triggered for disabled MenuItems\'); },\n              disabled: true\n            },\n            {\n              text: \'Custom render\',\n              avatar: \'/images/215x210_avatar.png\',\n              href: \'/components/menu-item#custom-render\', // <-- Details here\n              render: CustomRender\n            }\n          ]\n        }\n      ];\n\n      return (\n        <Dropdown data={data}>\n          <Button>Menu</Button>\n        </Dropdown>\n      );\n    }'
});

/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dropdown__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Menu_components_menuData__ = __webpack_require__(78);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'disabled',
  title: 'Disabled',
  description: 'Disable the Dropdown and its trigger.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_0__Button__["a" /* default */], data: __WEBPACK_IMPORTED_MODULE_2__Menu_components_menuData__["a" /* default */], Dropdown: __WEBPACK_IMPORTED_MODULE_1__Dropdown__["a" /* default */] },
  source: '\n    <Dropdown data={data} disabled>\n      <Button>Menu</Button>\n    </Dropdown>'
});

/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dropdown__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Menu_components_menuData__ = __webpack_require__(78);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'basic',
  title: 'Example',
  description: 'Placement is relative to the trigger.\nDropdowns will automatically change position relative to the trigger depending on viewport constraints.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_0__Button__["a" /* default */], data: __WEBPACK_IMPORTED_MODULE_2__Menu_components_menuData__["a" /* default */], Dropdown: __WEBPACK_IMPORTED_MODULE_1__Dropdown__["a" /* default */] },
  source: '\n    <Dropdown data={data}>\n      <Button>Menu</Button>\n    </Dropdown>'
});

/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dropdown__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Menu_components_menuData__ = __webpack_require__(78);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'on-open-close',
  hideFromProd: true,
  title: 'onOpen and onClose',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_0__Button__["a" /* default */], data: __WEBPACK_IMPORTED_MODULE_2__Menu_components_menuData__["a" /* default */], Dropdown: __WEBPACK_IMPORTED_MODULE_1__Dropdown__["a" /* default */] },
  source: '\n    () => {\n      const onOpen = () => {\n        console.log(\'Opened\');\n      };\n\n      const onClose = () => {\n        console.log(\'Closed\');\n      };\n\n      return (\n        <Dropdown data={data} onOpen={onOpen} onClose={onClose}>\n          <Button>Menu</Button>\n        </Dropdown>\n      );\n    }'
});

/***/ }),
/* 1617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dropdown__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Menu_components_menuData__ = __webpack_require__(78);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', {
  height: '400px',
  position: 'relative',

  '> div': {
    left: '50%',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'placement',
  title: 'Placement',
  description: 'The `placement` prop determines the initial placement of the Dropdown content relative to the trigger.\nThe Dropdown will react to viewport edges and scrolling.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_0__Button__["a" /* default */], data: __WEBPACK_IMPORTED_MODULE_3__Menu_components_menuData__["a" /* default */], DemoLayout: DemoLayout, Dropdown: __WEBPACK_IMPORTED_MODULE_2__Dropdown__["a" /* default */] },
  source: '\n    <DemoLayout>\n      <Dropdown\n        placement="bottom-start"\n        data={data}\n        isOpen>\n        <Button>Menu</Button>\n      </Dropdown>\n    </DemoLayout>'
});

/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dropdown__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popover_components_ScrollBox__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Menu_components_menuData__ = __webpack_require__(78);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'scrolling-container',
  title: 'Scrolling container',
  description: 'Dropdown will attempt to keep its menu visible in an `overflow: scroll` container.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_0__Button__["a" /* default */], data: __WEBPACK_IMPORTED_MODULE_3__Menu_components_menuData__["a" /* default */], Dropdown: __WEBPACK_IMPORTED_MODULE_1__Dropdown__["a" /* default */], ScrollParent: __WEBPACK_IMPORTED_MODULE_2__Popover_components_ScrollBox__["a" /* default */] },
  source: '\n    <ScrollParent height={430}>\n      <Dropdown\n        data={data}\n        isOpen\n        placement="bottom-start">\n        <Button>Menu</Button>\n      </Dropdown>\n    </ScrollParent>\n  '
});

/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dropdown__ = __webpack_require__(49);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('div', {
  height: '210px'
});

var data = [{
  items: [{
    text: 'Light years star stuff'
  }, {
    text: 'Harvesting star light citizens of distant epochs'
  }, {
    text: 'Encyclopaedia galactica vastness is bearable'
  }, {
    text: 'Shores of the cosmic ocean'
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'wide',
  title: 'Wide',
  description: 'Dropdown can display a wider menu (~50% wider).\nUse this when there are MenuItems that wrap and look odd.\nMake sure you have enough room for the wider Menu on the devices you\'re supporting.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], data: data, DemoLayout: DemoLayout, Dropdown: __WEBPACK_IMPORTED_MODULE_2__Dropdown__["a" /* default */] },
  source: '\n    <DemoLayout>\n      <Dropdown wide isOpen data={data}>\n        <Button>Menu</Button>\n      </Dropdown>\n    </DemoLayout>'
});

/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_IconMenu__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dropdown__ = __webpack_require__(49);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var data = [{ items: [{ text: 'Settings' }, { text: 'Help' }, { text: 'Log out' }] }];

var shortData = [{ items: [{ text: 'Reload' }] }];

var navData = [{
  items: [{ text: 'Preferences' }, { text: 'Account' }, { text: 'About us' }, { text: 'Pricing' }, { text: 'Community' }, { text: 'Help' }, { text: 'Log in' }]
}];

/* harmony default export */ __webpack_exports__["a"] = ([{
  type: 'do',
  title: 'keep available options in context',
  example: _jsx(__WEBPACK_IMPORTED_MODULE_3__Dropdown__["a" /* default */], {
    data: data
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], {
    primary: true
  }, void 0, 'Account')),
  description: 'Dropdown options should be related to the trigger so users can find actions easily.'
}, {
  type: 'dont',
  title: 'use less than 2 elements',
  example: _jsx(__WEBPACK_IMPORTED_MODULE_3__Dropdown__["a" /* default */], {
    data: shortData
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], {
    primary: true
  }, void 0, 'File')),
  description: 'Presenting a Dropdown with only one option is unnecessary UI.\nIf your app renders only one option depending on state, consider a different layout for that special case.'
}, {
  type: 'dont',
  title: 'use Dropdown as primary navigation',
  example: _jsx(__WEBPACK_IMPORTED_MODULE_3__Dropdown__["a" /* default */], {
    data: navData
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], {
    iconStart: _jsx(__WEBPACK_IMPORTED_MODULE_2__Icon_IconMenu__["a" /* default */], {})
  })),
  description: 'Don\'t use a Dropdown as a way to hide navigation, even on mobile devices.\nEither reduce the amount of navigation in your application, or consider building a drawer with the [Menu](../menu).'
}]);

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

module.exports = {
	"description": "Dropdown provides a transitory list of actions that appears upon user interaction with a trigger.",
	"methods": [
		{
			"name": "getTriggerProps",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "props",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				}
			],
			"returns": null
		},
		{
			"name": "getItems",
			"docblock": null,
			"modifiers": [],
			"params": [],
			"returns": null
		},
		{
			"name": "onTriggerKeyDown",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "open",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "openActions",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "close",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "closeActions",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "isControlled",
			"docblock": null,
			"modifiers": [],
			"params": [],
			"returns": null
		},
		{
			"name": "getItemProps",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "props",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				},
				{
					"name": "scope",
					"type": {
						"name": "Object",
						"alias": "Object"
					}
				}
			],
			"returns": null
		},
		{
			"name": "itemOnClick",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "item",
					"type": {
						"name": "signature",
						"type": "object",
						"raw": "{\n  iconEnd?: React$Element<*>,\n  iconStart?: React$Element<*>,\n  disabled?: boolean,\n  divider?: boolean,\n  onClick?: (event: SyntheticEvent<>) => void,\n  render?: (item: Object, props: Object, theme: Object) => React$Element<*>,\n  secondaryText?: React$Node,\n  text?: React$Node,\n  variant?: 'regular' | 'danger' | 'success' | 'warning'\n}",
						"signature": {
							"properties": [
								{
									"key": "iconEnd",
									"value": {
										"name": "React$Element",
										"elements": [
											{
												"name": "unknown"
											}
										],
										"raw": "React$Element<*>",
										"required": false
									}
								},
								{
									"key": "iconStart",
									"value": {
										"name": "React$Element",
										"elements": [
											{
												"name": "unknown"
											}
										],
										"raw": "React$Element<*>",
										"required": false
									}
								},
								{
									"key": "disabled",
									"value": {
										"name": "boolean",
										"required": false
									}
								},
								{
									"key": "divider",
									"value": {
										"name": "boolean",
										"required": false
									}
								},
								{
									"key": "onClick",
									"value": {
										"name": "signature",
										"type": "function",
										"raw": "(event: SyntheticEvent<>) => void",
										"signature": {
											"arguments": [
												{
													"name": "event",
													"type": {
														"name": "SyntheticEvent",
														"elements": [],
														"raw": "SyntheticEvent<>"
													}
												}
											],
											"return": {
												"name": "void"
											}
										},
										"required": false
									}
								},
								{
									"key": "render",
									"value": {
										"name": "signature",
										"type": "function",
										"raw": "(item: Object, props: Object, theme: Object) => React$Element<*>",
										"signature": {
											"arguments": [
												{
													"name": "item",
													"type": {
														"name": "Object"
													}
												},
												{
													"name": "props",
													"type": {
														"name": "Object"
													}
												},
												{
													"name": "theme",
													"type": {
														"name": "Object"
													}
												}
											],
											"return": {
												"name": "React$Element",
												"elements": [
													{
														"name": "unknown"
													}
												],
												"raw": "React$Element<*>"
											}
										},
										"required": false
									}
								},
								{
									"key": "secondaryText",
									"value": {
										"name": "React$Node",
										"required": false
									}
								},
								{
									"key": "text",
									"value": {
										"name": "React$Node",
										"required": false
									}
								},
								{
									"key": "variant",
									"value": {
										"name": "union",
										"raw": "'regular' | 'danger' | 'success' | 'warning'",
										"elements": [
											{
												"name": "literal",
												"value": "'regular'"
											},
											{
												"name": "literal",
												"value": "'danger'"
											},
											{
												"name": "literal",
												"value": "'success'"
											},
											{
												"name": "literal",
												"value": "'warning'"
											}
										],
										"required": false
									}
								}
							]
						},
						"alias": "Item"
					}
				},
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "focusTrigger",
			"docblock": null,
			"modifiers": [],
			"params": [],
			"returns": null
		}
	],
	"props": {
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": true,
			"description": "Trigger for the Dropdown"
		},
		"defaultIsOpen": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Open the Dropdown immediately upon initialization"
		},
		"disabled": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Disable the Dropdown"
		},
		"data": {
			"flowType": {
				"name": "Array",
				"elements": [
					{
						"name": "signature",
						"type": "object",
						"raw": "{ items: Array<Item>, title?: React$Node }",
						"signature": {
							"properties": [
								{
									"key": "items",
									"value": {
										"name": "Array",
										"elements": [
											{
												"name": "signature",
												"type": "object",
												"raw": "{\n  iconEnd?: React$Element<*>,\n  iconStart?: React$Element<*>,\n  disabled?: boolean,\n  divider?: boolean,\n  onClick?: (event: SyntheticEvent<>) => void,\n  render?: (item: Object, props: Object, theme: Object) => React$Element<*>,\n  secondaryText?: React$Node,\n  text?: React$Node,\n  variant?: 'regular' | 'danger' | 'success' | 'warning'\n}",
												"signature": {
													"properties": [
														{
															"key": "iconEnd",
															"value": {
																"name": "React$Element",
																"elements": [
																	{
																		"name": "unknown"
																	}
																],
																"raw": "React$Element<*>",
																"required": false
															}
														},
														{
															"key": "iconStart",
															"value": {
																"name": "React$Element",
																"elements": [
																	{
																		"name": "unknown"
																	}
																],
																"raw": "React$Element<*>",
																"required": false
															}
														},
														{
															"key": "disabled",
															"value": {
																"name": "boolean",
																"required": false
															}
														},
														{
															"key": "divider",
															"value": {
																"name": "boolean",
																"required": false
															}
														},
														{
															"key": "onClick",
															"value": {
																"name": "signature",
																"type": "function",
																"raw": "(event: SyntheticEvent<>) => void",
																"signature": {
																	"arguments": [
																		{
																			"name": "event",
																			"type": {
																				"name": "SyntheticEvent",
																				"elements": [],
																				"raw": "SyntheticEvent<>"
																			}
																		}
																	],
																	"return": {
																		"name": "void"
																	}
																},
																"required": false
															}
														},
														{
															"key": "render",
															"value": {
																"name": "signature",
																"type": "function",
																"raw": "(item: Object, props: Object, theme: Object) => React$Element<*>",
																"signature": {
																	"arguments": [
																		{
																			"name": "item",
																			"type": {
																				"name": "Object"
																			}
																		},
																		{
																			"name": "props",
																			"type": {
																				"name": "Object"
																			}
																		},
																		{
																			"name": "theme",
																			"type": {
																				"name": "Object"
																			}
																		}
																	],
																	"return": {
																		"name": "React$Element",
																		"elements": [
																			{
																				"name": "unknown"
																			}
																		],
																		"raw": "React$Element<*>"
																	}
																},
																"required": false
															}
														},
														{
															"key": "secondaryText",
															"value": {
																"name": "React$Node",
																"required": false
															}
														},
														{
															"key": "text",
															"value": {
																"name": "React$Node",
																"required": false
															}
														},
														{
															"key": "variant",
															"value": {
																"name": "union",
																"raw": "'regular' | 'danger' | 'success' | 'warning'",
																"elements": [
																	{
																		"name": "literal",
																		"value": "'regular'"
																	},
																	{
																		"name": "literal",
																		"value": "'danger'"
																	},
																	{
																		"name": "literal",
																		"value": "'success'"
																	},
																	{
																		"name": "literal",
																		"value": "'warning'"
																	}
																],
																"required": false
															}
														}
													]
												}
											}
										],
										"raw": "Array<Item>",
										"required": true
									}
								},
								{
									"key": "title",
									"value": {
										"name": "React$Node",
										"required": false
									}
								}
							]
						}
					}
				],
				"raw": "Array<{ items: Array<Item>, title?: React$Node }>"
			},
			"required": true,
			"description": "Data from which the [Menu](../menu#data) will be constructed (see [example](#data))"
		},
		"isOpen": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "For use with controlled components, in which the app manages Dropdown state"
		},
		"modifiers": {
			"flowType": {
				"name": "Object"
			},
			"required": false,
			"description": "Plugins that are used to alter behavior. See [PopperJS docs](https://popper.js.org/popper-documentation.html#modifiers) for options."
		},
		"onClose": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(event: SyntheticEvent<>) => void",
				"signature": {
					"arguments": [
						{
							"name": "event",
							"type": {
								"name": "SyntheticEvent",
								"elements": [],
								"raw": "SyntheticEvent<>"
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "Called when Dropdown is closed"
		},
		"onOpen": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(event: SyntheticEvent<>) => void",
				"signature": {
					"arguments": [
						{
							"name": "event",
							"type": {
								"name": "SyntheticEvent",
								"elements": [],
								"raw": "SyntheticEvent<>"
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "Called when Dropdown is opened"
		},
		"placement": {
			"flowType": {
				"name": "union",
				"raw": "| 'bottom-end'\n| 'bottom-start'\n| 'left-end'\n| 'left-start'\n| 'right-end'\n| 'right-start'\n| 'top-end'\n| 'top-start'",
				"elements": [
					{
						"name": "literal",
						"value": "'bottom-end'"
					},
					{
						"name": "literal",
						"value": "'bottom-start'"
					},
					{
						"name": "literal",
						"value": "'left-end'"
					},
					{
						"name": "literal",
						"value": "'left-start'"
					},
					{
						"name": "literal",
						"value": "'right-end'"
					},
					{
						"name": "literal",
						"value": "'right-start'"
					},
					{
						"name": "literal",
						"value": "'top-end'"
					},
					{
						"name": "literal",
						"value": "'top-start'"
					}
				]
			},
			"required": false,
			"description": "Placement of the Dropdown menu",
			"defaultValue": {
				"value": "'bottom-start'",
				"computed": false
			}
		},
		"wide": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Display a wider Dropdown menu"
		}
	}
}

/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon_Icon__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bestPractices__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples__ = __webpack_require__(1624);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var doc = __webpack_require__(1650);

/* harmony default export */ __webpack_exports__["a"] = ({
  bestPractices: __WEBPACK_IMPORTED_MODULE_1__bestPractices__["a" /* default */],
  componentTheme: __WEBPACK_IMPORTED_MODULE_0__Icon_Icon__["a" /* componentTheme */],
  doc: doc,
  examples: __WEBPACK_IMPORTED_MODULE_2__examples__["a" /* default */],
  slug: 'icon',
  title: 'Icon',
  whenHowToUse: 'Icons can symbolize actions and objects in your interace.\nUse icons in combination with labels to help users more quickly process your UI.\n\nDon\'t use too many icons or you run the risk of creating visual clutter.\n\nIcons are usually used inside of a [Button](../button) to reinforce the action.\nIf used alone, Icon placement should be very clear. For example, a play icon \u25BA could be used instead of writing out the word "Play".\n\nIcons should only be used if they aid communication, not merely for decoration.'
});

/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_IconRefresh__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon_IconLocalPlay__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon_IconLocalOffer__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconLocalLaundryService__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon_IconStoreMallDirectory__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon_IconStreetview__ = __webpack_require__(187);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */










/* harmony default export */ __webpack_exports__["a"] = ([{
  type: 'do',
  title: 'use Icons with labels',
  example: _jsx(__WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], {
    iconStart: _jsx(__WEBPACK_IMPORTED_MODULE_2__Icon_IconRefresh__["a" /* default */], {}),
    primary: true
  }, void 0, 'Refresh'),
  description: 'Icons are used to reinforce a message.'
}, {
  type: 'dont',
  title: 'use Icons without context',
  example: _jsx(__WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], {
    primary: true,
    iconStart: _jsx(__WEBPACK_IMPORTED_MODULE_3__Icon_IconLocalPlay__["a" /* default */], {})
  }),
  description: 'Icons can be small and should not be presented without labels unless they are very simple and well-known.'
}, {
  type: 'dont',
  title: 'use Icons as decoration',
  example: _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], {
    minimal: true,
    iconStart: _jsx(__WEBPACK_IMPORTED_MODULE_4__Icon_IconLocalOffer__["a" /* default */], {})
  }, void 0, 'Local Offer'), _jsx(__WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], {
    minimal: true,
    iconStart: _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_IconLocalLaundryService__["a" /* default */], {})
  }, void 0, 'Laundry Service'), _jsx(__WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], {
    minimal: true,
    iconStart: _jsx(__WEBPACK_IMPORTED_MODULE_6__Icon_IconStoreMallDirectory__["a" /* default */], {})
  }, void 0, 'Store Directory'), _jsx(__WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], {
    minimal: true,
    iconStart: _jsx(__WEBPACK_IMPORTED_MODULE_7__Icon_IconStreetview__["a" /* default */], {})
  }, void 0, 'Street View')),
  description: 'In large lists of Buttons, avoid using Icons on all elements, as they become visual noise.'
}]);

/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon__ = __webpack_require__(1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__custom__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rtl__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sizes__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__title__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__categories__ = __webpack_require__(1632);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_0__icon__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__sizes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__rtl__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__custom__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__categories__["a" /* default */]]);

/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon_IconSentimentSatisfied__ = __webpack_require__(79);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'icon',
  title: 'Example',
  description: 'Bundled Icons should be imported directly.\n\n`import IconPrint from \'mineral-ui/Icon/IconPrint\'`.\n\nIcons are used to make your interface easier to scan.',
  scope: { IconSentimentSatisfied: __WEBPACK_IMPORTED_MODULE_0__Icon_IconSentimentSatisfied__["a" /* default */] },
  source: '<IconSentimentSatisfied />'
});

/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon_IconSentimentSatisfied__ = __webpack_require__(79);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'color',
  title: 'Color',
  description: 'You can apply a color to any icon.\nIn most cases, the icon should share color with its associated label.',
  scope: { IconSentimentSatisfied: __WEBPACK_IMPORTED_MODULE_0__Icon_IconSentimentSatisfied__["a" /* default */] },
  source: '<IconSentimentSatisfied color="coral" />'
});

/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(1628);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'custom',
  title: 'Custom',
  description: 'You can render a custom icon by supplying an SVG as a child to Icon.\nThe default export from the `Icon` package is the custom wrapper.\n\n`import Icon from \'mineral-ui/Icon\'`',
  scope: { Icon: __WEBPACK_IMPORTED_MODULE_0__Icon__["a" /* default */] },
  source: '\n    <Icon size="7em" title="CA Technologies">\n      <svg viewBox="0 0 16 16">\n        <path\n          className="trademark"\n          d="M14.514 10.187c-0.256 0-0.419-0.186-0.419-0.442s0.186-0.442 0.419-0.442c0.256 0 0.419 0.186 0.419 0.442 0 0.279-0.163 0.442-0.419 0.442zM14.514 9.373c-0.209 0-0.372 0.14-0.372 0.395s0.163 0.372 0.372 0.372c0.209 0 0.372-0.14 0.372-0.372 0-0.256-0.163-0.395-0.372-0.395zM14.653 9.977l-0.14-0.209h-0.070v0.209h-0.093v-0.489h0.14c0.093 0 0.163 0.047 0.163 0.14 0 0.070-0.047 0.116-0.093 0.14l0.14 0.186-0.047 0.023zM14.514 9.582h-0.070v0.14h0.070c0.047 0 0.093-0.023 0.093-0.070s-0.023-0.070-0.093-0.070z"\n        />\n        <g className="technologies">\n          <path d="M0.788 12.187v-0.465h0.349v0.465h0.279v0.279h-0.279v0.814c0 0.070 0.047 0.093 0.116 0.093 0.047 0 0.116-0.023 0.163-0.023v0.279c-0.093 0-0.186 0.023-0.279 0.023-0.256 0-0.349-0.116-0.349-0.326v-0.861h-0.186v-0.279h0.186z" />\n          <path d="M1.905 12.955c0 0.302 0.14 0.419 0.302 0.419s0.233-0.070 0.326-0.163l0.256 0.163c-0.14 0.209-0.326 0.302-0.605 0.302-0.372 0-0.605-0.279-0.605-0.744s0.233-0.744 0.605-0.744c0.372 0 0.582 0.326 0.582 0.651v0.116h-0.861zM2.44 12.722c0-0.209-0.116-0.302-0.279-0.302s-0.279 0.116-0.279 0.302h0.558z" />\n          <path d="M3.859 12.653c-0.047-0.116-0.116-0.209-0.279-0.209-0.186 0-0.279 0.14-0.279 0.465s0.093 0.465 0.279 0.465c0.14 0 0.233-0.093 0.302-0.233l0.256 0.14c-0.14 0.256-0.302 0.349-0.558 0.349-0.395 0-0.605-0.279-0.605-0.744s0.233-0.744 0.605-0.744c0.279 0 0.489 0.14 0.558 0.372l-0.279 0.14z" />\n          <path d="M4.394 13.607v-1.977h0.349v0.698c0.093-0.093 0.233-0.186 0.419-0.186 0.279 0 0.419 0.186 0.419 0.489v0.977h-0.349v-0.931c0-0.186-0.070-0.256-0.186-0.256-0.14 0-0.256 0.093-0.326 0.163v1.024h-0.326z" />\n          <path d="M5.906 13.607v-1.442h0.302v0.163c0.116-0.093 0.279-0.186 0.442-0.186 0.279 0 0.419 0.186 0.419 0.489v0.977h-0.349v-0.931c0-0.186-0.070-0.256-0.186-0.256-0.14 0-0.256 0.093-0.326 0.163v1.024h-0.302z" />\n          <path d="M7.953 12.164c0.395 0 0.628 0.279 0.628 0.744s-0.233 0.744-0.628 0.744c-0.395 0-0.628-0.279-0.628-0.744s0.233-0.744 0.628-0.744zM7.953 12.443c-0.186 0-0.279 0.14-0.279 0.465s0.093 0.465 0.279 0.465c0.186 0 0.279-0.14 0.279-0.465s-0.093-0.465-0.279-0.465z" />\n          <path d="M8.837 13.607v-1.977h0.349v1.977z" />\n          <path d="M10.070 12.164c0.395 0 0.628 0.279 0.628 0.744s-0.233 0.744-0.628 0.744c-0.395 0-0.628-0.279-0.628-0.744s0.233-0.744 0.628-0.744zM10.070 12.443c-0.186 0-0.279 0.14-0.279 0.465s0.093 0.465 0.279 0.465c0.186 0 0.279-0.14 0.279-0.465s-0.093-0.465-0.279-0.465z" />\n          <path d="M12.094 12.397c-0.070 0-0.163 0-0.209 0.023 0.047 0.070 0.070 0.14 0.070 0.256 0 0.279-0.186 0.465-0.535 0.465-0.14 0-0.256 0-0.256 0.093 0 0.233 0.931-0.093 0.931 0.489 0 0.209-0.209 0.419-0.651 0.419-0.372 0-0.628-0.116-0.628-0.349 0-0.186 0.14-0.256 0.256-0.256v0c-0.070-0.047-0.209-0.070-0.209-0.233 0-0.14 0.163-0.233 0.209-0.256-0.116-0.093-0.209-0.209-0.209-0.372 0-0.256 0.186-0.489 0.558-0.489 0.116 0 0.256 0.047 0.349 0.116 0.070-0.093 0.163-0.14 0.326-0.116v0.209zM11.094 13.746c0 0.116 0.093 0.163 0.372 0.163 0.209 0 0.302-0.116 0.302-0.163 0-0.070-0.093-0.163-0.419-0.163-0.209 0-0.256 0.116-0.256 0.163zM11.396 12.42c-0.14 0-0.256 0.093-0.256 0.233s0.093 0.233 0.256 0.233c0.14 0 0.233-0.116 0.233-0.233 0-0.14-0.093-0.233-0.233-0.233z" />\n          <path d="M12.327 11.932v-0.326h0.349v0.326h-0.349zM12.676 13.188v0.419h-0.349v-1.442h0.349v1.024z" />\n          <path d="M13.281 12.955c0 0.302 0.14 0.419 0.302 0.419s0.233-0.070 0.326-0.163l0.256 0.163c-0.14 0.209-0.326 0.302-0.605 0.302-0.372 0-0.605-0.279-0.605-0.744s0.233-0.744 0.628-0.744c0.372 0 0.582 0.326 0.582 0.651v0.116h-0.884zM13.816 12.722c0-0.209-0.116-0.302-0.279-0.302s-0.279 0.116-0.279 0.302h0.558z" />\n          <path d="M15.119 12.56c-0.070-0.070-0.163-0.14-0.256-0.14-0.14 0-0.186 0.047-0.186 0.14 0 0.256 0.721 0.14 0.721 0.675 0 0.302-0.233 0.419-0.512 0.419-0.233 0-0.419-0.093-0.535-0.279l0.233-0.163c0.070 0.116 0.186 0.209 0.326 0.209 0.116 0 0.209-0.070 0.209-0.163 0-0.233-0.721-0.163-0.721-0.651 0-0.256 0.233-0.419 0.465-0.419 0.186 0 0.372 0.070 0.512 0.209l-0.256 0.163z" />\n        </g>\n        <g className="ca">\n          <path d="M10.838 8.14c-0.279 0.419-0.698 0.675-1.186 0.675-0.651 0-1.21-0.302-1.21-1.024 0-1.047 1.535-1.419 2.722-1.489v0.302c0 0.698 0 1.047-0.326 1.535zM8.651 4.348c0.186-0.489 0.651-0.675 1.303-0.675 0.931 0 1.186 0.651 1.21 1.186v0.256c-2.559 0.116-4.955 0.605-4.909 2.931 0.023 1.628 1.512 2.303 2.536 2.303 1.186 0 1.838-0.326 2.489-1.117 0 0.349 0.047 0.698 0.116 0.954h2.28c-0.116-0.395-0.163-0.814-0.163-1.21v-4.257c0-1.024-0.186-1.605-0.744-2.117-0.535-0.489-1.373-0.744-2.536-0.744-1.070 0-1.977 0.233-2.652 0.698v0c0.558 0.465 0.931 1.070 1.070 1.791v0z" />\n          <path d="M6.116 7.953c0 0.047 0 0.093 0 0.14 0 0.023 0 0.047 0 0.070 0.047 0.837 0.442 1.349 0.814 1.652-0.628 0.372-1.396 0.512-2.070 0.512-2.443 0.023-3.908-1.721-3.908-4.141 0-2.512 1.512-4.327 4.071-4.327 1.861 0 3.396 1 3.559 2.931h-2.233c0-0.744-0.512-1.117-1.233-1.117-1.163 0-1.512 0.814-1.512 2.326 0 1.535 0.326 2.419 1.512 2.419 0.442 0 0.791-0.14 1-0.465v0z" />\n        </g>\n      </svg>\n    </Icon>'
});

/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(2);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Icon__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon3DRotation__ = __webpack_require__(286);
/* unused harmony reexport Icon3DRotation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IconAccessibility__ = __webpack_require__(287);
/* unused harmony reexport IconAccessibility */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IconAccessible__ = __webpack_require__(288);
/* unused harmony reexport IconAccessible */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IconAccountBalance__ = __webpack_require__(289);
/* unused harmony reexport IconAccountBalance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IconAccountBalanceWallet__ = __webpack_require__(290);
/* unused harmony reexport IconAccountBalanceWallet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IconAccountBox__ = __webpack_require__(291);
/* unused harmony reexport IconAccountBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IconAccountCircle__ = __webpack_require__(292);
/* unused harmony reexport IconAccountCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IconAddShoppingCart__ = __webpack_require__(293);
/* unused harmony reexport IconAddShoppingCart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__IconAlarm__ = __webpack_require__(294);
/* unused harmony reexport IconAlarm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__IconAlarmAdd__ = __webpack_require__(295);
/* unused harmony reexport IconAlarmAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__IconAlarmOff__ = __webpack_require__(296);
/* unused harmony reexport IconAlarmOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__IconAlarmOn__ = __webpack_require__(297);
/* unused harmony reexport IconAlarmOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__IconAllOut__ = __webpack_require__(298);
/* unused harmony reexport IconAllOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__IconAndroid__ = __webpack_require__(299);
/* unused harmony reexport IconAndroid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__IconAnnouncement__ = __webpack_require__(300);
/* unused harmony reexport IconAnnouncement */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__IconAspectRatio__ = __webpack_require__(301);
/* unused harmony reexport IconAspectRatio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__IconAssessment__ = __webpack_require__(302);
/* unused harmony reexport IconAssessment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__IconAssignment__ = __webpack_require__(120);
/* unused harmony reexport IconAssignment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__IconAssignmentInd__ = __webpack_require__(303);
/* unused harmony reexport IconAssignmentInd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__IconAssignmentLate__ = __webpack_require__(304);
/* unused harmony reexport IconAssignmentLate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__IconAssignmentReturn__ = __webpack_require__(305);
/* unused harmony reexport IconAssignmentReturn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__IconAssignmentReturned__ = __webpack_require__(306);
/* unused harmony reexport IconAssignmentReturned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__IconAssignmentTurnedIn__ = __webpack_require__(307);
/* unused harmony reexport IconAssignmentTurnedIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__IconAutorenew__ = __webpack_require__(308);
/* unused harmony reexport IconAutorenew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__IconBackup__ = __webpack_require__(309);
/* unused harmony reexport IconBackup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__IconBook__ = __webpack_require__(310);
/* unused harmony reexport IconBook */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__IconBookmark__ = __webpack_require__(311);
/* unused harmony reexport IconBookmark */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__IconBookmarkBorder__ = __webpack_require__(312);
/* unused harmony reexport IconBookmarkBorder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__IconBugReport__ = __webpack_require__(313);
/* unused harmony reexport IconBugReport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__IconBuild__ = __webpack_require__(314);
/* unused harmony reexport IconBuild */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__IconCached__ = __webpack_require__(315);
/* unused harmony reexport IconCached */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__IconCameraEnhance__ = __webpack_require__(316);
/* unused harmony reexport IconCameraEnhance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__IconCardGiftcard__ = __webpack_require__(317);
/* unused harmony reexport IconCardGiftcard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__IconCardMembership__ = __webpack_require__(318);
/* unused harmony reexport IconCardMembership */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__IconCardTravel__ = __webpack_require__(319);
/* unused harmony reexport IconCardTravel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__IconChangeHistory__ = __webpack_require__(320);
/* unused harmony reexport IconChangeHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__IconCheckCircle__ = __webpack_require__(321);
/* unused harmony reexport IconCheckCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__IconChromeReaderMode__ = __webpack_require__(322);
/* unused harmony reexport IconChromeReaderMode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__IconClass__ = __webpack_require__(323);
/* unused harmony reexport IconClass */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__IconCode__ = __webpack_require__(324);
/* unused harmony reexport IconCode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__IconCompareArrows__ = __webpack_require__(325);
/* unused harmony reexport IconCompareArrows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__IconCopyright__ = __webpack_require__(326);
/* unused harmony reexport IconCopyright */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__IconCreditCard__ = __webpack_require__(327);
/* unused harmony reexport IconCreditCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__IconDashboard__ = __webpack_require__(328);
/* unused harmony reexport IconDashboard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__IconDateRange__ = __webpack_require__(329);
/* unused harmony reexport IconDateRange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__IconDelete__ = __webpack_require__(330);
/* unused harmony reexport IconDelete */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__IconDeleteForever__ = __webpack_require__(331);
/* unused harmony reexport IconDeleteForever */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__IconDescription__ = __webpack_require__(332);
/* unused harmony reexport IconDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__IconDns__ = __webpack_require__(333);
/* unused harmony reexport IconDns */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__IconDone__ = __webpack_require__(334);
/* unused harmony reexport IconDone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__IconDoneAll__ = __webpack_require__(335);
/* unused harmony reexport IconDoneAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__IconDonutLarge__ = __webpack_require__(336);
/* unused harmony reexport IconDonutLarge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__IconDonutSmall__ = __webpack_require__(337);
/* unused harmony reexport IconDonutSmall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__IconEject__ = __webpack_require__(338);
/* unused harmony reexport IconEject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__IconEuroSymbol__ = __webpack_require__(339);
/* unused harmony reexport IconEuroSymbol */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__IconEvent__ = __webpack_require__(340);
/* unused harmony reexport IconEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__IconEventSeat__ = __webpack_require__(341);
/* unused harmony reexport IconEventSeat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__IconExitToApp__ = __webpack_require__(342);
/* unused harmony reexport IconExitToApp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__IconExplore__ = __webpack_require__(343);
/* unused harmony reexport IconExplore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__IconExtension__ = __webpack_require__(344);
/* unused harmony reexport IconExtension */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__IconFace__ = __webpack_require__(345);
/* unused harmony reexport IconFace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__IconFavorite__ = __webpack_require__(124);
/* unused harmony reexport IconFavorite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__IconFavoriteBorder__ = __webpack_require__(346);
/* unused harmony reexport IconFavoriteBorder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__IconFeedback__ = __webpack_require__(347);
/* unused harmony reexport IconFeedback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__IconFindInPage__ = __webpack_require__(348);
/* unused harmony reexport IconFindInPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__IconFindReplace__ = __webpack_require__(349);
/* unused harmony reexport IconFindReplace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__IconFingerprint__ = __webpack_require__(350);
/* unused harmony reexport IconFingerprint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__IconFlightLand__ = __webpack_require__(351);
/* unused harmony reexport IconFlightLand */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__IconFlightTakeoff__ = __webpack_require__(352);
/* unused harmony reexport IconFlightTakeoff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__IconFlipToBack__ = __webpack_require__(353);
/* unused harmony reexport IconFlipToBack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__IconFlipToFront__ = __webpack_require__(354);
/* unused harmony reexport IconFlipToFront */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__IconGTranslate__ = __webpack_require__(355);
/* unused harmony reexport IconGTranslate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__IconGavel__ = __webpack_require__(356);
/* unused harmony reexport IconGavel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__IconGetApp__ = __webpack_require__(357);
/* unused harmony reexport IconGetApp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__IconGif__ = __webpack_require__(358);
/* unused harmony reexport IconGif */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__IconGrade__ = __webpack_require__(359);
/* unused harmony reexport IconGrade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__IconGroupWork__ = __webpack_require__(360);
/* unused harmony reexport IconGroupWork */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__IconHelp__ = __webpack_require__(125);
/* unused harmony reexport IconHelp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__IconHelpOutline__ = __webpack_require__(361);
/* unused harmony reexport IconHelpOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__IconHighlightOff__ = __webpack_require__(362);
/* unused harmony reexport IconHighlightOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__IconHistory__ = __webpack_require__(363);
/* unused harmony reexport IconHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__IconHome__ = __webpack_require__(364);
/* unused harmony reexport IconHome */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__IconHourglassEmpty__ = __webpack_require__(365);
/* unused harmony reexport IconHourglassEmpty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__IconHourglassFull__ = __webpack_require__(366);
/* unused harmony reexport IconHourglassFull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__IconHttp__ = __webpack_require__(367);
/* unused harmony reexport IconHttp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__IconHttps__ = __webpack_require__(368);
/* unused harmony reexport IconHttps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__IconImportantDevices__ = __webpack_require__(369);
/* unused harmony reexport IconImportantDevices */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__IconInfo__ = __webpack_require__(169);
/* unused harmony reexport IconInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__IconInfoOutline__ = __webpack_require__(370);
/* unused harmony reexport IconInfoOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__IconInput__ = __webpack_require__(371);
/* unused harmony reexport IconInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__IconInvertColors__ = __webpack_require__(372);
/* unused harmony reexport IconInvertColors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__IconLabel__ = __webpack_require__(373);
/* unused harmony reexport IconLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__IconLabelOutline__ = __webpack_require__(374);
/* unused harmony reexport IconLabelOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__IconLanguage__ = __webpack_require__(375);
/* unused harmony reexport IconLanguage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__IconLaunch__ = __webpack_require__(376);
/* unused harmony reexport IconLaunch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__IconLightbulbOutline__ = __webpack_require__(377);
/* unused harmony reexport IconLightbulbOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__IconLineStyle__ = __webpack_require__(378);
/* unused harmony reexport IconLineStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__IconLineWeight__ = __webpack_require__(379);
/* unused harmony reexport IconLineWeight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__IconList__ = __webpack_require__(380);
/* unused harmony reexport IconList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__IconLock__ = __webpack_require__(381);
/* unused harmony reexport IconLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__IconLockOpen__ = __webpack_require__(382);
/* unused harmony reexport IconLockOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__IconLockOutline__ = __webpack_require__(383);
/* unused harmony reexport IconLockOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__IconLoyalty__ = __webpack_require__(384);
/* unused harmony reexport IconLoyalty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__IconMarkunreadMailbox__ = __webpack_require__(385);
/* unused harmony reexport IconMarkunreadMailbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__IconMotorcycle__ = __webpack_require__(386);
/* unused harmony reexport IconMotorcycle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__IconNoteAdd__ = __webpack_require__(387);
/* unused harmony reexport IconNoteAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__IconOfflinePin__ = __webpack_require__(388);
/* unused harmony reexport IconOfflinePin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__IconOpacity__ = __webpack_require__(389);
/* unused harmony reexport IconOpacity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__IconOpenInBrowser__ = __webpack_require__(390);
/* unused harmony reexport IconOpenInBrowser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__IconOpenInNew__ = __webpack_require__(391);
/* unused harmony reexport IconOpenInNew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__IconOpenWith__ = __webpack_require__(392);
/* unused harmony reexport IconOpenWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__IconPageview__ = __webpack_require__(393);
/* unused harmony reexport IconPageview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__IconPanTool__ = __webpack_require__(394);
/* unused harmony reexport IconPanTool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__IconPayment__ = __webpack_require__(395);
/* unused harmony reexport IconPayment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__IconPermCameraMic__ = __webpack_require__(396);
/* unused harmony reexport IconPermCameraMic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__IconPermContactCalendar__ = __webpack_require__(397);
/* unused harmony reexport IconPermContactCalendar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__IconPermDataSetting__ = __webpack_require__(398);
/* unused harmony reexport IconPermDataSetting */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__IconPermDeviceInformation__ = __webpack_require__(399);
/* unused harmony reexport IconPermDeviceInformation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__IconPermIdentity__ = __webpack_require__(400);
/* unused harmony reexport IconPermIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__IconPermMedia__ = __webpack_require__(401);
/* unused harmony reexport IconPermMedia */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__IconPermPhoneMsg__ = __webpack_require__(402);
/* unused harmony reexport IconPermPhoneMsg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__IconPermScanWifi__ = __webpack_require__(403);
/* unused harmony reexport IconPermScanWifi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__IconPets__ = __webpack_require__(404);
/* unused harmony reexport IconPets */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__IconPictureInPicture__ = __webpack_require__(405);
/* unused harmony reexport IconPictureInPicture */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__IconPictureInPictureAlt__ = __webpack_require__(406);
/* unused harmony reexport IconPictureInPictureAlt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__IconPlayForWork__ = __webpack_require__(407);
/* unused harmony reexport IconPlayForWork */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__IconPolymer__ = __webpack_require__(408);
/* unused harmony reexport IconPolymer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__IconPowerSettingsNew__ = __webpack_require__(409);
/* unused harmony reexport IconPowerSettingsNew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__IconPregnantWoman__ = __webpack_require__(410);
/* unused harmony reexport IconPregnantWoman */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__IconPrint__ = __webpack_require__(411);
/* unused harmony reexport IconPrint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__IconQueryBuilder__ = __webpack_require__(412);
/* unused harmony reexport IconQueryBuilder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__IconQuestionAnswer__ = __webpack_require__(413);
/* unused harmony reexport IconQuestionAnswer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__IconReceipt__ = __webpack_require__(414);
/* unused harmony reexport IconReceipt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__IconRecordVoiceOver__ = __webpack_require__(415);
/* unused harmony reexport IconRecordVoiceOver */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__IconRedeem__ = __webpack_require__(416);
/* unused harmony reexport IconRedeem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__IconRemoveShoppingCart__ = __webpack_require__(417);
/* unused harmony reexport IconRemoveShoppingCart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__IconReorder__ = __webpack_require__(418);
/* unused harmony reexport IconReorder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__IconReportProblem__ = __webpack_require__(419);
/* unused harmony reexport IconReportProblem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__IconRestore__ = __webpack_require__(420);
/* unused harmony reexport IconRestore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__IconRestorePage__ = __webpack_require__(421);
/* unused harmony reexport IconRestorePage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__IconRoom__ = __webpack_require__(422);
/* unused harmony reexport IconRoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__IconRoundedCorner__ = __webpack_require__(423);
/* unused harmony reexport IconRoundedCorner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__IconRowing__ = __webpack_require__(424);
/* unused harmony reexport IconRowing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__IconSchedule__ = __webpack_require__(425);
/* unused harmony reexport IconSchedule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__IconSearch__ = __webpack_require__(426);
/* unused harmony reexport IconSearch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__IconSettings__ = __webpack_require__(427);
/* unused harmony reexport IconSettings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__IconSettingsApplications__ = __webpack_require__(428);
/* unused harmony reexport IconSettingsApplications */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__IconSettingsBackupRestore__ = __webpack_require__(429);
/* unused harmony reexport IconSettingsBackupRestore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__IconSettingsBluetooth__ = __webpack_require__(430);
/* unused harmony reexport IconSettingsBluetooth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__IconSettingsBrightness__ = __webpack_require__(431);
/* unused harmony reexport IconSettingsBrightness */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__IconSettingsCell__ = __webpack_require__(432);
/* unused harmony reexport IconSettingsCell */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__IconSettingsEthernet__ = __webpack_require__(433);
/* unused harmony reexport IconSettingsEthernet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__IconSettingsInputAntenna__ = __webpack_require__(434);
/* unused harmony reexport IconSettingsInputAntenna */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__IconSettingsInputComponent__ = __webpack_require__(435);
/* unused harmony reexport IconSettingsInputComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__IconSettingsInputComposite__ = __webpack_require__(436);
/* unused harmony reexport IconSettingsInputComposite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__IconSettingsInputHdmi__ = __webpack_require__(437);
/* unused harmony reexport IconSettingsInputHdmi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__IconSettingsInputSvideo__ = __webpack_require__(438);
/* unused harmony reexport IconSettingsInputSvideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__IconSettingsOverscan__ = __webpack_require__(439);
/* unused harmony reexport IconSettingsOverscan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__IconSettingsPhone__ = __webpack_require__(440);
/* unused harmony reexport IconSettingsPhone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__IconSettingsPower__ = __webpack_require__(441);
/* unused harmony reexport IconSettingsPower */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__IconSettingsRemote__ = __webpack_require__(442);
/* unused harmony reexport IconSettingsRemote */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__IconSettingsVoice__ = __webpack_require__(443);
/* unused harmony reexport IconSettingsVoice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__IconShop__ = __webpack_require__(444);
/* unused harmony reexport IconShop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__IconShopTwo__ = __webpack_require__(445);
/* unused harmony reexport IconShopTwo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__IconShoppingBasket__ = __webpack_require__(446);
/* unused harmony reexport IconShoppingBasket */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__IconShoppingCart__ = __webpack_require__(447);
/* unused harmony reexport IconShoppingCart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__IconSpeakerNotes__ = __webpack_require__(448);
/* unused harmony reexport IconSpeakerNotes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__IconSpeakerNotesOff__ = __webpack_require__(449);
/* unused harmony reexport IconSpeakerNotesOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__IconSpellcheck__ = __webpack_require__(450);
/* unused harmony reexport IconSpellcheck */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__IconStars__ = __webpack_require__(451);
/* unused harmony reexport IconStars */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__IconStore__ = __webpack_require__(452);
/* unused harmony reexport IconStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__IconSubject__ = __webpack_require__(453);
/* unused harmony reexport IconSubject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__IconSupervisorAccount__ = __webpack_require__(454);
/* unused harmony reexport IconSupervisorAccount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__IconSwapHoriz__ = __webpack_require__(455);
/* unused harmony reexport IconSwapHoriz */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__IconSwapVert__ = __webpack_require__(456);
/* unused harmony reexport IconSwapVert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__IconSwapVerticalCircle__ = __webpack_require__(457);
/* unused harmony reexport IconSwapVerticalCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__IconSystemUpdateAlt__ = __webpack_require__(458);
/* unused harmony reexport IconSystemUpdateAlt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__IconTab__ = __webpack_require__(459);
/* unused harmony reexport IconTab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__IconTabUnselected__ = __webpack_require__(460);
/* unused harmony reexport IconTabUnselected */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__IconTheaters__ = __webpack_require__(461);
/* unused harmony reexport IconTheaters */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__IconThumbDown__ = __webpack_require__(462);
/* unused harmony reexport IconThumbDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__IconThumbUp__ = __webpack_require__(463);
/* unused harmony reexport IconThumbUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__IconThumbsUpDown__ = __webpack_require__(464);
/* unused harmony reexport IconThumbsUpDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__IconTimeline__ = __webpack_require__(465);
/* unused harmony reexport IconTimeline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__IconToc__ = __webpack_require__(466);
/* unused harmony reexport IconToc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__IconToday__ = __webpack_require__(467);
/* unused harmony reexport IconToday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__IconToll__ = __webpack_require__(468);
/* unused harmony reexport IconToll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__IconTouchApp__ = __webpack_require__(469);
/* unused harmony reexport IconTouchApp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__IconTrackChanges__ = __webpack_require__(470);
/* unused harmony reexport IconTrackChanges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__IconTranslate__ = __webpack_require__(471);
/* unused harmony reexport IconTranslate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__IconTrendingDown__ = __webpack_require__(472);
/* unused harmony reexport IconTrendingDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__IconTrendingFlat__ = __webpack_require__(473);
/* unused harmony reexport IconTrendingFlat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__IconTrendingUp__ = __webpack_require__(474);
/* unused harmony reexport IconTrendingUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__IconTurnedIn__ = __webpack_require__(475);
/* unused harmony reexport IconTurnedIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__IconTurnedInNot__ = __webpack_require__(476);
/* unused harmony reexport IconTurnedInNot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__IconUpdate__ = __webpack_require__(477);
/* unused harmony reexport IconUpdate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__IconVerifiedUser__ = __webpack_require__(478);
/* unused harmony reexport IconVerifiedUser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__IconViewAgenda__ = __webpack_require__(479);
/* unused harmony reexport IconViewAgenda */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__IconViewArray__ = __webpack_require__(480);
/* unused harmony reexport IconViewArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__IconViewCarousel__ = __webpack_require__(481);
/* unused harmony reexport IconViewCarousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__IconViewColumn__ = __webpack_require__(482);
/* unused harmony reexport IconViewColumn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__IconViewDay__ = __webpack_require__(483);
/* unused harmony reexport IconViewDay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__IconViewHeadline__ = __webpack_require__(484);
/* unused harmony reexport IconViewHeadline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__IconViewList__ = __webpack_require__(485);
/* unused harmony reexport IconViewList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__IconViewModule__ = __webpack_require__(486);
/* unused harmony reexport IconViewModule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__IconViewQuilt__ = __webpack_require__(487);
/* unused harmony reexport IconViewQuilt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__IconViewStream__ = __webpack_require__(488);
/* unused harmony reexport IconViewStream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__IconViewWeek__ = __webpack_require__(489);
/* unused harmony reexport IconViewWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__IconVisibility__ = __webpack_require__(490);
/* unused harmony reexport IconVisibility */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__IconVisibilityOff__ = __webpack_require__(491);
/* unused harmony reexport IconVisibilityOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__IconWatchLater__ = __webpack_require__(492);
/* unused harmony reexport IconWatchLater */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__IconWork__ = __webpack_require__(493);
/* unused harmony reexport IconWork */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__IconYoutubeSearchedFor__ = __webpack_require__(494);
/* unused harmony reexport IconYoutubeSearchedFor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__IconZoomIn__ = __webpack_require__(495);
/* unused harmony reexport IconZoomIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__IconZoomOut__ = __webpack_require__(496);
/* unused harmony reexport IconZoomOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__IconAddAlert__ = __webpack_require__(497);
/* unused harmony reexport IconAddAlert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__IconError__ = __webpack_require__(498);
/* unused harmony reexport IconError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__IconErrorOutline__ = __webpack_require__(499);
/* unused harmony reexport IconErrorOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__IconWarning__ = __webpack_require__(168);
/* unused harmony reexport IconWarning */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__IconAddToQueue__ = __webpack_require__(500);
/* unused harmony reexport IconAddToQueue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__IconAirplay__ = __webpack_require__(501);
/* unused harmony reexport IconAirplay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__IconAlbum__ = __webpack_require__(502);
/* unused harmony reexport IconAlbum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__IconArtTrack__ = __webpack_require__(503);
/* unused harmony reexport IconArtTrack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__IconAvTimer__ = __webpack_require__(504);
/* unused harmony reexport IconAvTimer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__IconBrandingWatermark__ = __webpack_require__(505);
/* unused harmony reexport IconBrandingWatermark */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__IconCallToAction__ = __webpack_require__(506);
/* unused harmony reexport IconCallToAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__IconClosedCaption__ = __webpack_require__(507);
/* unused harmony reexport IconClosedCaption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__IconEqualizer__ = __webpack_require__(508);
/* unused harmony reexport IconEqualizer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__IconExplicit__ = __webpack_require__(509);
/* unused harmony reexport IconExplicit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__IconFastForward__ = __webpack_require__(510);
/* unused harmony reexport IconFastForward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__IconFastRewind__ = __webpack_require__(511);
/* unused harmony reexport IconFastRewind */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__IconFeaturedPlayList__ = __webpack_require__(512);
/* unused harmony reexport IconFeaturedPlayList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__IconFeaturedVideo__ = __webpack_require__(513);
/* unused harmony reexport IconFeaturedVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__IconFiberDvr__ = __webpack_require__(514);
/* unused harmony reexport IconFiberDvr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__IconFiberManualRecord__ = __webpack_require__(515);
/* unused harmony reexport IconFiberManualRecord */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__IconFiberNew__ = __webpack_require__(516);
/* unused harmony reexport IconFiberNew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__IconFiberPin__ = __webpack_require__(517);
/* unused harmony reexport IconFiberPin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__IconFiberSmartRecord__ = __webpack_require__(518);
/* unused harmony reexport IconFiberSmartRecord */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239__IconForward10__ = __webpack_require__(519);
/* unused harmony reexport IconForward10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240__IconForward30__ = __webpack_require__(520);
/* unused harmony reexport IconForward30 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241__IconForward5__ = __webpack_require__(521);
/* unused harmony reexport IconForward5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242__IconGames__ = __webpack_require__(522);
/* unused harmony reexport IconGames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243__IconHd__ = __webpack_require__(523);
/* unused harmony reexport IconHd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244__IconHearing__ = __webpack_require__(524);
/* unused harmony reexport IconHearing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245__IconHighQuality__ = __webpack_require__(525);
/* unused harmony reexport IconHighQuality */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_246__IconLibraryAdd__ = __webpack_require__(526);
/* unused harmony reexport IconLibraryAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_247__IconLibraryBooks__ = __webpack_require__(527);
/* unused harmony reexport IconLibraryBooks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_248__IconLibraryMusic__ = __webpack_require__(528);
/* unused harmony reexport IconLibraryMusic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_249__IconLoop__ = __webpack_require__(529);
/* unused harmony reexport IconLoop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_250__IconMic__ = __webpack_require__(530);
/* unused harmony reexport IconMic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_251__IconMicNone__ = __webpack_require__(531);
/* unused harmony reexport IconMicNone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_252__IconMicOff__ = __webpack_require__(532);
/* unused harmony reexport IconMicOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_253__IconMovie__ = __webpack_require__(533);
/* unused harmony reexport IconMovie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_254__IconMusicVideo__ = __webpack_require__(534);
/* unused harmony reexport IconMusicVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_255__IconNewReleases__ = __webpack_require__(535);
/* unused harmony reexport IconNewReleases */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_256__IconNotInterested__ = __webpack_require__(536);
/* unused harmony reexport IconNotInterested */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_257__IconNote__ = __webpack_require__(537);
/* unused harmony reexport IconNote */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_258__IconPause__ = __webpack_require__(538);
/* unused harmony reexport IconPause */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_259__IconPauseCircleFilled__ = __webpack_require__(539);
/* unused harmony reexport IconPauseCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_260__IconPauseCircleOutline__ = __webpack_require__(540);
/* unused harmony reexport IconPauseCircleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_261__IconPlayArrow__ = __webpack_require__(541);
/* unused harmony reexport IconPlayArrow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_262__IconPlayCircleFilled__ = __webpack_require__(542);
/* unused harmony reexport IconPlayCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_263__IconPlayCircleOutline__ = __webpack_require__(543);
/* unused harmony reexport IconPlayCircleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_264__IconPlaylistAdd__ = __webpack_require__(544);
/* unused harmony reexport IconPlaylistAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_265__IconPlaylistAddCheck__ = __webpack_require__(545);
/* unused harmony reexport IconPlaylistAddCheck */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_266__IconPlaylistPlay__ = __webpack_require__(546);
/* unused harmony reexport IconPlaylistPlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_267__IconQueue__ = __webpack_require__(547);
/* unused harmony reexport IconQueue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_268__IconQueueMusic__ = __webpack_require__(548);
/* unused harmony reexport IconQueueMusic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_269__IconQueuePlayNext__ = __webpack_require__(549);
/* unused harmony reexport IconQueuePlayNext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_270__IconRadio__ = __webpack_require__(550);
/* unused harmony reexport IconRadio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_271__IconRecentActors__ = __webpack_require__(551);
/* unused harmony reexport IconRecentActors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_272__IconRemoveFromQueue__ = __webpack_require__(552);
/* unused harmony reexport IconRemoveFromQueue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_273__IconRepeat__ = __webpack_require__(553);
/* unused harmony reexport IconRepeat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_274__IconRepeatOne__ = __webpack_require__(554);
/* unused harmony reexport IconRepeatOne */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_275__IconReplay10__ = __webpack_require__(555);
/* unused harmony reexport IconReplay10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_276__IconReplay__ = __webpack_require__(556);
/* unused harmony reexport IconReplay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_277__IconReplay30__ = __webpack_require__(557);
/* unused harmony reexport IconReplay30 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_278__IconReplay5__ = __webpack_require__(558);
/* unused harmony reexport IconReplay5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_279__IconShuffle__ = __webpack_require__(559);
/* unused harmony reexport IconShuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_280__IconSkipNext__ = __webpack_require__(560);
/* unused harmony reexport IconSkipNext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_281__IconSkipPrevious__ = __webpack_require__(561);
/* unused harmony reexport IconSkipPrevious */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_282__IconSlowMotionVideo__ = __webpack_require__(121);
/* unused harmony reexport IconSlowMotionVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_283__IconSnooze__ = __webpack_require__(562);
/* unused harmony reexport IconSnooze */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_284__IconSortByAlpha__ = __webpack_require__(563);
/* unused harmony reexport IconSortByAlpha */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_285__IconStop__ = __webpack_require__(564);
/* unused harmony reexport IconStop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_286__IconSubscriptions__ = __webpack_require__(565);
/* unused harmony reexport IconSubscriptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_287__IconSubtitles__ = __webpack_require__(566);
/* unused harmony reexport IconSubtitles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_288__IconSurroundSound__ = __webpack_require__(567);
/* unused harmony reexport IconSurroundSound */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_289__IconVideoCall__ = __webpack_require__(568);
/* unused harmony reexport IconVideoCall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_290__IconVideoLabel__ = __webpack_require__(569);
/* unused harmony reexport IconVideoLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_291__IconVideoLibrary__ = __webpack_require__(570);
/* unused harmony reexport IconVideoLibrary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_292__IconVideocam__ = __webpack_require__(571);
/* unused harmony reexport IconVideocam */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_293__IconVideocamOff__ = __webpack_require__(572);
/* unused harmony reexport IconVideocamOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_294__IconVolumeDown__ = __webpack_require__(573);
/* unused harmony reexport IconVolumeDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_295__IconVolumeMute__ = __webpack_require__(574);
/* unused harmony reexport IconVolumeMute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_296__IconVolumeOff__ = __webpack_require__(575);
/* unused harmony reexport IconVolumeOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_297__IconVolumeUp__ = __webpack_require__(576);
/* unused harmony reexport IconVolumeUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_298__IconWeb__ = __webpack_require__(577);
/* unused harmony reexport IconWeb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_299__IconWebAsset__ = __webpack_require__(578);
/* unused harmony reexport IconWebAsset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_300__IconBusiness__ = __webpack_require__(579);
/* unused harmony reexport IconBusiness */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_301__IconCall__ = __webpack_require__(580);
/* unused harmony reexport IconCall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_302__IconCallEnd__ = __webpack_require__(581);
/* unused harmony reexport IconCallEnd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_303__IconCallMade__ = __webpack_require__(582);
/* unused harmony reexport IconCallMade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_304__IconCallMerge__ = __webpack_require__(583);
/* unused harmony reexport IconCallMerge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_305__IconCallMissed__ = __webpack_require__(584);
/* unused harmony reexport IconCallMissed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_306__IconCallMissedOutgoing__ = __webpack_require__(585);
/* unused harmony reexport IconCallMissedOutgoing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_307__IconCallReceived__ = __webpack_require__(586);
/* unused harmony reexport IconCallReceived */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_308__IconCallSplit__ = __webpack_require__(587);
/* unused harmony reexport IconCallSplit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_309__IconChat__ = __webpack_require__(588);
/* unused harmony reexport IconChat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_310__IconChatBubble__ = __webpack_require__(589);
/* unused harmony reexport IconChatBubble */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_311__IconChatBubbleOutline__ = __webpack_require__(590);
/* unused harmony reexport IconChatBubbleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_312__IconClearAll__ = __webpack_require__(591);
/* unused harmony reexport IconClearAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_313__IconComment__ = __webpack_require__(592);
/* unused harmony reexport IconComment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_314__IconContactMail__ = __webpack_require__(593);
/* unused harmony reexport IconContactMail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_315__IconContactPhone__ = __webpack_require__(594);
/* unused harmony reexport IconContactPhone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_316__IconContacts__ = __webpack_require__(595);
/* unused harmony reexport IconContacts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_317__IconDialerSip__ = __webpack_require__(596);
/* unused harmony reexport IconDialerSip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_318__IconDialpad__ = __webpack_require__(597);
/* unused harmony reexport IconDialpad */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_319__IconEmail__ = __webpack_require__(598);
/* unused harmony reexport IconEmail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_320__IconForum__ = __webpack_require__(599);
/* unused harmony reexport IconForum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_321__IconImportContacts__ = __webpack_require__(600);
/* unused harmony reexport IconImportContacts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_322__IconImportExport__ = __webpack_require__(601);
/* unused harmony reexport IconImportExport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_323__IconInvertColorsOff__ = __webpack_require__(602);
/* unused harmony reexport IconInvertColorsOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_324__IconLiveHelp__ = __webpack_require__(603);
/* unused harmony reexport IconLiveHelp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_325__IconLocationOff__ = __webpack_require__(604);
/* unused harmony reexport IconLocationOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_326__IconLocationOn__ = __webpack_require__(605);
/* unused harmony reexport IconLocationOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_327__IconMailOutline__ = __webpack_require__(606);
/* unused harmony reexport IconMailOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_328__IconMessage__ = __webpack_require__(607);
/* unused harmony reexport IconMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_329__IconNoSim__ = __webpack_require__(608);
/* unused harmony reexport IconNoSim */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_330__IconPhone__ = __webpack_require__(609);
/* unused harmony reexport IconPhone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_331__IconPhonelinkErase__ = __webpack_require__(610);
/* unused harmony reexport IconPhonelinkErase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_332__IconPhonelinkLock__ = __webpack_require__(611);
/* unused harmony reexport IconPhonelinkLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_333__IconPhonelinkRing__ = __webpack_require__(612);
/* unused harmony reexport IconPhonelinkRing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_334__IconPhonelinkSetup__ = __webpack_require__(613);
/* unused harmony reexport IconPhonelinkSetup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_335__IconPortableWifiOff__ = __webpack_require__(614);
/* unused harmony reexport IconPortableWifiOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_336__IconPresentToAll__ = __webpack_require__(615);
/* unused harmony reexport IconPresentToAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_337__IconRingVolume__ = __webpack_require__(616);
/* unused harmony reexport IconRingVolume */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_338__IconRssFeed__ = __webpack_require__(617);
/* unused harmony reexport IconRssFeed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_339__IconScreenShare__ = __webpack_require__(618);
/* unused harmony reexport IconScreenShare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_340__IconSpeakerPhone__ = __webpack_require__(619);
/* unused harmony reexport IconSpeakerPhone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_341__IconStayCurrentLandscape__ = __webpack_require__(620);
/* unused harmony reexport IconStayCurrentLandscape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_342__IconStayCurrentPortrait__ = __webpack_require__(621);
/* unused harmony reexport IconStayCurrentPortrait */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_343__IconStayPrimaryLandscape__ = __webpack_require__(622);
/* unused harmony reexport IconStayPrimaryLandscape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_344__IconStayPrimaryPortrait__ = __webpack_require__(623);
/* unused harmony reexport IconStayPrimaryPortrait */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_345__IconStopScreenShare__ = __webpack_require__(624);
/* unused harmony reexport IconStopScreenShare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_346__IconSwapCalls__ = __webpack_require__(625);
/* unused harmony reexport IconSwapCalls */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_347__IconTextsms__ = __webpack_require__(626);
/* unused harmony reexport IconTextsms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_348__IconVoicemail__ = __webpack_require__(627);
/* unused harmony reexport IconVoicemail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_349__IconVpnKey__ = __webpack_require__(628);
/* unused harmony reexport IconVpnKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_350__IconAdd__ = __webpack_require__(629);
/* unused harmony reexport IconAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_351__IconAddBox__ = __webpack_require__(630);
/* unused harmony reexport IconAddBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_352__IconAddCircle__ = __webpack_require__(631);
/* unused harmony reexport IconAddCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_353__IconAddCircleOutline__ = __webpack_require__(632);
/* unused harmony reexport IconAddCircleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_354__IconArchive__ = __webpack_require__(633);
/* unused harmony reexport IconArchive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_355__IconBackspace__ = __webpack_require__(177);
/* unused harmony reexport IconBackspace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_356__IconBlock__ = __webpack_require__(634);
/* unused harmony reexport IconBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_357__IconClear__ = __webpack_require__(635);
/* unused harmony reexport IconClear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_358__IconContentCopy__ = __webpack_require__(636);
/* unused harmony reexport IconContentCopy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_359__IconContentCut__ = __webpack_require__(637);
/* unused harmony reexport IconContentCut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_360__IconContentPaste__ = __webpack_require__(638);
/* unused harmony reexport IconContentPaste */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_361__IconCreate__ = __webpack_require__(639);
/* unused harmony reexport IconCreate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_362__IconDeleteSweep__ = __webpack_require__(640);
/* unused harmony reexport IconDeleteSweep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_363__IconDrafts__ = __webpack_require__(641);
/* unused harmony reexport IconDrafts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_364__IconFilterList__ = __webpack_require__(642);
/* unused harmony reexport IconFilterList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_365__IconFlag__ = __webpack_require__(643);
/* unused harmony reexport IconFlag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_366__IconFontDownload__ = __webpack_require__(644);
/* unused harmony reexport IconFontDownload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_367__IconForward__ = __webpack_require__(645);
/* unused harmony reexport IconForward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_368__IconGesture__ = __webpack_require__(646);
/* unused harmony reexport IconGesture */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_369__IconInbox__ = __webpack_require__(647);
/* unused harmony reexport IconInbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_370__IconLink__ = __webpack_require__(648);
/* unused harmony reexport IconLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_371__IconLowPriority__ = __webpack_require__(649);
/* unused harmony reexport IconLowPriority */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_372__IconMail__ = __webpack_require__(650);
/* unused harmony reexport IconMail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_373__IconMarkunread__ = __webpack_require__(651);
/* unused harmony reexport IconMarkunread */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_374__IconMoveToInbox__ = __webpack_require__(652);
/* unused harmony reexport IconMoveToInbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_375__IconNextWeek__ = __webpack_require__(653);
/* unused harmony reexport IconNextWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_376__IconRedo__ = __webpack_require__(654);
/* unused harmony reexport IconRedo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_377__IconRemove__ = __webpack_require__(655);
/* unused harmony reexport IconRemove */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_378__IconRemoveCircle__ = __webpack_require__(656);
/* unused harmony reexport IconRemoveCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_379__IconRemoveCircleOutline__ = __webpack_require__(657);
/* unused harmony reexport IconRemoveCircleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_380__IconReply__ = __webpack_require__(658);
/* unused harmony reexport IconReply */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_381__IconReplyAll__ = __webpack_require__(659);
/* unused harmony reexport IconReplyAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_382__IconReport__ = __webpack_require__(660);
/* unused harmony reexport IconReport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_383__IconSave__ = __webpack_require__(661);
/* unused harmony reexport IconSave */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_384__IconSelectAll__ = __webpack_require__(662);
/* unused harmony reexport IconSelectAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_385__IconSend__ = __webpack_require__(663);
/* unused harmony reexport IconSend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_386__IconSort__ = __webpack_require__(664);
/* unused harmony reexport IconSort */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_387__IconTextFormat__ = __webpack_require__(665);
/* unused harmony reexport IconTextFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_388__IconUnarchive__ = __webpack_require__(666);
/* unused harmony reexport IconUnarchive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_389__IconUndo__ = __webpack_require__(667);
/* unused harmony reexport IconUndo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_390__IconWeekend__ = __webpack_require__(668);
/* unused harmony reexport IconWeekend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_391__IconAccessAlarm__ = __webpack_require__(669);
/* unused harmony reexport IconAccessAlarm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_392__IconAccessAlarms__ = __webpack_require__(670);
/* unused harmony reexport IconAccessAlarms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_393__IconAccessTime__ = __webpack_require__(671);
/* unused harmony reexport IconAccessTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_394__IconAddAlarm__ = __webpack_require__(672);
/* unused harmony reexport IconAddAlarm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_395__IconAirplanemodeActive__ = __webpack_require__(673);
/* unused harmony reexport IconAirplanemodeActive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_396__IconAirplanemodeInactive__ = __webpack_require__(674);
/* unused harmony reexport IconAirplanemodeInactive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_397__IconBattery20__ = __webpack_require__(675);
/* unused harmony reexport IconBattery20 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_398__IconBattery30__ = __webpack_require__(676);
/* unused harmony reexport IconBattery30 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_399__IconBattery50__ = __webpack_require__(677);
/* unused harmony reexport IconBattery50 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_400__IconBattery60__ = __webpack_require__(678);
/* unused harmony reexport IconBattery60 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_401__IconBattery80__ = __webpack_require__(679);
/* unused harmony reexport IconBattery80 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_402__IconBattery90__ = __webpack_require__(680);
/* unused harmony reexport IconBattery90 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_403__IconBatteryAlert__ = __webpack_require__(681);
/* unused harmony reexport IconBatteryAlert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_404__IconBatteryCharging20__ = __webpack_require__(682);
/* unused harmony reexport IconBatteryCharging20 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_405__IconBatteryCharging30__ = __webpack_require__(683);
/* unused harmony reexport IconBatteryCharging30 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_406__IconBatteryCharging50__ = __webpack_require__(684);
/* unused harmony reexport IconBatteryCharging50 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_407__IconBatteryCharging60__ = __webpack_require__(685);
/* unused harmony reexport IconBatteryCharging60 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_408__IconBatteryCharging80__ = __webpack_require__(686);
/* unused harmony reexport IconBatteryCharging80 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_409__IconBatteryCharging90__ = __webpack_require__(687);
/* unused harmony reexport IconBatteryCharging90 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_410__IconBatteryChargingFull__ = __webpack_require__(688);
/* unused harmony reexport IconBatteryChargingFull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_411__IconBatteryFull__ = __webpack_require__(689);
/* unused harmony reexport IconBatteryFull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_412__IconBatteryStd__ = __webpack_require__(690);
/* unused harmony reexport IconBatteryStd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_413__IconBatteryUnknown__ = __webpack_require__(691);
/* unused harmony reexport IconBatteryUnknown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_414__IconBluetooth__ = __webpack_require__(692);
/* unused harmony reexport IconBluetooth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_415__IconBluetoothConnected__ = __webpack_require__(693);
/* unused harmony reexport IconBluetoothConnected */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_416__IconBluetoothDisabled__ = __webpack_require__(694);
/* unused harmony reexport IconBluetoothDisabled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_417__IconBluetoothSearching__ = __webpack_require__(695);
/* unused harmony reexport IconBluetoothSearching */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_418__IconBrightnessAuto__ = __webpack_require__(696);
/* unused harmony reexport IconBrightnessAuto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_419__IconBrightnessHigh__ = __webpack_require__(697);
/* unused harmony reexport IconBrightnessHigh */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_420__IconBrightnessLow__ = __webpack_require__(698);
/* unused harmony reexport IconBrightnessLow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_421__IconBrightnessMedium__ = __webpack_require__(699);
/* unused harmony reexport IconBrightnessMedium */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_422__IconDataUsage__ = __webpack_require__(700);
/* unused harmony reexport IconDataUsage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_423__IconDeveloperMode__ = __webpack_require__(701);
/* unused harmony reexport IconDeveloperMode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_424__IconDevices__ = __webpack_require__(702);
/* unused harmony reexport IconDevices */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_425__IconDvr__ = __webpack_require__(703);
/* unused harmony reexport IconDvr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_426__IconGpsFixed__ = __webpack_require__(704);
/* unused harmony reexport IconGpsFixed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_427__IconGpsNotFixed__ = __webpack_require__(705);
/* unused harmony reexport IconGpsNotFixed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_428__IconGpsOff__ = __webpack_require__(706);
/* unused harmony reexport IconGpsOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_429__IconGraphicEq__ = __webpack_require__(707);
/* unused harmony reexport IconGraphicEq */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_430__IconLocationDisabled__ = __webpack_require__(708);
/* unused harmony reexport IconLocationDisabled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_431__IconLocationSearching__ = __webpack_require__(709);
/* unused harmony reexport IconLocationSearching */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_432__IconNetworkCell__ = __webpack_require__(710);
/* unused harmony reexport IconNetworkCell */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_433__IconNetworkWifi__ = __webpack_require__(711);
/* unused harmony reexport IconNetworkWifi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_434__IconNfc__ = __webpack_require__(712);
/* unused harmony reexport IconNfc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_435__IconScreenLockLandscape__ = __webpack_require__(713);
/* unused harmony reexport IconScreenLockLandscape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_436__IconScreenLockPortrait__ = __webpack_require__(714);
/* unused harmony reexport IconScreenLockPortrait */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_437__IconScreenLockRotation__ = __webpack_require__(715);
/* unused harmony reexport IconScreenLockRotation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_438__IconScreenRotation__ = __webpack_require__(716);
/* unused harmony reexport IconScreenRotation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_439__IconSdStorage__ = __webpack_require__(717);
/* unused harmony reexport IconSdStorage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_440__IconSettingsSystemDaydream__ = __webpack_require__(718);
/* unused harmony reexport IconSettingsSystemDaydream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_441__IconSignalCellular0Bar__ = __webpack_require__(719);
/* unused harmony reexport IconSignalCellular0Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_442__IconSignalCellular1Bar__ = __webpack_require__(720);
/* unused harmony reexport IconSignalCellular1Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_443__IconSignalCellular2Bar__ = __webpack_require__(721);
/* unused harmony reexport IconSignalCellular2Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_444__IconSignalCellular3Bar__ = __webpack_require__(722);
/* unused harmony reexport IconSignalCellular3Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_445__IconSignalCellular4Bar__ = __webpack_require__(723);
/* unused harmony reexport IconSignalCellular4Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_446__IconSignalCellularConnectedNoInternet0Bar__ = __webpack_require__(724);
/* unused harmony reexport IconSignalCellularConnectedNoInternet0Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_447__IconSignalCellularConnectedNoInternet1Bar__ = __webpack_require__(725);
/* unused harmony reexport IconSignalCellularConnectedNoInternet1Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_448__IconSignalCellularConnectedNoInternet2Bar__ = __webpack_require__(726);
/* unused harmony reexport IconSignalCellularConnectedNoInternet2Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_449__IconSignalCellularConnectedNoInternet3Bar__ = __webpack_require__(727);
/* unused harmony reexport IconSignalCellularConnectedNoInternet3Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_450__IconSignalCellularConnectedNoInternet4Bar__ = __webpack_require__(728);
/* unused harmony reexport IconSignalCellularConnectedNoInternet4Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_451__IconSignalCellularNoSim__ = __webpack_require__(729);
/* unused harmony reexport IconSignalCellularNoSim */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_452__IconSignalCellularNull__ = __webpack_require__(730);
/* unused harmony reexport IconSignalCellularNull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_453__IconSignalCellularOff__ = __webpack_require__(731);
/* unused harmony reexport IconSignalCellularOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_454__IconSignalWifi0Bar__ = __webpack_require__(732);
/* unused harmony reexport IconSignalWifi0Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_455__IconSignalWifi1Bar__ = __webpack_require__(733);
/* unused harmony reexport IconSignalWifi1Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_456__IconSignalWifi1BarLock__ = __webpack_require__(734);
/* unused harmony reexport IconSignalWifi1BarLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_457__IconSignalWifi2Bar__ = __webpack_require__(735);
/* unused harmony reexport IconSignalWifi2Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_458__IconSignalWifi2BarLock__ = __webpack_require__(736);
/* unused harmony reexport IconSignalWifi2BarLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_459__IconSignalWifi3Bar__ = __webpack_require__(737);
/* unused harmony reexport IconSignalWifi3Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_460__IconSignalWifi3BarLock__ = __webpack_require__(738);
/* unused harmony reexport IconSignalWifi3BarLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_461__IconSignalWifi4Bar__ = __webpack_require__(739);
/* unused harmony reexport IconSignalWifi4Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_462__IconSignalWifi4BarLock__ = __webpack_require__(740);
/* unused harmony reexport IconSignalWifi4BarLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_463__IconSignalWifiOff__ = __webpack_require__(741);
/* unused harmony reexport IconSignalWifiOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_464__IconStorage__ = __webpack_require__(742);
/* unused harmony reexport IconStorage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_465__IconUsb__ = __webpack_require__(743);
/* unused harmony reexport IconUsb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_466__IconWallpaper__ = __webpack_require__(744);
/* unused harmony reexport IconWallpaper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_467__IconWidgets__ = __webpack_require__(745);
/* unused harmony reexport IconWidgets */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_468__IconWifiLock__ = __webpack_require__(746);
/* unused harmony reexport IconWifiLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_469__IconWifiTethering__ = __webpack_require__(747);
/* unused harmony reexport IconWifiTethering */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_470__IconAttachFile__ = __webpack_require__(748);
/* unused harmony reexport IconAttachFile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_471__IconAttachMoney__ = __webpack_require__(749);
/* unused harmony reexport IconAttachMoney */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_472__IconBorderAll__ = __webpack_require__(750);
/* unused harmony reexport IconBorderAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_473__IconBorderBottom__ = __webpack_require__(751);
/* unused harmony reexport IconBorderBottom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_474__IconBorderClear__ = __webpack_require__(752);
/* unused harmony reexport IconBorderClear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_475__IconBorderColor__ = __webpack_require__(753);
/* unused harmony reexport IconBorderColor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_476__IconBorderHorizontal__ = __webpack_require__(754);
/* unused harmony reexport IconBorderHorizontal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_477__IconBorderInner__ = __webpack_require__(755);
/* unused harmony reexport IconBorderInner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_478__IconBorderLeft__ = __webpack_require__(756);
/* unused harmony reexport IconBorderLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_479__IconBorderOuter__ = __webpack_require__(757);
/* unused harmony reexport IconBorderOuter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_480__IconBorderRight__ = __webpack_require__(758);
/* unused harmony reexport IconBorderRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_481__IconBorderStyle__ = __webpack_require__(759);
/* unused harmony reexport IconBorderStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_482__IconBorderTop__ = __webpack_require__(760);
/* unused harmony reexport IconBorderTop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_483__IconBorderVertical__ = __webpack_require__(761);
/* unused harmony reexport IconBorderVertical */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_484__IconBubbleChart__ = __webpack_require__(762);
/* unused harmony reexport IconBubbleChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_485__IconDragHandle__ = __webpack_require__(763);
/* unused harmony reexport IconDragHandle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_486__IconFormatAlignCenter__ = __webpack_require__(764);
/* unused harmony reexport IconFormatAlignCenter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_487__IconFormatAlignJustify__ = __webpack_require__(765);
/* unused harmony reexport IconFormatAlignJustify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_488__IconFormatAlignLeft__ = __webpack_require__(766);
/* unused harmony reexport IconFormatAlignLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_489__IconFormatAlignRight__ = __webpack_require__(767);
/* unused harmony reexport IconFormatAlignRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_490__IconFormatBold__ = __webpack_require__(768);
/* unused harmony reexport IconFormatBold */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_491__IconFormatClear__ = __webpack_require__(769);
/* unused harmony reexport IconFormatClear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_492__IconFormatColorFill__ = __webpack_require__(770);
/* unused harmony reexport IconFormatColorFill */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_493__IconFormatColorReset__ = __webpack_require__(771);
/* unused harmony reexport IconFormatColorReset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_494__IconFormatColorText__ = __webpack_require__(772);
/* unused harmony reexport IconFormatColorText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_495__IconFormatIndentDecrease__ = __webpack_require__(773);
/* unused harmony reexport IconFormatIndentDecrease */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_496__IconFormatIndentIncrease__ = __webpack_require__(774);
/* unused harmony reexport IconFormatIndentIncrease */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_497__IconFormatItalic__ = __webpack_require__(775);
/* unused harmony reexport IconFormatItalic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_498__IconFormatLineSpacing__ = __webpack_require__(776);
/* unused harmony reexport IconFormatLineSpacing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_499__IconFormatListBulleted__ = __webpack_require__(777);
/* unused harmony reexport IconFormatListBulleted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_500__IconFormatListNumbered__ = __webpack_require__(778);
/* unused harmony reexport IconFormatListNumbered */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_501__IconFormatPaint__ = __webpack_require__(779);
/* unused harmony reexport IconFormatPaint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_502__IconFormatQuote__ = __webpack_require__(780);
/* unused harmony reexport IconFormatQuote */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_503__IconFormatShapes__ = __webpack_require__(781);
/* unused harmony reexport IconFormatShapes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_504__IconFormatSize__ = __webpack_require__(782);
/* unused harmony reexport IconFormatSize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_505__IconFormatStrikethrough__ = __webpack_require__(783);
/* unused harmony reexport IconFormatStrikethrough */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_506__IconFormatTextdirectionLToR__ = __webpack_require__(784);
/* unused harmony reexport IconFormatTextdirectionLToR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_507__IconFormatTextdirectionRToL__ = __webpack_require__(785);
/* unused harmony reexport IconFormatTextdirectionRToL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_508__IconFormatUnderlined__ = __webpack_require__(786);
/* unused harmony reexport IconFormatUnderlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_509__IconFunctions__ = __webpack_require__(787);
/* unused harmony reexport IconFunctions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_510__IconHighlight__ = __webpack_require__(788);
/* unused harmony reexport IconHighlight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_511__IconInsertChart__ = __webpack_require__(789);
/* unused harmony reexport IconInsertChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_512__IconInsertComment__ = __webpack_require__(790);
/* unused harmony reexport IconInsertComment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_513__IconInsertDriveFile__ = __webpack_require__(791);
/* unused harmony reexport IconInsertDriveFile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_514__IconInsertEmoticon__ = __webpack_require__(792);
/* unused harmony reexport IconInsertEmoticon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_515__IconInsertInvitation__ = __webpack_require__(793);
/* unused harmony reexport IconInsertInvitation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_516__IconInsertLink__ = __webpack_require__(794);
/* unused harmony reexport IconInsertLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_517__IconInsertPhoto__ = __webpack_require__(795);
/* unused harmony reexport IconInsertPhoto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_518__IconLinearScale__ = __webpack_require__(796);
/* unused harmony reexport IconLinearScale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_519__IconMergeType__ = __webpack_require__(797);
/* unused harmony reexport IconMergeType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_520__IconModeComment__ = __webpack_require__(798);
/* unused harmony reexport IconModeComment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_521__IconModeEdit__ = __webpack_require__(799);
/* unused harmony reexport IconModeEdit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_522__IconMonetizationOn__ = __webpack_require__(800);
/* unused harmony reexport IconMonetizationOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_523__IconMoneyOff__ = __webpack_require__(801);
/* unused harmony reexport IconMoneyOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_524__IconMultilineChart__ = __webpack_require__(802);
/* unused harmony reexport IconMultilineChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_525__IconPieChart__ = __webpack_require__(803);
/* unused harmony reexport IconPieChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_526__IconPieChartOutlined__ = __webpack_require__(804);
/* unused harmony reexport IconPieChartOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_527__IconPublish__ = __webpack_require__(805);
/* unused harmony reexport IconPublish */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_528__IconShortText__ = __webpack_require__(806);
/* unused harmony reexport IconShortText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_529__IconShowChart__ = __webpack_require__(807);
/* unused harmony reexport IconShowChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_530__IconSpaceBar__ = __webpack_require__(808);
/* unused harmony reexport IconSpaceBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_531__IconStrikethroughS__ = __webpack_require__(809);
/* unused harmony reexport IconStrikethroughS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_532__IconTextFields__ = __webpack_require__(810);
/* unused harmony reexport IconTextFields */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_533__IconTitle__ = __webpack_require__(811);
/* unused harmony reexport IconTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_534__IconVerticalAlignBottom__ = __webpack_require__(812);
/* unused harmony reexport IconVerticalAlignBottom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_535__IconVerticalAlignCenter__ = __webpack_require__(813);
/* unused harmony reexport IconVerticalAlignCenter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_536__IconVerticalAlignTop__ = __webpack_require__(814);
/* unused harmony reexport IconVerticalAlignTop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_537__IconWrapText__ = __webpack_require__(815);
/* unused harmony reexport IconWrapText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_538__IconAttachment__ = __webpack_require__(816);
/* unused harmony reexport IconAttachment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_539__IconCloud__ = __webpack_require__(39);
/* unused harmony reexport IconCloud */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_540__IconCloudCircle__ = __webpack_require__(817);
/* unused harmony reexport IconCloudCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_541__IconCloudDone__ = __webpack_require__(818);
/* unused harmony reexport IconCloudDone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_542__IconCloudDownload__ = __webpack_require__(819);
/* unused harmony reexport IconCloudDownload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_543__IconCloudOff__ = __webpack_require__(820);
/* unused harmony reexport IconCloudOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_544__IconCloudQueue__ = __webpack_require__(821);
/* unused harmony reexport IconCloudQueue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_545__IconCloudUpload__ = __webpack_require__(822);
/* unused harmony reexport IconCloudUpload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_546__IconCreateNewFolder__ = __webpack_require__(823);
/* unused harmony reexport IconCreateNewFolder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_547__IconFileDownload__ = __webpack_require__(824);
/* unused harmony reexport IconFileDownload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_548__IconFileUpload__ = __webpack_require__(825);
/* unused harmony reexport IconFileUpload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_549__IconFolder__ = __webpack_require__(826);
/* unused harmony reexport IconFolder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_550__IconFolderOpen__ = __webpack_require__(827);
/* unused harmony reexport IconFolderOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_551__IconFolderShared__ = __webpack_require__(828);
/* unused harmony reexport IconFolderShared */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_552__IconCast__ = __webpack_require__(829);
/* unused harmony reexport IconCast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_553__IconCastConnected__ = __webpack_require__(830);
/* unused harmony reexport IconCastConnected */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_554__IconComputer__ = __webpack_require__(831);
/* unused harmony reexport IconComputer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_555__IconDesktopMac__ = __webpack_require__(832);
/* unused harmony reexport IconDesktopMac */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_556__IconDesktopWindows__ = __webpack_require__(833);
/* unused harmony reexport IconDesktopWindows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_557__IconDeveloperBoard__ = __webpack_require__(834);
/* unused harmony reexport IconDeveloperBoard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_558__IconDeviceHub__ = __webpack_require__(835);
/* unused harmony reexport IconDeviceHub */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_559__IconDevicesOther__ = __webpack_require__(836);
/* unused harmony reexport IconDevicesOther */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_560__IconDock__ = __webpack_require__(837);
/* unused harmony reexport IconDock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_561__IconGamepad__ = __webpack_require__(838);
/* unused harmony reexport IconGamepad */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_562__IconHeadset__ = __webpack_require__(839);
/* unused harmony reexport IconHeadset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_563__IconHeadsetMic__ = __webpack_require__(840);
/* unused harmony reexport IconHeadsetMic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_564__IconKeyboard__ = __webpack_require__(841);
/* unused harmony reexport IconKeyboard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_565__IconKeyboardArrowDown__ = __webpack_require__(842);
/* unused harmony reexport IconKeyboardArrowDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_566__IconKeyboardArrowLeft__ = __webpack_require__(843);
/* unused harmony reexport IconKeyboardArrowLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_567__IconKeyboardArrowRight__ = __webpack_require__(844);
/* unused harmony reexport IconKeyboardArrowRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_568__IconKeyboardArrowUp__ = __webpack_require__(845);
/* unused harmony reexport IconKeyboardArrowUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_569__IconKeyboardBackspace__ = __webpack_require__(846);
/* unused harmony reexport IconKeyboardBackspace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_570__IconKeyboardCapslock__ = __webpack_require__(847);
/* unused harmony reexport IconKeyboardCapslock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_571__IconKeyboardHide__ = __webpack_require__(848);
/* unused harmony reexport IconKeyboardHide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_572__IconKeyboardReturn__ = __webpack_require__(849);
/* unused harmony reexport IconKeyboardReturn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_573__IconKeyboardTab__ = __webpack_require__(850);
/* unused harmony reexport IconKeyboardTab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_574__IconKeyboardVoice__ = __webpack_require__(851);
/* unused harmony reexport IconKeyboardVoice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_575__IconLaptop__ = __webpack_require__(852);
/* unused harmony reexport IconLaptop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_576__IconLaptopChromebook__ = __webpack_require__(853);
/* unused harmony reexport IconLaptopChromebook */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_577__IconLaptopMac__ = __webpack_require__(854);
/* unused harmony reexport IconLaptopMac */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_578__IconLaptopWindows__ = __webpack_require__(855);
/* unused harmony reexport IconLaptopWindows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_579__IconMemory__ = __webpack_require__(856);
/* unused harmony reexport IconMemory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_580__IconMouse__ = __webpack_require__(857);
/* unused harmony reexport IconMouse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_581__IconPhoneAndroid__ = __webpack_require__(858);
/* unused harmony reexport IconPhoneAndroid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_582__IconPhoneIphone__ = __webpack_require__(859);
/* unused harmony reexport IconPhoneIphone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_583__IconPhonelink__ = __webpack_require__(860);
/* unused harmony reexport IconPhonelink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_584__IconPhonelinkOff__ = __webpack_require__(861);
/* unused harmony reexport IconPhonelinkOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_585__IconPowerInput__ = __webpack_require__(862);
/* unused harmony reexport IconPowerInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_586__IconRouter__ = __webpack_require__(863);
/* unused harmony reexport IconRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_587__IconScanner__ = __webpack_require__(864);
/* unused harmony reexport IconScanner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_588__IconSecurity__ = __webpack_require__(865);
/* unused harmony reexport IconSecurity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_589__IconSimCard__ = __webpack_require__(866);
/* unused harmony reexport IconSimCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_590__IconSmartphone__ = __webpack_require__(867);
/* unused harmony reexport IconSmartphone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_591__IconSpeaker__ = __webpack_require__(868);
/* unused harmony reexport IconSpeaker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_592__IconSpeakerGroup__ = __webpack_require__(869);
/* unused harmony reexport IconSpeakerGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_593__IconTablet__ = __webpack_require__(870);
/* unused harmony reexport IconTablet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_594__IconTabletAndroid__ = __webpack_require__(871);
/* unused harmony reexport IconTabletAndroid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_595__IconTabletMac__ = __webpack_require__(872);
/* unused harmony reexport IconTabletMac */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_596__IconToys__ = __webpack_require__(873);
/* unused harmony reexport IconToys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_597__IconTv__ = __webpack_require__(874);
/* unused harmony reexport IconTv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_598__IconVideogameAsset__ = __webpack_require__(875);
/* unused harmony reexport IconVideogameAsset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_599__IconWatch__ = __webpack_require__(876);
/* unused harmony reexport IconWatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_600__IconAddAPhoto__ = __webpack_require__(877);
/* unused harmony reexport IconAddAPhoto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_601__IconAddToPhotos__ = __webpack_require__(878);
/* unused harmony reexport IconAddToPhotos */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_602__IconAdjust__ = __webpack_require__(879);
/* unused harmony reexport IconAdjust */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_603__IconAssistant__ = __webpack_require__(880);
/* unused harmony reexport IconAssistant */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_604__IconAssistantPhoto__ = __webpack_require__(881);
/* unused harmony reexport IconAssistantPhoto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_605__IconAudiotrack__ = __webpack_require__(882);
/* unused harmony reexport IconAudiotrack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_606__IconBlurCircular__ = __webpack_require__(883);
/* unused harmony reexport IconBlurCircular */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_607__IconBlurLinear__ = __webpack_require__(884);
/* unused harmony reexport IconBlurLinear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_608__IconBlurOff__ = __webpack_require__(885);
/* unused harmony reexport IconBlurOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_609__IconBlurOn__ = __webpack_require__(886);
/* unused harmony reexport IconBlurOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_610__IconBrightness1__ = __webpack_require__(887);
/* unused harmony reexport IconBrightness1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_611__IconBrightness2__ = __webpack_require__(888);
/* unused harmony reexport IconBrightness2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_612__IconBrightness3__ = __webpack_require__(889);
/* unused harmony reexport IconBrightness3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_613__IconBrightness4__ = __webpack_require__(890);
/* unused harmony reexport IconBrightness4 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_614__IconBrightness5__ = __webpack_require__(891);
/* unused harmony reexport IconBrightness5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_615__IconBrightness6__ = __webpack_require__(892);
/* unused harmony reexport IconBrightness6 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_616__IconBrightness7__ = __webpack_require__(893);
/* unused harmony reexport IconBrightness7 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_617__IconBrokenImage__ = __webpack_require__(894);
/* unused harmony reexport IconBrokenImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_618__IconBrush__ = __webpack_require__(895);
/* unused harmony reexport IconBrush */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_619__IconBurstMode__ = __webpack_require__(896);
/* unused harmony reexport IconBurstMode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_620__IconCamera__ = __webpack_require__(897);
/* unused harmony reexport IconCamera */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_621__IconCameraAlt__ = __webpack_require__(898);
/* unused harmony reexport IconCameraAlt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_622__IconCameraFront__ = __webpack_require__(899);
/* unused harmony reexport IconCameraFront */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_623__IconCameraRear__ = __webpack_require__(900);
/* unused harmony reexport IconCameraRear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_624__IconCameraRoll__ = __webpack_require__(901);
/* unused harmony reexport IconCameraRoll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_625__IconCenterFocusStrong__ = __webpack_require__(902);
/* unused harmony reexport IconCenterFocusStrong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_626__IconCenterFocusWeak__ = __webpack_require__(903);
/* unused harmony reexport IconCenterFocusWeak */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_627__IconCollections__ = __webpack_require__(904);
/* unused harmony reexport IconCollections */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_628__IconCollectionsBookmark__ = __webpack_require__(905);
/* unused harmony reexport IconCollectionsBookmark */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_629__IconColorLens__ = __webpack_require__(906);
/* unused harmony reexport IconColorLens */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_630__IconColorize__ = __webpack_require__(907);
/* unused harmony reexport IconColorize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_631__IconCompare__ = __webpack_require__(908);
/* unused harmony reexport IconCompare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_632__IconControlPoint__ = __webpack_require__(909);
/* unused harmony reexport IconControlPoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_633__IconControlPointDuplicate__ = __webpack_require__(910);
/* unused harmony reexport IconControlPointDuplicate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_634__IconCrop169__ = __webpack_require__(911);
/* unused harmony reexport IconCrop169 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_635__IconCrop__ = __webpack_require__(912);
/* unused harmony reexport IconCrop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_636__IconCrop32__ = __webpack_require__(913);
/* unused harmony reexport IconCrop32 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_637__IconCrop54__ = __webpack_require__(914);
/* unused harmony reexport IconCrop54 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_638__IconCrop75__ = __webpack_require__(915);
/* unused harmony reexport IconCrop75 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_639__IconCropDin__ = __webpack_require__(916);
/* unused harmony reexport IconCropDin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_640__IconCropFree__ = __webpack_require__(917);
/* unused harmony reexport IconCropFree */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_641__IconCropLandscape__ = __webpack_require__(918);
/* unused harmony reexport IconCropLandscape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_642__IconCropOriginal__ = __webpack_require__(919);
/* unused harmony reexport IconCropOriginal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_643__IconCropPortrait__ = __webpack_require__(920);
/* unused harmony reexport IconCropPortrait */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_644__IconCropRotate__ = __webpack_require__(921);
/* unused harmony reexport IconCropRotate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_645__IconCropSquare__ = __webpack_require__(922);
/* unused harmony reexport IconCropSquare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_646__IconDehaze__ = __webpack_require__(923);
/* unused harmony reexport IconDehaze */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_647__IconDetails__ = __webpack_require__(924);
/* unused harmony reexport IconDetails */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_648__IconEdit__ = __webpack_require__(925);
/* unused harmony reexport IconEdit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_649__IconExposure__ = __webpack_require__(926);
/* unused harmony reexport IconExposure */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_650__IconExposureNeg1__ = __webpack_require__(927);
/* unused harmony reexport IconExposureNeg1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_651__IconExposureNeg2__ = __webpack_require__(928);
/* unused harmony reexport IconExposureNeg2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_652__IconExposurePlus1__ = __webpack_require__(929);
/* unused harmony reexport IconExposurePlus1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_653__IconExposurePlus2__ = __webpack_require__(930);
/* unused harmony reexport IconExposurePlus2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_654__IconExposureZero__ = __webpack_require__(931);
/* unused harmony reexport IconExposureZero */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_655__IconFilter1__ = __webpack_require__(932);
/* unused harmony reexport IconFilter1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_656__IconFilter2__ = __webpack_require__(933);
/* unused harmony reexport IconFilter2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_657__IconFilter__ = __webpack_require__(934);
/* unused harmony reexport IconFilter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_658__IconFilter3__ = __webpack_require__(935);
/* unused harmony reexport IconFilter3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_659__IconFilter4__ = __webpack_require__(936);
/* unused harmony reexport IconFilter4 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_660__IconFilter5__ = __webpack_require__(937);
/* unused harmony reexport IconFilter5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_661__IconFilter6__ = __webpack_require__(938);
/* unused harmony reexport IconFilter6 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_662__IconFilter7__ = __webpack_require__(939);
/* unused harmony reexport IconFilter7 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_663__IconFilter8__ = __webpack_require__(940);
/* unused harmony reexport IconFilter8 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_664__IconFilter9__ = __webpack_require__(941);
/* unused harmony reexport IconFilter9 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_665__IconFilter9Plus__ = __webpack_require__(942);
/* unused harmony reexport IconFilter9Plus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_666__IconFilterBAndW__ = __webpack_require__(943);
/* unused harmony reexport IconFilterBAndW */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_667__IconFilterCenterFocus__ = __webpack_require__(944);
/* unused harmony reexport IconFilterCenterFocus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_668__IconFilterDrama__ = __webpack_require__(945);
/* unused harmony reexport IconFilterDrama */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_669__IconFilterFrames__ = __webpack_require__(946);
/* unused harmony reexport IconFilterFrames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_670__IconFilterHdr__ = __webpack_require__(947);
/* unused harmony reexport IconFilterHdr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_671__IconFilterNone__ = __webpack_require__(948);
/* unused harmony reexport IconFilterNone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_672__IconFilterTiltShift__ = __webpack_require__(949);
/* unused harmony reexport IconFilterTiltShift */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_673__IconFilterVintage__ = __webpack_require__(950);
/* unused harmony reexport IconFilterVintage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_674__IconFlare__ = __webpack_require__(951);
/* unused harmony reexport IconFlare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_675__IconFlashAuto__ = __webpack_require__(952);
/* unused harmony reexport IconFlashAuto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_676__IconFlashOff__ = __webpack_require__(953);
/* unused harmony reexport IconFlashOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_677__IconFlashOn__ = __webpack_require__(954);
/* unused harmony reexport IconFlashOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_678__IconFlip__ = __webpack_require__(955);
/* unused harmony reexport IconFlip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_679__IconGradient__ = __webpack_require__(956);
/* unused harmony reexport IconGradient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_680__IconGrain__ = __webpack_require__(957);
/* unused harmony reexport IconGrain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_681__IconGridOff__ = __webpack_require__(958);
/* unused harmony reexport IconGridOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_682__IconGridOn__ = __webpack_require__(959);
/* unused harmony reexport IconGridOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_683__IconHdrOff__ = __webpack_require__(960);
/* unused harmony reexport IconHdrOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_684__IconHdrOn__ = __webpack_require__(961);
/* unused harmony reexport IconHdrOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_685__IconHdrStrong__ = __webpack_require__(962);
/* unused harmony reexport IconHdrStrong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_686__IconHdrWeak__ = __webpack_require__(963);
/* unused harmony reexport IconHdrWeak */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_687__IconHealing__ = __webpack_require__(964);
/* unused harmony reexport IconHealing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_688__IconImage__ = __webpack_require__(965);
/* unused harmony reexport IconImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_689__IconImageAspectRatio__ = __webpack_require__(966);
/* unused harmony reexport IconImageAspectRatio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_690__IconIso__ = __webpack_require__(967);
/* unused harmony reexport IconIso */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_691__IconLandscape__ = __webpack_require__(968);
/* unused harmony reexport IconLandscape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_692__IconLeakAdd__ = __webpack_require__(969);
/* unused harmony reexport IconLeakAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_693__IconLeakRemove__ = __webpack_require__(970);
/* unused harmony reexport IconLeakRemove */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_694__IconLens__ = __webpack_require__(971);
/* unused harmony reexport IconLens */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_695__IconLinkedCamera__ = __webpack_require__(972);
/* unused harmony reexport IconLinkedCamera */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_696__IconLooks__ = __webpack_require__(973);
/* unused harmony reexport IconLooks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_697__IconLooks3__ = __webpack_require__(974);
/* unused harmony reexport IconLooks3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_698__IconLooks4__ = __webpack_require__(975);
/* unused harmony reexport IconLooks4 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_699__IconLooks5__ = __webpack_require__(976);
/* unused harmony reexport IconLooks5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_700__IconLooks6__ = __webpack_require__(977);
/* unused harmony reexport IconLooks6 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_701__IconLooksOne__ = __webpack_require__(978);
/* unused harmony reexport IconLooksOne */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_702__IconLooksTwo__ = __webpack_require__(979);
/* unused harmony reexport IconLooksTwo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_703__IconLoupe__ = __webpack_require__(980);
/* unused harmony reexport IconLoupe */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_704__IconMonochromePhotos__ = __webpack_require__(981);
/* unused harmony reexport IconMonochromePhotos */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_705__IconMovieCreation__ = __webpack_require__(982);
/* unused harmony reexport IconMovieCreation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_706__IconMovieFilter__ = __webpack_require__(983);
/* unused harmony reexport IconMovieFilter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_707__IconMusicNote__ = __webpack_require__(984);
/* unused harmony reexport IconMusicNote */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_708__IconNature__ = __webpack_require__(985);
/* unused harmony reexport IconNature */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_709__IconNaturePeople__ = __webpack_require__(986);
/* unused harmony reexport IconNaturePeople */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_710__IconNavigateBefore__ = __webpack_require__(987);
/* unused harmony reexport IconNavigateBefore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_711__IconNavigateNext__ = __webpack_require__(988);
/* unused harmony reexport IconNavigateNext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_712__IconPalette__ = __webpack_require__(989);
/* unused harmony reexport IconPalette */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_713__IconPanorama__ = __webpack_require__(990);
/* unused harmony reexport IconPanorama */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_714__IconPanoramaFishEye__ = __webpack_require__(991);
/* unused harmony reexport IconPanoramaFishEye */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_715__IconPanoramaHorizontal__ = __webpack_require__(992);
/* unused harmony reexport IconPanoramaHorizontal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_716__IconPanoramaVertical__ = __webpack_require__(993);
/* unused harmony reexport IconPanoramaVertical */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_717__IconPanoramaWideAngle__ = __webpack_require__(994);
/* unused harmony reexport IconPanoramaWideAngle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_718__IconPhoto__ = __webpack_require__(995);
/* unused harmony reexport IconPhoto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_719__IconPhotoAlbum__ = __webpack_require__(996);
/* unused harmony reexport IconPhotoAlbum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_720__IconPhotoCamera__ = __webpack_require__(997);
/* unused harmony reexport IconPhotoCamera */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_721__IconPhotoFilter__ = __webpack_require__(998);
/* unused harmony reexport IconPhotoFilter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_722__IconPhotoLibrary__ = __webpack_require__(999);
/* unused harmony reexport IconPhotoLibrary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_723__IconPhotoSizeSelectActual__ = __webpack_require__(1000);
/* unused harmony reexport IconPhotoSizeSelectActual */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_724__IconPhotoSizeSelectLarge__ = __webpack_require__(1001);
/* unused harmony reexport IconPhotoSizeSelectLarge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_725__IconPhotoSizeSelectSmall__ = __webpack_require__(1002);
/* unused harmony reexport IconPhotoSizeSelectSmall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_726__IconPictureAsPdf__ = __webpack_require__(1003);
/* unused harmony reexport IconPictureAsPdf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_727__IconPortrait__ = __webpack_require__(1004);
/* unused harmony reexport IconPortrait */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_728__IconRemoveRedEye__ = __webpack_require__(1005);
/* unused harmony reexport IconRemoveRedEye */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_729__IconRotate90DegreesCcw__ = __webpack_require__(1006);
/* unused harmony reexport IconRotate90DegreesCcw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_730__IconRotateLeft__ = __webpack_require__(1007);
/* unused harmony reexport IconRotateLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_731__IconRotateRight__ = __webpack_require__(1008);
/* unused harmony reexport IconRotateRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_732__IconSlideshow__ = __webpack_require__(1009);
/* unused harmony reexport IconSlideshow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_733__IconStraighten__ = __webpack_require__(1010);
/* unused harmony reexport IconStraighten */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_734__IconStyle__ = __webpack_require__(1011);
/* unused harmony reexport IconStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_735__IconSwitchCamera__ = __webpack_require__(1012);
/* unused harmony reexport IconSwitchCamera */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_736__IconSwitchVideo__ = __webpack_require__(1013);
/* unused harmony reexport IconSwitchVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_737__IconTagFaces__ = __webpack_require__(1014);
/* unused harmony reexport IconTagFaces */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_738__IconTexture__ = __webpack_require__(1015);
/* unused harmony reexport IconTexture */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_739__IconTimelapse__ = __webpack_require__(1016);
/* unused harmony reexport IconTimelapse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_740__IconTimer10__ = __webpack_require__(1017);
/* unused harmony reexport IconTimer10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_741__IconTimer__ = __webpack_require__(1018);
/* unused harmony reexport IconTimer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_742__IconTimer3__ = __webpack_require__(1019);
/* unused harmony reexport IconTimer3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_743__IconTimerOff__ = __webpack_require__(1020);
/* unused harmony reexport IconTimerOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_744__IconTonality__ = __webpack_require__(1021);
/* unused harmony reexport IconTonality */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_745__IconTransform__ = __webpack_require__(1022);
/* unused harmony reexport IconTransform */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_746__IconTune__ = __webpack_require__(1023);
/* unused harmony reexport IconTune */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_747__IconViewComfy__ = __webpack_require__(1024);
/* unused harmony reexport IconViewComfy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_748__IconViewCompact__ = __webpack_require__(1025);
/* unused harmony reexport IconViewCompact */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_749__IconVignette__ = __webpack_require__(1026);
/* unused harmony reexport IconVignette */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_750__IconWbAuto__ = __webpack_require__(1027);
/* unused harmony reexport IconWbAuto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_751__IconWbCloudy__ = __webpack_require__(1028);
/* unused harmony reexport IconWbCloudy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_752__IconWbIncandescent__ = __webpack_require__(1029);
/* unused harmony reexport IconWbIncandescent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_753__IconWbIridescent__ = __webpack_require__(1030);
/* unused harmony reexport IconWbIridescent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_754__IconWbSunny__ = __webpack_require__(1031);
/* unused harmony reexport IconWbSunny */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_755__IconAddLocation__ = __webpack_require__(1032);
/* unused harmony reexport IconAddLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_756__IconBeenhere__ = __webpack_require__(1033);
/* unused harmony reexport IconBeenhere */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_757__IconDirections__ = __webpack_require__(1034);
/* unused harmony reexport IconDirections */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_758__IconDirectionsBike__ = __webpack_require__(1035);
/* unused harmony reexport IconDirectionsBike */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_759__IconDirectionsBoat__ = __webpack_require__(1036);
/* unused harmony reexport IconDirectionsBoat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_760__IconDirectionsBus__ = __webpack_require__(1037);
/* unused harmony reexport IconDirectionsBus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_761__IconDirectionsCar__ = __webpack_require__(1038);
/* unused harmony reexport IconDirectionsCar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_762__IconDirectionsRailway__ = __webpack_require__(1039);
/* unused harmony reexport IconDirectionsRailway */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_763__IconDirectionsRun__ = __webpack_require__(1040);
/* unused harmony reexport IconDirectionsRun */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_764__IconDirectionsSubway__ = __webpack_require__(1041);
/* unused harmony reexport IconDirectionsSubway */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_765__IconDirectionsTransit__ = __webpack_require__(1042);
/* unused harmony reexport IconDirectionsTransit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_766__IconDirectionsWalk__ = __webpack_require__(1043);
/* unused harmony reexport IconDirectionsWalk */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_767__IconEditLocation__ = __webpack_require__(1044);
/* unused harmony reexport IconEditLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_768__IconEvStation__ = __webpack_require__(1045);
/* unused harmony reexport IconEvStation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_769__IconFlight__ = __webpack_require__(1046);
/* unused harmony reexport IconFlight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_770__IconHotel__ = __webpack_require__(1047);
/* unused harmony reexport IconHotel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_771__IconLayers__ = __webpack_require__(1048);
/* unused harmony reexport IconLayers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_772__IconLayersClear__ = __webpack_require__(1049);
/* unused harmony reexport IconLayersClear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_773__IconLocalActivity__ = __webpack_require__(1050);
/* unused harmony reexport IconLocalActivity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_774__IconLocalAirport__ = __webpack_require__(1051);
/* unused harmony reexport IconLocalAirport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_775__IconLocalAtm__ = __webpack_require__(1052);
/* unused harmony reexport IconLocalAtm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_776__IconLocalBar__ = __webpack_require__(1053);
/* unused harmony reexport IconLocalBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_777__IconLocalCafe__ = __webpack_require__(1054);
/* unused harmony reexport IconLocalCafe */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_778__IconLocalCarWash__ = __webpack_require__(1055);
/* unused harmony reexport IconLocalCarWash */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_779__IconLocalConvenienceStore__ = __webpack_require__(1056);
/* unused harmony reexport IconLocalConvenienceStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_780__IconLocalDining__ = __webpack_require__(1057);
/* unused harmony reexport IconLocalDining */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_781__IconLocalDrink__ = __webpack_require__(1058);
/* unused harmony reexport IconLocalDrink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_782__IconLocalFlorist__ = __webpack_require__(1059);
/* unused harmony reexport IconLocalFlorist */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_783__IconLocalGasStation__ = __webpack_require__(1060);
/* unused harmony reexport IconLocalGasStation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_784__IconLocalGroceryStore__ = __webpack_require__(1061);
/* unused harmony reexport IconLocalGroceryStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_785__IconLocalHospital__ = __webpack_require__(1062);
/* unused harmony reexport IconLocalHospital */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_786__IconLocalHotel__ = __webpack_require__(1063);
/* unused harmony reexport IconLocalHotel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_787__IconLocalLaundryService__ = __webpack_require__(185);
/* unused harmony reexport IconLocalLaundryService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_788__IconLocalLibrary__ = __webpack_require__(1064);
/* unused harmony reexport IconLocalLibrary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_789__IconLocalMall__ = __webpack_require__(1065);
/* unused harmony reexport IconLocalMall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_790__IconLocalMovies__ = __webpack_require__(1066);
/* unused harmony reexport IconLocalMovies */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_791__IconLocalOffer__ = __webpack_require__(184);
/* unused harmony reexport IconLocalOffer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_792__IconLocalParking__ = __webpack_require__(1067);
/* unused harmony reexport IconLocalParking */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_793__IconLocalPharmacy__ = __webpack_require__(1068);
/* unused harmony reexport IconLocalPharmacy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_794__IconLocalPhone__ = __webpack_require__(1069);
/* unused harmony reexport IconLocalPhone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_795__IconLocalPizza__ = __webpack_require__(1070);
/* unused harmony reexport IconLocalPizza */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_796__IconLocalPlay__ = __webpack_require__(183);
/* unused harmony reexport IconLocalPlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_797__IconLocalPostOffice__ = __webpack_require__(1071);
/* unused harmony reexport IconLocalPostOffice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_798__IconLocalPrintshop__ = __webpack_require__(1072);
/* unused harmony reexport IconLocalPrintshop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_799__IconLocalSee__ = __webpack_require__(1073);
/* unused harmony reexport IconLocalSee */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_800__IconLocalShipping__ = __webpack_require__(1074);
/* unused harmony reexport IconLocalShipping */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_801__IconLocalTaxi__ = __webpack_require__(1075);
/* unused harmony reexport IconLocalTaxi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_802__IconMap__ = __webpack_require__(1076);
/* unused harmony reexport IconMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_803__IconMyLocation__ = __webpack_require__(1077);
/* unused harmony reexport IconMyLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_804__IconNavigation__ = __webpack_require__(1078);
/* unused harmony reexport IconNavigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_805__IconNearMe__ = __webpack_require__(1079);
/* unused harmony reexport IconNearMe */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_806__IconPersonPin__ = __webpack_require__(1080);
/* unused harmony reexport IconPersonPin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_807__IconPersonPinCircle__ = __webpack_require__(1081);
/* unused harmony reexport IconPersonPinCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_808__IconPinDrop__ = __webpack_require__(1082);
/* unused harmony reexport IconPinDrop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_809__IconPlace__ = __webpack_require__(1083);
/* unused harmony reexport IconPlace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_810__IconRateReview__ = __webpack_require__(1084);
/* unused harmony reexport IconRateReview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_811__IconRestaurant__ = __webpack_require__(1085);
/* unused harmony reexport IconRestaurant */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_812__IconRestaurantMenu__ = __webpack_require__(1086);
/* unused harmony reexport IconRestaurantMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_813__IconSatellite__ = __webpack_require__(1087);
/* unused harmony reexport IconSatellite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_814__IconStoreMallDirectory__ = __webpack_require__(186);
/* unused harmony reexport IconStoreMallDirectory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_815__IconStreetview__ = __webpack_require__(187);
/* unused harmony reexport IconStreetview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_816__IconSubway__ = __webpack_require__(1088);
/* unused harmony reexport IconSubway */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_817__IconTerrain__ = __webpack_require__(1089);
/* unused harmony reexport IconTerrain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_818__IconTraffic__ = __webpack_require__(1090);
/* unused harmony reexport IconTraffic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_819__IconTrain__ = __webpack_require__(1091);
/* unused harmony reexport IconTrain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_820__IconTram__ = __webpack_require__(1092);
/* unused harmony reexport IconTram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_821__IconTransferWithinAStation__ = __webpack_require__(1093);
/* unused harmony reexport IconTransferWithinAStation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_822__IconZoomOutMap__ = __webpack_require__(1094);
/* unused harmony reexport IconZoomOutMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_823__IconApps__ = __webpack_require__(1095);
/* unused harmony reexport IconApps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_824__IconArrowBack__ = __webpack_require__(176);
/* unused harmony reexport IconArrowBack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_825__IconArrowDownward__ = __webpack_require__(1096);
/* unused harmony reexport IconArrowDownward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_826__IconArrowDropDown__ = __webpack_require__(1097);
/* unused harmony reexport IconArrowDropDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_827__IconArrowDropDownCircle__ = __webpack_require__(1098);
/* unused harmony reexport IconArrowDropDownCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_828__IconArrowDropUp__ = __webpack_require__(1099);
/* unused harmony reexport IconArrowDropUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_829__IconArrowForward__ = __webpack_require__(1100);
/* unused harmony reexport IconArrowForward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_830__IconArrowUpward__ = __webpack_require__(1101);
/* unused harmony reexport IconArrowUpward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_831__IconCancel__ = __webpack_require__(1102);
/* unused harmony reexport IconCancel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_832__IconCheck__ = __webpack_require__(119);
/* unused harmony reexport IconCheck */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_833__IconChevronLeft__ = __webpack_require__(1103);
/* unused harmony reexport IconChevronLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_834__IconChevronRight__ = __webpack_require__(1104);
/* unused harmony reexport IconChevronRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_835__IconClose__ = __webpack_require__(1105);
/* unused harmony reexport IconClose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_836__IconExpandLess__ = __webpack_require__(1106);
/* unused harmony reexport IconExpandLess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_837__IconExpandMore__ = __webpack_require__(1107);
/* unused harmony reexport IconExpandMore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_838__IconFirstPage__ = __webpack_require__(1108);
/* unused harmony reexport IconFirstPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_839__IconFullscreen__ = __webpack_require__(1109);
/* unused harmony reexport IconFullscreen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_840__IconFullscreenExit__ = __webpack_require__(1110);
/* unused harmony reexport IconFullscreenExit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_841__IconLastPage__ = __webpack_require__(1111);
/* unused harmony reexport IconLastPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_842__IconMenu__ = __webpack_require__(181);
/* unused harmony reexport IconMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_843__IconMoreHoriz__ = __webpack_require__(1112);
/* unused harmony reexport IconMoreHoriz */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_844__IconMoreVert__ = __webpack_require__(1113);
/* unused harmony reexport IconMoreVert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_845__IconRefresh__ = __webpack_require__(182);
/* unused harmony reexport IconRefresh */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_846__IconSubdirectoryArrowLeft__ = __webpack_require__(1114);
/* unused harmony reexport IconSubdirectoryArrowLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_847__IconSubdirectoryArrowRight__ = __webpack_require__(1115);
/* unused harmony reexport IconSubdirectoryArrowRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_848__IconUnfoldLess__ = __webpack_require__(1116);
/* unused harmony reexport IconUnfoldLess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_849__IconUnfoldMore__ = __webpack_require__(1117);
/* unused harmony reexport IconUnfoldMore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_850__IconAdb__ = __webpack_require__(1118);
/* unused harmony reexport IconAdb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_851__IconAirlineSeatFlat__ = __webpack_require__(1119);
/* unused harmony reexport IconAirlineSeatFlat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_852__IconAirlineSeatFlatAngled__ = __webpack_require__(1120);
/* unused harmony reexport IconAirlineSeatFlatAngled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_853__IconAirlineSeatIndividualSuite__ = __webpack_require__(1121);
/* unused harmony reexport IconAirlineSeatIndividualSuite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_854__IconAirlineSeatLegroomExtra__ = __webpack_require__(1122);
/* unused harmony reexport IconAirlineSeatLegroomExtra */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_855__IconAirlineSeatLegroomNormal__ = __webpack_require__(1123);
/* unused harmony reexport IconAirlineSeatLegroomNormal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_856__IconAirlineSeatLegroomReduced__ = __webpack_require__(1124);
/* unused harmony reexport IconAirlineSeatLegroomReduced */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_857__IconAirlineSeatReclineExtra__ = __webpack_require__(1125);
/* unused harmony reexport IconAirlineSeatReclineExtra */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_858__IconAirlineSeatReclineNormal__ = __webpack_require__(1126);
/* unused harmony reexport IconAirlineSeatReclineNormal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_859__IconBluetoothAudio__ = __webpack_require__(1127);
/* unused harmony reexport IconBluetoothAudio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_860__IconConfirmationNumber__ = __webpack_require__(1128);
/* unused harmony reexport IconConfirmationNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_861__IconDiscFull__ = __webpack_require__(1129);
/* unused harmony reexport IconDiscFull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_862__IconDoNotDisturb__ = __webpack_require__(1130);
/* unused harmony reexport IconDoNotDisturb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_863__IconDoNotDisturbAlt__ = __webpack_require__(1131);
/* unused harmony reexport IconDoNotDisturbAlt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_864__IconDoNotDisturbOff__ = __webpack_require__(1132);
/* unused harmony reexport IconDoNotDisturbOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_865__IconDoNotDisturbOn__ = __webpack_require__(1133);
/* unused harmony reexport IconDoNotDisturbOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_866__IconDriveEta__ = __webpack_require__(1134);
/* unused harmony reexport IconDriveEta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_867__IconEnhancedEncryption__ = __webpack_require__(1135);
/* unused harmony reexport IconEnhancedEncryption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_868__IconEventAvailable__ = __webpack_require__(1136);
/* unused harmony reexport IconEventAvailable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_869__IconEventBusy__ = __webpack_require__(1137);
/* unused harmony reexport IconEventBusy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_870__IconEventNote__ = __webpack_require__(1138);
/* unused harmony reexport IconEventNote */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_871__IconFolderSpecial__ = __webpack_require__(1139);
/* unused harmony reexport IconFolderSpecial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_872__IconLiveTv__ = __webpack_require__(1140);
/* unused harmony reexport IconLiveTv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_873__IconMms__ = __webpack_require__(1141);
/* unused harmony reexport IconMms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_874__IconMore__ = __webpack_require__(1142);
/* unused harmony reexport IconMore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_875__IconNetworkCheck__ = __webpack_require__(1143);
/* unused harmony reexport IconNetworkCheck */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_876__IconNetworkLocked__ = __webpack_require__(1144);
/* unused harmony reexport IconNetworkLocked */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_877__IconNoEncryption__ = __webpack_require__(1145);
/* unused harmony reexport IconNoEncryption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_878__IconOndemandVideo__ = __webpack_require__(1146);
/* unused harmony reexport IconOndemandVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_879__IconPersonalVideo__ = __webpack_require__(1147);
/* unused harmony reexport IconPersonalVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_880__IconPhoneBluetoothSpeaker__ = __webpack_require__(1148);
/* unused harmony reexport IconPhoneBluetoothSpeaker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_881__IconPhoneForwarded__ = __webpack_require__(1149);
/* unused harmony reexport IconPhoneForwarded */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_882__IconPhoneInTalk__ = __webpack_require__(1150);
/* unused harmony reexport IconPhoneInTalk */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_883__IconPhoneLocked__ = __webpack_require__(1151);
/* unused harmony reexport IconPhoneLocked */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_884__IconPhoneMissed__ = __webpack_require__(1152);
/* unused harmony reexport IconPhoneMissed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_885__IconPhonePaused__ = __webpack_require__(1153);
/* unused harmony reexport IconPhonePaused */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_886__IconPower__ = __webpack_require__(1154);
/* unused harmony reexport IconPower */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_887__IconPriorityHigh__ = __webpack_require__(1155);
/* unused harmony reexport IconPriorityHigh */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_888__IconRvHookup__ = __webpack_require__(1156);
/* unused harmony reexport IconRvHookup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_889__IconSdCard__ = __webpack_require__(1157);
/* unused harmony reexport IconSdCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_890__IconSimCardAlert__ = __webpack_require__(1158);
/* unused harmony reexport IconSimCardAlert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_891__IconSms__ = __webpack_require__(1159);
/* unused harmony reexport IconSms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_892__IconSmsFailed__ = __webpack_require__(1160);
/* unused harmony reexport IconSmsFailed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_893__IconSync__ = __webpack_require__(1161);
/* unused harmony reexport IconSync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_894__IconSyncDisabled__ = __webpack_require__(1162);
/* unused harmony reexport IconSyncDisabled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_895__IconSyncProblem__ = __webpack_require__(1163);
/* unused harmony reexport IconSyncProblem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_896__IconSystemUpdate__ = __webpack_require__(1164);
/* unused harmony reexport IconSystemUpdate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_897__IconTapAndPlay__ = __webpack_require__(1165);
/* unused harmony reexport IconTapAndPlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_898__IconTimeToLeave__ = __webpack_require__(1166);
/* unused harmony reexport IconTimeToLeave */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_899__IconVibration__ = __webpack_require__(1167);
/* unused harmony reexport IconVibration */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_900__IconVoiceChat__ = __webpack_require__(1168);
/* unused harmony reexport IconVoiceChat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_901__IconVpnLock__ = __webpack_require__(1169);
/* unused harmony reexport IconVpnLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_902__IconWc__ = __webpack_require__(1170);
/* unused harmony reexport IconWc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_903__IconWifi__ = __webpack_require__(1171);
/* unused harmony reexport IconWifi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_904__IconAcUnit__ = __webpack_require__(1172);
/* unused harmony reexport IconAcUnit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_905__IconAirportShuttle__ = __webpack_require__(1173);
/* unused harmony reexport IconAirportShuttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_906__IconAllInclusive__ = __webpack_require__(1174);
/* unused harmony reexport IconAllInclusive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_907__IconBeachAccess__ = __webpack_require__(1175);
/* unused harmony reexport IconBeachAccess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_908__IconBusinessCenter__ = __webpack_require__(1176);
/* unused harmony reexport IconBusinessCenter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_909__IconCasino__ = __webpack_require__(1177);
/* unused harmony reexport IconCasino */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_910__IconChildCare__ = __webpack_require__(1178);
/* unused harmony reexport IconChildCare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_911__IconChildFriendly__ = __webpack_require__(1179);
/* unused harmony reexport IconChildFriendly */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_912__IconFitnessCenter__ = __webpack_require__(1180);
/* unused harmony reexport IconFitnessCenter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_913__IconFreeBreakfast__ = __webpack_require__(1181);
/* unused harmony reexport IconFreeBreakfast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_914__IconGolfCourse__ = __webpack_require__(1182);
/* unused harmony reexport IconGolfCourse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_915__IconHotTub__ = __webpack_require__(1183);
/* unused harmony reexport IconHotTub */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_916__IconKitchen__ = __webpack_require__(1184);
/* unused harmony reexport IconKitchen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_917__IconPool__ = __webpack_require__(1185);
/* unused harmony reexport IconPool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_918__IconRoomService__ = __webpack_require__(1186);
/* unused harmony reexport IconRoomService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_919__IconSmokeFree__ = __webpack_require__(1187);
/* unused harmony reexport IconSmokeFree */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_920__IconSmokingRooms__ = __webpack_require__(1188);
/* unused harmony reexport IconSmokingRooms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_921__IconSpa__ = __webpack_require__(1189);
/* unused harmony reexport IconSpa */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_922__IconCake__ = __webpack_require__(1190);
/* unused harmony reexport IconCake */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_923__IconDomain__ = __webpack_require__(1191);
/* unused harmony reexport IconDomain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_924__IconGroup__ = __webpack_require__(1192);
/* unused harmony reexport IconGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_925__IconGroupAdd__ = __webpack_require__(1193);
/* unused harmony reexport IconGroupAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_926__IconLocationCity__ = __webpack_require__(1194);
/* unused harmony reexport IconLocationCity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_927__IconMood__ = __webpack_require__(1195);
/* unused harmony reexport IconMood */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_928__IconMoodBad__ = __webpack_require__(1196);
/* unused harmony reexport IconMoodBad */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_929__IconNotifications__ = __webpack_require__(1197);
/* unused harmony reexport IconNotifications */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_930__IconNotificationsActive__ = __webpack_require__(1198);
/* unused harmony reexport IconNotificationsActive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_931__IconNotificationsNone__ = __webpack_require__(1199);
/* unused harmony reexport IconNotificationsNone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_932__IconNotificationsOff__ = __webpack_require__(1200);
/* unused harmony reexport IconNotificationsOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_933__IconNotificationsPaused__ = __webpack_require__(1201);
/* unused harmony reexport IconNotificationsPaused */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_934__IconPages__ = __webpack_require__(1202);
/* unused harmony reexport IconPages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_935__IconPartyMode__ = __webpack_require__(1203);
/* unused harmony reexport IconPartyMode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_936__IconPeople__ = __webpack_require__(1204);
/* unused harmony reexport IconPeople */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_937__IconPeopleOutline__ = __webpack_require__(1205);
/* unused harmony reexport IconPeopleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_938__IconPerson__ = __webpack_require__(1206);
/* unused harmony reexport IconPerson */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_939__IconPersonAdd__ = __webpack_require__(1207);
/* unused harmony reexport IconPersonAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_940__IconPersonOutline__ = __webpack_require__(1208);
/* unused harmony reexport IconPersonOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_941__IconPlusOne__ = __webpack_require__(1209);
/* unused harmony reexport IconPlusOne */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_942__IconPoll__ = __webpack_require__(1210);
/* unused harmony reexport IconPoll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_943__IconPublic__ = __webpack_require__(1211);
/* unused harmony reexport IconPublic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_944__IconSchool__ = __webpack_require__(1212);
/* unused harmony reexport IconSchool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_945__IconSentimentDissatisfied__ = __webpack_require__(1213);
/* unused harmony reexport IconSentimentDissatisfied */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_946__IconSentimentNeutral__ = __webpack_require__(1214);
/* unused harmony reexport IconSentimentNeutral */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_947__IconSentimentSatisfied__ = __webpack_require__(79);
/* unused harmony reexport IconSentimentSatisfied */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_948__IconSentimentVeryDissatisfied__ = __webpack_require__(1215);
/* unused harmony reexport IconSentimentVeryDissatisfied */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_949__IconSentimentVerySatisfied__ = __webpack_require__(1216);
/* unused harmony reexport IconSentimentVerySatisfied */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_950__IconShare__ = __webpack_require__(1217);
/* unused harmony reexport IconShare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_951__IconWhatshot__ = __webpack_require__(1218);
/* unused harmony reexport IconWhatshot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_952__IconCheckBox__ = __webpack_require__(1219);
/* unused harmony reexport IconCheckBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_953__IconCheckBoxOutlineBlank__ = __webpack_require__(1220);
/* unused harmony reexport IconCheckBoxOutlineBlank */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_954__IconIndeterminateCheckBox__ = __webpack_require__(1221);
/* unused harmony reexport IconIndeterminateCheckBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_955__IconRadioButtonChecked__ = __webpack_require__(1222);
/* unused harmony reexport IconRadioButtonChecked */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_956__IconRadioButtonUnchecked__ = __webpack_require__(1223);
/* unused harmony reexport IconRadioButtonUnchecked */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_957__IconStar__ = __webpack_require__(1224);
/* unused harmony reexport IconStar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_958__IconStarBorder__ = __webpack_require__(1225);
/* unused harmony reexport IconStarBorder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_959__IconStarHalf__ = __webpack_require__(1226);
/* unused harmony reexport IconStarHalf */
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* eslint-disable prettier/prettier */

































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon_IconHelp__ = __webpack_require__(125);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'rtl',
  title: 'RTL',
  description: 'Some icons will be [automatically mirrored](http://google.github.io/material-design-icons/#which-icons-should-be-mirrored-for-rtl-) for RTL (right-to-left) languages, depending on context.',
  scope: { IconHelp: __WEBPACK_IMPORTED_MODULE_1__Icon_IconHelp__["a" /* default */], ThemeProvider: __WEBPACK_IMPORTED_MODULE_0__themes__["a" /* ThemeProvider */] },
  source: '\n    <ThemeProvider theme={{ direction: \'rtl\' }}>\n      <IconHelp />\n    </ThemeProvider>'
});

/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon_IconSentimentSatisfied__ = __webpack_require__(79);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'sizes',
  title: 'Sizes',
  description: 'Icons are available in three preset sizes, or you can supply your own custom size.',
  scope: { IconSentimentSatisfied: __WEBPACK_IMPORTED_MODULE_0__Icon_IconSentimentSatisfied__["a" /* default */] },
  source: '\n    <div>\n      <IconSentimentSatisfied size="small" />\n      <IconSentimentSatisfied />\n      <IconSentimentSatisfied size="large" />\n      <IconSentimentSatisfied size="7em" />\n    </div>'
});

/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon_IconSentimentSatisfied__ = __webpack_require__(79);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'title',
  title: 'Title',
  description: 'Standalone icons need a title, as opposed to decorative icons (those that repeat the information conveyed by text or do not add significant value).',
  scope: { IconSentimentSatisfied: __WEBPACK_IMPORTED_MODULE_0__Icon_IconSentimentSatisfied__["a" /* default */] },
  source: '<IconSentimentSatisfied title="smiley-face" />'
});

/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CategoryIndex__ = __webpack_require__(1633);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'categories',
  title: 'Icons by Category',
  hideSource: true,
  scope: { CategoryIndex: __WEBPACK_IMPORTED_MODULE_0__components_CategoryIndex__["a" /* default */] },
  source: '<CategoryIndex />'
});

/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CategoryIndex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categories_ActionIcons__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__categories_AlertIcons__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__categories_AvIcons__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__categories_CommunicationIcons__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__categories_ContentIcons__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__categories_DeviceIcons__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__categories_EditorIcons__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__categories_FileIcons__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__categories_HardwareIcons__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__categories_ImageIcons__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__categories_MapsIcons__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__categories_NavigationIcons__ = __webpack_require__(1645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__categories_NotificationIcons__ = __webpack_require__(1646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__categories_PlacesIcons__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__categories_SocialIcons__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__categories_ToggleIcons__ = __webpack_require__(1649);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* eslint-disable prettier/prettier */

















var _ref = _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__categories_ActionIcons__["a" /* default */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_2__categories_AlertIcons__["a" /* default */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_3__categories_AvIcons__["a" /* default */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_4__categories_CommunicationIcons__["a" /* default */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_5__categories_ContentIcons__["a" /* default */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_6__categories_DeviceIcons__["a" /* default */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_7__categories_EditorIcons__["a" /* default */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_8__categories_FileIcons__["a" /* default */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_9__categories_HardwareIcons__["a" /* default */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_10__categories_ImageIcons__["a" /* default */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_11__categories_MapsIcons__["a" /* default */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_12__categories_NavigationIcons__["a" /* default */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_13__categories_NotificationIcons__["a" /* default */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_14__categories_PlacesIcons__["a" /* default */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_15__categories_SocialIcons__["a" /* default */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_16__categories_ToggleIcons__["a" /* default */], {}));

function CategoryIndex() {
  return _ref;
}

/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ActionIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Figure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FigCaption__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FigContainer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryHeader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_Icon3DRotation__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon_IconAccessibility__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon_IconAccessible__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icon_IconAccountBalance__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icon_IconAccountBalanceWallet__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icon_IconAccountBox__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon_IconAccountCircle__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icon_IconAddShoppingCart__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icon_IconAlarm__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icon_IconAlarmAdd__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Icon_IconAlarmOff__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icon_IconAlarmOn__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Icon_IconAllOut__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Icon_IconAndroid__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Icon_IconAnnouncement__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Icon_IconAspectRatio__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Icon_IconAssessment__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Icon_IconAssignment__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Icon_IconAssignmentInd__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Icon_IconAssignmentLate__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Icon_IconAssignmentReturn__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Icon_IconAssignmentReturned__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Icon_IconAssignmentTurnedIn__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Icon_IconAutorenew__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Icon_IconBackup__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Icon_IconBook__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Icon_IconBookmark__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Icon_IconBookmarkBorder__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Icon_IconBugReport__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Icon_IconBuild__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Icon_IconCached__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Icon_IconCameraEnhance__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Icon_IconCardGiftcard__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Icon_IconCardMembership__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Icon_IconCardTravel__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Icon_IconChangeHistory__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Icon_IconCheckCircle__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Icon_IconChromeReaderMode__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Icon_IconClass__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Icon_IconCode__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Icon_IconCompareArrows__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Icon_IconCopyright__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Icon_IconCreditCard__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Icon_IconDashboard__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Icon_IconDateRange__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Icon_IconDelete__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Icon_IconDeleteForever__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Icon_IconDescription__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Icon_IconDns__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Icon_IconDone__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Icon_IconDoneAll__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Icon_IconDonutLarge__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Icon_IconDonutSmall__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Icon_IconEject__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Icon_IconEuroSymbol__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__Icon_IconEvent__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Icon_IconEventSeat__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Icon_IconExitToApp__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Icon_IconExplore__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Icon_IconExtension__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Icon_IconFace__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Icon_IconFavorite__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Icon_IconFavoriteBorder__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Icon_IconFeedback__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Icon_IconFindInPage__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Icon_IconFindReplace__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Icon_IconFingerprint__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Icon_IconFlightLand__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__Icon_IconFlightTakeoff__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__Icon_IconFlipToBack__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__Icon_IconFlipToFront__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__Icon_IconGTranslate__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__Icon_IconGavel__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__Icon_IconGetApp__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__Icon_IconGif__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__Icon_IconGrade__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__Icon_IconGroupWork__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__Icon_IconHelp__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__Icon_IconHelpOutline__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__Icon_IconHighlightOff__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__Icon_IconHistory__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__Icon_IconHome__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__Icon_IconHourglassEmpty__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__Icon_IconHourglassFull__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__Icon_IconHttp__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__Icon_IconHttps__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__Icon_IconImportantDevices__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__Icon_IconInfo__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__Icon_IconInfoOutline__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__Icon_IconInput__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__Icon_IconInvertColors__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__Icon_IconLabel__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__Icon_IconLabelOutline__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__Icon_IconLanguage__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__Icon_IconLaunch__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__Icon_IconLightbulbOutline__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__Icon_IconLineStyle__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__Icon_IconLineWeight__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__Icon_IconList__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__Icon_IconLock__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__Icon_IconLockOpen__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__Icon_IconLockOutline__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__Icon_IconLoyalty__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__Icon_IconMarkunreadMailbox__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__Icon_IconMotorcycle__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__Icon_IconNoteAdd__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__Icon_IconOfflinePin__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__Icon_IconOpacity__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__Icon_IconOpenInBrowser__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__Icon_IconOpenInNew__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__Icon_IconOpenWith__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__Icon_IconPageview__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__Icon_IconPanTool__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__Icon_IconPayment__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__Icon_IconPermCameraMic__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__Icon_IconPermContactCalendar__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__Icon_IconPermDataSetting__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__Icon_IconPermDeviceInformation__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__Icon_IconPermIdentity__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__Icon_IconPermMedia__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__Icon_IconPermPhoneMsg__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__Icon_IconPermScanWifi__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__Icon_IconPets__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__Icon_IconPictureInPicture__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__Icon_IconPictureInPictureAlt__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__Icon_IconPlayForWork__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__Icon_IconPolymer__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__Icon_IconPowerSettingsNew__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__Icon_IconPregnantWoman__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__Icon_IconPrint__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__Icon_IconQueryBuilder__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__Icon_IconQuestionAnswer__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__Icon_IconReceipt__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__Icon_IconRecordVoiceOver__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__Icon_IconRedeem__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__Icon_IconRemoveShoppingCart__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__Icon_IconReorder__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__Icon_IconReportProblem__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__Icon_IconRestore__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__Icon_IconRestorePage__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__Icon_IconRoom__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__Icon_IconRoundedCorner__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__Icon_IconRowing__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__Icon_IconSchedule__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__Icon_IconSearch__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__Icon_IconSettings__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__Icon_IconSettingsApplications__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__Icon_IconSettingsBackupRestore__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__Icon_IconSettingsBluetooth__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__Icon_IconSettingsBrightness__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__Icon_IconSettingsCell__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__Icon_IconSettingsEthernet__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__Icon_IconSettingsInputAntenna__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__Icon_IconSettingsInputComponent__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__Icon_IconSettingsInputComposite__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__Icon_IconSettingsInputHdmi__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__Icon_IconSettingsInputSvideo__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__Icon_IconSettingsOverscan__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__Icon_IconSettingsPhone__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__Icon_IconSettingsPower__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__Icon_IconSettingsRemote__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__Icon_IconSettingsVoice__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__Icon_IconShop__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__Icon_IconShopTwo__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__Icon_IconShoppingBasket__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__Icon_IconShoppingCart__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__Icon_IconSpeakerNotes__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__Icon_IconSpeakerNotesOff__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__Icon_IconSpellcheck__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__Icon_IconStars__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__Icon_IconStore__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__Icon_IconSubject__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__Icon_IconSupervisorAccount__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__Icon_IconSwapHoriz__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__Icon_IconSwapVert__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__Icon_IconSwapVerticalCircle__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__Icon_IconSystemUpdateAlt__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__Icon_IconTab__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__Icon_IconTabUnselected__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__Icon_IconTheaters__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__Icon_IconThumbDown__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__Icon_IconThumbUp__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__Icon_IconThumbsUpDown__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__Icon_IconTimeline__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__Icon_IconToc__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__Icon_IconToday__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__Icon_IconToll__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__Icon_IconTouchApp__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__Icon_IconTrackChanges__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__Icon_IconTranslate__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__Icon_IconTrendingDown__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__Icon_IconTrendingFlat__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__Icon_IconTrendingUp__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__Icon_IconTurnedIn__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__Icon_IconTurnedInNot__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__Icon_IconUpdate__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__Icon_IconVerifiedUser__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__Icon_IconViewAgenda__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__Icon_IconViewArray__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__Icon_IconViewCarousel__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__Icon_IconViewColumn__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__Icon_IconViewDay__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__Icon_IconViewHeadline__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__Icon_IconViewList__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__Icon_IconViewModule__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__Icon_IconViewQuilt__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__Icon_IconViewStream__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__Icon_IconViewWeek__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__Icon_IconVisibility__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__Icon_IconVisibilityOff__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__Icon_IconWatchLater__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__Icon_IconWork__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__Icon_IconYoutubeSearchedFor__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__Icon_IconZoomIn__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__Icon_IconZoomOut__ = __webpack_require__(496);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/* eslint-disable prettier/prettier */
























































































































































































































var _ref = _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__CategoryHeader__["a" /* default */], {}, void 0, 'action'), _jsx(__WEBPACK_IMPORTED_MODULE_3__FigContainer__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_Icon3DRotation__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'Icon3DRotation')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Icon_IconAccessibility__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAccessibility')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Icon_IconAccessible__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAccessible')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Icon_IconAccountBalance__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAccountBalance')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__Icon_IconAccountBalanceWallet__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAccountBalanceWallet')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Icon_IconAccountBox__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAccountBox')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__Icon_IconAccountCircle__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAccountCircle')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_12__Icon_IconAddShoppingCart__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAddShoppingCart')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_13__Icon_IconAlarm__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAlarm')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Icon_IconAlarmAdd__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAlarmAdd')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__Icon_IconAlarmOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAlarmOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__Icon_IconAlarmOn__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAlarmOn')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_17__Icon_IconAllOut__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAllOut')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_18__Icon_IconAndroid__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAndroid')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_19__Icon_IconAnnouncement__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAnnouncement')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_20__Icon_IconAspectRatio__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAspectRatio')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_21__Icon_IconAssessment__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAssessment')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_22__Icon_IconAssignment__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAssignment')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_23__Icon_IconAssignmentInd__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAssignmentInd')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_24__Icon_IconAssignmentLate__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAssignmentLate')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_25__Icon_IconAssignmentReturn__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAssignmentReturn')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_26__Icon_IconAssignmentReturned__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAssignmentReturned')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_27__Icon_IconAssignmentTurnedIn__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAssignmentTurnedIn')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_28__Icon_IconAutorenew__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAutorenew')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_29__Icon_IconBackup__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBackup')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_30__Icon_IconBook__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBook')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_31__Icon_IconBookmark__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBookmark')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_32__Icon_IconBookmarkBorder__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBookmarkBorder')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_33__Icon_IconBugReport__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBugReport')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_34__Icon_IconBuild__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBuild')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_35__Icon_IconCached__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCached')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_36__Icon_IconCameraEnhance__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCameraEnhance')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_37__Icon_IconCardGiftcard__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCardGiftcard')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_38__Icon_IconCardMembership__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCardMembership')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_39__Icon_IconCardTravel__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCardTravel')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_40__Icon_IconChangeHistory__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconChangeHistory')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_41__Icon_IconCheckCircle__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCheckCircle')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_42__Icon_IconChromeReaderMode__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconChromeReaderMode')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_43__Icon_IconClass__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconClass')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_44__Icon_IconCode__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCode')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_45__Icon_IconCompareArrows__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCompareArrows')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_46__Icon_IconCopyright__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCopyright')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_47__Icon_IconCreditCard__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCreditCard')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_48__Icon_IconDashboard__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDashboard')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_49__Icon_IconDateRange__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDateRange')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_50__Icon_IconDelete__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDelete')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_51__Icon_IconDeleteForever__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDeleteForever')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_52__Icon_IconDescription__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDescription')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_53__Icon_IconDns__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDns')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_54__Icon_IconDone__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDone')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_55__Icon_IconDoneAll__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDoneAll')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_56__Icon_IconDonutLarge__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDonutLarge')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_57__Icon_IconDonutSmall__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDonutSmall')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_58__Icon_IconEject__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconEject')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_59__Icon_IconEuroSymbol__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconEuroSymbol')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_60__Icon_IconEvent__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconEvent')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_61__Icon_IconEventSeat__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconEventSeat')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_62__Icon_IconExitToApp__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconExitToApp')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_63__Icon_IconExplore__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconExplore')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_64__Icon_IconExtension__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconExtension')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_65__Icon_IconFace__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFace')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_66__Icon_IconFavorite__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFavorite')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_67__Icon_IconFavoriteBorder__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFavoriteBorder')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_68__Icon_IconFeedback__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFeedback')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_69__Icon_IconFindInPage__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFindInPage')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_70__Icon_IconFindReplace__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFindReplace')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_71__Icon_IconFingerprint__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFingerprint')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_72__Icon_IconFlightLand__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFlightLand')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_73__Icon_IconFlightTakeoff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFlightTakeoff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_74__Icon_IconFlipToBack__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFlipToBack')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_75__Icon_IconFlipToFront__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFlipToFront')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_76__Icon_IconGTranslate__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGTranslate')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_77__Icon_IconGavel__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGavel')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_78__Icon_IconGetApp__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGetApp')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_79__Icon_IconGif__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGif')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_80__Icon_IconGrade__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGrade')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_81__Icon_IconGroupWork__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGroupWork')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_82__Icon_IconHelp__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHelp')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_83__Icon_IconHelpOutline__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHelpOutline')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_84__Icon_IconHighlightOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHighlightOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_85__Icon_IconHistory__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHistory')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_86__Icon_IconHome__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHome')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_87__Icon_IconHourglassEmpty__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHourglassEmpty')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_88__Icon_IconHourglassFull__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHourglassFull')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_89__Icon_IconHttp__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHttp')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_90__Icon_IconHttps__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHttps')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_91__Icon_IconImportantDevices__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconImportantDevices')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_92__Icon_IconInfo__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconInfo')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_93__Icon_IconInfoOutline__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconInfoOutline')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_94__Icon_IconInput__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconInput')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_95__Icon_IconInvertColors__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconInvertColors')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_96__Icon_IconLabel__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLabel')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_97__Icon_IconLabelOutline__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLabelOutline')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_98__Icon_IconLanguage__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLanguage')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_99__Icon_IconLaunch__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLaunch')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_100__Icon_IconLightbulbOutline__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLightbulbOutline')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_101__Icon_IconLineStyle__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLineStyle')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_102__Icon_IconLineWeight__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLineWeight')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_103__Icon_IconList__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconList')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_104__Icon_IconLock__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLock')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_105__Icon_IconLockOpen__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLockOpen')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_106__Icon_IconLockOutline__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLockOutline')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_107__Icon_IconLoyalty__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLoyalty')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_108__Icon_IconMarkunreadMailbox__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMarkunreadMailbox')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_109__Icon_IconMotorcycle__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMotorcycle')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_110__Icon_IconNoteAdd__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNoteAdd')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_111__Icon_IconOfflinePin__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconOfflinePin')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_112__Icon_IconOpacity__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconOpacity')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_113__Icon_IconOpenInBrowser__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconOpenInBrowser')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_114__Icon_IconOpenInNew__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconOpenInNew')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_115__Icon_IconOpenWith__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconOpenWith')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_116__Icon_IconPageview__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPageview')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_117__Icon_IconPanTool__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPanTool')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_118__Icon_IconPayment__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPayment')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_119__Icon_IconPermCameraMic__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPermCameraMic')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_120__Icon_IconPermContactCalendar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPermContactCalendar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_121__Icon_IconPermDataSetting__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPermDataSetting')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_122__Icon_IconPermDeviceInformation__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPermDeviceInformation')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_123__Icon_IconPermIdentity__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPermIdentity')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_124__Icon_IconPermMedia__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPermMedia')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_125__Icon_IconPermPhoneMsg__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPermPhoneMsg')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_126__Icon_IconPermScanWifi__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPermScanWifi')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_127__Icon_IconPets__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPets')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_128__Icon_IconPictureInPicture__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPictureInPicture')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_129__Icon_IconPictureInPictureAlt__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPictureInPictureAlt')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_130__Icon_IconPlayForWork__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPlayForWork')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_131__Icon_IconPolymer__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPolymer')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_132__Icon_IconPowerSettingsNew__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPowerSettingsNew')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_133__Icon_IconPregnantWoman__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPregnantWoman')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_134__Icon_IconPrint__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPrint')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_135__Icon_IconQueryBuilder__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconQueryBuilder')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_136__Icon_IconQuestionAnswer__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconQuestionAnswer')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_137__Icon_IconReceipt__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconReceipt')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_138__Icon_IconRecordVoiceOver__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRecordVoiceOver')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_139__Icon_IconRedeem__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRedeem')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_140__Icon_IconRemoveShoppingCart__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRemoveShoppingCart')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_141__Icon_IconReorder__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconReorder')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_142__Icon_IconReportProblem__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconReportProblem')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_143__Icon_IconRestore__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRestore')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_144__Icon_IconRestorePage__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRestorePage')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_145__Icon_IconRoom__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRoom')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_146__Icon_IconRoundedCorner__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRoundedCorner')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_147__Icon_IconRowing__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRowing')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_148__Icon_IconSchedule__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSchedule')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_149__Icon_IconSearch__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSearch')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_150__Icon_IconSettings__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSettings')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_151__Icon_IconSettingsApplications__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSettingsApplications')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_152__Icon_IconSettingsBackupRestore__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSettingsBackupRestore')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_153__Icon_IconSettingsBluetooth__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSettingsBluetooth')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_154__Icon_IconSettingsBrightness__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSettingsBrightness')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_155__Icon_IconSettingsCell__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSettingsCell')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_156__Icon_IconSettingsEthernet__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSettingsEthernet')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_157__Icon_IconSettingsInputAntenna__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSettingsInputAntenna')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_158__Icon_IconSettingsInputComponent__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSettingsInputComponent')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_159__Icon_IconSettingsInputComposite__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSettingsInputComposite')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_160__Icon_IconSettingsInputHdmi__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSettingsInputHdmi')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_161__Icon_IconSettingsInputSvideo__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSettingsInputSvideo')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_162__Icon_IconSettingsOverscan__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSettingsOverscan')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_163__Icon_IconSettingsPhone__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSettingsPhone')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_164__Icon_IconSettingsPower__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSettingsPower')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_165__Icon_IconSettingsRemote__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSettingsRemote')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_166__Icon_IconSettingsVoice__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSettingsVoice')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_167__Icon_IconShop__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconShop')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_168__Icon_IconShopTwo__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconShopTwo')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_169__Icon_IconShoppingBasket__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconShoppingBasket')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_170__Icon_IconShoppingCart__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconShoppingCart')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_171__Icon_IconSpeakerNotes__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSpeakerNotes')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_172__Icon_IconSpeakerNotesOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSpeakerNotesOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_173__Icon_IconSpellcheck__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSpellcheck')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_174__Icon_IconStars__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconStars')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_175__Icon_IconStore__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconStore')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_176__Icon_IconSubject__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSubject')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_177__Icon_IconSupervisorAccount__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSupervisorAccount')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_178__Icon_IconSwapHoriz__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSwapHoriz')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_179__Icon_IconSwapVert__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSwapVert')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_180__Icon_IconSwapVerticalCircle__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSwapVerticalCircle')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_181__Icon_IconSystemUpdateAlt__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSystemUpdateAlt')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_182__Icon_IconTab__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTab')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_183__Icon_IconTabUnselected__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTabUnselected')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_184__Icon_IconTheaters__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTheaters')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_185__Icon_IconThumbDown__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconThumbDown')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_186__Icon_IconThumbUp__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconThumbUp')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_187__Icon_IconThumbsUpDown__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconThumbsUpDown')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_188__Icon_IconTimeline__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTimeline')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_189__Icon_IconToc__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconToc')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_190__Icon_IconToday__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconToday')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_191__Icon_IconToll__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconToll')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_192__Icon_IconTouchApp__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTouchApp')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_193__Icon_IconTrackChanges__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTrackChanges')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_194__Icon_IconTranslate__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTranslate')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_195__Icon_IconTrendingDown__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTrendingDown')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_196__Icon_IconTrendingFlat__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTrendingFlat')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_197__Icon_IconTrendingUp__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTrendingUp')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_198__Icon_IconTurnedIn__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTurnedIn')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_199__Icon_IconTurnedInNot__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTurnedInNot')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_200__Icon_IconUpdate__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconUpdate')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_201__Icon_IconVerifiedUser__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVerifiedUser')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_202__Icon_IconViewAgenda__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconViewAgenda')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_203__Icon_IconViewArray__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconViewArray')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_204__Icon_IconViewCarousel__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconViewCarousel')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_205__Icon_IconViewColumn__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconViewColumn')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_206__Icon_IconViewDay__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconViewDay')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_207__Icon_IconViewHeadline__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconViewHeadline')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_208__Icon_IconViewList__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconViewList')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_209__Icon_IconViewModule__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconViewModule')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_210__Icon_IconViewQuilt__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconViewQuilt')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_211__Icon_IconViewStream__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconViewStream')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_212__Icon_IconViewWeek__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconViewWeek')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_213__Icon_IconVisibility__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVisibility')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_214__Icon_IconVisibilityOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVisibilityOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_215__Icon_IconWatchLater__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWatchLater')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_216__Icon_IconWork__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWork')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_217__Icon_IconYoutubeSearchedFor__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconYoutubeSearchedFor')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_218__Icon_IconZoomIn__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconZoomIn')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_219__Icon_IconZoomOut__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconZoomOut'))));

function ActionIcons() {
  return _ref;
}

/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AlertIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Figure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FigCaption__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FigContainer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryHeader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconAddAlert__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon_IconError__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon_IconErrorOutline__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icon_IconWarning__ = __webpack_require__(168);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/* eslint-disable prettier/prettier */





var _ref = _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__CategoryHeader__["a" /* default */], {}, void 0, 'alert'), _jsx(__WEBPACK_IMPORTED_MODULE_3__FigContainer__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_IconAddAlert__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAddAlert')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Icon_IconError__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconError')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Icon_IconErrorOutline__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconErrorOutline')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Icon_IconWarning__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWarning'))));

function AlertIcons() {
  return _ref;
}

/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AvIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Figure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FigCaption__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FigContainer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryHeader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconAddToQueue__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon_IconAirplay__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon_IconAlbum__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icon_IconArtTrack__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icon_IconAvTimer__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icon_IconBrandingWatermark__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon_IconCallToAction__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icon_IconClosedCaption__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icon_IconEqualizer__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icon_IconExplicit__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Icon_IconFastForward__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icon_IconFastRewind__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Icon_IconFeaturedPlayList__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Icon_IconFeaturedVideo__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Icon_IconFiberDvr__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Icon_IconFiberManualRecord__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Icon_IconFiberNew__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Icon_IconFiberPin__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Icon_IconFiberSmartRecord__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Icon_IconForward10__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Icon_IconForward30__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Icon_IconForward5__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Icon_IconGames__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Icon_IconHd__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Icon_IconHearing__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Icon_IconHighQuality__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Icon_IconLibraryAdd__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Icon_IconLibraryBooks__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Icon_IconLibraryMusic__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Icon_IconLoop__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Icon_IconMic__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Icon_IconMicNone__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Icon_IconMicOff__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Icon_IconMovie__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Icon_IconMusicVideo__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Icon_IconNewReleases__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Icon_IconNotInterested__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Icon_IconNote__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Icon_IconPause__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Icon_IconPauseCircleFilled__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Icon_IconPauseCircleOutline__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Icon_IconPlayArrow__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Icon_IconPlayCircleFilled__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Icon_IconPlayCircleOutline__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Icon_IconPlaylistAdd__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Icon_IconPlaylistAddCheck__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Icon_IconPlaylistPlay__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Icon_IconQueue__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Icon_IconQueueMusic__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Icon_IconQueuePlayNext__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Icon_IconRadio__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Icon_IconRecentActors__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Icon_IconRemoveFromQueue__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Icon_IconRepeat__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Icon_IconRepeatOne__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__Icon_IconReplay10__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Icon_IconReplay__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Icon_IconReplay30__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Icon_IconReplay5__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Icon_IconShuffle__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Icon_IconSkipNext__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Icon_IconSkipPrevious__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Icon_IconSlowMotionVideo__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Icon_IconSnooze__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Icon_IconSortByAlpha__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Icon_IconStop__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Icon_IconSubscriptions__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Icon_IconSubtitles__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__Icon_IconSurroundSound__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__Icon_IconVideoCall__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__Icon_IconVideoLabel__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__Icon_IconVideoLibrary__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__Icon_IconVideocam__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__Icon_IconVideocamOff__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__Icon_IconVolumeDown__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__Icon_IconVolumeMute__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__Icon_IconVolumeOff__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__Icon_IconVolumeUp__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__Icon_IconWeb__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__Icon_IconWebAsset__ = __webpack_require__(578);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/* eslint-disable prettier/prettier */

















































































var _ref = _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__CategoryHeader__["a" /* default */], {}, void 0, 'av'), _jsx(__WEBPACK_IMPORTED_MODULE_3__FigContainer__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_IconAddToQueue__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAddToQueue')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Icon_IconAirplay__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAirplay')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Icon_IconAlbum__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAlbum')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Icon_IconArtTrack__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconArtTrack')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__Icon_IconAvTimer__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAvTimer')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Icon_IconBrandingWatermark__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBrandingWatermark')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__Icon_IconCallToAction__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCallToAction')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_12__Icon_IconClosedCaption__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconClosedCaption')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_13__Icon_IconEqualizer__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconEqualizer')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Icon_IconExplicit__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconExplicit')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__Icon_IconFastForward__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFastForward')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__Icon_IconFastRewind__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFastRewind')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_17__Icon_IconFeaturedPlayList__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFeaturedPlayList')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_18__Icon_IconFeaturedVideo__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFeaturedVideo')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_19__Icon_IconFiberDvr__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFiberDvr')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_20__Icon_IconFiberManualRecord__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFiberManualRecord')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_21__Icon_IconFiberNew__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFiberNew')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_22__Icon_IconFiberPin__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFiberPin')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_23__Icon_IconFiberSmartRecord__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFiberSmartRecord')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_24__Icon_IconForward10__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconForward10')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_25__Icon_IconForward30__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconForward30')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_26__Icon_IconForward5__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconForward5')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_27__Icon_IconGames__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGames')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_28__Icon_IconHd__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHd')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_29__Icon_IconHearing__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHearing')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_30__Icon_IconHighQuality__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHighQuality')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_31__Icon_IconLibraryAdd__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLibraryAdd')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_32__Icon_IconLibraryBooks__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLibraryBooks')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_33__Icon_IconLibraryMusic__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLibraryMusic')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_34__Icon_IconLoop__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLoop')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_35__Icon_IconMic__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMic')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_36__Icon_IconMicNone__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMicNone')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_37__Icon_IconMicOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMicOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_38__Icon_IconMovie__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMovie')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_39__Icon_IconMusicVideo__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMusicVideo')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_40__Icon_IconNewReleases__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNewReleases')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_41__Icon_IconNotInterested__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNotInterested')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_42__Icon_IconNote__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNote')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_43__Icon_IconPause__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPause')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_44__Icon_IconPauseCircleFilled__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPauseCircleFilled')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_45__Icon_IconPauseCircleOutline__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPauseCircleOutline')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_46__Icon_IconPlayArrow__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPlayArrow')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_47__Icon_IconPlayCircleFilled__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPlayCircleFilled')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_48__Icon_IconPlayCircleOutline__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPlayCircleOutline')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_49__Icon_IconPlaylistAdd__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPlaylistAdd')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_50__Icon_IconPlaylistAddCheck__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPlaylistAddCheck')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_51__Icon_IconPlaylistPlay__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPlaylistPlay')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_52__Icon_IconQueue__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconQueue')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_53__Icon_IconQueueMusic__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconQueueMusic')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_54__Icon_IconQueuePlayNext__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconQueuePlayNext')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_55__Icon_IconRadio__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRadio')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_56__Icon_IconRecentActors__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRecentActors')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_57__Icon_IconRemoveFromQueue__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRemoveFromQueue')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_58__Icon_IconRepeat__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRepeat')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_59__Icon_IconRepeatOne__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRepeatOne')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_60__Icon_IconReplay10__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconReplay10')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_61__Icon_IconReplay__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconReplay')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_62__Icon_IconReplay30__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconReplay30')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_63__Icon_IconReplay5__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconReplay5')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_64__Icon_IconShuffle__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconShuffle')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_65__Icon_IconSkipNext__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSkipNext')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_66__Icon_IconSkipPrevious__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSkipPrevious')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_67__Icon_IconSlowMotionVideo__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSlowMotionVideo')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_68__Icon_IconSnooze__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSnooze')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_69__Icon_IconSortByAlpha__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSortByAlpha')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_70__Icon_IconStop__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconStop')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_71__Icon_IconSubscriptions__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSubscriptions')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_72__Icon_IconSubtitles__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSubtitles')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_73__Icon_IconSurroundSound__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSurroundSound')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_74__Icon_IconVideoCall__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVideoCall')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_75__Icon_IconVideoLabel__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVideoLabel')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_76__Icon_IconVideoLibrary__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVideoLibrary')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_77__Icon_IconVideocam__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVideocam')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_78__Icon_IconVideocamOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVideocamOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_79__Icon_IconVolumeDown__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVolumeDown')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_80__Icon_IconVolumeMute__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVolumeMute')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_81__Icon_IconVolumeOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVolumeOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_82__Icon_IconVolumeUp__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVolumeUp')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_83__Icon_IconWeb__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWeb')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_84__Icon_IconWebAsset__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWebAsset'))));

function AvIcons() {
  return _ref;
}

/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CommunicationIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Figure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FigCaption__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FigContainer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryHeader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconBusiness__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon_IconCall__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon_IconCallEnd__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icon_IconCallMade__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icon_IconCallMerge__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icon_IconCallMissed__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon_IconCallMissedOutgoing__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icon_IconCallReceived__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icon_IconCallSplit__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icon_IconChat__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Icon_IconChatBubble__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icon_IconChatBubbleOutline__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Icon_IconClearAll__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Icon_IconComment__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Icon_IconContactMail__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Icon_IconContactPhone__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Icon_IconContacts__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Icon_IconDialerSip__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Icon_IconDialpad__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Icon_IconEmail__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Icon_IconForum__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Icon_IconImportContacts__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Icon_IconImportExport__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Icon_IconInvertColorsOff__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Icon_IconLiveHelp__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Icon_IconLocationOff__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Icon_IconLocationOn__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Icon_IconMailOutline__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Icon_IconMessage__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Icon_IconNoSim__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Icon_IconPhone__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Icon_IconPhonelinkErase__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Icon_IconPhonelinkLock__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Icon_IconPhonelinkRing__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Icon_IconPhonelinkSetup__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Icon_IconPortableWifiOff__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Icon_IconPresentToAll__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Icon_IconRingVolume__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Icon_IconRssFeed__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Icon_IconScreenShare__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Icon_IconSpeakerPhone__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Icon_IconStayCurrentLandscape__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Icon_IconStayCurrentPortrait__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Icon_IconStayPrimaryLandscape__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Icon_IconStayPrimaryPortrait__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Icon_IconStopScreenShare__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Icon_IconSwapCalls__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Icon_IconTextsms__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Icon_IconVoicemail__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Icon_IconVpnKey__ = __webpack_require__(628);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/* eslint-disable prettier/prettier */



















































var _ref = _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__CategoryHeader__["a" /* default */], {}, void 0, 'communication'), _jsx(__WEBPACK_IMPORTED_MODULE_3__FigContainer__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_IconBusiness__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBusiness')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Icon_IconCall__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCall')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Icon_IconCallEnd__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCallEnd')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Icon_IconCallMade__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCallMade')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__Icon_IconCallMerge__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCallMerge')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Icon_IconCallMissed__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCallMissed')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__Icon_IconCallMissedOutgoing__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCallMissedOutgoing')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_12__Icon_IconCallReceived__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCallReceived')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_13__Icon_IconCallSplit__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCallSplit')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Icon_IconChat__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconChat')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__Icon_IconChatBubble__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconChatBubble')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__Icon_IconChatBubbleOutline__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconChatBubbleOutline')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_17__Icon_IconClearAll__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconClearAll')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_18__Icon_IconComment__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconComment')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_19__Icon_IconContactMail__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconContactMail')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_20__Icon_IconContactPhone__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconContactPhone')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_21__Icon_IconContacts__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconContacts')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_22__Icon_IconDialerSip__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDialerSip')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_23__Icon_IconDialpad__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDialpad')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_24__Icon_IconEmail__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconEmail')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_25__Icon_IconForum__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconForum')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_26__Icon_IconImportContacts__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconImportContacts')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_27__Icon_IconImportExport__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconImportExport')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_28__Icon_IconInvertColorsOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconInvertColorsOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_29__Icon_IconLiveHelp__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLiveHelp')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_30__Icon_IconLocationOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocationOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_31__Icon_IconLocationOn__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocationOn')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_32__Icon_IconMailOutline__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMailOutline')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_33__Icon_IconMessage__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMessage')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_34__Icon_IconNoSim__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNoSim')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_35__Icon_IconPhone__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhone')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_36__Icon_IconPhonelinkErase__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhonelinkErase')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_37__Icon_IconPhonelinkLock__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhonelinkLock')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_38__Icon_IconPhonelinkRing__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhonelinkRing')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_39__Icon_IconPhonelinkSetup__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhonelinkSetup')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_40__Icon_IconPortableWifiOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPortableWifiOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_41__Icon_IconPresentToAll__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPresentToAll')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_42__Icon_IconRingVolume__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRingVolume')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_43__Icon_IconRssFeed__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRssFeed')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_44__Icon_IconScreenShare__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconScreenShare')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_45__Icon_IconSpeakerPhone__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSpeakerPhone')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_46__Icon_IconStayCurrentLandscape__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconStayCurrentLandscape')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_47__Icon_IconStayCurrentPortrait__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconStayCurrentPortrait')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_48__Icon_IconStayPrimaryLandscape__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconStayPrimaryLandscape')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_49__Icon_IconStayPrimaryPortrait__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconStayPrimaryPortrait')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_50__Icon_IconStopScreenShare__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconStopScreenShare')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_51__Icon_IconSwapCalls__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSwapCalls')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_52__Icon_IconTextsms__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTextsms')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_53__Icon_IconVoicemail__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVoicemail')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_54__Icon_IconVpnKey__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVpnKey'))));

function CommunicationIcons() {
  return _ref;
}

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContentIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Figure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FigCaption__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FigContainer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryHeader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconAdd__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon_IconAddBox__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon_IconAddCircle__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icon_IconAddCircleOutline__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icon_IconArchive__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icon_IconBackspace__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon_IconBlock__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icon_IconClear__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icon_IconContentCopy__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icon_IconContentCut__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Icon_IconContentPaste__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icon_IconCreate__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Icon_IconDeleteSweep__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Icon_IconDrafts__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Icon_IconFilterList__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Icon_IconFlag__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Icon_IconFontDownload__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Icon_IconForward__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Icon_IconGesture__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Icon_IconInbox__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Icon_IconLink__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Icon_IconLowPriority__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Icon_IconMail__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Icon_IconMarkunread__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Icon_IconMoveToInbox__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Icon_IconNextWeek__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Icon_IconRedo__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Icon_IconRemove__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Icon_IconRemoveCircle__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Icon_IconRemoveCircleOutline__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Icon_IconReply__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Icon_IconReplyAll__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Icon_IconReport__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Icon_IconSave__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Icon_IconSelectAll__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Icon_IconSend__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Icon_IconSort__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Icon_IconTextFormat__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Icon_IconUnarchive__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Icon_IconUndo__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Icon_IconWeekend__ = __webpack_require__(668);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/* eslint-disable prettier/prettier */










































var _ref = _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__CategoryHeader__["a" /* default */], {}, void 0, 'content'), _jsx(__WEBPACK_IMPORTED_MODULE_3__FigContainer__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_IconAdd__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAdd')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Icon_IconAddBox__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAddBox')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Icon_IconAddCircle__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAddCircle')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Icon_IconAddCircleOutline__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAddCircleOutline')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__Icon_IconArchive__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconArchive')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Icon_IconBackspace__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBackspace')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__Icon_IconBlock__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBlock')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_12__Icon_IconClear__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconClear')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_13__Icon_IconContentCopy__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconContentCopy')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Icon_IconContentCut__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconContentCut')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__Icon_IconContentPaste__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconContentPaste')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__Icon_IconCreate__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCreate')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_17__Icon_IconDeleteSweep__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDeleteSweep')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_18__Icon_IconDrafts__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDrafts')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_19__Icon_IconFilterList__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilterList')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_20__Icon_IconFlag__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFlag')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_21__Icon_IconFontDownload__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFontDownload')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_22__Icon_IconForward__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconForward')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_23__Icon_IconGesture__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGesture')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_24__Icon_IconInbox__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconInbox')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_25__Icon_IconLink__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLink')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_26__Icon_IconLowPriority__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLowPriority')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_27__Icon_IconMail__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMail')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_28__Icon_IconMarkunread__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMarkunread')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_29__Icon_IconMoveToInbox__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMoveToInbox')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_30__Icon_IconNextWeek__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNextWeek')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_31__Icon_IconRedo__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRedo')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_32__Icon_IconRemove__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRemove')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_33__Icon_IconRemoveCircle__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRemoveCircle')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_34__Icon_IconRemoveCircleOutline__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRemoveCircleOutline')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_35__Icon_IconReply__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconReply')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_36__Icon_IconReplyAll__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconReplyAll')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_37__Icon_IconReport__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconReport')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_38__Icon_IconSave__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSave')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_39__Icon_IconSelectAll__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSelectAll')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_40__Icon_IconSend__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSend')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_41__Icon_IconSort__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSort')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_42__Icon_IconTextFormat__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTextFormat')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_43__Icon_IconUnarchive__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconUnarchive')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_44__Icon_IconUndo__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconUndo')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_45__Icon_IconWeekend__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWeekend'))));

function ContentIcons() {
  return _ref;
}

/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DeviceIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Figure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FigCaption__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FigContainer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryHeader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconAccessAlarm__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon_IconAccessAlarms__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon_IconAccessTime__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icon_IconAddAlarm__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icon_IconAirplanemodeActive__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icon_IconAirplanemodeInactive__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon_IconBattery20__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icon_IconBattery30__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icon_IconBattery50__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icon_IconBattery60__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Icon_IconBattery80__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icon_IconBattery90__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Icon_IconBatteryAlert__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Icon_IconBatteryCharging20__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Icon_IconBatteryCharging30__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Icon_IconBatteryCharging50__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Icon_IconBatteryCharging60__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Icon_IconBatteryCharging80__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Icon_IconBatteryCharging90__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Icon_IconBatteryChargingFull__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Icon_IconBatteryFull__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Icon_IconBatteryStd__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Icon_IconBatteryUnknown__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Icon_IconBluetooth__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Icon_IconBluetoothConnected__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Icon_IconBluetoothDisabled__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Icon_IconBluetoothSearching__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Icon_IconBrightnessAuto__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Icon_IconBrightnessHigh__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Icon_IconBrightnessLow__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Icon_IconBrightnessMedium__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Icon_IconDataUsage__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Icon_IconDeveloperMode__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Icon_IconDevices__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Icon_IconDvr__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Icon_IconGpsFixed__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Icon_IconGpsNotFixed__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Icon_IconGpsOff__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Icon_IconGraphicEq__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Icon_IconLocationDisabled__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Icon_IconLocationSearching__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Icon_IconNetworkCell__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Icon_IconNetworkWifi__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Icon_IconNfc__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Icon_IconScreenLockLandscape__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Icon_IconScreenLockPortrait__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Icon_IconScreenLockRotation__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Icon_IconScreenRotation__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Icon_IconSdStorage__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Icon_IconSettingsSystemDaydream__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Icon_IconSignalCellular0Bar__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Icon_IconSignalCellular1Bar__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Icon_IconSignalCellular2Bar__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Icon_IconSignalCellular3Bar__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Icon_IconSignalCellular4Bar__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__Icon_IconSignalCellularConnectedNoInternet0Bar__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Icon_IconSignalCellularConnectedNoInternet1Bar__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Icon_IconSignalCellularConnectedNoInternet2Bar__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Icon_IconSignalCellularConnectedNoInternet3Bar__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Icon_IconSignalCellularConnectedNoInternet4Bar__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Icon_IconSignalCellularNoSim__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Icon_IconSignalCellularNull__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Icon_IconSignalCellularOff__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Icon_IconSignalWifi0Bar__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Icon_IconSignalWifi1Bar__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Icon_IconSignalWifi1BarLock__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Icon_IconSignalWifi2Bar__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Icon_IconSignalWifi2BarLock__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__Icon_IconSignalWifi3Bar__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__Icon_IconSignalWifi3BarLock__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__Icon_IconSignalWifi4Bar__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__Icon_IconSignalWifi4BarLock__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__Icon_IconSignalWifiOff__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__Icon_IconStorage__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__Icon_IconUsb__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__Icon_IconWallpaper__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__Icon_IconWidgets__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__Icon_IconWifiLock__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__Icon_IconWifiTethering__ = __webpack_require__(747);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/* eslint-disable prettier/prettier */
















































































var _ref = _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__CategoryHeader__["a" /* default */], {}, void 0, 'device'), _jsx(__WEBPACK_IMPORTED_MODULE_3__FigContainer__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_IconAccessAlarm__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAccessAlarm')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Icon_IconAccessAlarms__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAccessAlarms')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Icon_IconAccessTime__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAccessTime')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Icon_IconAddAlarm__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAddAlarm')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__Icon_IconAirplanemodeActive__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAirplanemodeActive')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Icon_IconAirplanemodeInactive__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAirplanemodeInactive')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__Icon_IconBattery20__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBattery20')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_12__Icon_IconBattery30__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBattery30')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_13__Icon_IconBattery50__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBattery50')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Icon_IconBattery60__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBattery60')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__Icon_IconBattery80__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBattery80')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__Icon_IconBattery90__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBattery90')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_17__Icon_IconBatteryAlert__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBatteryAlert')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_18__Icon_IconBatteryCharging20__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBatteryCharging20')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_19__Icon_IconBatteryCharging30__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBatteryCharging30')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_20__Icon_IconBatteryCharging50__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBatteryCharging50')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_21__Icon_IconBatteryCharging60__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBatteryCharging60')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_22__Icon_IconBatteryCharging80__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBatteryCharging80')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_23__Icon_IconBatteryCharging90__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBatteryCharging90')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_24__Icon_IconBatteryChargingFull__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBatteryChargingFull')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_25__Icon_IconBatteryFull__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBatteryFull')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_26__Icon_IconBatteryStd__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBatteryStd')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_27__Icon_IconBatteryUnknown__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBatteryUnknown')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_28__Icon_IconBluetooth__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBluetooth')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_29__Icon_IconBluetoothConnected__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBluetoothConnected')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_30__Icon_IconBluetoothDisabled__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBluetoothDisabled')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_31__Icon_IconBluetoothSearching__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBluetoothSearching')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_32__Icon_IconBrightnessAuto__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBrightnessAuto')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_33__Icon_IconBrightnessHigh__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBrightnessHigh')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_34__Icon_IconBrightnessLow__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBrightnessLow')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_35__Icon_IconBrightnessMedium__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBrightnessMedium')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_36__Icon_IconDataUsage__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDataUsage')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_37__Icon_IconDeveloperMode__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDeveloperMode')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_38__Icon_IconDevices__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDevices')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_39__Icon_IconDvr__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDvr')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_40__Icon_IconGpsFixed__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGpsFixed')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_41__Icon_IconGpsNotFixed__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGpsNotFixed')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_42__Icon_IconGpsOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGpsOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_43__Icon_IconGraphicEq__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGraphicEq')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_44__Icon_IconLocationDisabled__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocationDisabled')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_45__Icon_IconLocationSearching__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocationSearching')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_46__Icon_IconNetworkCell__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNetworkCell')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_47__Icon_IconNetworkWifi__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNetworkWifi')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_48__Icon_IconNfc__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNfc')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_49__Icon_IconScreenLockLandscape__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconScreenLockLandscape')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_50__Icon_IconScreenLockPortrait__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconScreenLockPortrait')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_51__Icon_IconScreenLockRotation__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconScreenLockRotation')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_52__Icon_IconScreenRotation__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconScreenRotation')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_53__Icon_IconSdStorage__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSdStorage')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_54__Icon_IconSettingsSystemDaydream__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSettingsSystemDaydream')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_55__Icon_IconSignalCellular0Bar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalCellular0Bar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_56__Icon_IconSignalCellular1Bar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalCellular1Bar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_57__Icon_IconSignalCellular2Bar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalCellular2Bar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_58__Icon_IconSignalCellular3Bar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalCellular3Bar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_59__Icon_IconSignalCellular4Bar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalCellular4Bar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_60__Icon_IconSignalCellularConnectedNoInternet0Bar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalCellularConnectedNoInternet0Bar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_61__Icon_IconSignalCellularConnectedNoInternet1Bar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalCellularConnectedNoInternet1Bar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_62__Icon_IconSignalCellularConnectedNoInternet2Bar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalCellularConnectedNoInternet2Bar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_63__Icon_IconSignalCellularConnectedNoInternet3Bar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalCellularConnectedNoInternet3Bar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_64__Icon_IconSignalCellularConnectedNoInternet4Bar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalCellularConnectedNoInternet4Bar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_65__Icon_IconSignalCellularNoSim__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalCellularNoSim')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_66__Icon_IconSignalCellularNull__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalCellularNull')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_67__Icon_IconSignalCellularOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalCellularOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_68__Icon_IconSignalWifi0Bar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalWifi0Bar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_69__Icon_IconSignalWifi1Bar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalWifi1Bar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_70__Icon_IconSignalWifi1BarLock__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalWifi1BarLock')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_71__Icon_IconSignalWifi2Bar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalWifi2Bar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_72__Icon_IconSignalWifi2BarLock__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalWifi2BarLock')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_73__Icon_IconSignalWifi3Bar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalWifi3Bar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_74__Icon_IconSignalWifi3BarLock__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalWifi3BarLock')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_75__Icon_IconSignalWifi4Bar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalWifi4Bar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_76__Icon_IconSignalWifi4BarLock__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalWifi4BarLock')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_77__Icon_IconSignalWifiOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSignalWifiOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_78__Icon_IconStorage__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconStorage')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_79__Icon_IconUsb__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconUsb')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_80__Icon_IconWallpaper__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWallpaper')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_81__Icon_IconWidgets__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWidgets')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_82__Icon_IconWifiLock__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWifiLock')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_83__Icon_IconWifiTethering__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWifiTethering'))));

function DeviceIcons() {
  return _ref;
}

/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = EditorIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Figure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FigCaption__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FigContainer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryHeader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconAttachFile__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon_IconAttachMoney__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon_IconBorderAll__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icon_IconBorderBottom__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icon_IconBorderClear__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icon_IconBorderColor__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon_IconBorderHorizontal__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icon_IconBorderInner__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icon_IconBorderLeft__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icon_IconBorderOuter__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Icon_IconBorderRight__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icon_IconBorderStyle__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Icon_IconBorderTop__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Icon_IconBorderVertical__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Icon_IconBubbleChart__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Icon_IconDragHandle__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Icon_IconFormatAlignCenter__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Icon_IconFormatAlignJustify__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Icon_IconFormatAlignLeft__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Icon_IconFormatAlignRight__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Icon_IconFormatBold__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Icon_IconFormatClear__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Icon_IconFormatColorFill__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Icon_IconFormatColorReset__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Icon_IconFormatColorText__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Icon_IconFormatIndentDecrease__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Icon_IconFormatIndentIncrease__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Icon_IconFormatItalic__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Icon_IconFormatLineSpacing__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Icon_IconFormatListBulleted__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Icon_IconFormatListNumbered__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Icon_IconFormatPaint__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Icon_IconFormatQuote__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Icon_IconFormatShapes__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Icon_IconFormatSize__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Icon_IconFormatStrikethrough__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Icon_IconFormatTextdirectionLToR__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Icon_IconFormatTextdirectionRToL__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Icon_IconFormatUnderlined__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Icon_IconFunctions__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Icon_IconHighlight__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Icon_IconInsertChart__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Icon_IconInsertComment__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Icon_IconInsertDriveFile__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Icon_IconInsertEmoticon__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Icon_IconInsertInvitation__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Icon_IconInsertLink__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Icon_IconInsertPhoto__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Icon_IconLinearScale__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Icon_IconMergeType__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Icon_IconModeComment__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Icon_IconModeEdit__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Icon_IconMonetizationOn__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Icon_IconMoneyOff__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Icon_IconMultilineChart__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__Icon_IconPieChart__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Icon_IconPieChartOutlined__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Icon_IconPublish__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Icon_IconShortText__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Icon_IconShowChart__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Icon_IconSpaceBar__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Icon_IconStrikethroughS__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Icon_IconTextFields__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Icon_IconTitle__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Icon_IconVerticalAlignBottom__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Icon_IconVerticalAlignCenter__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Icon_IconVerticalAlignTop__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Icon_IconWrapText__ = __webpack_require__(815);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/* eslint-disable prettier/prettier */





































































var _ref = _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__CategoryHeader__["a" /* default */], {}, void 0, 'editor'), _jsx(__WEBPACK_IMPORTED_MODULE_3__FigContainer__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_IconAttachFile__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAttachFile')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Icon_IconAttachMoney__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAttachMoney')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Icon_IconBorderAll__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBorderAll')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Icon_IconBorderBottom__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBorderBottom')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__Icon_IconBorderClear__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBorderClear')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Icon_IconBorderColor__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBorderColor')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__Icon_IconBorderHorizontal__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBorderHorizontal')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_12__Icon_IconBorderInner__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBorderInner')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_13__Icon_IconBorderLeft__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBorderLeft')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Icon_IconBorderOuter__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBorderOuter')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__Icon_IconBorderRight__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBorderRight')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__Icon_IconBorderStyle__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBorderStyle')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_17__Icon_IconBorderTop__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBorderTop')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_18__Icon_IconBorderVertical__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBorderVertical')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_19__Icon_IconBubbleChart__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBubbleChart')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_20__Icon_IconDragHandle__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDragHandle')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_21__Icon_IconFormatAlignCenter__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatAlignCenter')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_22__Icon_IconFormatAlignJustify__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatAlignJustify')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_23__Icon_IconFormatAlignLeft__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatAlignLeft')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_24__Icon_IconFormatAlignRight__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatAlignRight')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_25__Icon_IconFormatBold__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatBold')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_26__Icon_IconFormatClear__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatClear')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_27__Icon_IconFormatColorFill__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatColorFill')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_28__Icon_IconFormatColorReset__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatColorReset')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_29__Icon_IconFormatColorText__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatColorText')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_30__Icon_IconFormatIndentDecrease__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatIndentDecrease')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_31__Icon_IconFormatIndentIncrease__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatIndentIncrease')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_32__Icon_IconFormatItalic__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatItalic')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_33__Icon_IconFormatLineSpacing__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatLineSpacing')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_34__Icon_IconFormatListBulleted__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatListBulleted')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_35__Icon_IconFormatListNumbered__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatListNumbered')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_36__Icon_IconFormatPaint__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatPaint')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_37__Icon_IconFormatQuote__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatQuote')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_38__Icon_IconFormatShapes__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatShapes')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_39__Icon_IconFormatSize__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatSize')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_40__Icon_IconFormatStrikethrough__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatStrikethrough')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_41__Icon_IconFormatTextdirectionLToR__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatTextdirectionLToR')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_42__Icon_IconFormatTextdirectionRToL__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatTextdirectionRToL')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_43__Icon_IconFormatUnderlined__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFormatUnderlined')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_44__Icon_IconFunctions__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFunctions')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_45__Icon_IconHighlight__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHighlight')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_46__Icon_IconInsertChart__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconInsertChart')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_47__Icon_IconInsertComment__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconInsertComment')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_48__Icon_IconInsertDriveFile__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconInsertDriveFile')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_49__Icon_IconInsertEmoticon__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconInsertEmoticon')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_50__Icon_IconInsertInvitation__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconInsertInvitation')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_51__Icon_IconInsertLink__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconInsertLink')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_52__Icon_IconInsertPhoto__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconInsertPhoto')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_53__Icon_IconLinearScale__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLinearScale')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_54__Icon_IconMergeType__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMergeType')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_55__Icon_IconModeComment__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconModeComment')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_56__Icon_IconModeEdit__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconModeEdit')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_57__Icon_IconMonetizationOn__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMonetizationOn')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_58__Icon_IconMoneyOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMoneyOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_59__Icon_IconMultilineChart__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMultilineChart')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_60__Icon_IconPieChart__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPieChart')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_61__Icon_IconPieChartOutlined__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPieChartOutlined')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_62__Icon_IconPublish__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPublish')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_63__Icon_IconShortText__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconShortText')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_64__Icon_IconShowChart__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconShowChart')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_65__Icon_IconSpaceBar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSpaceBar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_66__Icon_IconStrikethroughS__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconStrikethroughS')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_67__Icon_IconTextFields__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTextFields')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_68__Icon_IconTitle__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTitle')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_69__Icon_IconVerticalAlignBottom__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVerticalAlignBottom')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_70__Icon_IconVerticalAlignCenter__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVerticalAlignCenter')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_71__Icon_IconVerticalAlignTop__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVerticalAlignTop')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_72__Icon_IconWrapText__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWrapText'))));

function EditorIcons() {
  return _ref;
}

/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FileIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Figure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FigCaption__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FigContainer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryHeader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconAttachment__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon_IconCloud__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon_IconCloudCircle__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icon_IconCloudDone__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icon_IconCloudDownload__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icon_IconCloudOff__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon_IconCloudQueue__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icon_IconCloudUpload__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icon_IconCreateNewFolder__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icon_IconFileDownload__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Icon_IconFileUpload__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icon_IconFolder__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Icon_IconFolderOpen__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Icon_IconFolderShared__ = __webpack_require__(828);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/* eslint-disable prettier/prettier */















var _ref = _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__CategoryHeader__["a" /* default */], {}, void 0, 'file'), _jsx(__WEBPACK_IMPORTED_MODULE_3__FigContainer__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_IconAttachment__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAttachment')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Icon_IconCloud__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCloud')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Icon_IconCloudCircle__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCloudCircle')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Icon_IconCloudDone__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCloudDone')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__Icon_IconCloudDownload__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCloudDownload')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Icon_IconCloudOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCloudOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__Icon_IconCloudQueue__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCloudQueue')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_12__Icon_IconCloudUpload__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCloudUpload')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_13__Icon_IconCreateNewFolder__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCreateNewFolder')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Icon_IconFileDownload__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFileDownload')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__Icon_IconFileUpload__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFileUpload')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__Icon_IconFolder__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFolder')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_17__Icon_IconFolderOpen__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFolderOpen')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_18__Icon_IconFolderShared__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFolderShared'))));

function FileIcons() {
  return _ref;
}

/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HardwareIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Figure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FigCaption__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FigContainer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryHeader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconCast__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon_IconCastConnected__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon_IconComputer__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icon_IconDesktopMac__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icon_IconDesktopWindows__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icon_IconDeveloperBoard__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon_IconDeviceHub__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icon_IconDevicesOther__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icon_IconDock__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icon_IconGamepad__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Icon_IconHeadset__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icon_IconHeadsetMic__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Icon_IconKeyboard__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Icon_IconKeyboardArrowDown__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Icon_IconKeyboardArrowLeft__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Icon_IconKeyboardArrowRight__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Icon_IconKeyboardArrowUp__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Icon_IconKeyboardBackspace__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Icon_IconKeyboardCapslock__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Icon_IconKeyboardHide__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Icon_IconKeyboardReturn__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Icon_IconKeyboardTab__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Icon_IconKeyboardVoice__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Icon_IconLaptop__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Icon_IconLaptopChromebook__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Icon_IconLaptopMac__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Icon_IconLaptopWindows__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Icon_IconMemory__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Icon_IconMouse__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Icon_IconPhoneAndroid__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Icon_IconPhoneIphone__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Icon_IconPhonelink__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Icon_IconPhonelinkOff__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Icon_IconPowerInput__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Icon_IconRouter__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Icon_IconScanner__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Icon_IconSecurity__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Icon_IconSimCard__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Icon_IconSmartphone__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Icon_IconSpeaker__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Icon_IconSpeakerGroup__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Icon_IconTablet__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Icon_IconTabletAndroid__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Icon_IconTabletMac__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Icon_IconToys__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Icon_IconTv__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Icon_IconVideogameAsset__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Icon_IconWatch__ = __webpack_require__(876);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/* eslint-disable prettier/prettier */

















































var _ref = _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__CategoryHeader__["a" /* default */], {}, void 0, 'hardware'), _jsx(__WEBPACK_IMPORTED_MODULE_3__FigContainer__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_IconCast__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCast')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Icon_IconCastConnected__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCastConnected')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Icon_IconComputer__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconComputer')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Icon_IconDesktopMac__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDesktopMac')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__Icon_IconDesktopWindows__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDesktopWindows')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Icon_IconDeveloperBoard__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDeveloperBoard')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__Icon_IconDeviceHub__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDeviceHub')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_12__Icon_IconDevicesOther__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDevicesOther')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_13__Icon_IconDock__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDock')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Icon_IconGamepad__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGamepad')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__Icon_IconHeadset__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHeadset')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__Icon_IconHeadsetMic__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHeadsetMic')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_17__Icon_IconKeyboard__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconKeyboard')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_18__Icon_IconKeyboardArrowDown__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconKeyboardArrowDown')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_19__Icon_IconKeyboardArrowLeft__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconKeyboardArrowLeft')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_20__Icon_IconKeyboardArrowRight__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconKeyboardArrowRight')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_21__Icon_IconKeyboardArrowUp__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconKeyboardArrowUp')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_22__Icon_IconKeyboardBackspace__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconKeyboardBackspace')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_23__Icon_IconKeyboardCapslock__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconKeyboardCapslock')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_24__Icon_IconKeyboardHide__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconKeyboardHide')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_25__Icon_IconKeyboardReturn__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconKeyboardReturn')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_26__Icon_IconKeyboardTab__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconKeyboardTab')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_27__Icon_IconKeyboardVoice__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconKeyboardVoice')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_28__Icon_IconLaptop__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLaptop')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_29__Icon_IconLaptopChromebook__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLaptopChromebook')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_30__Icon_IconLaptopMac__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLaptopMac')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_31__Icon_IconLaptopWindows__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLaptopWindows')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_32__Icon_IconMemory__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMemory')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_33__Icon_IconMouse__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMouse')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_34__Icon_IconPhoneAndroid__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhoneAndroid')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_35__Icon_IconPhoneIphone__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhoneIphone')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_36__Icon_IconPhonelink__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhonelink')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_37__Icon_IconPhonelinkOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhonelinkOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_38__Icon_IconPowerInput__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPowerInput')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_39__Icon_IconRouter__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRouter')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_40__Icon_IconScanner__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconScanner')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_41__Icon_IconSecurity__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSecurity')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_42__Icon_IconSimCard__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSimCard')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_43__Icon_IconSmartphone__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSmartphone')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_44__Icon_IconSpeaker__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSpeaker')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_45__Icon_IconSpeakerGroup__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSpeakerGroup')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_46__Icon_IconTablet__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTablet')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_47__Icon_IconTabletAndroid__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTabletAndroid')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_48__Icon_IconTabletMac__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTabletMac')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_49__Icon_IconToys__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconToys')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_50__Icon_IconTv__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTv')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_51__Icon_IconVideogameAsset__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVideogameAsset')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_52__Icon_IconWatch__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWatch'))));

function HardwareIcons() {
  return _ref;
}

/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ImageIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Figure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FigCaption__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FigContainer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryHeader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconAddAPhoto__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon_IconAddToPhotos__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon_IconAdjust__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icon_IconAssistant__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icon_IconAssistantPhoto__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icon_IconAudiotrack__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon_IconBlurCircular__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icon_IconBlurLinear__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icon_IconBlurOff__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icon_IconBlurOn__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Icon_IconBrightness1__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icon_IconBrightness2__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Icon_IconBrightness3__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Icon_IconBrightness4__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Icon_IconBrightness5__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Icon_IconBrightness6__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Icon_IconBrightness7__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Icon_IconBrokenImage__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Icon_IconBrush__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Icon_IconBurstMode__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Icon_IconCamera__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Icon_IconCameraAlt__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Icon_IconCameraFront__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Icon_IconCameraRear__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Icon_IconCameraRoll__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Icon_IconCenterFocusStrong__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Icon_IconCenterFocusWeak__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Icon_IconCollections__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Icon_IconCollectionsBookmark__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Icon_IconColorLens__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Icon_IconColorize__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Icon_IconCompare__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Icon_IconControlPoint__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Icon_IconControlPointDuplicate__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Icon_IconCrop169__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Icon_IconCrop__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Icon_IconCrop32__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Icon_IconCrop54__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Icon_IconCrop75__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Icon_IconCropDin__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Icon_IconCropFree__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Icon_IconCropLandscape__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Icon_IconCropOriginal__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Icon_IconCropPortrait__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Icon_IconCropRotate__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Icon_IconCropSquare__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Icon_IconDehaze__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Icon_IconDetails__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Icon_IconEdit__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Icon_IconExposure__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Icon_IconExposureNeg1__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Icon_IconExposureNeg2__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Icon_IconExposurePlus1__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Icon_IconExposurePlus2__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Icon_IconExposureZero__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__Icon_IconFilter1__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Icon_IconFilter2__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Icon_IconFilter__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Icon_IconFilter3__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Icon_IconFilter4__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Icon_IconFilter5__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Icon_IconFilter6__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Icon_IconFilter7__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Icon_IconFilter8__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Icon_IconFilter9__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Icon_IconFilter9Plus__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Icon_IconFilterBAndW__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Icon_IconFilterCenterFocus__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__Icon_IconFilterDrama__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__Icon_IconFilterFrames__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__Icon_IconFilterHdr__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__Icon_IconFilterNone__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__Icon_IconFilterTiltShift__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__Icon_IconFilterVintage__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__Icon_IconFlare__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__Icon_IconFlashAuto__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__Icon_IconFlashOff__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__Icon_IconFlashOn__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__Icon_IconFlip__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__Icon_IconGradient__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__Icon_IconGrain__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__Icon_IconGridOff__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__Icon_IconGridOn__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__Icon_IconHdrOff__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__Icon_IconHdrOn__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__Icon_IconHdrStrong__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__Icon_IconHdrWeak__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__Icon_IconHealing__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__Icon_IconImage__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__Icon_IconImageAspectRatio__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__Icon_IconIso__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__Icon_IconLandscape__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__Icon_IconLeakAdd__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__Icon_IconLeakRemove__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__Icon_IconLens__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__Icon_IconLinkedCamera__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__Icon_IconLooks__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__Icon_IconLooks3__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__Icon_IconLooks4__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__Icon_IconLooks5__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__Icon_IconLooks6__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__Icon_IconLooksOne__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__Icon_IconLooksTwo__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__Icon_IconLoupe__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__Icon_IconMonochromePhotos__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__Icon_IconMovieCreation__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__Icon_IconMovieFilter__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__Icon_IconMusicNote__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__Icon_IconNature__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__Icon_IconNaturePeople__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__Icon_IconNavigateBefore__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__Icon_IconNavigateNext__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__Icon_IconPalette__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__Icon_IconPanorama__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__Icon_IconPanoramaFishEye__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__Icon_IconPanoramaHorizontal__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__Icon_IconPanoramaVertical__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__Icon_IconPanoramaWideAngle__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__Icon_IconPhoto__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__Icon_IconPhotoAlbum__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__Icon_IconPhotoCamera__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__Icon_IconPhotoFilter__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__Icon_IconPhotoLibrary__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__Icon_IconPhotoSizeSelectActual__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__Icon_IconPhotoSizeSelectLarge__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__Icon_IconPhotoSizeSelectSmall__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__Icon_IconPictureAsPdf__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__Icon_IconPortrait__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__Icon_IconRemoveRedEye__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__Icon_IconRotate90DegreesCcw__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__Icon_IconRotateLeft__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__Icon_IconRotateRight__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__Icon_IconSlideshow__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__Icon_IconStraighten__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__Icon_IconStyle__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__Icon_IconSwitchCamera__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__Icon_IconSwitchVideo__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__Icon_IconTagFaces__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__Icon_IconTexture__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__Icon_IconTimelapse__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__Icon_IconTimer10__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__Icon_IconTimer__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__Icon_IconTimer3__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__Icon_IconTimerOff__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__Icon_IconTonality__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__Icon_IconTransform__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__Icon_IconTune__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__Icon_IconViewComfy__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__Icon_IconViewCompact__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__Icon_IconVignette__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__Icon_IconWbAuto__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__Icon_IconWbCloudy__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__Icon_IconWbIncandescent__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__Icon_IconWbIridescent__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__Icon_IconWbSunny__ = __webpack_require__(1031);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/* eslint-disable prettier/prettier */




























































































































































var _ref = _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__CategoryHeader__["a" /* default */], {}, void 0, 'image'), _jsx(__WEBPACK_IMPORTED_MODULE_3__FigContainer__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_IconAddAPhoto__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAddAPhoto')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Icon_IconAddToPhotos__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAddToPhotos')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Icon_IconAdjust__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAdjust')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Icon_IconAssistant__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAssistant')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__Icon_IconAssistantPhoto__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAssistantPhoto')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Icon_IconAudiotrack__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAudiotrack')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__Icon_IconBlurCircular__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBlurCircular')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_12__Icon_IconBlurLinear__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBlurLinear')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_13__Icon_IconBlurOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBlurOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Icon_IconBlurOn__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBlurOn')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__Icon_IconBrightness1__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBrightness1')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__Icon_IconBrightness2__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBrightness2')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_17__Icon_IconBrightness3__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBrightness3')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_18__Icon_IconBrightness4__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBrightness4')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_19__Icon_IconBrightness5__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBrightness5')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_20__Icon_IconBrightness6__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBrightness6')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_21__Icon_IconBrightness7__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBrightness7')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_22__Icon_IconBrokenImage__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBrokenImage')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_23__Icon_IconBrush__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBrush')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_24__Icon_IconBurstMode__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBurstMode')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_25__Icon_IconCamera__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCamera')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_26__Icon_IconCameraAlt__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCameraAlt')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_27__Icon_IconCameraFront__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCameraFront')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_28__Icon_IconCameraRear__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCameraRear')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_29__Icon_IconCameraRoll__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCameraRoll')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_30__Icon_IconCenterFocusStrong__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCenterFocusStrong')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_31__Icon_IconCenterFocusWeak__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCenterFocusWeak')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_32__Icon_IconCollections__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCollections')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_33__Icon_IconCollectionsBookmark__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCollectionsBookmark')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_34__Icon_IconColorLens__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconColorLens')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_35__Icon_IconColorize__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconColorize')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_36__Icon_IconCompare__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCompare')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_37__Icon_IconControlPoint__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconControlPoint')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_38__Icon_IconControlPointDuplicate__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconControlPointDuplicate')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_39__Icon_IconCrop169__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCrop169')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_40__Icon_IconCrop__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCrop')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_41__Icon_IconCrop32__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCrop32')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_42__Icon_IconCrop54__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCrop54')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_43__Icon_IconCrop75__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCrop75')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_44__Icon_IconCropDin__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCropDin')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_45__Icon_IconCropFree__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCropFree')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_46__Icon_IconCropLandscape__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCropLandscape')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_47__Icon_IconCropOriginal__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCropOriginal')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_48__Icon_IconCropPortrait__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCropPortrait')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_49__Icon_IconCropRotate__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCropRotate')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_50__Icon_IconCropSquare__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCropSquare')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_51__Icon_IconDehaze__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDehaze')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_52__Icon_IconDetails__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDetails')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_53__Icon_IconEdit__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconEdit')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_54__Icon_IconExposure__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconExposure')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_55__Icon_IconExposureNeg1__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconExposureNeg1')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_56__Icon_IconExposureNeg2__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconExposureNeg2')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_57__Icon_IconExposurePlus1__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconExposurePlus1')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_58__Icon_IconExposurePlus2__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconExposurePlus2')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_59__Icon_IconExposureZero__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconExposureZero')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_60__Icon_IconFilter1__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilter1')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_61__Icon_IconFilter2__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilter2')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_62__Icon_IconFilter__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilter')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_63__Icon_IconFilter3__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilter3')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_64__Icon_IconFilter4__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilter4')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_65__Icon_IconFilter5__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilter5')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_66__Icon_IconFilter6__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilter6')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_67__Icon_IconFilter7__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilter7')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_68__Icon_IconFilter8__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilter8')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_69__Icon_IconFilter9__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilter9')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_70__Icon_IconFilter9Plus__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilter9Plus')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_71__Icon_IconFilterBAndW__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilterBAndW')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_72__Icon_IconFilterCenterFocus__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilterCenterFocus')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_73__Icon_IconFilterDrama__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilterDrama')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_74__Icon_IconFilterFrames__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilterFrames')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_75__Icon_IconFilterHdr__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilterHdr')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_76__Icon_IconFilterNone__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilterNone')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_77__Icon_IconFilterTiltShift__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilterTiltShift')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_78__Icon_IconFilterVintage__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFilterVintage')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_79__Icon_IconFlare__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFlare')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_80__Icon_IconFlashAuto__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFlashAuto')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_81__Icon_IconFlashOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFlashOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_82__Icon_IconFlashOn__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFlashOn')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_83__Icon_IconFlip__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFlip')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_84__Icon_IconGradient__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGradient')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_85__Icon_IconGrain__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGrain')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_86__Icon_IconGridOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGridOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_87__Icon_IconGridOn__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGridOn')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_88__Icon_IconHdrOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHdrOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_89__Icon_IconHdrOn__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHdrOn')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_90__Icon_IconHdrStrong__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHdrStrong')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_91__Icon_IconHdrWeak__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHdrWeak')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_92__Icon_IconHealing__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHealing')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_93__Icon_IconImage__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconImage')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_94__Icon_IconImageAspectRatio__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconImageAspectRatio')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_95__Icon_IconIso__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconIso')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_96__Icon_IconLandscape__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLandscape')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_97__Icon_IconLeakAdd__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLeakAdd')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_98__Icon_IconLeakRemove__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLeakRemove')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_99__Icon_IconLens__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLens')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_100__Icon_IconLinkedCamera__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLinkedCamera')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_101__Icon_IconLooks__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLooks')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_102__Icon_IconLooks3__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLooks3')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_103__Icon_IconLooks4__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLooks4')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_104__Icon_IconLooks5__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLooks5')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_105__Icon_IconLooks6__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLooks6')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_106__Icon_IconLooksOne__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLooksOne')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_107__Icon_IconLooksTwo__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLooksTwo')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_108__Icon_IconLoupe__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLoupe')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_109__Icon_IconMonochromePhotos__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMonochromePhotos')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_110__Icon_IconMovieCreation__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMovieCreation')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_111__Icon_IconMovieFilter__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMovieFilter')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_112__Icon_IconMusicNote__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMusicNote')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_113__Icon_IconNature__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNature')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_114__Icon_IconNaturePeople__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNaturePeople')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_115__Icon_IconNavigateBefore__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNavigateBefore')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_116__Icon_IconNavigateNext__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNavigateNext')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_117__Icon_IconPalette__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPalette')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_118__Icon_IconPanorama__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPanorama')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_119__Icon_IconPanoramaFishEye__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPanoramaFishEye')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_120__Icon_IconPanoramaHorizontal__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPanoramaHorizontal')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_121__Icon_IconPanoramaVertical__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPanoramaVertical')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_122__Icon_IconPanoramaWideAngle__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPanoramaWideAngle')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_123__Icon_IconPhoto__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhoto')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_124__Icon_IconPhotoAlbum__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhotoAlbum')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_125__Icon_IconPhotoCamera__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhotoCamera')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_126__Icon_IconPhotoFilter__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhotoFilter')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_127__Icon_IconPhotoLibrary__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhotoLibrary')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_128__Icon_IconPhotoSizeSelectActual__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhotoSizeSelectActual')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_129__Icon_IconPhotoSizeSelectLarge__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhotoSizeSelectLarge')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_130__Icon_IconPhotoSizeSelectSmall__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhotoSizeSelectSmall')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_131__Icon_IconPictureAsPdf__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPictureAsPdf')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_132__Icon_IconPortrait__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPortrait')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_133__Icon_IconRemoveRedEye__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRemoveRedEye')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_134__Icon_IconRotate90DegreesCcw__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRotate90DegreesCcw')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_135__Icon_IconRotateLeft__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRotateLeft')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_136__Icon_IconRotateRight__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRotateRight')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_137__Icon_IconSlideshow__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSlideshow')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_138__Icon_IconStraighten__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconStraighten')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_139__Icon_IconStyle__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconStyle')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_140__Icon_IconSwitchCamera__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSwitchCamera')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_141__Icon_IconSwitchVideo__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSwitchVideo')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_142__Icon_IconTagFaces__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTagFaces')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_143__Icon_IconTexture__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTexture')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_144__Icon_IconTimelapse__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTimelapse')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_145__Icon_IconTimer10__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTimer10')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_146__Icon_IconTimer__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTimer')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_147__Icon_IconTimer3__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTimer3')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_148__Icon_IconTimerOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTimerOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_149__Icon_IconTonality__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTonality')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_150__Icon_IconTransform__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTransform')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_151__Icon_IconTune__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTune')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_152__Icon_IconViewComfy__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconViewComfy')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_153__Icon_IconViewCompact__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconViewCompact')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_154__Icon_IconVignette__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVignette')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_155__Icon_IconWbAuto__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWbAuto')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_156__Icon_IconWbCloudy__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWbCloudy')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_157__Icon_IconWbIncandescent__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWbIncandescent')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_158__Icon_IconWbIridescent__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWbIridescent')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_159__Icon_IconWbSunny__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWbSunny'))));

function ImageIcons() {
  return _ref;
}

/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MapsIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Figure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FigCaption__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FigContainer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryHeader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconAddLocation__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon_IconBeenhere__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon_IconDirections__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icon_IconDirectionsBike__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icon_IconDirectionsBoat__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icon_IconDirectionsBus__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon_IconDirectionsCar__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icon_IconDirectionsRailway__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icon_IconDirectionsRun__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icon_IconDirectionsSubway__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Icon_IconDirectionsTransit__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icon_IconDirectionsWalk__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Icon_IconEditLocation__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Icon_IconEvStation__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Icon_IconFlight__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Icon_IconHotel__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Icon_IconLayers__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Icon_IconLayersClear__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Icon_IconLocalActivity__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Icon_IconLocalAirport__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Icon_IconLocalAtm__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Icon_IconLocalBar__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Icon_IconLocalCafe__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Icon_IconLocalCarWash__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Icon_IconLocalConvenienceStore__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Icon_IconLocalDining__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Icon_IconLocalDrink__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Icon_IconLocalFlorist__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Icon_IconLocalGasStation__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Icon_IconLocalGroceryStore__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Icon_IconLocalHospital__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Icon_IconLocalHotel__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Icon_IconLocalLaundryService__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Icon_IconLocalLibrary__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Icon_IconLocalMall__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Icon_IconLocalMovies__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Icon_IconLocalOffer__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Icon_IconLocalParking__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Icon_IconLocalPharmacy__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Icon_IconLocalPhone__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Icon_IconLocalPizza__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Icon_IconLocalPlay__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Icon_IconLocalPostOffice__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Icon_IconLocalPrintshop__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Icon_IconLocalSee__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Icon_IconLocalShipping__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Icon_IconLocalTaxi__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Icon_IconMap__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Icon_IconMyLocation__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Icon_IconNavigation__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Icon_IconNearMe__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Icon_IconPersonPin__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Icon_IconPersonPinCircle__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Icon_IconPinDrop__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Icon_IconPlace__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__Icon_IconRateReview__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Icon_IconRestaurant__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Icon_IconRestaurantMenu__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Icon_IconSatellite__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Icon_IconStoreMallDirectory__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Icon_IconStreetview__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Icon_IconSubway__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Icon_IconTerrain__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Icon_IconTraffic__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Icon_IconTrain__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Icon_IconTram__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Icon_IconTransferWithinAStation__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Icon_IconZoomOutMap__ = __webpack_require__(1094);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/* eslint-disable prettier/prettier */





































































var _ref = _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__CategoryHeader__["a" /* default */], {}, void 0, 'maps'), _jsx(__WEBPACK_IMPORTED_MODULE_3__FigContainer__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_IconAddLocation__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAddLocation')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Icon_IconBeenhere__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBeenhere')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Icon_IconDirections__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDirections')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Icon_IconDirectionsBike__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDirectionsBike')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__Icon_IconDirectionsBoat__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDirectionsBoat')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Icon_IconDirectionsBus__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDirectionsBus')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__Icon_IconDirectionsCar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDirectionsCar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_12__Icon_IconDirectionsRailway__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDirectionsRailway')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_13__Icon_IconDirectionsRun__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDirectionsRun')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Icon_IconDirectionsSubway__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDirectionsSubway')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__Icon_IconDirectionsTransit__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDirectionsTransit')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__Icon_IconDirectionsWalk__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDirectionsWalk')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_17__Icon_IconEditLocation__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconEditLocation')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_18__Icon_IconEvStation__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconEvStation')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_19__Icon_IconFlight__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFlight')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_20__Icon_IconHotel__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHotel')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_21__Icon_IconLayers__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLayers')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_22__Icon_IconLayersClear__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLayersClear')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_23__Icon_IconLocalActivity__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalActivity')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_24__Icon_IconLocalAirport__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalAirport')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_25__Icon_IconLocalAtm__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalAtm')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_26__Icon_IconLocalBar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalBar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_27__Icon_IconLocalCafe__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalCafe')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_28__Icon_IconLocalCarWash__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalCarWash')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_29__Icon_IconLocalConvenienceStore__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalConvenienceStore')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_30__Icon_IconLocalDining__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalDining')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_31__Icon_IconLocalDrink__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalDrink')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_32__Icon_IconLocalFlorist__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalFlorist')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_33__Icon_IconLocalGasStation__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalGasStation')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_34__Icon_IconLocalGroceryStore__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalGroceryStore')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_35__Icon_IconLocalHospital__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalHospital')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_36__Icon_IconLocalHotel__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalHotel')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_37__Icon_IconLocalLaundryService__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalLaundryService')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_38__Icon_IconLocalLibrary__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalLibrary')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_39__Icon_IconLocalMall__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalMall')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_40__Icon_IconLocalMovies__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalMovies')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_41__Icon_IconLocalOffer__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalOffer')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_42__Icon_IconLocalParking__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalParking')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_43__Icon_IconLocalPharmacy__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalPharmacy')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_44__Icon_IconLocalPhone__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalPhone')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_45__Icon_IconLocalPizza__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalPizza')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_46__Icon_IconLocalPlay__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalPlay')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_47__Icon_IconLocalPostOffice__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalPostOffice')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_48__Icon_IconLocalPrintshop__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalPrintshop')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_49__Icon_IconLocalSee__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalSee')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_50__Icon_IconLocalShipping__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalShipping')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_51__Icon_IconLocalTaxi__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocalTaxi')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_52__Icon_IconMap__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMap')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_53__Icon_IconMyLocation__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMyLocation')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_54__Icon_IconNavigation__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNavigation')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_55__Icon_IconNearMe__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNearMe')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_56__Icon_IconPersonPin__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPersonPin')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_57__Icon_IconPersonPinCircle__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPersonPinCircle')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_58__Icon_IconPinDrop__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPinDrop')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_59__Icon_IconPlace__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPlace')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_60__Icon_IconRateReview__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRateReview')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_61__Icon_IconRestaurant__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRestaurant')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_62__Icon_IconRestaurantMenu__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRestaurantMenu')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_63__Icon_IconSatellite__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSatellite')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_64__Icon_IconStoreMallDirectory__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconStoreMallDirectory')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_65__Icon_IconStreetview__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconStreetview')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_66__Icon_IconSubway__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSubway')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_67__Icon_IconTerrain__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTerrain')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_68__Icon_IconTraffic__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTraffic')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_69__Icon_IconTrain__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTrain')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_70__Icon_IconTram__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTram')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_71__Icon_IconTransferWithinAStation__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTransferWithinAStation')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_72__Icon_IconZoomOutMap__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconZoomOutMap'))));

function MapsIcons() {
  return _ref;
}

/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NavigationIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Figure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FigCaption__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FigContainer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryHeader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconApps__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon_IconArrowBack__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon_IconArrowDownward__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icon_IconArrowDropDown__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icon_IconArrowDropDownCircle__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icon_IconArrowDropUp__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon_IconArrowForward__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icon_IconArrowUpward__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icon_IconCancel__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icon_IconCheck__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Icon_IconChevronLeft__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icon_IconChevronRight__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Icon_IconClose__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Icon_IconExpandLess__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Icon_IconExpandMore__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Icon_IconFirstPage__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Icon_IconFullscreen__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Icon_IconFullscreenExit__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Icon_IconLastPage__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Icon_IconMenu__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Icon_IconMoreHoriz__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Icon_IconMoreVert__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Icon_IconRefresh__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Icon_IconSubdirectoryArrowLeft__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Icon_IconSubdirectoryArrowRight__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Icon_IconUnfoldLess__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Icon_IconUnfoldMore__ = __webpack_require__(1117);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/* eslint-disable prettier/prettier */




























var _ref = _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__CategoryHeader__["a" /* default */], {}, void 0, 'navigation'), _jsx(__WEBPACK_IMPORTED_MODULE_3__FigContainer__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_IconApps__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconApps')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Icon_IconArrowBack__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconArrowBack')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Icon_IconArrowDownward__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconArrowDownward')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Icon_IconArrowDropDown__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconArrowDropDown')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__Icon_IconArrowDropDownCircle__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconArrowDropDownCircle')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Icon_IconArrowDropUp__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconArrowDropUp')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__Icon_IconArrowForward__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconArrowForward')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_12__Icon_IconArrowUpward__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconArrowUpward')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_13__Icon_IconCancel__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCancel')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Icon_IconCheck__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCheck')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__Icon_IconChevronLeft__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconChevronLeft')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__Icon_IconChevronRight__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconChevronRight')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_17__Icon_IconClose__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconClose')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_18__Icon_IconExpandLess__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconExpandLess')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_19__Icon_IconExpandMore__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconExpandMore')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_20__Icon_IconFirstPage__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFirstPage')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_21__Icon_IconFullscreen__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFullscreen')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_22__Icon_IconFullscreenExit__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFullscreenExit')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_23__Icon_IconLastPage__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLastPage')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_24__Icon_IconMenu__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMenu')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_25__Icon_IconMoreHoriz__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMoreHoriz')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_26__Icon_IconMoreVert__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMoreVert')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_27__Icon_IconRefresh__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRefresh')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_28__Icon_IconSubdirectoryArrowLeft__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSubdirectoryArrowLeft')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_29__Icon_IconSubdirectoryArrowRight__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSubdirectoryArrowRight')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_30__Icon_IconUnfoldLess__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconUnfoldLess')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_31__Icon_IconUnfoldMore__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconUnfoldMore'))));

function NavigationIcons() {
  return _ref;
}

/***/ }),
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NotificationIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Figure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FigCaption__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FigContainer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryHeader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconAdb__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon_IconAirlineSeatFlat__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon_IconAirlineSeatFlatAngled__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icon_IconAirlineSeatIndividualSuite__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icon_IconAirlineSeatLegroomExtra__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icon_IconAirlineSeatLegroomNormal__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon_IconAirlineSeatLegroomReduced__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icon_IconAirlineSeatReclineExtra__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icon_IconAirlineSeatReclineNormal__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icon_IconBluetoothAudio__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Icon_IconConfirmationNumber__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icon_IconDiscFull__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Icon_IconDoNotDisturb__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Icon_IconDoNotDisturbAlt__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Icon_IconDoNotDisturbOff__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Icon_IconDoNotDisturbOn__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Icon_IconDriveEta__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Icon_IconEnhancedEncryption__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Icon_IconEventAvailable__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Icon_IconEventBusy__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Icon_IconEventNote__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Icon_IconFolderSpecial__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Icon_IconLiveTv__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Icon_IconMms__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Icon_IconMore__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Icon_IconNetworkCheck__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Icon_IconNetworkLocked__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Icon_IconNoEncryption__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Icon_IconOndemandVideo__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Icon_IconPersonalVideo__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Icon_IconPhoneBluetoothSpeaker__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Icon_IconPhoneForwarded__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Icon_IconPhoneInTalk__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Icon_IconPhoneLocked__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Icon_IconPhoneMissed__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Icon_IconPhonePaused__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Icon_IconPower__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Icon_IconPriorityHigh__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Icon_IconRvHookup__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Icon_IconSdCard__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Icon_IconSimCardAlert__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Icon_IconSms__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Icon_IconSmsFailed__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Icon_IconSync__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Icon_IconSyncDisabled__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Icon_IconSyncProblem__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Icon_IconSystemUpdate__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Icon_IconTapAndPlay__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Icon_IconTimeToLeave__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Icon_IconVibration__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Icon_IconVoiceChat__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Icon_IconVpnLock__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Icon_IconWc__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Icon_IconWifi__ = __webpack_require__(1171);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/* eslint-disable prettier/prettier */























































var _ref = _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__CategoryHeader__["a" /* default */], {}, void 0, 'notification'), _jsx(__WEBPACK_IMPORTED_MODULE_3__FigContainer__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_IconAdb__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAdb')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Icon_IconAirlineSeatFlat__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAirlineSeatFlat')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Icon_IconAirlineSeatFlatAngled__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAirlineSeatFlatAngled')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Icon_IconAirlineSeatIndividualSuite__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAirlineSeatIndividualSuite')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__Icon_IconAirlineSeatLegroomExtra__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAirlineSeatLegroomExtra')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Icon_IconAirlineSeatLegroomNormal__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAirlineSeatLegroomNormal')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__Icon_IconAirlineSeatLegroomReduced__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAirlineSeatLegroomReduced')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_12__Icon_IconAirlineSeatReclineExtra__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAirlineSeatReclineExtra')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_13__Icon_IconAirlineSeatReclineNormal__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAirlineSeatReclineNormal')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Icon_IconBluetoothAudio__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBluetoothAudio')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__Icon_IconConfirmationNumber__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconConfirmationNumber')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__Icon_IconDiscFull__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDiscFull')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_17__Icon_IconDoNotDisturb__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDoNotDisturb')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_18__Icon_IconDoNotDisturbAlt__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDoNotDisturbAlt')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_19__Icon_IconDoNotDisturbOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDoNotDisturbOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_20__Icon_IconDoNotDisturbOn__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDoNotDisturbOn')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_21__Icon_IconDriveEta__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDriveEta')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_22__Icon_IconEnhancedEncryption__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconEnhancedEncryption')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_23__Icon_IconEventAvailable__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconEventAvailable')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_24__Icon_IconEventBusy__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconEventBusy')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_25__Icon_IconEventNote__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconEventNote')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_26__Icon_IconFolderSpecial__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFolderSpecial')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_27__Icon_IconLiveTv__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLiveTv')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_28__Icon_IconMms__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMms')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_29__Icon_IconMore__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMore')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_30__Icon_IconNetworkCheck__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNetworkCheck')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_31__Icon_IconNetworkLocked__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNetworkLocked')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_32__Icon_IconNoEncryption__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNoEncryption')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_33__Icon_IconOndemandVideo__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconOndemandVideo')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_34__Icon_IconPersonalVideo__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPersonalVideo')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_35__Icon_IconPhoneBluetoothSpeaker__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhoneBluetoothSpeaker')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_36__Icon_IconPhoneForwarded__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhoneForwarded')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_37__Icon_IconPhoneInTalk__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhoneInTalk')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_38__Icon_IconPhoneLocked__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhoneLocked')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_39__Icon_IconPhoneMissed__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhoneMissed')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_40__Icon_IconPhonePaused__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPhonePaused')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_41__Icon_IconPower__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPower')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_42__Icon_IconPriorityHigh__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPriorityHigh')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_43__Icon_IconRvHookup__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRvHookup')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_44__Icon_IconSdCard__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSdCard')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_45__Icon_IconSimCardAlert__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSimCardAlert')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_46__Icon_IconSms__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSms')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_47__Icon_IconSmsFailed__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSmsFailed')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_48__Icon_IconSync__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSync')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_49__Icon_IconSyncDisabled__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSyncDisabled')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_50__Icon_IconSyncProblem__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSyncProblem')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_51__Icon_IconSystemUpdate__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSystemUpdate')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_52__Icon_IconTapAndPlay__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTapAndPlay')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_53__Icon_IconTimeToLeave__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconTimeToLeave')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_54__Icon_IconVibration__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVibration')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_55__Icon_IconVoiceChat__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVoiceChat')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_56__Icon_IconVpnLock__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconVpnLock')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_57__Icon_IconWc__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWc')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_58__Icon_IconWifi__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWifi'))));

function NotificationIcons() {
  return _ref;
}

/***/ }),
/* 1647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PlacesIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Figure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FigCaption__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FigContainer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryHeader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconAcUnit__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon_IconAirportShuttle__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon_IconAllInclusive__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icon_IconBeachAccess__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icon_IconBusinessCenter__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icon_IconCasino__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon_IconChildCare__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icon_IconChildFriendly__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icon_IconFitnessCenter__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icon_IconFreeBreakfast__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Icon_IconGolfCourse__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icon_IconHotTub__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Icon_IconKitchen__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Icon_IconPool__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Icon_IconRoomService__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Icon_IconSmokeFree__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Icon_IconSmokingRooms__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Icon_IconSpa__ = __webpack_require__(1189);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/* eslint-disable prettier/prettier */



















var _ref = _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__CategoryHeader__["a" /* default */], {}, void 0, 'places'), _jsx(__WEBPACK_IMPORTED_MODULE_3__FigContainer__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_IconAcUnit__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAcUnit')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Icon_IconAirportShuttle__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAirportShuttle')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Icon_IconAllInclusive__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconAllInclusive')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Icon_IconBeachAccess__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBeachAccess')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__Icon_IconBusinessCenter__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconBusinessCenter')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Icon_IconCasino__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCasino')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__Icon_IconChildCare__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconChildCare')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_12__Icon_IconChildFriendly__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconChildFriendly')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_13__Icon_IconFitnessCenter__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFitnessCenter')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Icon_IconFreeBreakfast__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconFreeBreakfast')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__Icon_IconGolfCourse__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGolfCourse')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__Icon_IconHotTub__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconHotTub')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_17__Icon_IconKitchen__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconKitchen')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_18__Icon_IconPool__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPool')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_19__Icon_IconRoomService__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRoomService')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_20__Icon_IconSmokeFree__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSmokeFree')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_21__Icon_IconSmokingRooms__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSmokingRooms')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_22__Icon_IconSpa__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSpa'))));

function PlacesIcons() {
  return _ref;
}

/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SocialIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Figure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FigCaption__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FigContainer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryHeader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconCake__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon_IconDomain__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon_IconGroup__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icon_IconGroupAdd__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icon_IconLocationCity__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icon_IconMood__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon_IconMoodBad__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icon_IconNotifications__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icon_IconNotificationsActive__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icon_IconNotificationsNone__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Icon_IconNotificationsOff__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icon_IconNotificationsPaused__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Icon_IconPages__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Icon_IconPartyMode__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Icon_IconPeople__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Icon_IconPeopleOutline__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Icon_IconPerson__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Icon_IconPersonAdd__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Icon_IconPersonOutline__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Icon_IconPlusOne__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Icon_IconPoll__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Icon_IconPublic__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Icon_IconSchool__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Icon_IconSentimentDissatisfied__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Icon_IconSentimentNeutral__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Icon_IconSentimentSatisfied__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Icon_IconSentimentVeryDissatisfied__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Icon_IconSentimentVerySatisfied__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Icon_IconShare__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Icon_IconWhatshot__ = __webpack_require__(1218);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/* eslint-disable prettier/prettier */































var _ref = _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__CategoryHeader__["a" /* default */], {}, void 0, 'social'), _jsx(__WEBPACK_IMPORTED_MODULE_3__FigContainer__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_IconCake__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCake')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Icon_IconDomain__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconDomain')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Icon_IconGroup__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGroup')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Icon_IconGroupAdd__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconGroupAdd')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__Icon_IconLocationCity__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconLocationCity')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Icon_IconMood__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMood')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__Icon_IconMoodBad__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconMoodBad')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_12__Icon_IconNotifications__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNotifications')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_13__Icon_IconNotificationsActive__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNotificationsActive')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Icon_IconNotificationsNone__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNotificationsNone')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__Icon_IconNotificationsOff__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNotificationsOff')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__Icon_IconNotificationsPaused__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconNotificationsPaused')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_17__Icon_IconPages__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPages')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_18__Icon_IconPartyMode__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPartyMode')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_19__Icon_IconPeople__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPeople')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_20__Icon_IconPeopleOutline__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPeopleOutline')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_21__Icon_IconPerson__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPerson')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_22__Icon_IconPersonAdd__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPersonAdd')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_23__Icon_IconPersonOutline__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPersonOutline')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_24__Icon_IconPlusOne__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPlusOne')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_25__Icon_IconPoll__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPoll')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_26__Icon_IconPublic__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconPublic')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_27__Icon_IconSchool__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSchool')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_28__Icon_IconSentimentDissatisfied__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSentimentDissatisfied')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_29__Icon_IconSentimentNeutral__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSentimentNeutral')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_30__Icon_IconSentimentSatisfied__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSentimentSatisfied')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_31__Icon_IconSentimentVeryDissatisfied__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSentimentVeryDissatisfied')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_32__Icon_IconSentimentVerySatisfied__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconSentimentVerySatisfied')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_33__Icon_IconShare__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconShare')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_34__Icon_IconWhatshot__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconWhatshot'))));

function SocialIcons() {
  return _ref;
}

/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ToggleIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Figure__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FigCaption__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FigContainer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryHeader__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconCheckBox__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon_IconCheckBoxOutlineBlank__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon_IconIndeterminateCheckBox__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icon_IconRadioButtonChecked__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icon_IconRadioButtonUnchecked__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icon_IconStar__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon_IconStarBorder__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icon_IconStarHalf__ = __webpack_require__(1226);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/* eslint-disable prettier/prettier */









var _ref = _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__CategoryHeader__["a" /* default */], {}, void 0, 'toggle'), _jsx(__WEBPACK_IMPORTED_MODULE_3__FigContainer__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_IconCheckBox__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCheckBox')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Icon_IconCheckBoxOutlineBlank__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconCheckBoxOutlineBlank')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7__Icon_IconIndeterminateCheckBox__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconIndeterminateCheckBox')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Icon_IconRadioButtonChecked__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRadioButtonChecked')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__Icon_IconRadioButtonUnchecked__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconRadioButtonUnchecked')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__Icon_IconStar__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconStar')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__Icon_IconStarBorder__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconStarBorder')), _jsx(__WEBPACK_IMPORTED_MODULE_1__Figure__["a" /* default */], {
  tabIndex: 0
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_12__Icon_IconStarHalf__["a" /* default */], {
  size: '32'
}), _jsx(__WEBPACK_IMPORTED_MODULE_2__FigCaption__["a" /* default */], {}, void 0, 'IconStarHalf'))));

function ToggleIcons() {
  return _ref;
}

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

module.exports = {
	"description": "Icons use graphical symbols to represent an object or concept in your UI.\nThey can be used to aid comprehension of core actions in your app, and to provide feedback for user input.\n\nMineral UI provides a large number of bundled Icon components as well\nas a generic Icon component to which you can provide your own SVG.",
	"displayName": "Icon",
	"methods": [],
	"props": {
		"size": {
			"flowType": {
				"name": "union",
				"raw": "'small' | 'medium' | 'large' | string",
				"elements": [
					{
						"name": "literal",
						"value": "'small'"
					},
					{
						"name": "literal",
						"value": "'medium'"
					},
					{
						"name": "literal",
						"value": "'large'"
					},
					{
						"name": "string"
					}
				]
			},
			"required": false,
			"description": "Available sizes, including custom - e.g. '5em' or '20px'",
			"defaultValue": {
				"value": "'medium'",
				"computed": false
			}
		},
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "SVG content, required for the generic Icon component"
		},
		"color": {
			"flowType": {
				"name": "string"
			},
			"required": false,
			"description": "Fill color, defaults to theme.color_gray_60"
		},
		"rtl": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Flip the Icon horizontally when used with RTL languages"
		},
		"title": {
			"flowType": {
				"name": "string"
			},
			"required": false,
			"description": "Alternative text"
		}
	}
}

/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Link_Link__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bestPractices__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples__ = __webpack_require__(1653);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var doc = __webpack_require__(1659);

/* harmony default export */ __webpack_exports__["a"] = ({
  bestPractices: __WEBPACK_IMPORTED_MODULE_1__bestPractices__["a" /* default */],
  componentTheme: __WEBPACK_IMPORTED_MODULE_0__Link_Link__["a" /* componentTheme */],
  doc: doc,
  examples: __WEBPACK_IMPORTED_MODULE_2__examples__["a" /* default */],
  slug: 'link',
  title: 'Link',
  whenHowToUse: 'Links should be used when the browser location will change.\nLinks should be clear about where the user will navigate.\nAvoid using "click here" or similar for Link content.\n\nIf you need a minimally styled Button, use `<Button minimal>Example</Button>`.'
});

/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(52);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




/* harmony default export */ __webpack_exports__["a"] = ([{
  type: 'do',
  title: 'use Links to navigate',
  example: _jsx('div', {}, void 0, _jsx('p', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Link__["a" /* default */], {
    href: 'https://mineral-ui.com'
  }, void 0, 'Lorem ipsum'), ' dolor sit amet, consectetur adipiscing elit. Donec mattis pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate interdum sollicitudin.'), _jsx('nav', {}, void 0, _jsx('li', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Link__["a" /* default */], {
    href: '/components/button'
  }, void 0, 'Button')), _jsx('li', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Link__["a" /* default */], {
    href: '/components/card/'
  }, void 0, 'Card')), _jsx('li', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Link__["a" /* default */], {
    href: '/components/icon'
  }, void 0, 'Icon')))),
  description: 'Links can be used inline to navigate to other content or pages.'
}, {
  type: 'dont',
  title: 'use a link to perform a page action',
  example: _jsx(__WEBPACK_IMPORTED_MODULE_1__Link__["a" /* default */], {}, void 0, 'Scroll to bottom'),
  description: 'To represent an action, use a [Button](../button).'
}]);

/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__link__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__children__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reactRouter__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__states__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__variants__ = __webpack_require__(1658);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_0__link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__children__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__variants__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__reactRouter__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__states__["a" /* default */]]);

/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(52);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var Big = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('p', { fontSize: '1.5em' });
var Bold = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('p', { fontWeight: 700 });
var Serif = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('p', { fontFamily: 'serif' });
var Small = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('p', { fontSize: '0.75em' });

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'basic',
  title: 'Example',
  description: 'Links inherit font size, weight, and family.',
  scope: { Big: Big, Bold: Bold, Link: __WEBPACK_IMPORTED_MODULE_1__Link__["a" /* default */], Serif: Serif, Small: Small },
  source: '\n    <div>\n      <Big>\n        Lorem ipsum dolor sit amet, <Link href="http://example.com">consectetur</Link> adipiscing elit,\n      </Big>\n\n      <Small>\n        sed do eiusmod tempor <Link href="http://example.com">incididunt</Link> ut labore et dolore magna aliqua.\n      </Small>\n\n      <Bold>\n        Ut enim <Link href="http://example.com">ad minim veniam</Link> quis nostrud exercitation\n      </Bold>\n\n      <Serif>\n        ullamco laboris <Link href="http://example.com">nisi ut</Link> aliquip ex ea commodo consequat.\n      </Serif>\n    </div>'
});

/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Link__ = __webpack_require__(52);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'children',
  title: 'Children',
  description: 'A Link will render any children.',
  scope: { Link: __WEBPACK_IMPORTED_MODULE_0__Link__["a" /* default */] },
  source: '\n    <Link href="http://example.com">\n      <img alt="gradient placeholder" src="/images/125x125.png" />\n    </Link>'
});

/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Link__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(93);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'react-router',
  title: 'Routing',
  description: 'Client-side routing can be achieved by passing a [ReactRouter Link](https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/docs/api/Link.md) (or other routing component that creates an `<a>` element) to the `element` prop.\nMineral UI styles are applied.\n',
  scope: { BrowserRouter: __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */], Link: __WEBPACK_IMPORTED_MODULE_0__Link__["a" /* default */], ReactRouterLink: __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], Redirect: __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */], Route: __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], Switch: __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Switch */] },
  source: '\n    <BrowserRouter>\n      <Switch>\n        <Route\n          path="/components/:componentId/:path?"\n          render={route => {\n            const path = route.match.params.path;\n\n            if (\'page-2\' === path) {\n              return <Link to="/components/link/page-1" replace element={ReactRouterLink}>Page 1</Link>;\n            }\n            return <Link to="/components/link/page-2" replace element={ReactRouterLink}>Page 2</Link>;\n          }}\n        />\n        <Redirect from="/" to="/components/link" />\n      </Switch>\n    </BrowserRouter>'
});

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamor__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_glamor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(52);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', {
  '& > a': {
    marginRight: '0.5rem'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'states',
  title: 'States',
  hideFromProd: true,
  hideSource: true,
  scope: { Link: __WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], DemoLayout: DemoLayout, simulate: __WEBPACK_IMPORTED_MODULE_0_glamor__["simulate"] },
  source: '\n    <DemoLayout>\n      <Link href="http://example.com">Regular</Link>\n      <Link {...simulate(\'hover\')} href="http://example.com">Hover</Link>\n      <Link {...simulate(\'focus\')} href="http://example.com">Focus</Link>\n      <Link {...simulate(\'focus\', \'hover\')} href="http://example.com">Focus & Hover</Link>\n      <Link {...simulate(\'focus\', \'active\')} href="http://example.com">Focus & Active</Link>\n      <Link {...simulate(\'active\')} href="http://example.com">Active</Link>\n      <br /><br />\n      <Link variant="danger" href="http://example.com">Danger</Link>\n      <Link {...simulate(\'hover\')} variant="danger" href="http://example.com">Hover</Link>\n      <Link {...simulate(\'focus\')} variant="danger" href="http://example.com">Focus</Link>\n      <Link {...simulate(\'focus\', \'hover\')} variant="danger" href="http://example.com">Focus & Hover</Link>\n      <Link {...simulate(\'focus\', \'active\')} variant="danger" href="http://example.com">Focus & Active</Link>\n      <Link  {...simulate(\'active\')} variant="danger" href="http://example.com">Active</Link>\n      <br /><br />\n      <Link variant="success" href="http://example.com">Success</Link>\n      <Link {...simulate(\'hover\')} variant="success" href="http://example.com">Hover</Link>\n      <Link {...simulate(\'focus\')} variant="success" href="http://example.com">Focus</Link>\n      <Link {...simulate(\'focus\', \'hover\')} variant="success" href="http://example.com">Focus & Hover</Link>\n      <Link {...simulate(\'focus\', \'active\')} variant="success" href="http://example.com">Focus & Active</Link>\n      <Link {...simulate(\'active\')} variant="success" href="http://example.com">Active</Link>\n      <br /><br />\n      <Link variant="warning" href="http://example.com">Warning</Link>\n      <Link {...simulate(\'hover\')} variant="warning" href="http://example.com">Hover</Link>\n      <Link {...simulate(\'focus\')} variant="warning" href="http://example.com">Focus</Link>\n      <Link {...simulate(\'focus\', \'hover\')} variant="warning" href="http://example.com">Focus & Hover</Link>\n      <Link {...simulate(\'focus\', \'active\')} variant="warning" href="http://example.com">Focus & Active</Link>\n      <Link {...simulate(\'active\')} variant="warning" href="http://example.com">Active</Link>\n    </DemoLayout>'
});

/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(52);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('div', {
  '& > a': {
    marginRight: '0.5rem'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'variants',
  title: 'Variants',
  description: 'Links can be styled as these variants, to help communicate purpose.',
  scope: { DemoLayout: DemoLayout, Link: __WEBPACK_IMPORTED_MODULE_1__Link__["a" /* default */] },
  source: '\n    <DemoLayout>\n      <Link href="http://example.com">Regular</Link>\n      <Link variant="danger" href="http://example.com">Danger</Link>\n      <Link variant="success" href="http://example.com">Success</Link>\n      <Link variant="warning" href="http://example.com">Warning</Link>\n    </DemoLayout>'
});

/***/ }),
/* 1659 */
/***/ (function(module, exports) {

module.exports = {
	"description": "The Link component creates a hyperlink to external pages, files, anchors on the same page or another URL.\nLinks trigger an action, select an option, or provide a gateway to more information.\nLinks are used to reduce clutter on a page when there are potentially many actions available.\n\nLinks with clear messaging and an appropriate variant applied communicate intention effectively.",
	"methods": [],
	"props": {
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "Content of the Link"
		},
		"href": {
			"flowType": {
				"name": "string"
			},
			"required": false,
			"description": "A URL or URL fragment to which the Link points"
		},
		"element": {
			"flowType": {
				"name": "$FlowFixMe"
			},
			"required": false,
			"description": "Element to be used as the root node - e.g. \"a\" or {&nbsp;ReactRouterLink&nbsp;}",
			"defaultValue": {
				"value": "'a'",
				"computed": false
			}
		},
		"variant": {
			"flowType": {
				"name": "union",
				"raw": "'regular' | 'danger' | 'success' | 'warning'",
				"elements": [
					{
						"name": "literal",
						"value": "'regular'"
					},
					{
						"name": "literal",
						"value": "'danger'"
					},
					{
						"name": "literal",
						"value": "'success'"
					},
					{
						"name": "literal",
						"value": "'warning'"
					}
				]
			},
			"required": false,
			"description": "Available variants",
			"defaultValue": {
				"value": "'regular'",
				"computed": false
			}
		}
	}
}

/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu_MenuDivider__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Menu_MenuGroup__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Menu_MenuGroupTitle__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Menu_MenuItem__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__examples_menu__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__examples_menu_divider__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__examples_menu_group__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__examples_menu_item__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bestPractices__ = __webpack_require__(1682);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */










var menuDoc = __webpack_require__(1678);
var menuDividerDoc = __webpack_require__(1679);
var menuGroupDoc = __webpack_require__(1680);
var menuItemDoc = __webpack_require__(1681);



/* harmony default export */ __webpack_exports__["a"] = ([{
  bestPractices: __WEBPACK_IMPORTED_MODULE_8__bestPractices__["a" /* default */].menu,
  doc: menuDoc,
  examples: __WEBPACK_IMPORTED_MODULE_4__examples_menu__["a" /* default */],
  slug: 'menu',
  title: 'Menu',
  whenHowToUse: 'A Menu should be used whenever you need to display a concise list of options to your user.\nThink through the consequenses of the actions in your Menu.\nIf there are potentially destructive actions exposed, be sure to use the correct [variants](/color#color-variants) to provide a hint to the user about what will happen after picking an option.\n\nLabels should have clear messaging in the form of `<verb> <noun>`, if possible.'
}, {
  bestPractices: __WEBPACK_IMPORTED_MODULE_8__bestPractices__["a" /* default */].menuDivider,
  componentTheme: __WEBPACK_IMPORTED_MODULE_0__Menu_MenuDivider__["a" /* componentTheme */],
  doc: menuDividerDoc,
  examples: __WEBPACK_IMPORTED_MODULE_5__examples_menu_divider__["a" /* default */],
  slug: 'menu-divider',
  subcomponent: true,
  title: 'MenuDivider',
  whenHowToUse: 'MenuDividers are used to visually separate [MenuGroups](../menu-group) or individual [MenuItems](../menu-item) to establish hierarchy in your Menu.\nThey could be used to separate items in a long list if all elements exist on the same conceptual level.\nFor example, if your Menu is composed of a long list of songs, a MenuDivider could be placed between songs that start with A, B, C, etc.\n\nDo not use MenuDividers to simply separate options as a decoration, or to provide "underlines" to the MenuItem.'
}, {
  bestPractices: __WEBPACK_IMPORTED_MODULE_8__bestPractices__["a" /* default */].menuGroup,
  componentTheme: [__WEBPACK_IMPORTED_MODULE_1__Menu_MenuGroup__["a" /* componentTheme */], __WEBPACK_IMPORTED_MODULE_2__Menu_MenuGroupTitle__["a" /* componentTheme */]],
  doc: menuGroupDoc,
  examples: __WEBPACK_IMPORTED_MODULE_6__examples_menu_group__["a" /* default */],
  slug: 'menu-group',
  subcomponent: true,
  title: 'MenuGroup',
  whenHowToUse: 'MenuGroups are used to group conceptually related elements, and to hint at other available, related options.\nIf the intention of the grouping is not immediately obvious, add a section title via the `title` prop to aid in your users\' decision-making process.\n\nIf there are only a few elements in a couple of groups, and the grouping logic is obvious, consider using a [MenuDivder](../menu-divider) instead.'
}, {
  bestPractices: __WEBPACK_IMPORTED_MODULE_8__bestPractices__["a" /* default */].menuItem,
  componentTheme: __WEBPACK_IMPORTED_MODULE_3__Menu_MenuItem__["a" /* componentTheme */],
  doc: menuItemDoc,
  examples: __WEBPACK_IMPORTED_MODULE_7__examples_menu_item__["a" /* default */],
  slug: 'menu-item',
  subcomponent: true,
  title: 'MenuItem',
  whenHowToUse: 'Use MenuItems to present the user with a choice of actions, and don\'t use MenuItems to display content that is not actionable.\nFor example, don\'t create a [Menu](../menu) with several options where the last item is an un-clickable status message showing the number of available servers.\nThis information is not _actionable_ and perhaps belongs somewhere else in your interface.\n\nUse the secondary text to give hints about extra functionality or provide status.'
}]);

/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menu__ = __webpack_require__(1663);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_1__menu__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__data__["a" /* default */]]);

/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon_IconCloud__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CustomRender__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DemoLayout__ = __webpack_require__(27);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'data',
  title: 'Data-Driven',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'Menu content can also be defined by an array of data, with the structure shown in the code example below.\nObject properties in the `items` array(s) will be passed on to the [MenuItem](../menu-item).\n\nA new [MenuGroup](../menu-group) will be created for each array object that has an `items` property defined.\n[MenuDividers](../menu-divider) are created simply by passing `{divider: true}` as an item.',
  scope: { CustomRender: __WEBPACK_IMPORTED_MODULE_3__components_CustomRender__["a" /* default */], DemoLayout: __WEBPACK_IMPORTED_MODULE_4__components_DemoLayout__["a" /* default */], IconCloud: __WEBPACK_IMPORTED_MODULE_1__Icon_IconCloud__["a" /* default */], Menu: __WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */] },
  source: '\n    () => {\n      const data = [\n        {\n          items: [\n            {\n              text: \'Menu item with onClick\',\n              onClick: event => { console.log(event); }\n            },\n            {\n              text: \'Menu item\',\n              secondaryText: \'Secondary text\'\n            }\n          ]\n        },\n        {\n          title: \'Group Title\',\n          items: [\n            {\n              text: \'Icon at start\',\n              iconStart: <IconCloud />\n            },\n            {\n              text: \'Icon at end\',\n              iconEnd: <IconCloud />\n            },\n            {\n              divider: true\n            },\n            {\n              text: \'Danger variant\',\n              variant: \'danger\' // \'danger\' | \'success\' | \'warning\'\n            },\n            {\n              text: \'Disabled menu item\',\n              disabled: true,\n              onClick: () => { console.log(\'onClick is not triggered for disabled items\'); }\n            },\n            {\n              text: \'Custom render\',\n              avatar: \'/images/125x125.png\',\n              href: \'/components/menu-item#custom-render\', // <-- Details here\n              render: CustomRender\n            }\n          ]\n        }\n      ];\n\n      return (\n        <DemoLayout>\n          <Menu data={data} />\n        </DemoLayout>\n      );\n    }'
});

/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon_IconCloud__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DemoLayout__ = __webpack_require__(27);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'menu',
  title: 'Example',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'Menus are composed of [MenuDivider](../menu-divider), [MenuGroup](../menu-group), and [MenuItem](../menu-item).\nMenus display a list of actions or navigation options.\n\n<Callout title="Note">\n  Menus normally occupy the full available width of their container.\n  The Menus here are width-constrained for illustration purposes.\n</Callout>',
  scope: { DemoLayout: __WEBPACK_IMPORTED_MODULE_3__components_DemoLayout__["a" /* default */], IconCloud: __WEBPACK_IMPORTED_MODULE_1__Icon_IconCloud__["a" /* default */], Menu: __WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */], MenuDivider: __WEBPACK_IMPORTED_MODULE_2__Menu__["a" /* MenuDivider */], MenuGroup: __WEBPACK_IMPORTED_MODULE_2__Menu__["b" /* MenuGroup */], MenuItem: __WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */] },
  source: '\n    <DemoLayout>\n      <Menu>\n        <MenuItem onClick={event => { console.log(event) }}>\n          Menu item with onClick\n        </MenuItem>\n        <MenuItem secondaryText="Secondary text">\n          Menu item\n        </MenuItem>\n        <MenuGroup title="Group Title">\n          <MenuItem iconStart={<IconCloud />}>Icon at start</MenuItem>\n          <MenuItem iconEnd={<IconCloud />}>Icon at end</MenuItem>\n          <MenuDivider />\n          <MenuItem variant="danger">Danger variant</MenuItem>\n          <MenuItem disabled onClick={event => { console.log(event) }}>Disabled menu item</MenuItem>\n        </MenuGroup>\n      </Menu>\n    </DemoLayout>'
});

/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menuDivider__ = __webpack_require__(1665);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_0__menuDivider__["a" /* default */]]);

/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__ = __webpack_require__(27);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'basic',
  title: 'Example',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0__themes__["g" /* mineralTheme */].color_gray_10,
  description: '[MenuItems](../menu-item) and [MenuGroups](../menu-group) can be separated with a MenuDivider.\nMenuDividers are used to create hierarchy by setting some options apart from others.',
  scope: { DemoLayout: __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__["a" /* default */], Menu: __WEBPACK_IMPORTED_MODULE_1__Menu__["d" /* default */], MenuDivider: __WEBPACK_IMPORTED_MODULE_1__Menu__["a" /* MenuDivider */], MenuGroup: __WEBPACK_IMPORTED_MODULE_1__Menu__["b" /* MenuGroup */], MenuItem: __WEBPACK_IMPORTED_MODULE_1__Menu__["c" /* MenuItem */] },
  source: '\n    <DemoLayout>\n      <Menu>\n        <MenuItem>\n          Menu item\n        </MenuItem>\n        <MenuDivider />\n        <MenuItem>\n          Menu item\n        </MenuItem>\n        <MenuItem>\n          Menu item\n        </MenuItem>\n        <MenuGroup title="Menu Group Title">\n          <MenuItem>\n            Menu item\n          </MenuItem>\n          <MenuItem>\n            Menu item\n          </MenuItem>\n        </MenuGroup>\n        <MenuDivider />\n        <MenuGroup>\n          <MenuItem>\n            Menu item\n          </MenuItem>\n          <MenuItem>\n            Menu item\n          </MenuItem>\n        </MenuGroup>\n      </Menu>\n    </DemoLayout>'
});

/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menuGroup__ = __webpack_require__(1667);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_0__menuGroup__["a" /* default */]]);

/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__ = __webpack_require__(27);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'menu-group',
  title: 'Example',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'To group [MenuItems](../menu-item) together, wrap them in a MenuGroup.\nOptionally, provide a title to provide context if the grouping is large or not immediately obvious.\n\nYour [Menu](../menu) may not need a MenuGroup title.\nIf your Menu is simple, instead consider using a [MenuDivider](../menu-divider), which is quicker to scan for your users.',
  scope: { DemoLayout: __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__["a" /* default */], Menu: __WEBPACK_IMPORTED_MODULE_1__Menu__["d" /* default */], MenuGroup: __WEBPACK_IMPORTED_MODULE_1__Menu__["b" /* MenuGroup */], MenuItem: __WEBPACK_IMPORTED_MODULE_1__Menu__["c" /* MenuItem */] },
  source: '\n    <DemoLayout>\n      <Menu>\n        <MenuGroup title="Menu Group Title">\n          <MenuItem>\n            Menu item\n          </MenuItem>\n          <MenuItem>\n            Menu item\n          </MenuItem>\n        </MenuGroup>\n        <MenuGroup title="Menu Group Title">\n          <MenuItem>\n            Menu item\n          </MenuItem>\n          <MenuItem>\n            Menu item\n          </MenuItem>\n        </MenuGroup>\n      </Menu>\n    </DemoLayout>'
});

/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__customRender__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__disabled__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kitchenSink__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__menuItem__ = __webpack_require__(1673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rtl__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__secondaryText__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__states__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__variants__ = __webpack_require__(1677);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */











/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_4__menuItem__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__secondaryText__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__variants__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__disabled__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__customRender__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__rtl__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__kitchenSink__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__states__["a" /* default */]]);

/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DemoLayout__ = __webpack_require__(27);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'custom-render',
  title: 'Custom Rendering',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'MenuItem can use a custom function for its rendering. This\nallows you to render any item data you might need (like an avatar, below). To\nhelp match the other MenuItems, you have access to its\n[theme variables](#theme-variables). The `CustomRender` component source below\nmight be a helpful template. Some things to keep in mind:\n\n1. Remember to include `:focus`, `:hover`, and `:active` styles.\n  - If this is to be used for a [Dropdown](../dropdown), also apply your\n     focus/hover styles when `props.isHighlighted === true`.\n1. Remember to accommodate the disabled state (`props.disabled === true`).\n1. If your app supports RTL languages, you can use `theme.direction` to\n   conditionally apply the necessary styles.',
  scope: {
    createStyledComponent: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */],
    DemoLayout: __WEBPACK_IMPORTED_MODULE_3__components_DemoLayout__["a" /* default */],
    getNormalizedValue: __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* getNormalizedValue */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */],
    MenuItem: __WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */],
    pxToEm: __WEBPACK_IMPORTED_MODULE_0__utils__["e" /* pxToEm */]
  },
  source: '\n    () => {\n      function CustomRender(item, props, theme) {\n        const { isHighlighted, disabled } = props;\n\n        const Root = createStyledComponent(\n          \'div\',\n          {\n            backgroundColor: isHighlighted && theme.color_theme_20,\n            display: \'flex\',\n            padding: theme.MenuItem_paddingVertical + \' \' + theme.MenuItem_paddingHorizontal,\n            textDecoration: \'none\',\n\n            \'&:focus\': {\n              backgroundColor: !disabled && theme.color_theme_20,\n              outline: 0\n            },\n\n            \'&:hover\': {\n              backgroundColor: !disabled && theme.color_theme_20\n            },\n\n            \'&:active\': {\n              backgroundColor: !disabled && theme.color_theme_40\n            }\n          },\n          {\n            includeStyleReset: true\n          }\n        );\n        const Work = createStyledComponent(\'span\', {\n          color: theme.color_text_caption,\n          display: \'block\',\n          fontSize: theme.fontSize_mouse,\n          marginTop: theme.space_stack_xs\n        });\n        const Avatar = createStyledComponent(\'img\', {\n          borderRadius: pxToEm(18),\n          display: \'block\',\n          flex: \'0 0 auto\',\n          height: pxToEm(36),\n          marginLeft: theme.direction === \'rtl\' && theme.MenuItemIcon_margin,\n          marginRight: theme.direction === \'ltr\' && theme.MenuItemIcon_margin,\n          width: pxToEm(36)\n        });\n        const Content = createStyledComponent(\'span\', {\n          flex: \'1 1 auto\',\n          fontSize: theme.MenuItemContent_fontSize,\n          whiteSpace: \'normal\',\n          wordBreak: \'break-all\'\n        });\n\n        const rootProps = {\n          disabled,\n          ...props\n        };\n\n        return (\n          <Root {...rootProps}>\n            {item.avatar && <Avatar alt={\'Photo of \' + item.username} src={item.avatar} />}\n            <Content>\n              {item.username}\n              {item.work && <Work>{item.work}</Work>}\n            </Content>\n          </Root>\n        );\n      }\n\n      const data = [\n        {\n          items: [\n            {\n              username: \'Newton\',\n              avatar: \'/images/215x210_avatar.png\',\n              work: \'Principia Mathematica\',\n              render: CustomRender\n            },\n            {\n              username: \'Descartes\',\n              avatar: \'/images/215x210_avatar.png\',\n              work: \'La G\xE9om\xE9trie\',\n              render: CustomRender\n            },\n            {\n              username: \'Euclid\',\n              avatar: \'/images/215x210_avatar.png\',\n              work: \'Elements\',\n              render: CustomRender\n            }\n          ]\n        }\n      ];\n\n      return (\n        <DemoLayout>\n          <Menu data={data} />\n        </DemoLayout>\n      )\n    }'
});

/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__ = __webpack_require__(27);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'disabled',
  title: 'Disabled',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'MenuItems can be disabled.\nRender a disabled MenuItem to let your user know that the option is available under the right conditions.\n\nFor example, you would disable "Open Recent" if there are no recent files available, yet you want the user to know that feature is available under other conditions.',
  scope: { DemoLayout: __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__["a" /* default */], Menu: __WEBPACK_IMPORTED_MODULE_1__Menu__["d" /* default */], MenuItem: __WEBPACK_IMPORTED_MODULE_1__Menu__["c" /* MenuItem */] },
  source: '\n    <DemoLayout>\n      <Menu>\n        <MenuItem>New File</MenuItem>\n        <MenuItem>Open</MenuItem>\n        <MenuItem disabled onClick={() => console.log(\'onClick is not triggered for disabled MenuItems\')}>\n          Open Recent\n        </MenuItem>\n        <MenuItem>Save</MenuItem>\n      </Menu>\n    </DemoLayout>'
});

/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon_IconCloud__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DemoLayout__ = __webpack_require__(27);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'icons',
  title: 'Menu Items with Icons',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'A MenuItem can display an [Icon](../icon) at its start, end, or both.\nIf both `startIcon` and `variant` props are provided, `startIcon` will be used.',
  scope: { DemoLayout: __WEBPACK_IMPORTED_MODULE_3__components_DemoLayout__["a" /* default */], IconCloud: __WEBPACK_IMPORTED_MODULE_1__Icon_IconCloud__["a" /* default */], Menu: __WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */], MenuItem: __WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */] },
  source: '\n    () => {\n      const icon = <IconCloud />;\n\n      return (\n        <DemoLayout>\n          <Menu>\n            <MenuItem iconStart={icon}>Start icon</MenuItem>\n            <MenuItem iconEnd={icon}>End icon</MenuItem>\n            <MenuItem iconStart={icon} iconEnd={icon}>Both icons</MenuItem>\n          </Menu>\n          <Menu>\n            <MenuItem iconStart={icon} variant="danger">Danger</MenuItem>\n            <MenuItem iconStart={icon} variant="success">Success</MenuItem>\n            <MenuItem iconStart={icon} variant="warning">Warning</MenuItem>\n            <MenuItem iconStart={icon} disabled>Disabled</MenuItem>\n          </Menu>\n        </DemoLayout>\n      );\n    }'
});

/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_IconCloud__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DemoLayout__ = __webpack_require__(27);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_4__components_DemoLayout__["a" /* default */], {
  '& > div:last-child': {
    // For <DropdownContent wide={true} />
    width: Object(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* pxToEm */])(344)
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'kitchen-sink',
  description: 'MenuItems are flexible enough to accommodate many different use cases.',
  title: 'Kitchen Sink',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1__themes__["g" /* mineralTheme */].color_gray_10,
  hideFromProd: true,
  scope: { DemoLayout: DemoLayout, IconCloud: __WEBPACK_IMPORTED_MODULE_2__Icon_IconCloud__["a" /* default */], Menu: __WEBPACK_IMPORTED_MODULE_3__Menu__["d" /* default */], MenuItem: __WEBPACK_IMPORTED_MODULE_3__Menu__["c" /* MenuItem */] },
  source: '\n    <DemoLayout>\n      <Menu>\n        <MenuItem\n          iconStart={<IconCloud />}\n          iconEnd={<IconCloud />}>\n          Kitchen Sink\n        </MenuItem>\n        <MenuItem\n          iconStart={<IconCloud />}\n          iconEnd={<IconCloud />}>\n          Kitchen Siiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiink\n        </MenuItem>\n        <MenuItem\n          iconStart={<IconCloud />}\n          iconEnd={<IconCloud />}>\n          Kitchen Sink with much longer text to force wrapping\n        </MenuItem>\n        <MenuItem\n          iconStart={<IconCloud />}\n          iconEnd={<IconCloud />}\n          secondaryText="Kitchen Sink">\n        </MenuItem>\n        <MenuItem\n          iconStart={<IconCloud />}\n          iconEnd={<IconCloud />}\n          secondaryText="Kitchen Siiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiink">\n        </MenuItem>\n        <MenuItem\n          iconStart={<IconCloud />}\n          iconEnd={<IconCloud />}\n          secondaryText="Kitchen Sink with much longer text to force wrapping">\n        </MenuItem>\n        <MenuItem\n          iconStart={<IconCloud />}\n          iconEnd={<IconCloud />}\n          secondaryText="Kitchen sink">\n          Kitchen Sink\n        </MenuItem>\n        <MenuItem\n          iconStart={<IconCloud />}\n          iconEnd={<IconCloud />}\n          secondaryText="Kitchen sink">\n          Kitchen Sink with much longer text to force wrapping\n        </MenuItem>\n        <MenuItem\n          iconStart={<IconCloud />}\n          iconEnd={<IconCloud />}\n          secondaryText="Kitchen Sink with much longer text to force wrapping">\n          Kitchen Sink\n        </MenuItem>\n        <MenuItem\n          iconStart={<IconCloud />}\n          iconEnd={<IconCloud />}\n          secondaryText="Kitchen Sink with much longer text to force wrapping">\n          Kitchen Sink with much longer text to force wrapping\n        </MenuItem>\n      </Menu>\n      <Menu>\n        <MenuItem\n          iconStart={<IconCloud />}\n          iconEnd={<IconCloud />}>\n          Kitchen Sink\n        </MenuItem>\n        <MenuItem\n          iconStart={<IconCloud />}\n          iconEnd={<IconCloud />}>\n          Kitchen Sink with much longer text to force wrapping\n        </MenuItem>\n        <MenuItem\n          iconStart={<IconCloud />}\n          iconEnd={<IconCloud />}\n          secondaryText="Kitchen Sink">\n        </MenuItem>\n        <MenuItem\n          iconStart={<IconCloud />}\n          iconEnd={<IconCloud />}\n          secondaryText="Kitchen Sink with much longer text to force wrapping">\n        </MenuItem>\n        <MenuItem\n          iconStart={<IconCloud />}\n          iconEnd={<IconCloud />}\n          secondaryText="Kitchen sink">\n          Kitchen Sink\n        </MenuItem>\n        <MenuItem\n          iconStart={<IconCloud />}\n          iconEnd={<IconCloud />}\n          secondaryText="Kitchen sink">\n          Kitchen Sink with much longer text to force wrapping\n        </MenuItem>\n        <MenuItem\n          iconStart={<IconCloud />}\n          iconEnd={<IconCloud />}\n          secondaryText="Kitchen Sink with much longer text to force wrapping">\n          Kitchen Sink\n        </MenuItem>\n        <MenuItem\n          iconStart={<IconCloud />}\n          iconEnd={<IconCloud />}\n          secondaryText="Kitchen Sink with much longer text to force wrapping">\n          Kitchen Sink with much longer text to force wrapping\n        </MenuItem>\n      </Menu>\n    </DemoLayout>\n  '
});

/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__ = __webpack_require__(27);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'basic',
  title: 'Example',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0__themes__["g" /* mineralTheme */].color_gray_10,
  description: '\nMenuItems are used to trigger an action or navigate to a new location.\n\n<Callout title="Note">\n  MenuItems normally occupy the full available width of their container.\n  The MenuItems here are width-constrained for illustration purposes.\n</Callout>',
  scope: { DemoLayout: __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__["a" /* default */], Menu: __WEBPACK_IMPORTED_MODULE_1__Menu__["d" /* default */], MenuItem: __WEBPACK_IMPORTED_MODULE_1__Menu__["c" /* MenuItem */] },
  source: '\n    <DemoLayout>\n      <Menu>\n        <MenuItem>\n          Light years\n        </MenuItem>\n        <MenuItem>\n          Star stuff\n        </MenuItem>\n        <MenuItem>\n          Encyclopaedia galactica\n        </MenuItem>\n      </Menu>\n    </DemoLayout>'
});

/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon_IconHelp__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DemoLayout__ = __webpack_require__(27);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'rtl',
  title: 'RTL Support',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_2__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'MenuItems with Icons are reversed when the `rtl` prop is set.\nA subset of Icons that [convey directionality](./icon#rtl) will be reversed.',
  scope: { DemoLayout: __WEBPACK_IMPORTED_MODULE_3__components_DemoLayout__["a" /* default */], IconHelp: __WEBPACK_IMPORTED_MODULE_0__Icon_IconHelp__["a" /* default */], Menu: __WEBPACK_IMPORTED_MODULE_1__Menu__["d" /* default */], MenuItem: __WEBPACK_IMPORTED_MODULE_1__Menu__["c" /* MenuItem */], ThemeProvider: __WEBPACK_IMPORTED_MODULE_2__themes__["a" /* ThemeProvider */] },
  source: '\n    <DemoLayout dir="rtl">\n      <ThemeProvider theme={{ direction: \'rtl\' }}>\n        <Menu>\n          <MenuItem>\u0646\u0635 \u0639\u0646\u0635\u0631 \u0627\u0644\u0642\u0627\u0626\u0645\u0629</MenuItem>\n          <MenuItem secondaryText="\u0646\u0635 \u062B\u0627\u0646\u0648\u064A">\u0646\u0635 \u0639\u0646\u0635\u0631 \u0627\u0644\u0642\u0627\u0626\u0645\u0629</MenuItem>\n          <MenuItem iconStart={<IconHelp />}>\u0631\u0645\u0632 \u0627\u0644\u0628\u062F\u0621</MenuItem>\n          <MenuItem iconEnd={<IconHelp />}>\u0631\u0645\u0632 \u0627\u0644\u0646\u0647\u0627\u064A\u0629</MenuItem>\n        </Menu>\n      </ThemeProvider>\n    </DemoLayout>'
});

/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__ = __webpack_require__(27);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'secondary-text',
  title: 'Secondary Text',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'A MenuItem can render secondary text, which will wrap when necessary.\nUse secondary text to give hints about extra functionality or show app status related to the action.',
  scope: { DemoLayout: __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__["a" /* default */], Menu: __WEBPACK_IMPORTED_MODULE_1__Menu__["d" /* default */], MenuItem: __WEBPACK_IMPORTED_MODULE_1__Menu__["c" /* MenuItem */] },
  source: '\n    <DemoLayout>\n      <Menu>\n        <MenuItem secondaryText="Star stuff">\n          Light years\n        </MenuItem>\n        <MenuItem secondaryText="Distant epochs">\n          Harvesting only\n        </MenuItem>\n        <MenuItem secondaryText="Cosmic ocean">\n          Encyclopaedia galactica\n        </MenuItem>\n      </Menu>\n    </DemoLayout>'
});

/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamor__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_glamor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DemoLayout__ = __webpack_require__(27);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'states',
  title: 'States',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_1__themes__["g" /* mineralTheme */].color_gray_10,
  hideFromProd: true,
  hideSource: true,
  scope: { DemoLayout: __WEBPACK_IMPORTED_MODULE_3__components_DemoLayout__["a" /* default */], Menu: __WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */], MenuItem: __WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], simulate: __WEBPACK_IMPORTED_MODULE_0_glamor__["simulate"] },
  source: '\n    <DemoLayout>\n      <Menu>\n        <MenuItem>\n          Regular\n        </MenuItem>\n        <MenuItem variant="danger">\n          Danger\n        </MenuItem>\n        <MenuItem variant="success">\n          Success\n        </MenuItem>\n        <MenuItem variant="warning">\n          Warning\n        </MenuItem>\n      </Menu>\n      <Menu>\n        <MenuItem {...simulate(\'hover\')}>\n          Hover\n        </MenuItem>\n        <MenuItem {...simulate(\'hover\')} variant="danger">\n          Hover\n        </MenuItem>\n        <MenuItem {...simulate(\'hover\')} variant="success">\n          Hover\n        </MenuItem>\n        <MenuItem {...simulate(\'hover\')} variant="warning">\n          Hover\n        </MenuItem>\n      </Menu>\n      <Menu>\n        <MenuItem {...simulate(\'focus\')}>\n          Focus\n        </MenuItem>\n        <MenuItem {...simulate(\'focus\')} variant="danger">\n          Focus\n        </MenuItem>\n        <MenuItem {...simulate(\'focus\')} variant="success">\n          Focus\n        </MenuItem>\n        <MenuItem {...simulate(\'focus\')} variant="warning">\n          Focus\n        </MenuItem>\n      </Menu>\n      <Menu>\n        <MenuItem {...simulate(\'focus\', \'hover\')}>\n          Focus & Hover\n        </MenuItem>\n        <MenuItem {...simulate(\'focus\', \'hover\')} variant="danger">\n          Focus & Hover\n        </MenuItem>\n        <MenuItem {...simulate(\'focus\', \'hover\')} variant="success">\n          Focus & Hover\n        </MenuItem>\n        <MenuItem {...simulate(\'focus\', \'hover\')} variant="warning">\n          Focus & Hover\n        </MenuItem>\n      </Menu>\n      <Menu>\n        <MenuItem {...simulate(\'focus\', \'active\')}>\n          Focus & Active\n        </MenuItem>\n        <MenuItem {...simulate(\'focus\', \'active\')} variant="danger">\n          Focus & Active\n        </MenuItem>\n        <MenuItem {...simulate(\'focus\', \'active\')} variant="success">\n          Focus & Active\n        </MenuItem>\n        <MenuItem {...simulate(\'focus\', \'active\')} variant="warning">\n          Focus & Active\n        </MenuItem>\n      </Menu>\n      <Menu>\n        <MenuItem {...simulate(\'active\')}>\n          Active\n        </MenuItem>\n        <MenuItem {...simulate(\'active\')} variant="danger">\n          Active\n        </MenuItem>\n        <MenuItem {...simulate(\'active\')} variant="success">\n          Active\n        </MenuItem>\n        <MenuItem {...simulate(\'active\')} variant="warning">\n          Active\n        </MenuItem>\n      </Menu>\n      <Menu>\n        <MenuItem disabled>\n          Disabled\n        </MenuItem>\n        <MenuItem disabled variant="danger">\n          Disabled\n        </MenuItem>\n        <MenuItem disabled variant="success">\n          Disabled\n        </MenuItem>\n        <MenuItem disabled variant="warning">\n          Disabled\n        </MenuItem>\n      </Menu>\n    </DemoLayout>'
});

/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Menu__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__ = __webpack_require__(27);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'variants',
  title: 'Variants',
  // $FlowFixMe
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0__themes__["g" /* mineralTheme */].color_gray_10,
  description: 'Use available [variants](/color#color-variants) to help communicate purpose.\nA `startIcon` will be automatically inserted to reinforce the intent.',
  scope: { DemoLayout: __WEBPACK_IMPORTED_MODULE_2__components_DemoLayout__["a" /* default */], Menu: __WEBPACK_IMPORTED_MODULE_1__Menu__["d" /* default */], MenuItem: __WEBPACK_IMPORTED_MODULE_1__Menu__["c" /* MenuItem */] },
  source: '\n    <DemoLayout>\n      <Menu>\n        <MenuItem variant="danger">\n          Danger\n        </MenuItem>\n        <MenuItem variant="success">\n          Success\n        </MenuItem>\n        <MenuItem variant="warning">\n          Warning\n        </MenuItem>\n      </Menu>\n    </DemoLayout>'
});

/***/ }),
/* 1678 */
/***/ (function(module, exports) {

module.exports = {
	"description": "A Menu presents a list of options representing actions or navigation.\nComposed of [MenuItems](../menu-item), Menu is usually combined with [Popover](../popover) to create a [Dropdown](../dropdown).\n\nMenus are great for collecting actions in one place so your users don't need to scan the entire document to find a feature.",
	"methods": [],
	"props": {
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "[MenuDivider](../menu-divider), [MenuGroup](../menu-group), or [MenuItem](../menu-item)"
		},
		"data": {
			"flowType": {
				"name": "Array",
				"elements": [
					{
						"name": "signature",
						"type": "object",
						"raw": "{ items: Array<Item>, title?: React$Node }",
						"signature": {
							"properties": [
								{
									"key": "items",
									"value": {
										"name": "Array",
										"elements": [
											{
												"name": "signature",
												"type": "object",
												"raw": "{\n  iconEnd?: React$Element<*>,\n  iconStart?: React$Element<*>,\n  disabled?: boolean,\n  divider?: boolean,\n  onClick?: (event: SyntheticEvent<>) => void,\n  render?: (item: Object, props: Object, theme: Object) => React$Element<*>,\n  secondaryText?: React$Node,\n  text?: React$Node,\n  variant?: 'regular' | 'danger' | 'success' | 'warning'\n}",
												"signature": {
													"properties": [
														{
															"key": "iconEnd",
															"value": {
																"name": "React$Element",
																"elements": [
																	{
																		"name": "unknown"
																	}
																],
																"raw": "React$Element<*>",
																"required": false
															}
														},
														{
															"key": "iconStart",
															"value": {
																"name": "React$Element",
																"elements": [
																	{
																		"name": "unknown"
																	}
																],
																"raw": "React$Element<*>",
																"required": false
															}
														},
														{
															"key": "disabled",
															"value": {
																"name": "boolean",
																"required": false
															}
														},
														{
															"key": "divider",
															"value": {
																"name": "boolean",
																"required": false
															}
														},
														{
															"key": "onClick",
															"value": {
																"name": "signature",
																"type": "function",
																"raw": "(event: SyntheticEvent<>) => void",
																"signature": {
																	"arguments": [
																		{
																			"name": "event",
																			"type": {
																				"name": "SyntheticEvent",
																				"elements": [],
																				"raw": "SyntheticEvent<>"
																			}
																		}
																	],
																	"return": {
																		"name": "void"
																	}
																},
																"required": false
															}
														},
														{
															"key": "render",
															"value": {
																"name": "signature",
																"type": "function",
																"raw": "(item: Object, props: Object, theme: Object) => React$Element<*>",
																"signature": {
																	"arguments": [
																		{
																			"name": "item",
																			"type": {
																				"name": "Object"
																			}
																		},
																		{
																			"name": "props",
																			"type": {
																				"name": "Object"
																			}
																		},
																		{
																			"name": "theme",
																			"type": {
																				"name": "Object"
																			}
																		}
																	],
																	"return": {
																		"name": "React$Element",
																		"elements": [
																			{
																				"name": "unknown"
																			}
																		],
																		"raw": "React$Element<*>"
																	}
																},
																"required": false
															}
														},
														{
															"key": "secondaryText",
															"value": {
																"name": "React$Node",
																"required": false
															}
														},
														{
															"key": "text",
															"value": {
																"name": "React$Node",
																"required": false
															}
														},
														{
															"key": "variant",
															"value": {
																"name": "union",
																"raw": "'regular' | 'danger' | 'success' | 'warning'",
																"elements": [
																	{
																		"name": "literal",
																		"value": "'regular'"
																	},
																	{
																		"name": "literal",
																		"value": "'danger'"
																	},
																	{
																		"name": "literal",
																		"value": "'success'"
																	},
																	{
																		"name": "literal",
																		"value": "'warning'"
																	}
																],
																"required": false
															}
														}
													]
												}
											}
										],
										"raw": "Array<Item>",
										"required": true
									}
								},
								{
									"key": "title",
									"value": {
										"name": "React$Node",
										"required": false
									}
								}
							]
						}
					}
				],
				"raw": "Array<{ items: Array<Item>, title?: React$Node }>"
			},
			"required": false,
			"description": "Data used to contruct Menu. See [example](#data)"
		},
		"getItemProps": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(props: Object, scope: Object) => Object",
				"signature": {
					"arguments": [
						{
							"name": "props",
							"type": {
								"name": "Object"
							}
						},
						{
							"name": "scope",
							"type": {
								"name": "Object"
							}
						}
					],
					"return": {
						"name": "Object"
					}
				}
			},
			"required": false,
			"description": "@Private Function that returns props to be applied to each item"
		}
	}
}

/***/ }),
/* 1679 */
/***/ (function(module, exports) {

module.exports = {
	"description": "MenuDividers separate [MenuItems](../menu-item) and [MenuGroups](../menu-group) to establish hierarchy in a [Menu](../menu) with several options.\n\nMenuDividers are not merely design elements to visually separate options.\nRather, the are a way to logically group choices.\nToo many dividers will add unnecessary weight to your Menu.",
	"methods": []
}

/***/ }),
/* 1680 */
/***/ (function(module, exports) {

module.exports = {
	"description": "MenuGroups assemble [MenuItems](../menu-items) and can display a title.\nGrouping Menu options provides context clues to users about related actions.\nAn optional title can be added to reinforce the intent of the grouping.",
	"methods": [],
	"props": {
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "[MenuItems](../menu-item)"
		},
		"title": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "Title for the group"
		}
	}
}

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

module.exports = {
	"description": "A MenuItem represents an option in a [Menu](../menu).\nThey can be used to trigger actions or navigate to a new location.\nMenuItems provide context through optional variants, secondary text, or [Icons](../icon).\n\nA custom rendering hook is exposed to enable any extra functionality your app requires.",
	"methods": [],
	"props": {
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "Rendered content of the component"
		},
		"disabled": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Disable the menu item"
		},
		"iconEnd": {
			"flowType": {
				"name": "React$Element",
				"elements": [
					{
						"name": "unknown"
					}
				],
				"raw": "React$Element<*>"
			},
			"required": false,
			"description": "Icon that goes after the children"
		},
		"iconStart": {
			"flowType": {
				"name": "React$Element",
				"elements": [
					{
						"name": "unknown"
					}
				],
				"raw": "React$Element<*>"
			},
			"required": false,
			"description": "Icon that goes before the children"
		},
		"isHighlighted": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Display the item in an active style"
		},
		"item": {
			"flowType": {
				"name": "signature",
				"type": "object",
				"raw": "{\n  iconEnd?: React$Element<*>,\n  iconStart?: React$Element<*>,\n  disabled?: boolean,\n  divider?: boolean,\n  onClick?: (event: SyntheticEvent<>) => void,\n  render?: (item: Object, props: Object, theme: Object) => React$Element<*>,\n  secondaryText?: React$Node,\n  text?: React$Node,\n  variant?: 'regular' | 'danger' | 'success' | 'warning'\n}",
				"signature": {
					"properties": [
						{
							"key": "iconEnd",
							"value": {
								"name": "React$Element",
								"elements": [
									{
										"name": "unknown"
									}
								],
								"raw": "React$Element<*>",
								"required": false
							}
						},
						{
							"key": "iconStart",
							"value": {
								"name": "React$Element",
								"elements": [
									{
										"name": "unknown"
									}
								],
								"raw": "React$Element<*>",
								"required": false
							}
						},
						{
							"key": "disabled",
							"value": {
								"name": "boolean",
								"required": false
							}
						},
						{
							"key": "divider",
							"value": {
								"name": "boolean",
								"required": false
							}
						},
						{
							"key": "onClick",
							"value": {
								"name": "signature",
								"type": "function",
								"raw": "(event: SyntheticEvent<>) => void",
								"signature": {
									"arguments": [
										{
											"name": "event",
											"type": {
												"name": "SyntheticEvent",
												"elements": [],
												"raw": "SyntheticEvent<>"
											}
										}
									],
									"return": {
										"name": "void"
									}
								},
								"required": false
							}
						},
						{
							"key": "render",
							"value": {
								"name": "signature",
								"type": "function",
								"raw": "(item: Object, props: Object, theme: Object) => React$Element<*>",
								"signature": {
									"arguments": [
										{
											"name": "item",
											"type": {
												"name": "Object"
											}
										},
										{
											"name": "props",
											"type": {
												"name": "Object"
											}
										},
										{
											"name": "theme",
											"type": {
												"name": "Object"
											}
										}
									],
									"return": {
										"name": "React$Element",
										"elements": [
											{
												"name": "unknown"
											}
										],
										"raw": "React$Element<*>"
									}
								},
								"required": false
							}
						},
						{
							"key": "secondaryText",
							"value": {
								"name": "React$Node",
								"required": false
							}
						},
						{
							"key": "text",
							"value": {
								"name": "React$Node",
								"required": false
							}
						},
						{
							"key": "variant",
							"value": {
								"name": "union",
								"raw": "'regular' | 'danger' | 'success' | 'warning'",
								"elements": [
									{
										"name": "literal",
										"value": "'regular'"
									},
									{
										"name": "literal",
										"value": "'danger'"
									},
									{
										"name": "literal",
										"value": "'success'"
									},
									{
										"name": "literal",
										"value": "'warning'"
									}
								],
								"required": false
							}
						}
					]
				}
			},
			"required": false,
			"description": "Item data (see [example](../menu#data))"
		},
		"onClick": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(event: SyntheticEvent<>) => void",
				"signature": {
					"arguments": [
						{
							"name": "event",
							"type": {
								"name": "SyntheticEvent",
								"elements": [],
								"raw": "SyntheticEvent<>"
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "Called with the click event"
		},
		"render": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(item: Item, props: Object, theme: Object) => React$Element<*>",
				"signature": {
					"arguments": [
						{
							"name": "item",
							"type": {
								"name": "signature",
								"type": "object",
								"raw": "{\n  iconEnd?: React$Element<*>,\n  iconStart?: React$Element<*>,\n  disabled?: boolean,\n  divider?: boolean,\n  onClick?: (event: SyntheticEvent<>) => void,\n  render?: (item: Object, props: Object, theme: Object) => React$Element<*>,\n  secondaryText?: React$Node,\n  text?: React$Node,\n  variant?: 'regular' | 'danger' | 'success' | 'warning'\n}",
								"signature": {
									"properties": [
										{
											"key": "iconEnd",
											"value": {
												"name": "React$Element",
												"elements": [
													{
														"name": "unknown"
													}
												],
												"raw": "React$Element<*>",
												"required": false
											}
										},
										{
											"key": "iconStart",
											"value": {
												"name": "React$Element",
												"elements": [
													{
														"name": "unknown"
													}
												],
												"raw": "React$Element<*>",
												"required": false
											}
										},
										{
											"key": "disabled",
											"value": {
												"name": "boolean",
												"required": false
											}
										},
										{
											"key": "divider",
											"value": {
												"name": "boolean",
												"required": false
											}
										},
										{
											"key": "onClick",
											"value": {
												"name": "signature",
												"type": "function",
												"raw": "(event: SyntheticEvent<>) => void",
												"signature": {
													"arguments": [
														{
															"name": "event",
															"type": {
																"name": "SyntheticEvent",
																"elements": [],
																"raw": "SyntheticEvent<>"
															}
														}
													],
													"return": {
														"name": "void"
													}
												},
												"required": false
											}
										},
										{
											"key": "render",
											"value": {
												"name": "signature",
												"type": "function",
												"raw": "(item: Object, props: Object, theme: Object) => React$Element<*>",
												"signature": {
													"arguments": [
														{
															"name": "item",
															"type": {
																"name": "Object"
															}
														},
														{
															"name": "props",
															"type": {
																"name": "Object"
															}
														},
														{
															"name": "theme",
															"type": {
																"name": "Object"
															}
														}
													],
													"return": {
														"name": "React$Element",
														"elements": [
															{
																"name": "unknown"
															}
														],
														"raw": "React$Element<*>"
													}
												},
												"required": false
											}
										},
										{
											"key": "secondaryText",
											"value": {
												"name": "React$Node",
												"required": false
											}
										},
										{
											"key": "text",
											"value": {
												"name": "React$Node",
												"required": false
											}
										},
										{
											"key": "variant",
											"value": {
												"name": "union",
												"raw": "'regular' | 'danger' | 'success' | 'warning'",
												"elements": [
													{
														"name": "literal",
														"value": "'regular'"
													},
													{
														"name": "literal",
														"value": "'danger'"
													},
													{
														"name": "literal",
														"value": "'success'"
													},
													{
														"name": "literal",
														"value": "'warning'"
													}
												],
												"required": false
											}
										}
									]
								}
							}
						},
						{
							"name": "props",
							"type": {
								"name": "Object"
							}
						},
						{
							"name": "theme",
							"type": {
								"name": "Object"
							}
						}
					],
					"return": {
						"name": "React$Element",
						"elements": [
							{
								"name": "unknown"
							}
						],
						"raw": "React$Element<*>"
					}
				}
			},
			"required": false,
			"description": "Custom render function"
		},
		"secondaryText": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "Secondary text"
		},
		"tabIndex": {
			"flowType": {
				"name": "number"
			},
			"required": false,
			"description": "Determines if the item can be focused",
			"defaultValue": {
				"value": "0",
				"computed": false
			}
		},
		"variant": {
			"flowType": {
				"name": "union",
				"raw": "'regular' | 'danger' | 'success' | 'warning'",
				"elements": [
					{
						"name": "literal",
						"value": "'regular'"
					},
					{
						"name": "literal",
						"value": "'danger'"
					},
					{
						"name": "literal",
						"value": "'success'"
					},
					{
						"name": "literal",
						"value": "'warning'"
					}
				]
			},
			"required": false,
			"description": "Available variants",
			"defaultValue": {
				"value": "'regular'",
				"computed": false
			}
		}
	}
}

/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Menu__ = __webpack_require__(18);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', function (_ref) {
  var theme = _ref.theme;
  return {
    backgroundColor: theme.color_gray_10,
    padding: theme.spacing_double,

    '& > div': {
      backgroundColor: 'white',
      width: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* pxToEm */])(224)
    }
  };
});

/* harmony default export */ __webpack_exports__["a"] = ({
  menu: [{
    type: 'do',
    title: 'use the appropriate variant for your intent',
    example: _jsx(DemoLayout, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Share'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Edit'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Duplicate'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {
      variant: 'danger'
    }, void 0, 'Delete'))),
    description: 'Match Mineral UI\'s [pre-defined variants](/color/#color-variants) with semantic purpose.'
  }, {
    type: 'do',
    title: 'use clear labeling for option messaging',
    example: _jsx(DemoLayout, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {
      secondaryText: 'Cmd + L'
    }, void 0, 'Select line'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {
      secondaryText: '\u2303 + \u21E7 + W'
    }, void 0, 'Select word'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {
      secondaryText: 'Cmd + J'
    }, void 0, 'Join lines'))),
    description: '[MenuItem](../menu-item) actions should be predictable for frictionless interaction.\n  Labels should be structured: `<verb> <noun>`.'
  }, {
    type: 'dont',
    title: 'cause confusion with the wrong variant',
    example: _jsx(DemoLayout, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Create new table'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Clone table'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {
      variant: 'success'
    }, void 0, 'Drop table'))),
    description: 'Using the wrong variant can cause confusion, or undue stress for users.'
  }, {
    type: 'dont',
    title: 'use vague option labels',
    example: _jsx(DemoLayout, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Go'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Various config options'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Do it'))),
    description: 'Users should know exactly what will happen when they choose an option.'
  }],
  menuDivider: [{
    type: 'do',
    title: 'divide menu options to establish hierarchy',
    example: _jsx(DemoLayout, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Adam'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Alex'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["a" /* MenuDivider */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Betsy'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Brian'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Bryson'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["a" /* MenuDivider */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Carly'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Charles'))),
    description: 'If a long list of menu options are all similar conceptually, create hierarchy by placing dividers.'
  }, {
    type: 'do',
    title: 'separate meaningfully different options',
    example: _jsx(DemoLayout, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Create'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Read'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Update'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["a" /* MenuDivider */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {
      variant: 'warning'
    }, void 0, 'Delete'))),
    description: 'You can separate options that are related but should be set apart to increase usability.'
  }, {
    type: 'dont',
    title: 'use dividers as a decorative element',
    example: _jsx(DemoLayout, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Helium'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["a" /* MenuDivider */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Neon'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["a" /* MenuDivider */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Argon'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["a" /* MenuDivider */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Krypton'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["a" /* MenuDivider */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Xenon'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["a" /* MenuDivider */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Radon'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["a" /* MenuDivider */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Oganesson'))),
    description: 'If there is no need to create further grouping, don\'t use MenuDividers for decoration.'
  }],
  menuGroup: [{
    type: 'do',
    title: 'create groups if there are more than one set of actions in a Menu',
    example: _jsx(DemoLayout, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["b" /* MenuGroup */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Undo'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Redo')), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["b" /* MenuGroup */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Cut'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Copy'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Paste')))),
    description: 'Users will be able to quickly scan their available options if there aren\'t too many actions at the same level of hierarchy.'
  }, {
    type: 'dont',
    title: 'repeat the obvious in the group title',
    example: _jsx(DemoLayout, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["b" /* MenuGroup */], {
      title: 'History Navigation'
    }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Undo'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Redo')), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["b" /* MenuGroup */], {
      title: 'Text Actions'
    }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Cut'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Copy'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Paste')))),
    description: 'If there are only a couple of groups with a handful of elements, trust that the user will figure out the grouping from context.'
  }, {
    type: 'dont',
    title: 'put too many items into a group',
    example: _jsx(DemoLayout, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["b" /* MenuGroup */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Decrease font size'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Increase font size')), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["a" /* MenuDivider */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["b" /* MenuGroup */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Toggle command palette'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Toggle console'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Toggle context view'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Toggle debugger'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Toggle diagnostics'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Toggle distraction free mode'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Toggle file tree'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Toggle git tab'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Toggle GitHub tab'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Toggle health'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Toggle outline view'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Toggle quick open'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Toggle React inspector'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Toggle soft wrap'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Toggle task runner'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Toggle test runner')))),
    description: 'If there are too many options in a group, it will be overwhelming to users and your feature will get buried.'
  }],
  menuItem: [{
    type: 'do',
    title: 'use the right intent',
    example: _jsx(DemoLayout, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Start instance'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Generate snapshot'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {
      variant: 'warning'
    }, void 0, 'Reboot instance'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {
      variant: 'danger'
    }, void 0, 'Terminate instance'))),
    description: 'Give your users hints about what the potential outcome of an action will be.'
  }, {
    type: 'do',
    title: 'use secondary text to give hints to the user',
    example: _jsx(DemoLayout, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {
      secondaryText: 'Cmd + X'
    }, void 0, 'Cut'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {
      secondaryText: 'Cmd + C'
    }, void 0, 'Copy'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {
      secondaryText: 'Cmd + V'
    }, void 0, 'Paste'))),
    description: 'Use the `secondaryText` attribute to give hints about extra functionality or provide status context.'
  }, {
    type: 'dont',
    title: 'use non-actions as placeholders for options',
    example: _jsx(DemoLayout, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {
      variant: 'success'
    }, void 0, 'Daily revenue - $6543'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Initiate full refund'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Initiate partial refund'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Email customer'))),
    description: 'All MenuItems in a Menu should be actionable. If an option only exists to provide information, it probably belongs somewhere else.'
  }, {
    type: 'dont',
    title: 'use disabled MenuItems as section titles',
    example: _jsx(DemoLayout, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["d" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {
      disabled: true
    }, void 0, 'Instance Id: 12345'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["a" /* MenuDivider */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Start instance'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {}, void 0, 'Generate snapshot'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {
      variant: 'warning'
    }, void 0, 'Reboot instance'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Menu__["c" /* MenuItem */], {
      variant: 'danger'
    }, void 0, 'Terminate instance'))),
    description: 'Use the `title` attribute to show meta information for a group, or place this information elsewhere in the interface.'
  }]
});

/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popover_PopoverContent__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bestPractices__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples__ = __webpack_require__(1685);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var doc = __webpack_require__(1694);

/* harmony default export */ __webpack_exports__["a"] = ({
  bestPractices: __WEBPACK_IMPORTED_MODULE_1__bestPractices__["a" /* default */],
  componentTheme: __WEBPACK_IMPORTED_MODULE_0__Popover_PopoverContent__["a" /* componentTheme */],
  doc: doc,
  examples: __WEBPACK_IMPORTED_MODULE_2__examples__["a" /* default */],
  slug: 'popover',
  title: 'Popover',
  whenHowToUse: 'Popovers contain content providing clarification for other interface elements.\nSince popovers are usually triggered with deliberate user actions, they can contain more complex information than a tooltip which appears upon hovering/focusing an element.\n\n- Keep content short. Don\'t put so much content that the tooltip requires a scrollbar.\n- Popovers can be used to implement other custom behaviors or widgets such as color pickers, or other task-specific custom inputs.\n- Popovers could be chained together in application logic to create walkthroughs for onboarding.\n'
});

/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Heading__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Popover__ = __webpack_require__(37);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








var styles = {
  badContentLayout: {
    maxWidth: '25em',
    maxHeight: '30em',
    overflowY: 'scroll'
  },
  badDemo: {
    width: '50em'
  },
  demoLayout: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  goodDemo: { width: '15em' },
  p: function p(_ref) {
    var theme = _ref.theme;
    return {
      marginBottom: 0,
      marginTop: theme.space_stack_sm
    };
  }
};

var BadContentLayout = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('div', styles.badContentLayout);
var GoodDemo = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('div', styles.goodDemo);
var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('div', styles.demoLayout);
var P = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('p', styles.p);

var _ref3 = _jsx(GoodDemo, {}, void 0, _jsx('p', {}, void 0, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque.'));

var _ref4 = _jsx(P, {}, void 0, 'Mineral UI');

var PopOverDo = function (_Component) {
  _inherits(PopOverDo, _Component);

  function PopOverDo() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, PopOverDo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = PopOverDo.__proto__ || Object.getPrototypeOf(PopOverDo)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      isOpen: false
    }, _this.onOpen = function () {
      _this.setState({ isOpen: true });
    }, _this.onClose = function (event) {
      // Prevent extra call to togglePopover when clicking the controlling button.
      // Also avoid interactions with other popovers.
      // eslint-disable-next-line
      var demoLayoutNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this.demoLayout);
      if (!event.nativeEvent && demoLayoutNode && event.target && event.target instanceof HTMLElement && demoLayoutNode.contains(event.target)) {
        // $FlowFixMe
        event.stopImmediatePropagation();
      }

      _this.setState({ isOpen: false });
    }, _this.togglePopover = function (event) {
      if (_this.state.isOpen) {
        _this.onClose(event);
      } else {
        _this.onOpen();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PopOverDo, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var DemoContent = _ref3;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        DemoLayout,
        {
          ref: function ref(node) {
            _this2.demoLayout = node;
          } },
        _jsx(__WEBPACK_IMPORTED_MODULE_3__Button__["a" /* default */], {
          primary: true,
          onClick: this.togglePopover
        }, void 0, 'Learn more'),
        _jsx(__WEBPACK_IMPORTED_MODULE_5__Popover__["a" /* default */], {
          onOpen: this.onOpen,
          onClose: this.onClose,
          isOpen: this.state.isOpen,
          content: DemoContent
        }, void 0, _ref4)
      );
    }
  }]);

  return PopOverDo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var BadContent = _jsx(BadContentLayout, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__Heading__["a" /* default */], {
  level: 2
}, void 0, 'The standard Lorem Ipsum passage, used since the 1500s'), _jsx('p', {}, void 0, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'), _jsx(__WEBPACK_IMPORTED_MODULE_4__Heading__["a" /* default */], {
  level: 2
}, void 0, 'Section 1.10.32 of \u201Cde Finibus Bonorum et Malorum\u201D, written by Cicero in 45 BC'), _jsx('p', {}, void 0, 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?'), _jsx(__WEBPACK_IMPORTED_MODULE_4__Heading__["a" /* default */], {
  level: 2
}, void 0, '1914 translation by H. Rackham'), _jsx('p', {}, void 0, '\u201CBut I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a pain that produces no resultant pleasure?\u201D'));

/* harmony default export */ __webpack_exports__["a"] = ([{
  type: 'do',
  title: 'use Popover to provide help to the user',
  example: _jsx(PopOverDo, {}),
  description: 'Provide extra context for selected interface elements.'
}, {
  type: 'dont',
  title: 'add too much content',
  example: _jsx(__WEBPACK_IMPORTED_MODULE_5__Popover__["a" /* default */], {
    content: BadContent
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3__Button__["a" /* default */], {}, void 0, 'Lorem Ipsum')),
  description: 'Content should be succinct. If more context is needed, provide a link to another resource with more detail. Add a `max-width` value to constrain the layout if this is intended app behavior.'
}]);

/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scrolling__ = __webpack_require__(1686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controlled__ = __webpack_require__(1687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__disabled__ = __webpack_require__(1688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__onOpenClose__ = __webpack_require__(1689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__overflow__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__placement__ = __webpack_require__(1691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__popover__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__title__ = __webpack_require__(1693);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */










/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_6__popover__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__placement__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__overflow__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__scrolling__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__onOpenClose__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__disabled__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__controlled__["a" /* default */]]);

/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DemoContent__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ScrollBox__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Popover__ = __webpack_require__(37);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'scrolling-container',
  title: 'Scrolling Container',
  description: 'Popover will attempt to stay visible in an `overflow: scroll` container.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_0__Button__["a" /* default */], DemoContent: __WEBPACK_IMPORTED_MODULE_1__components_DemoContent__["a" /* default */], ScrollParent: __WEBPACK_IMPORTED_MODULE_2__components_ScrollBox__["a" /* default */], Popover: __WEBPACK_IMPORTED_MODULE_3__Popover__["a" /* default */] },
  source: '\n    <ScrollParent>\n      <Popover\n        content={<DemoContent />}\n        placement="left"\n        isOpen>\n        <Button>Open Popover</Button>\n      </Popover>\n    </ScrollParent>\n  '
});

/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DemoContent__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Popover__ = __webpack_require__(37);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* createStyledComponent */])('div', {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between'
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'controlled',
  title: 'Controlled',
  description: 'Popover controls its own state by default,\nand can optionally be managed by the application as a controlled component through the `isOpen` attribute.\nCallbacks for `onOpen` and `onClose` are also provided.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_3__Button__["a" /* default */], Component: __WEBPACK_IMPORTED_MODULE_0_react__["Component"], DemoContent: __WEBPACK_IMPORTED_MODULE_4__components_DemoContent__["a" /* default */], DemoLayout: DemoLayout, findDOMNode: __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"], Popover: __WEBPACK_IMPORTED_MODULE_5__Popover__["a" /* default */] },
  source: '\n    class App extends Component {\n      constructor(props) {\n        super(props);\n\n        this.state = {\n          isOpen: false\n        };\n\n        this.onOpen = this.onOpen.bind(this);\n        this.onClose = this.onClose.bind(this);\n        this.togglePopover = this.togglePopover.bind(this);\n      }\n\n      onOpen(event) {\n        this.setState({ isOpen: true });\n      }\n\n      onClose(event) {\n        // Prevent extra call to togglePopover when clicking the controlling button.\n        // Also avoid interactions with other popovers.\n        const demoLayoutNode = findDOMNode(this.demoLayout);\n        if (\n          !event.nativeEvent &&\n          demoLayoutNode &&\n          demoLayoutNode.contains(event.target)\n        ) {\n          event.stopImmediatePropagation();\n        }\n\n        this.setState({ isOpen: false });\n      }\n\n      togglePopover(event) {\n        if (this.state.isOpen) {\n          this.onClose(event);\n        } else {\n          this.onOpen(event);\n        }\n      }\n\n      render() {\n        const label = this.state.isOpen ? \'Close Popover\' : \'Open Popover\';\n        return (\n          <DemoLayout ref={node => { this.demoLayout = node }}>\n            <Popover\n              content={<DemoContent />}\n              isOpen={this.state.isOpen}\n              onOpen={this.onOpen}\n              onClose={this.onClose}>\n              <Button>{label}</Button>\n            </Popover>\n            <Button onClick={this.togglePopover}>{label}</Button>\n          </DemoLayout>\n        );\n      }\n    }'
});

/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DemoContent__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popover__ = __webpack_require__(37);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'disabled',
  title: 'Disabled',
  description: 'Disable the Popover and its trigger.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_0__Button__["a" /* default */], DemoContent: __WEBPACK_IMPORTED_MODULE_1__components_DemoContent__["a" /* default */], Popover: __WEBPACK_IMPORTED_MODULE_2__Popover__["a" /* default */] },
  source: '\n    <Popover content={<DemoContent />} disabled>\n      <Button>Open Popover</Button>\n    </Popover>'
});

/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Popover__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DemoContent__ = __webpack_require__(53);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'on-open-close',
  hideFromProd: true,
  title: 'onOpen and onClose',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_0__Button__["a" /* default */], DemoContent: __WEBPACK_IMPORTED_MODULE_2__components_DemoContent__["a" /* default */], Popover: __WEBPACK_IMPORTED_MODULE_1__Popover__["a" /* default */] },
  source: '\n    () => {\n      const onOpen = () => {\n        console.log(\'Opened\');\n      };\n\n      const onClose = () => {\n        console.log(\'Closed\');\n      };\n\n      return (\n        <Popover content={<DemoContent />} onOpen={onOpen} onClose={onClose}>\n          <Button>Menu</Button>\n        </Popover>\n      );\n    }'
});

/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DemoContent__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Popover__ = __webpack_require__(37);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var OverflowContainer = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', {
  backgroundColor: 'aliceblue',
  overflow: 'hidden',
  padding: '25px'
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'overflow',
  title: 'Overflow',
  description: 'A Popover can extend beyond its bounding container (the blue area in this example) even if the parent\'s `overflow` is set to `hidden`.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_0__Button__["a" /* default */], DemoContent: __WEBPACK_IMPORTED_MODULE_2__components_DemoContent__["a" /* default */], OverflowContainer: OverflowContainer, Popover: __WEBPACK_IMPORTED_MODULE_3__Popover__["a" /* default */] },
  source: '\n    <OverflowContainer>\n      <Popover\n        content={<DemoContent />}\n        placement="right"\n        isOpen>\n        <Button>Open Popover</Button>\n      </Popover>\n    </OverflowContainer>'
});

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DemoContent__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Popover__ = __webpack_require__(37);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */])('div', {
  height: '350px',
  position: 'relative',

  '> div': {
    left: '50%',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'placement',
  title: 'Placement',
  description: 'The `placement` prop determines the initial placement of the Popover content relative to the trigger.\nThe Popover will still react to viewport edges and scrolling.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_0__Button__["a" /* default */], DemoContent: __WEBPACK_IMPORTED_MODULE_2__components_DemoContent__["a" /* default */], DemoLayout: DemoLayout, Popover: __WEBPACK_IMPORTED_MODULE_3__Popover__["a" /* default */] },
  source: '\n    <DemoLayout>\n      <Popover\n        content={<DemoContent />}\n        placement="bottom"\n        isOpen>\n        <Button>Open Popover</Button>\n      </Popover>\n    </DemoLayout>'
});

/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DemoContent__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popover__ = __webpack_require__(37);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'basic',
  title: 'Example',
  description: 'Popovers wrap the triggering component.\nPlacement is relative to the location of the trigger.\nPopovers will change position relative to the trigger automatically depending on viewport constraints.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_0__Button__["a" /* default */], DemoContent: __WEBPACK_IMPORTED_MODULE_1__components_DemoContent__["a" /* default */], Popover: __WEBPACK_IMPORTED_MODULE_2__Popover__["a" /* default */] },
  source: '\n    <Popover content={<DemoContent />}>\n      <Button>Open Popover</Button>\n    </Popover>'
});

/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DemoContent__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Popover__ = __webpack_require__(37);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('div', {
  padding: '5em 0'
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'title',
  title: 'Title and Subtitle',
  description: 'Formatted titles will be rendered above any other content if provided.\nSubtitles will only be rendered if the `title` attribute is present.',
  scope: { Button: __WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */], DemoContent: __WEBPACK_IMPORTED_MODULE_2__components_DemoContent__["a" /* default */], DemoLayout: DemoLayout, Popover: __WEBPACK_IMPORTED_MODULE_3__Popover__["a" /* default */] },
  source: '\n    <DemoLayout>\n      <Popover\n        content={<DemoContent />}\n        placement="right"\n        subtitle="Subtitle"\n        title="Title"\n        isOpen>\n        <Button>Open Popover</Button>\n      </Popover>\n    </DemoLayout>'
});

/***/ }),
/* 1694 */
/***/ (function(module, exports) {

module.exports = {
	"description": "Popovers hold supporting information or user controls.\nPopovers will float over page content.\nPlacement, scroll behavior and focus management can all be controlled to customize your implementation.\nPopovers can be toggled on a user action or a state change.",
	"methods": [
		{
			"name": "close",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "closeActions",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "focusTrigger",
			"docblock": null,
			"modifiers": [],
			"params": [],
			"returns": null
		},
		{
			"name": "handleDocumentClick",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "handleDocumentKeydown",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "isClickOutsideComponent",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "isControlled",
			"docblock": null,
			"modifiers": [],
			"params": [],
			"returns": null
		},
		{
			"name": "open",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "openActions",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		},
		{
			"name": "toggleOpenState",
			"docblock": null,
			"modifiers": [],
			"params": [
				{
					"name": "event",
					"type": {
						"name": "SyntheticEvent",
						"elements": [],
						"raw": "SyntheticEvent<>",
						"alias": "SyntheticEvent"
					}
				}
			],
			"returns": null
		}
	],
	"props": {
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": true,
			"description": "Trigger for the Popover"
		},
		"content": {
			"flowType": {
				"name": "$FlowFixMe"
			},
			"required": true,
			"description": "Content of the Popover"
		},
		"disabled": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Disables the Popover"
		},
		"hasArrow": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Include an arrow on the Popover content pointing to the trigger",
			"defaultValue": {
				"value": "true",
				"computed": false
			}
		},
		"isOpen": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "For use with controlled components, in which the app manages Popover state"
		},
		"modifiers": {
			"flowType": {
				"name": "Object"
			},
			"required": false,
			"description": "Plugins that are used to alter behavior. See [PopperJS docs](https://popper.js.org/popper-documentation.html#modifiers) for options."
		},
		"onClose": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(event: SyntheticEvent<>) => void",
				"signature": {
					"arguments": [
						{
							"name": "event",
							"type": {
								"name": "SyntheticEvent",
								"elements": [],
								"raw": "SyntheticEvent<>"
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "Called when Popover is closed"
		},
		"onOpen": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(event: SyntheticEvent<>) => void",
				"signature": {
					"arguments": [
						{
							"name": "event",
							"type": {
								"name": "SyntheticEvent",
								"elements": [],
								"raw": "SyntheticEvent<>"
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "Called when Popover is opened"
		},
		"defaultIsOpen": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Open the Popover immediately upon initialization"
		},
		"getTriggerProps": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(props: Object, scope?: Object) => Object",
				"signature": {
					"arguments": [
						{
							"name": "props",
							"type": {
								"name": "Object"
							}
						},
						{
							"name": "scope",
							"type": {
								"name": "Object"
							}
						}
					],
					"return": {
						"name": "Object"
					}
				}
			},
			"required": false,
			"description": "Function that returns props to be applied to the trigger"
		},
		"placement": {
			"flowType": {
				"name": "union",
				"raw": "| 'auto'\n| 'auto-end'\n| 'auto-start'\n| 'bottom'\n| 'bottom-end'\n| 'bottom-start'\n| 'left'\n| 'left-end'\n| 'left-start'\n| 'right'\n| 'right-end'\n| 'right-start'\n| 'top'\n| 'top-end'\n| 'top-start'",
				"elements": [
					{
						"name": "literal",
						"value": "'auto'"
					},
					{
						"name": "literal",
						"value": "'auto-end'"
					},
					{
						"name": "literal",
						"value": "'auto-start'"
					},
					{
						"name": "literal",
						"value": "'bottom'"
					},
					{
						"name": "literal",
						"value": "'bottom-end'"
					},
					{
						"name": "literal",
						"value": "'bottom-start'"
					},
					{
						"name": "literal",
						"value": "'left'"
					},
					{
						"name": "literal",
						"value": "'left-end'"
					},
					{
						"name": "literal",
						"value": "'left-start'"
					},
					{
						"name": "literal",
						"value": "'right'"
					},
					{
						"name": "literal",
						"value": "'right-end'"
					},
					{
						"name": "literal",
						"value": "'right-start'"
					},
					{
						"name": "literal",
						"value": "'top'"
					},
					{
						"name": "literal",
						"value": "'top-end'"
					},
					{
						"name": "literal",
						"value": "'top-start'"
					}
				]
			},
			"required": false,
			"description": "Placement of the Popover",
			"defaultValue": {
				"value": "'bottom'",
				"computed": false
			}
		},
		"subtitle": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "Subtitle displayed under the title"
		},
		"title": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "Title of the Popover"
		},
		"triggerRef": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(node: ?React$Component<*, *>) => void",
				"signature": {
					"arguments": [
						{
							"name": "node",
							"type": {
								"name": "React$Component",
								"elements": [
									{
										"name": "unknown"
									},
									{
										"name": "unknown"
									}
								],
								"raw": "React$Component<*, *>",
								"nullable": true
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "@Private ref for the Popover trigger"
		},
		"wrapContent": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Display the content with default styles",
			"defaultValue": {
				"value": "true",
				"computed": false
			}
		}
	}
}

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bestPractices__ = __webpack_require__(1696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples__ = __webpack_require__(1697);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var doc = __webpack_require__(1699);

/* harmony default export */ __webpack_exports__["a"] = ({
  bestPractices: __WEBPACK_IMPORTED_MODULE_0__bestPractices__["a" /* default */],
  doc: doc,
  examples: __WEBPACK_IMPORTED_MODULE_1__examples__["a" /* default */],
  slug: 'theme-provider',
  title: 'ThemeProvider',
  whenHowToUse: 'ThemeProvider can be used as a wrapper around the root App component to override theme variables.\nIt can be used deeper in your component hierarchy to theme specific areas.\n\nGranular control for individual React instances is provided by `createThemedComponent`'
});

/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ([{
  type: 'do',
  title: 'override theme variables at the top level',
  example: '\n```\nimport mineralTheme from \'mineral-ui/themes/mineralTheme\';\n\n<ThemeProvider theme={{\n  ...mineralTheme,\n  color_primary: \'rebeccapurple\'\n}}>\n  <App />\n</ThemeProvider>\n```\n',
  description: 'Try to keep theme overrides all in one place, as they will be easier to change later.\nIf you are creating custom-themed components which will be re-used, it\'s fine to keep them in the component definition.'
}, {
  type: 'do',
  title: 'use a second or third themeprovider to style different sections',
  example: '\n```\n<ThemeProvider>\n  <div>The Main Part of your app</div>\n  <ThemeProvider theme={{\n    color_primary: \'limegreen\'\n  }}>\n    <div>The admin section</div>\n  </ThemeProvider\n</ThemeProvider>\n```\n',
  description: 'You might want to style different pages of your app with separate themes to create a visual separation.'
}, {
  type: 'dont',
  title: 'override themes unless you really need to',
  example: '\n```\n<ThemeProvider theme={{ color_primary: \'#f00\' }}>\n  <div>Awesome custom app</div>\n</ThemeProvider>\n```\n',
  description: 'Try to use the default Mineral UI theme as-is. We\'ve designed the colors, typography and layout as a system to provide turn-key consistency for your app.'
}]);

/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeProvider__ = __webpack_require__(1698);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_0__themeProvider__["a" /* default */]]);

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_components_Sample__ = __webpack_require__(188);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



// TODO: Extract shared components to common location


var DemoLayout = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */])('div', {
  '& > *': {
    marginRight: '0.5rem'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'theme-provider',
  title: 'Example',
  description: 'Wrap any number of components in a `ThemeProvider` to have those components reference the specified theme. That theme will be shallowly merged with the parent theme.',
  scope: { DemoLayout: DemoLayout, ThemeProvider: __WEBPACK_IMPORTED_MODULE_1__themes__["a" /* ThemeProvider */], Sample: __WEBPACK_IMPORTED_MODULE_2__utils_components_Sample__["a" /* default */] },
  source: '\n    () => {\n      return (\n        <DemoLayout>\n          {/* This will affect all components inside this ThemeProvider that use this variable. */}\n          <ThemeProvider theme={{ color_primary: \'mediumvioletred\' }}>\n            <Sample />\n          </ThemeProvider>\n\n          {/* This will affect all components inside this ThemeProvider that use this variable,\n              which should only be Sample components due to the namespace. */}\n          <ThemeProvider theme={{ Sample_color: \'mediumvioletred\' }}>\n          \t<Sample />\n          </ThemeProvider>\n        </DemoLayout>\n      );\n    }'
});

/***/ }),
/* 1699 */
/***/ (function(module, exports) {

module.exports = {
	"description": "ThemeProvider passes along a theme to its children.",
	"methods": [],
	"props": {
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "Components to which the theme will be applied"
		},
		"theme": {
			"flowType": {
				"name": "Object"
			},
			"required": false,
			"description": "A shallow object of [theme variables](/theming/#theming-theme-variables) and their values",
			"defaultValue": {
				"value": "mineralTheme",
				"computed": true
			}
		}
	}
}

/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__examples__ = __webpack_require__(1701);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  doc: {
    description: 'Mineral UI provides several different bundled themes.  Choose the one that best suits your style.  Please see the [theming guide](/theming) for more information.'
  },
  examples: __WEBPACK_IMPORTED_MODULE_0__examples__["a" /* default */],
  hidePropDoc: true,
  slug: 'themes',
  title: 'Themes'
});

/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__available__ = __webpack_require__(1702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes__ = __webpack_require__(1703);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_1__themes__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__available__["a" /* default */]]);

/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon_IconFavorite__ = __webpack_require__(124);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var icon = _jsx(__WEBPACK_IMPORTED_MODULE_3__Icon_IconFavorite__["a" /* default */], {});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'available',
  title: 'Available themes',
  description: 'To apply a different theme, simply import it, and pass it to your [ThemeProvider](/components/theme-provider).\n\n```js\nimport limeTheme from \'mineral-ui/themes/limeTheme\'; // Available themes: blueTheme, duskTheme, indigoTheme, limeTheme, mineralTheme, purpleTheme, skyTheme, slateTheme, tealTheme\n```\n  ',
  scope: {
    Button: __WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */],
    icon: icon,
    ThemeProvider: __WEBPACK_IMPORTED_MODULE_2__themes__["a" /* ThemeProvider */],
    blueTheme: __WEBPACK_IMPORTED_MODULE_2__themes__["b" /* blueTheme */],
    duskTheme: __WEBPACK_IMPORTED_MODULE_2__themes__["d" /* duskTheme */],
    indigoTheme: __WEBPACK_IMPORTED_MODULE_2__themes__["e" /* indigoTheme */],
    limeTheme: __WEBPACK_IMPORTED_MODULE_2__themes__["f" /* limeTheme */],
    mineralTheme: __WEBPACK_IMPORTED_MODULE_2__themes__["g" /* mineralTheme */],
    purpleTheme: __WEBPACK_IMPORTED_MODULE_2__themes__["h" /* purpleTheme */],
    skyTheme: __WEBPACK_IMPORTED_MODULE_2__themes__["i" /* skyTheme */],
    slateTheme: __WEBPACK_IMPORTED_MODULE_2__themes__["j" /* slateTheme */],
    tealTheme: __WEBPACK_IMPORTED_MODULE_2__themes__["k" /* tealTheme */]
  },
  source: '\n    <ThemeProvider theme={limeTheme}>\n      <Button primary iconStart={icon}>I prefer choice!</Button>\n    </ThemeProvider>\n  '
});

/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon_IconFavorite__ = __webpack_require__(124);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var icon = _jsx(__WEBPACK_IMPORTED_MODULE_3__Icon_IconFavorite__["a" /* default */], {});

/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'themes',
  title: 'Example',
  description: 'Themes are applied via the [ThemeProvider](/components/theme-provider) which by default uses the mineral theme.',

  scope: { Button: __WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */], icon: icon, ThemeProvider: __WEBPACK_IMPORTED_MODULE_1__themes__["a" /* ThemeProvider */] },
  source: '\n    <ThemeProvider>\n      <Button primary iconStart={icon}>I like the default</Button>\n    </ThemeProvider>\n  '
});

/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__examples__ = __webpack_require__(1705);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  doc: {
    description: 'Shared utilities'
  },
  examples: __WEBPACK_IMPORTED_MODULE_0__examples__["a" /* default */],
  hidePropDoc: true,
  slug: 'utils',
  title: 'Utils'
});

/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStyledComponent__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createThemedComponent__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sample__ = __webpack_require__(1708);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_2__sample__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__createThemedComponent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__createStyledComponent__["a" /* default */]]);

/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Sample__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Code__ = __webpack_require__(1227);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'create-styled-component',
  title: _jsx(__WEBPACK_IMPORTED_MODULE_3__components_Code__["a" /* default */], {}, void 0, 'createStyledComponent(element, styles, options)'),
  description: '\nThis is how you apply arbitrary styles to a component.\n\n`element` \u2014 a React component or a string representation of an HTML\nelement\n\n`styles` \u2014 an\n[object of style rules](https://github.com/threepointone/glamor/blob/master/docs/howto.md)\nor a function that accepts props and context and returns an object of style\nrules\n\n`options` \u2014 An object of optional configuration. A mix of Mineral UI and\n[Glamorous options](https://glamorous.rocks/api). Most common uses are\nsetting a display name on your component,\n`{ displayName: \'MyComponentName\' }`, declaring which props to forward\non to the element, `{ forwardProps: [href, customProp] }`, and including\na style reset `{ includeStyleReset: true }`.\n  ',
  scope: { createStyledComponent: __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* createStyledComponent */], Sample: __WEBPACK_IMPORTED_MODULE_2__components_Sample__["a" /* default */] },
  source: '\n    () => {\n      const MyStyledSample = createStyledComponent(Sample, ({ theme }) => ({\n        outline: \'3px dashed mediumvioletred\',\n        fontSize: theme.fontSize_h1\n      }));\n\n      return <MyStyledSample />;\n    }\n  '
});

/***/ }),
/* 1707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Sample__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Code__ = __webpack_require__(1227);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'create-themed-component',
  title: _jsx(__WEBPACK_IMPORTED_MODULE_3__components_Code__["a" /* default */], {}, void 0, 'createThemedComponent(component, theme)'),
  description: '\nIf you only need to style the themed properties of a component, you can use\nthis helper. It\u2019s effectively the same as wrapping a ThemeProvider around a\nsingle component.\n\n`component` \u2014 a [Glamorous](https://github.com/paypal/glamorous")\ncomponent\n\n`theme` \u2014 a shallow object of theme variables or a function that accepts\nprops and context and returns an object of theme variables\n  ',
  scope: { createThemedComponent: __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* createThemedComponent */], Sample: __WEBPACK_IMPORTED_MODULE_2__components_Sample__["a" /* default */] },
  source: '\n    () => {\n      const MyThemedSample = createThemedComponent(Sample, ({ theme }) => ({\n        color_text: \'mediumvioletred\',\n        Sample_backgroundColor: theme.color_theme_20\n      }));\n\n      return <MyThemedSample />;\n    }'
});

/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'sample-component',
  title: 'Sample Component',
  description: 'Just a simple sample component to demonstrate the styling below.',
  scope: { createStyledComponent: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* createStyledComponent */] },
  source: '\n    () => {\n      const Sample = createStyledComponent(\'span\', ({ theme }) => ({\n        backgroundColor: theme.Sample_backgroundColor || \'lavender\',\n        color: theme.Sample_color || theme.color_text,\n        display: \'inline-block\',\n        outline: \'1px solid\' + theme.borderColor,\n        padding: theme.space_inset_sm\n      }));\n\n      return <Sample>Sample</Sample>\n    }'
});

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1710);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(1229)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1228)(undefined);
// imports


// module
exports.push([module.i, "body{margin:0}main{display:block}", ""]);

// exports


/***/ })
],[1230]);


// WEBPACK FOOTER //
// index.js